/** PROTOTYPED */
const getLocale = () => ({
    "general": {
        "voltar": "Back",
        "procurar": "Search",
        "adicionar": "Add",
        "editar": "Edit",
        "informacoes": "Information",
        "buscar": "Search",
        "salvar": "Save",
        "duplicar": "Duplicate",
        "salvarEdicao": "Save edition",
        "semDados": "No data registered",
        "alertas": "Alerts",
        "desde": "Since",
        "pesquisar": "Find",
        "sim": "Yes",
        "nao": "No",
        "consulta": "Query",
        "exportar": "Export",
        "exportarPDF": "Export PDF",
        "exportarXLS": "Export XLS",
        "exportarTextoCSV": "Export CSV",
        "diaMesAno": "Mm/dd/yyyy",
        "mesAno": "Mm/yyyy",
        "horaMinuto": "Hh:mm",
        "diaMesAnoHoraMinuto": "Mm/dd/yyyy hh:mm",
        "recarregar": "Recharge",
        "mudarLinguagem": "Trocar para português",
        "ingles": "English",
        "portugues": "Portuguese",    
    },
    "OcorrenciaAnormal": {
        "ListaDeOcorrenciasAnormais": {
            "deletar": "Are you sure you would like to delete this abnormal occurrence?",
            "titulo": "List of abnormal occurrences",
            "botaoAdicionar": "Add abnormal occurrence",
            "tabela": {
                "semOcorrencias": "There are no events registered",
                "ID": "ID",
                "Tipo": "Type",
                "Descricao": "Description",
                "Acoes": "Actions"
            }
        },
        "AdicionarOcorrenciaAnormal": {
            "titulo": "Register abnormal occurrence",
            "formulario": {
                "Tipo": "Type",
                "Descricao": "Description",
                "AcaoRequerida": "Required action"
            }
        },
        "EditarOcorrenciaAnormal": {
            "titulo": "Edit Abnormal Occurrence",
            "formulario": {
                "Tipo": "Type",
                "Descricao": "Description",
                "AcaoRequerida": "Required action"
            }
        }
    },
    "Frotas": {
        "StatusFrotas": {
            "deletar": "Are you sure you would like to delete this fleet?",
            "alertaFadiga": "Are you sure you'd like to change this crew member's fatigue alert?",
            "titulo": "Fleet status",
            "botaoEditarStatus": "Edit status",
            "botaoMudarData": "Change date",
            "tituloStatusParaData": "Fleet status for",
            "listaFrotas": {
                "PMD": "PMD",
                "Disponivel": "Available",
                "Motivo": "Reason",
                "Previsao": "Prediction",
                "IndisponivelDesde": "Unavailable since",
                "AdicionadoPor": "Added by",
                "InspetorMecanico": "Inspector / Mechanic",
                "FlightFollowing": "Flight Following",
                "Comandantes": "Captains",
                "Copilotos": "Copilots",
                "Comissarios": "Flight Attendants",
                "Observacoes": "Comments"
            }
        },
        "AdicionarFrota": {
            "deletar": "Are you sure you would like to delete this fleet?",
            "titulo": "Add fleet",
            "botaoEditarStatus": "Edit status",
            "formulario": {
                "Base": "Base",
                "Aeronave": "Aircraft",
                "Disponivel": "Available",
                "Motivo": "Reason",
                "Previsao": "Prediction",
                "IndisponivelDesde": "Unavailable since",
                "InspetorMecanico": "Inspector / Mechanic",
                "Comandantes": "Captains",
                "Copilotos": "Copilots",
                "Comissarios": "Flight Attendants",
                "FlightFollowingAnormal": "Abnormal Flight Following",
                "Desde": "Since",
                "Observacoes": "Comments",
                "placeholder": {
                    "SelecionarBase": "Select base",
                    "SelecionarFrota": "Select fleet"
                }
            },
            "listaFrotas": {
                "PMD": "PMD",
                "Disponivel": "Available",
                "Motivo": "Reason",
                "Previsao": "Prediction",
                "IndisponivelDesde": "Unavailable since",
                "AdicionadoPor": "Added by",
                "InspetorMecanico": "Inspector / Mechanic",
                "FlightFollowing": "Flight Following",
                "Comandantes": "Captains",
                "Copilotos": "Copilots",
                "Comissarios": "Flight Attendants",
                "Observacoes": "Comments"
            }
        }
    },
    "PeriodoReboqueAeronave": {
        "ListaDePeriodoReboqueAeronave": {
            "deletar": "Are you sure you would like to delete this towing period?",
            "titulo": "List of Aircraft Towing Periods",
            "botaoAdicionarPeriodo": "Add tow period",
            "tabela": {
                "ID": "ID",
                "Usuario": "User",
                "Aeronave": "Aircraft",
                "Localidade": "Location",
                "Inicio": "Start",
                "Fim": "End",
                "TempoTotal": "Total time",
                "Acoes": "Actions"
            }
        },
        "AdicionarPeriodoReboqueAeronave": {
            "titulo": "Register towing period",
            "tituloErro": "The following filling errors prevented the report from being finalized",
            "formulario": {
                "Aeronave": "Aircraft",
                "Localidade": "Location",
                "Inicio": "Start",
                "Fim": "End",
                "botaoAdicionarPeriodoReboque": "Add tow period",
                "placeholder": {
                    "SelecioneAeronave": "Select the Aircraft",
                    "SelecioneLocalidade": "Select the location"
                }
            }
        },
        "EditarPeriodoReboqueAeronave": {
            "titulo": "Edit tow period",
            "tituloErro": "The following filling errors prevented the report from being finalized",
            "formulario": {
                "Aeronave": "Aircraft",
                "Localidade": "Location",
                "Inicio": "Start",
                "Fim": "End",
                "TempoTotal": "Total Time",
                "botaoSalvarEdicao": "Save edit",
                "placeholder": {
                    "SelecioneAeronave": "Select the aircraft",
                    "SelecioneLocalidade": "Select the location"
                }
            }
        }
    },
    "ModelosAeronaves": {
        "ListaModelosAeronaves": {
            "deletar": "Are you sure you would like to delete this aircraft model?",
            "titulo": "List of aircraft models",
            "botaoAdicionarModelo": "Add aircraft model",
            "tabela": {
                "semAeronaves": "There are no registered aircraft",
                "ID": "ID",
                "Nome": "Name",
                "Modelo": "Model",
                "Classe": "Class",
                "Porte": "Size",
                "Motorização": "Motorization",
                "Acoes": "Actions"
            }
        },
        "AdicionarModelosAeronaves": {
            "titulo": "Register aircraft model",
            "formulario": {
                "Nome": "Name",
                "Modelo": "Model",
                "Classe": "Class",
                "opcoesClasses": {
                    "Aviao": "Plane",
                    "Helicoptero": "Helicopter"
                },
                "Porte": "Size",
                "opcoesPorte": {
                    "Pequeno": "Small",
                    "Medio": "Midsize",
                    "SuperMedio": "Super midsize",
                    "Grande": "Large"
                },
                "UnidadeCombustivel": "Fuel unit",
                "TipoCombustivel": "Type of fuel",
                "Motorizacao": "Motorization",
                "opcoesMotorizacao": {
                    "Multimotor": "Multi-engine",
                    "Monomotor": "Single-engine"
                },
                "TipoTripulacao": "Crew type",
                "opcoesTipoTripulacao": {
                    "DualPilot": "Dual Pilot",
                    "SinglePilot": "Single Pilot"
                },
                "CentroDeCusto": "Cost center",
                "Fabricante": "Manufacturer",
                "UsarEmPlanejamento": "Use in planning",
                "ExibirPMDnoStatusFrota": "Display PMD in Fleet Status",
                "ConsumoHoraSolo": "Consumption/Hour - Soil",
                "ConsumoHoraVoo": "Consumption/Hour - Flight",
                "CapacidadeDeCombustível": "Fuel Capacity",
                "botaoAdicionarModelo": "Add aircraft model",
                "placeholder": {
                    "NomeAeronave": "Aircraft name",
                    "ModeloAeronave": "Aircraft model",
                    "SelecioneClasse": "Select the class",
                    "SelecionePorte": "Select the size",
                    "SelecioneUnidadeCombustivel": "Select fuel unit",
                    "SelecioneTipoCombustivel": "Select fuel type",
                    "SelecioneMotorizacao": "Select engine",
                    "SelecioneTripulacao": "Select the crew",
                    "CentroDeCustoAeronave": "Aircraft cost center",
                    "FabricanteAeronave": "Aircraft manufacturer"
                }
            }
        },
        "EditarModelosAeronaves": {
            "deletar": "Are you sure you would like to delete this similar aircraft model?",
            "titulo": "Edit aircraft model",
            "formulario": {
                "Nome": "Name",
                "Modelo": "Model",
                "Classe": "Class",
                "opcoesClasses": {
                    "Aviao": "Plane",
                    "Helicoptero": "Helicopter"
                },
                "Porte": "Size",
                "opcoesPorte": {
                    "Pequeno": "Small",
                    "Medio": "Midsize",
                    "SuperMedio": "Super midsize",
                    "Grande": "Large"
                },
                "UnidadeCombustivel": "Fuel unit",
                "TipoCombustivel": "Type of fuel",
                "Motorizacao": "Motorization",
                "opcoesMotorizacao": {
                    "Multimotor": "Multi-engine",
                    "Monomotor": "Single-engine"
                },
                "TipoTripulacao": "Crew type",
                "opcoesTipoTripulacao": {
                    "DualPilot": "Dual Pilot",
                    "SinglePilot": "Single Pilot"
                },
                "CentroDeCusto": "Cost center",
                "Fabricante": "Manufacturer",
                "UsarEmPlanejamento": "Use in planning",
                "ExibirPMDnoStatusFrota": "Display PMD in Fleet Status",
                "ConsumoHoraSolo": "Consumption/Hour - Soil",
                "ConsumoHoraVoo": "Consumption/Hour - Flight",
                "CapacidadeDeCombustível": "Fuel Capacity",
                "botaoSalvarEdicao": "Save edit",
                "placeholder": {
                    "NomeAeronave": "Aircraft name",
                    "ModeloAeronave": "Aircraft model",
                    "SelecioneClasse": "Select the class",
                    "SelecionePorte": "Select the size",
                    "SelecioneUnidadeCombustivel": "Select fuel unit",
                    "SelecioneTipoCombustivel": "Select fuel type",
                    "SelecioneMotorizacao": "Select engine",
                    "SelecioneTripulacao": "Select the crew",
                    "CentroDeCustoAeronave": "Aircraft cost center",
                    "FabricanteAeronave": "Aircraft manufacturer",
                    "SelecionarModeloSimilar": "Select similar model"
                }
            },
            "tabela": {
                "titulo": "Similar models",
                "modelo": "Model",
                "acoes": "Actions",
                "formulario": {
                    "AdicionarModelo": "Add Template",
                    "botaoAdicionarSimilar": "Add similar",
                    "placeholder": {
                        "SelecionarModeloSimilar": "Select similar model"
                    }
                }
            }
        }
    },
    "Aeronaves": {
        "ListaDeAeronaves": {
            "ativar": "Are you sure you would like to activate this aircraft?",
            "arquivar": "Are you sure you'd like to archive this aircraft?",
            "ativo": "Active",
            "arquivado": "Archived",
            "deletar": "Are you sure you would like to delete this aircraft?",
            "titulo": "Aircraft list",
            "botaoAdicionarAeronave": "Add aircraft",
            "tabela": {
                "semAeronaves": "There are no registered aircraft",
                "ID": "ID",
                "Matricula": "Registration",
                "Modelo": "Model",
                "Status": "Status",
                "Acoes": "Actions"
            }
        },
        "AdicionarAeronaves": {
            "titulo": "Register aircraft",
            "formulario": {
                "Modelo": "Model",
                "Matricula": "Registration",
                "Tipo": "Type",
                "NumeroSerie": "Serial number",
                "CentroCustoTripulacao": "Cost Center - Crew",
                "CentroCUstoCoordenacao": "Cost Center - Coordination",
                "CA": "CA",
                "IAM": "IAM",
                "Peso": "Weight",
                "CodigoPTBR": "PTBR code",
                "ConsumoHoraSolo": "Consumption/Hour - Soil",
                "ConsumoHoraVoo": "Consumption/Hour - Flight",
                "CapacidadeDeCombustível": "Fuel Capacity",
                "botaoAdicionarAeronave": "Add aircraft",
                "placeholder": {
                    "SelecioneModeloAeronave": "Select aircraft model",
                    "RegistroAeronave": "Aircraft registration",
                    "SelecionarTipoOperacao": "Select type of operation"
                }
            }
        },
        "EditarAeronaves": {
            "opcoesTipoDeCargo": {
                "Tripulacao": "Crew",
                "CVODVO": "CVO/DVO",
                "MestreDeCarga": "Cargo Master",
                "Mecanico": "Mechanic",
                "Administrativo": "Administrative",
                "Indireto": "Indirect"
            },
            "deletarCentroDeCusto": "Are you sure you want to delete this cost center?",
            "atualizarVoeOmni": "Are you sure you want to update the fields: Weight; Consumption/Hour - Solo; Consumption/Hour - Flight; and Fuel Capacity. With VoeOmni data?",
            "titulo": "Edit aircraft",
            "botaoVoeOmni": "VoeOmni update",
            "formulario": {
                "Modelo": "Model",
                "Matricula": "Registration",
                "Tipo": "Type",
                "NumeroSerie": "Serial number",
                "CentroCustoTripulacao": "Cost Center - Crew",
                "CentroCUstoCoordenacao": "Cost Center - Coordination",
                "CA": "CA",
                "IAM": "IAM",
                "Peso": "Weight",
                "CodigoPTBR": "PTBR code",
                "ConsumoHoraSolo": "Consumption/Hour - Soil",
                "ConsumoHoraVoo": "Consumption/Hour - Flight",
                "CapacidadeDeCombustível": "Fuel Capacity",
                "botaoSalvarEdicao": "Save edit",
                "placeholder": {
                    "SelecioneModeloAeronave": "Select aircraft model",
                    "RegistroAeronave": "Aircraft registration",
                    "SelecionarTipoOperacao": "Select type of operation"
                }
            },
            "CentroDeCustos": {
                "tituloCentroDeCustos": "Cost centers",
                "adicionarCentroDeCusto": "Add cost center",
                "formulario": {
                    "TipoDeCargo": "Job type",
                    "CentrosDeCusto": "Cost Centers",
                    "botaoAdicionarCentroDeCusto": "Add Cost Center",
                    "placeholder": {
                        "SelecionarTipoDeCargo": "Select job type",
                        "SelecionarCentroDeCusto": "Select cost center"
                    }
                },
                "tabela": {
                    "tituloTipoDeCargo": "Job type",
                    "tituloCentroDeCusto": "Cost center"
                }
            }
        },
        "ControleMensalDeMovimentacao": {
            "titulo": "Monthly Control of Movement of Contracted Aircraft",
            "formulario": {
                "MesAno": "Month year"
            },
            "semColaboradores": "There are no registered employees"
        },
        "ControleAnualDeMovimentacao": {
            "titulo": "Annual Control of Movement of Contracted Aircraft",
            "formulario": {
                "Ano": "Year"
            },
            "semColaboradores": "There are no registered employees"
        }
    },
    "OperadoresAeroporto": {
        "ListaDeOperadores": {
            "titulo": "List of airport operators",
            "botaoAdicionarOperador": "Add airport operator",
            "tabela": {
                "ID": "ID",
                "Nome": "Name",
                "Email": "Email",
                "Acoes": "Actions"
            }
        },
        "AdicionarOperadoresAeroporto": {
            "titulo": "Register airport operators",
            "formulario": {
                "Nome": "Name",
                "Email": "Email",
                "botaoAdicionarOperadoresAeroporto": "Add"
            }
        },
        "EditarOperadoresAeroporto": {
            "titulo": "Edit airport operators",
            "formulario": {
                "Nome": "Name",
                "Email": "Email",
                "botaoSalvarEdicao": "Save edit"
            },
            "localidades": {
                "titulo": "Places",
                "adicionarCentroDeCusto": "Add locations",
                "formulario": {
                    "Localidade": "Location",
                    "botaoAdicionarLocalidade": "Add location",
                    "placeholder": {
                        "SelecionarLocalidade": "Select location"
                    }
                },
                "tabela": {
                    "Localidade": "Location",
                    "Acoes": "Actions"
                }
            },
            "tabelaPpe": {
                "titulo": "PPE Table (Tariff for Permanence in the Stay Area)",
                "formulario": {
                    "NaturezaDoVoo": "Flight Type",
                    "OpcoesNaturezaDoVoo": {
                        "Domestico": "Domestic",
                        "Internacional": "International"
                    },
                    "Grupo": "Group",
                    "PmdDe": "Pmd from",
                    "PmdAte": "Pmd until",
                    "Moeda": "Coin",
                    "DataDeInicioDeVigencia": "Effective date",
                    "DataDeTerminoDeVigencia": "Effective date",
                    "Valor": "Value",
                    "botaoAdicionarPpe": "Add PPE"
                },
                "tabela": {
                    "NaturezaDoVoo": "Flight Type",
                    "PmdDe": "PMD of",
                    "PmdAte": "PMD up to",
                    "Grupo": "Group",
                    "Moeda": "Coin",
                    "Valor": "Value",
                    "DataInicioVigencia": "Effective Date",
                    "DataTerminoVigencia": "Effective Date",
                    "Acoes": "Actions"
                },
                "modalDuplicarPpe": {
                    "titulo": "Duplication",
                    "formulario": {
                        "DataDeInicioDeVigencia": "Effective date",
                        "DataDeTerminoDeVigencia": "Effective date",
                        "Valor": "Value",
                        "botaoDuplicarPpe": "Duplicate PPE"
                    }
                },
                "modalEditarPpe": {
                    "titulo": "Edit PPE",
                    "formulario": {
                        "NaturezaDoVoo": "Flight Type",
                        "OpcoesNaturezaDoVoo": {
                            "Domestico": "Domestic",
                            "Internacional": "International"
                        },
                        "Grupo": "Group",
                        "PmdDe": "Pmd from",
                        "PmdAte": "Pmd until",
                        "Moeda": "Coin",
                        "DataDeInicioDeVigencia": "Effective date",
                        "DataDeTerminoDeVigencia": "Effective date",
                        "Valor": "Value",
                        "botaoEditarPpe": "Edit PPE"
                    }
                }
            },
            "tabelaPpm": {
                "titulo": "PPM Table (Tariff for Permanence in the Maneuvering Yard)",
                "formulario": {
                    "NaturezaDoVoo": "Flight Type",
                    "OpcoesNaturezaDoVoo": {
                        "Domestico": "Domestic",
                        "Internacional": "International"
                    },
                    "Grupo": "Group",
                    "PmdDe": "Pmd from",
                    "PmdAte": "Pmd until",
                    "Moeda": "Coin",
                    "DataDeInicioDeVigencia": "Effective date",
                    "DataDeTerminoDeVigencia": "Effective date",
                    "Valor": "Value",
                    "botaoAdicionarPpm": "Add PPM"
                },
                "tabela": {
                    "NaturezaDoVoo": "Flight Type",
                    "PmdDe": "PMD of",
                    "PmdAte": "PMD up to",
                    "Grupo": "Group",
                    "Moeda": "Coin",
                    "Valor": "Value",
                    "DataInicioVigencia": "Effective Date",
                    "DataTerminoVigencia": "Effective Date",
                    "Acoes": "Actions"
                },
                "modalDuplicarPpm": {
                    "titulo": "Duplication",
                    "formulario": {
                        "DataDeInicioDeVigencia": "Effective date",
                        "DataDeTerminoDeVigencia": "Effective date",
                        "Valor": "Value",
                        "botaoDuplicarPpm": "Duplicate PPM"
                    }
                },
                "modalEditarPpm": {
                    "titulo": "Edit PPM",
                    "formulario": {
                        "NaturezaDoVoo": "Flight Type",
                        "OpcoesNaturezaDoVoo": {
                            "Domestico": "Domestic",
                            "Internacional": "International"
                        },
                        "Grupo": "Group",
                        "PmdDe": "Pmd from",
                        "PmdAte": "Pmd until",
                        "Moeda": "Coin",
                        "DataDeInicioDeVigencia": "Effective date",
                        "DataDeTerminoDeVigencia": "Effective date",
                        "Valor": "Value",
                        "botaoEditarPpm": "Edit PPM"
                    }
                }
            },
            "tabelaTpo": {
                "titulo": "TPO Table (Landing Fare)",
                "formulario": {
                    "NaturezaDoVoo": "Flight Type",
                    "OpcoesNaturezaDoVoo": {
                        "Domestico": "Domestic",
                        "Internacional": "International"
                    },
                    "Grupo": "Group",
                    "PmdDe": "Pmd from",
                    "PmdAte": "Pmd until",
                    "Moeda": "Coin",
                    "DataDeInicioDeVigencia": "Effective date",
                    "DataDeTerminoDeVigencia": "Effective date",
                    "Valor": "Value",
                    "botaoAdicionarTpo": "Add TPO"
                },
                "tabela": {
                    "NaturezaDoVoo": "Flight Type",
                    "PmdDe": "PMD of",
                    "PmdAte": "PMD up to",
                    "Grupo": "Group",
                    "Moeda": "Coin",
                    "Valor": "Value",
                    "DataInicioVigencia": "Effective Date",
                    "DataTerminoVigencia": "Effective Date",
                    "Acoes": "Actions"
                },
                "modalDuplicarTpo": {
                    "titulo": "Duplication",
                    "formulario": {
                        "DataDeInicioDeVigencia": "Effective date",
                        "DataDeTerminoDeVigencia": "Effective date",
                        "Valor": "Value",
                        "botaoDuplicarTpo": "Duplicate TPO"
                    }
                },
                "modalEditarTpo": {
                    "titulo": "Edit TPO",
                    "formulario": {
                        "NaturezaDoVoo": "Flight Type",
                        "OpcoesNaturezaDoVoo": {
                            "Domestico": "Domestic",
                            "Internacional": "International"
                        },
                        "Grupo": "Group",
                        "PmdDe": "Pmd from",
                        "PmdAte": "Pmd until",
                        "Moeda": "Coin",
                        "DataDeInicioDeVigencia": "Effective date",
                        "DataDeTerminoDeVigencia": "Effective date",
                        "Valor": "Value",
                        "botaoEditarTpo": "Edit TPO"
                    }
                }
            }
        }
    },
    "ResponsaveisPeloEspacoAereo": {
        "ListaDeResponsaveisPeloEspacoAereo": {
            "titulo": "List of controllers",
            "botaoAdicionarResponsavel": "Add controller",
            "tabela": {
                "ID": "ID",
                "Nome": "Name",
                "Email": "Email",
                "Acoes": "Actions"
            }
        },
        "AdicionarResponsaveisPeloEspacoAereo": {
            "titulo": "Register controller",
            "formulario": {
                "Nome": "Name",
                "Email": "Email",
                "Pais": "Country",
                "botaoAdicionarResponsaveisPeloEspacoAereo": "Add",
                "placeHolder": {
                    "SelecionarPais": "Select country"
                }
            }
        },
        "EditarResponsaveisPeloEspacoAereo": {
            "titulo": "Edit controller",
            "formulario": {
                "Nome": "Name",
                "Email": "Email",
                "Pais": "Country",
                "botaoSalvarEdicao": "Save edit",
                "placeHolder": {
                    "SelecionarPais": "Select country"
                }
            },
            "tabelaAdr": {
                "titulo": "Table of TAT ADR (Tariff for the Use of Communications and Radio Aids for Air Navigation in the Control Area)",
                "formulario": {
                    "NaturezaDoVoo": "Flight Type",
                    "OpcoesNaturezaDoVoo": {
                        "Domestico": "Domestic",
                        "Internacional": "International"
                    },
                    "Classe": "Class",
                    "PmdDe": "Pmd from",
                    "PmdAte": "Pmd until",
                    "DataDeInicioDeVigencia": "Effective date",
                    "DataDeTerminoDeVigencia": "Effective date",
                    "Valor": "Value",
                    "botaoAdicionarAdr": "Add ADR"
                },
                "tabela": {
                    "NaturezaDoVoo": "Flight Type",
                    "PmdDe": "PMD of",
                    "PmdAte": "PMD up to",
                    "Classe": "Class",
                    "Moeda": "Coin",
                    "Valor": "Value",
                    "DataInicioVigencia": "Effective Date",
                    "DataTerminoVigencia": "Effective Date",
                    "Acoes": "Actions"
                },
                "modalDuplicarAdr": {
                    "titulo": "Duplication",
                    "formulario": {
                        "DataDeInicioDeVigencia": "Effective date",
                        "DataDeTerminoDeVigencia": "Effective date",
                        "Valor": "Value",
                        "botaoDuplicarAdr": "Duplicate ADR"
                    }
                },
                "modalEditarAdr": {
                    "titulo": "Edit ADR",
                    "formulario": {
                        "NaturezaDoVoo": "Flight Type",
                        "OpcoesNaturezaDoVoo": {
                            "Domestico": "Domestic",
                            "Internacional": "International"
                        },
                        "Classe": "Class",
                        "PmdDe": "Pmd from",
                        "PmdAte": "Pmd until",
                        "DataDeInicioDeVigencia": "Effective date",
                        "DataDeTerminoDeVigencia": "Effective date",
                        "Valor": "Value",
                        "botaoEditarAdr": "Edit ADR"
                    }
                }
            },
            "tabelaApp": {
                "titulo": "TAT APP Table (Tariff for the Use of Communications and Radio Aids to Air Navigation in the Approach Control Area)",
                "formulario": {
                    "NaturezaDoVoo": "Flight Type",
                    "OpcoesNaturezaDoVoo": {
                        "Domestico": "Domestic",
                        "Internacional": "International"
                    },
                    "Classe": "Class",
                    "PmdDe": "Pmd from",
                    "PmdAte": "Pmd until",
                    "DataDeInicioDeVigencia": "Effective date",
                    "DataDeTerminoDeVigencia": "Effective date",
                    "Valor": "Value",
                    "botaoAdicionarApp": "Add APP"
                },
                "tabela": {
                    "NaturezaDoVoo": "Flight Type",
                    "PmdDe": "PMD of",
                    "PmdAte": "PMD up to",
                    "Classe": "Class",
                    "Moeda": "Coin",
                    "Valor": "Value",
                    "DataInicioVigencia": "Effective Date",
                    "DataTerminoVigencia": "Effective Date",
                    "Acoes": "Actions"
                },
                "modalDuplicarApp": {
                    "titulo": "Duplication",
                    "formulario": {
                        "DataDeInicioDeVigencia": "Effective date",
                        "DataDeTerminoDeVigencia": "Effective date",
                        "Valor": "Value",
                        "botaoDuplicarApp": "Duplicate APP"
                    }
                },
                "modalEditarApp": {
                    "titulo": "Edit APP",
                    "formulario": {
                        "NaturezaDoVoo": "Flight Type",
                        "OpcoesNaturezaDoVoo": {
                            "Domestico": "Domestic",
                            "Internacional": "International"
                        },
                        "Classe": "Class",
                        "PmdDe": "Pmd from",
                        "PmdAte": "Pmd until",
                        "DataDeInicioDeVigencia": "Effective date",
                        "DataDeTerminoDeVigencia": "Effective date",
                        "Valor": "Value",
                        "botaoEditarApp": "Edit APP"
                    }
                }
            },
            "tabelaPan": {
                "titulo": "PAN Table (Tariff for the Use of Communications and Aids to Air Navigation on Route)",
                "formulario": {
                    "NaturezaDoVoo": "Flight Type",
                    "OpcoesNaturezaDoVoo": {
                        "Domestico": "Domestic",
                        "Internacional": "International"
                    },
                    "PmdDe": "Pmd from",
                    "PmdAte": "Pmd until",
                    "DataDeInicioDeVigencia": "Effective date",
                    "DataDeTerminoDeVigencia": "Effective date",
                    "Valor": "Value",
                    "botaoAdicionarPan": "Add PAN"
                },
                "tabela": {
                    "NaturezaDoVoo": "Flight Type",
                    "PmdDe": "PMD of",
                    "PmdAte": "PMD up to",
                    "Moeda": "Coin",
                    "Valor": "Value",
                    "DataInicioVigencia": "Effective Date",
                    "DataTerminoVigencia": "Effective Date",
                    "Acoes": "Actions"
                },
                "modalDuplicarPan": {
                    "titulo": "Duplication",
                    "formulario": {
                        "DataDeInicioDeVigencia": "Effective date",
                        "DataDeTerminoDeVigencia": "Effective date",
                        "Valor": "Value",
                        "botaoDuplicarPan": "Duplicate PAN"
                    }
                },
                "modalEditarPan": {
                    "titulo": "Edit PAN",
                    "formulario": {
                        "NaturezaDoVoo": "Flight Type",
                        "OpcoesNaturezaDoVoo": {
                            "Domestico": "Domestic",
                            "Internacional": "International"
                        },
                        "PmdDe": "Pmd from",
                        "PmdAte": "Pmd until",
                        "DataDeInicioDeVigencia": "Effective date",
                        "DataDeTerminoDeVigencia": "Effective date",
                        "Valor": "Value",
                        "botaoEditarPan": "Edit PAN"
                    }
                }
            },
            "unidades": {
                "deletar": "Are you sure you would like to delete this unit?",
                "titulo": "Units",
                "formulario": {
                    "Nome": "Name",
                    "Email": "Email",
                    "botaoAdicionarUnidade": "Add unit"
                },
                "tabela": {
                    "Unidade": "Unit",
                    "Email": "Email",
                    "Acoes": "Actions"
                }
            },
            "localidadeDaUnidade": {
                "deletar": "Are you sure you would like to delete this location?",
                "titulo": "Unit Locations",
                "formulario": {
                    "Localidade": "Location",
                    "Unidade": "Unit",
                    "botaoAdicionarLocalidadeDaUnidade": "Add unit location",
                    "placeHolder": {
                        "SelecionarLocalidade": "Select location",
                        "SelecionarUnidade": "Select unit"
                    }
                },
                "tabela": {
                    "Localidade": "Location",
                    "Unidade": "Unit",
                    "Acoes": "Actions"
                }
            }
        }
    },
    "Indisponibilidades": {
        "ListaDeIndisponibilidades": {
            "deletar": "Are you sure you'd like to delete this unavailability?",
            "titulo": "Unavailability list",
            "botaoAdicionarIndisponibilidade": "Add unavailability",
            "semIndisponibilidades": "There are no registered unavailabilitys",
            "tabela": {
                "ID": "ID",
                "Matricula": "Registration",
                "Frota": "Fleet",
                "Contrato": "Contract",
                "Desde": "Since",
                "Ate": "Until",
                "Total": "Total",
                "Acoes": "Actions"
            }
        },
        "AeronavesIndisponiveis": {
            "deletar": "Are you sure you'd like to delete this unavailability?",
            "titulo": "Unavailable aircraft",
            "botaoAdicionarIndisponibilidade": "Add unavailability",
            "semIndisponibilidades": "There are no registered unavailabilitys",
            "tabela": {
                "ID": "ID",
                "Matricula": "Registration",
                "Frota": "Fleet",
                "Contrato": "Contract",
                "Desde": "Since",
                "Ate": "Until",
                "Total": "Total",
                "Acoes": "Actions"
            }
        },
        "AdicionarIndisponibilidade": {
            "titulo": "Register unavailability",
            "erros": "The following filling errors prevented the unavailability form from being processed",
            "formulario": {
                "Contrato": "Contract",
                "InicioInterrupcao": "Interruption - start",
                "Base": "Base",
                "Tipo": "Type",
                "HoraInicialContratual": "Contractual start time",
                "HoraTerminoContratual": "Contractual End Time",
                "TempoDisponibilidadeContratual": "Contractual Availability Time",
                "Franquia": "Franchise",
                "OcorrenciaAnormal": "Abnormal occurrence",
                "opcoesOcorrenciaAnormal": {
                    "Sim": "Yes",
                    "Nao": "No"
                },
                "Razao": "Reason",
                "PrevisaoRetorno": "Forecast return",
                "FimInterrupcao": "Interrupt - end",
                "DiferencaPrevisaoRetorno": "Difference - Forecast x Return",
                "botaoAdicionarIndisponibilidade": "Add unavailability",
                "placeholder": {
                    "SelecionarContrato": "Select contract",
                    "SelecionarBase": "Select base",
                    "SelecionarTipo": "Select type"
                }
            }
        },
        "EditarIndisponibilidade": {
            "finalizarFicha": "Are you sure you want to finish this form?",
            "reprovarFicha": "Are you sure you want to reject this form?",
            "deletarBackup": "Are you sure you want to delete this backup?",
            "titulo": "Edit unavailability",
            "erros": "The following filling errors prevented the unavailability form from being processed",
            "formulario": {
                "Contrato": "Contract",
                "InicioInterrupcao": "Interruption - start",
                "Base": "Base",
                "Tipo": "Type",
                "HoraInicialContratual": "Contractual start time",
                "HoraTerminoContratual": "Contractual End Time",
                "TempoDisponibilidadeContratual": "Contractual Availability Time",
                "Franquia": "Franchise",
                "OcorrenciaAnormal": "Abnormal occurrence",
                "opcoesOcorrenciaAnormal": {
                    "Sim": "Yes",
                    "Nao": "No"
                },
                "Razao": "Reason",
                "PrevisaoRetorno": "Forecast return",
                "FimInterrupcao": "Interrupt - end",
                "DiferencaPrevisaoRetorno": "Difference - Forecast x Return",
                "botaoAdicionarIndisponibilidade": "Add unavailability",
                "placeholder": {
                    "SelecionarBase": "Select base",
                    "SelecionarTipo": "Select type"
                }
            },
            "backup": {
                "titulo": "Add Backup",
                "formulario": {
                    "AeronaveBackup": "Backup aircraft",
                    "DataInicial": "Initial date",
                    "DataFinal": "Final date",
                    "botaoSalvarBackup": "Save backup",
                    "placeholder": {
                        "SelecionarAeronaveDeBackup": "Select backup aircraft"
                    }
                }
            },
            "tabelaBackup": {
                "titulo": "Backups",
                "aeronave": "Aircraft",
                "dataInicial": "Initial date",
                "dataFinal": "Final date",
                "acoes": "Actions"
            },
            "tabelaTotais": {
                "titulo": "Totals",
                "inicioDisponibilidade": "Availability start",
                "fimDisponibilidade": "Availability finish",
                "disponibilidade": "Availability",
                "franquia": "Spare Time",
                "indisponibilidadeContratual": "Contractual unavailability",
                "indisponibilidadeContratualSemFranquia": "Contractual Unavailability - Not Deductible",
                "indisponibilidadeReal": "Real unavailability"
            },
            "tabelaAprovacoes": {
                "titulo": "Approvals",
                "ID": "ID",
                "tipo": "Type",
                "interrompido": "Interrupted",
                "finalizado": "Finished",
                "aprovado": "Okay",
                "interrompidoPor": "Interrupted by",
                "finalizadoPor": "Finished by",
                "aprovadoPor": "Approved by",
                "justificativa": "Justification",
                "acoes": "Actions"
            },
            "modalJustificativa": {
                "titulo": "Justify the disapproval",
                "formulario": {
                    "Justificar": "Justify"
                }
            }
        },
        "ListaDeIndisponibilidadesFinalizadas": {
            "deletar": "Are you sure you'd like to delete this unavailability?",
            "titulo": "Completed unavailability list",
            "botaoAdicionarIndisponibilidade": "Add unavailability",
            "semIndisponibilidades": "There are no registered unavailabilitys",
            "tabela": {
                "ID": "ID",
                "Matricula": "Registration",
                "Frota": "Fleet",
                "Contrato": "Contract",
                "Desde": "Since",
                "Ate": "Until",
                "Total": "Total",
                "Acoes": "Actions"
            }
        }
    },
    "Bases": {
        "ListaDeBases": {
            "ativar": "Are you sure you would like to activate this base?",
            "arquivar": "Are you sure you'd like to archive this base?",
            "ativo": "Active",
            "arquivado": "Archived",
            "deletar": "Are you sure you would like to delete this base?",
            "titulo": "List of bases",
            "botaoAdicionarBase": "Add base",
            "tabela": {
                "semBases": "There are no registered databases",
                "ID": "ID",
                "Nome": "Name",
                "CodigoICAO": "ICAO code",
                "CodigoIATA": "IATA code",
                "Cidade": "City",
                "UF": "State",
                "Status": "Status",
                "Acoes": "Actions"
            }
        },
        "AdicionarBase": {
            "titulo": "Register base",
            "formulario": {
                "Nome": "Name",
                "CodigoICAO": "Code ICAO",
                "CodigoIATA": "Code IATA",
                "Cidade": "City",
                "Estado": "State",
                "CEP": "Zip code",
                "Telefone": "Phone number",
                "Ordem": "Order",
                "Email": "Email",
                "DiariasAdicionais": "Additional Rates",
                "DiariaObrigatoria": "Mandatory daily rate",
                "VerbaIndenizadoraDeTransporte": "Transportation Compensation Fund",
                "VerbaIndenizadoraDeDeslocamento": "Displacement compensation amount",
                "Observacoes": "Comments",
                "botaoAdicionarBase": "Add base",
                "placeholder": {
                    "NomeDaBase": "Base name",
                    "CodigoICAO": "ICAO code",
                    "CodigoIATA": "IATA code",
                    "CidadeDaBase": "Base city",
                    "EstadoDaBase": "Base state",
                    "CEPdaBase": "Base zip code",
                    "TelefoneDaBase": "Base phone",
                    "OrdemDaBase": "Base order",
                    "Email": "Email"
                }
            }
        },
        "EditarBase": {
            "titulo": "Edit Base",
            "tabDadosDaBase": {
                "tituloTab": "Base Data",
                "tiposDeCargo": {
                    "Tripulacao": "Crew",
                    "CVODVO": "CVO/DVO",
                    "MestreCarga": "Load master",
                    "Mecanico": "Mechanic",
                    "Administrativo": "Administrative",
                    "Indireto": "Indirect"
                },
                "deletarData": "Are you sure you want to delete this date?",
                "deletarCentroDeCusto": "Are you sure you want to delete this cost center?",
                "deletarEmpresa": "Are you sure you want to delete this company?",
                "formulario": {
                    "Nome": "Name",
                    "CodigoICAO": "Code ICAO",
                    "CodigoIATA": "Code IATA",
                    "Cidade": "City",
                    "Estado": "State",
                    "CEP": "Zip code",
                    "Telefone": "Phone number",
                    "Responsavel": "Responsible",
                    "Ordem": "Order",
                    "Email": "Email",
                    "BasesDoSigmec": "Sigmec bases",
                    "DiariasAdicionais": "Additional daily",
                    "Ativa": "Active",
                    "DiariaObrigatoria": "Mandatory daily rate",
                    "VerbaIndenizatoriaDeTransporte": "Transportation Compensation Fund",
                    "VerbaIndenizatoriaDeDeslocamento": "Displacement compensation amount",
                    "Observacoes": "Comments",
                    "botaoSalvarEdicao": "Save edit",
                    "placeholder": {
                        "NomeDaBase": "Base name",
                        "CodigoICAO": "ICAO code",
                        "CodigoIATA": "IATA code",
                        "CidadeDaBase": "Base city",
                        "EstadoDaBase": "Base state",
                        "CEPdaBase": "Base zip code",
                        "TelefoneDaBase": "Base phone",
                        "SelecionarResponsavel": "Select responsible",
                        "OrdemDaBase": "Base order",
                        "Email": "Email",
                        "SelecionarPorte": "Select size"
                    }
                },
                "basesRubi": {
                    "titulo": "Bases - Rubi",
                    "formulario": {
                        "CodigoRubi": "Rubi code",
                        "placeholder": {
                            "CodigoRubi": "Rubi code"
                        }
                    },
                    "tabela": {
                        "Codigo": "Code",
                        "Acoes": "Actions"
                    }
                },
                "datasDeTroca": {
                    "titulo": "Exchange Dates",
                    "datasQueNaoPagamDeslocamento": "These dates do not pay displacement",
                    "formulario": {
                        "Data": "Date"
                    },
                    "tabela": {
                        "Data": "Date"
                    }
                },
                "centrosDeCusto": {
                    "titulo": "Cost centers",
                    "adicionarCentroDeCusto": "Add cost center",
                    "formulario": {
                        "TipoDeCargo": "Job type",
                        "CentrosDeCusto": "Cost Centers",
                        "botaoAdicionarCentroDeCusto": "Add Cost Center",
                        "placeholder": {
                            "SelecionarTipoDeCargo": "Select job type",
                            "SelecionarCentroDeCusto": "Select cost center"
                        }
                    },
                    "tabela": {
                        "TipoDeCargo": "Type of Position",
                        "CentroDeCusto": "Cost center"
                    }
                },
                "empresas": {
                    "titulo": "Companies",
                    "adicionarEmpresa": "Add company",
                    "formulario": {
                        "Empresas": "Companies",
                        "botaoAdicionarEmpresa": "Add company",
                        "placeholder": {
                            "SelecionarEmpresa": "Select job type"
                        }
                    },
                    "tabela": {
                        "Empresa": "Company"
                    }
                }
            }
        }
    },
    "Certificados": {
        "ListaDeCertificados": {
            "titulo": "List of certifications",
            "botaoAdicionarCertificado": "Add certification",
            "tabela": {
                "semCertificados": "There are no registered certifications",
                "ID": "ID",
                "Nome": "Name",
                "Tipo": "Type",
                "Modelo": "Model",
                "Validade": "Expires in",
                "CargaHoraria": "Workload",
                "Acoes": "Actions"
            }
        },
        "AdicionarCerfiticado": {
            "opcoesPresenca": {
                "Presenca": "Presence",
                "EAD": "EAD"
            },
            "mensagemSelecioneDestinado": "Select the \"Intended for:\"",
            "mensagemSelecioneTipo": "Select the \"Type:\"",
            "mensagemSelecioneNome": "Select the \"Name:\"",
            "titulo": "Register certification",
            "formulario": {
                "Nome": "Name",
                "TipoDeVencimento": "Maturity Type",
                "opcoesVencimento": {
                    "VencimentoPorDia": "Expiration per Day (dd/mm/yyyy)",
                    "VencimentoPorMes": "Expiration per Month (mm/yyyy)"
                },
                "Modelo": "Model",
                "Tipo": "Type",
                "DestinadoA": "Destined to",
                "NotaMinima": "Minimum grade",
                "Validade": "Expires in",
                "CargaHoraria": "Workload",
                "ContaExperienciaOffShore": "Off-Shore Experience Account",
                "ContaExperienciaSelva": "Jungle Experience account",
                "ExperienciaNoturna": "Night Experience",
                "botaoAdicionarCertificado": "Add certification",
                "placeholder": {
                    "RegistroDeCertificado": "Certification registration",
                    "SelecionarTipoDeVencimento": "Select payment type",
                    "SelecionarModeloDeAeronave": "Select aircraft model",
                    "SelecionarTipo": "Select type",
                    "NotaMinimaParaValidacaoDoCertificado": "Minimum score for certification validation.",
                    "ValidadeEmMesesDoCertificado": "Validity in months of the certification. Only numbers.",
                    "CargaHorariaDoCertificado": "Certification workload."
                }
            }
        },
        "ListaDeCertificadosGeral": {
            "titulo": "General certification list",
            "tabela": {
                "semCertificados": "There are no registered certifications",
                "ID": "ID",
                "Matricula": "Reg.",
                "NomeDoTripulante": "Crew name",
                "Certificado": "Certification",
                "CargaHoraria": "Workload",
                "Inicio": "Start",
                "Fim": "End",
                "Vencimento": "Maturity",
                "Ativo": "Active?"
            }
        },
        "EditarCertificado": {
            "titulo": "Edit Certification",
            "tabDadosDoCertificado": {
                "tituloTab": "Certification data",
                "mensagemSelecioneDestinado": "Select the \"Intended for:\"",
                "mensagemSelecioneTipo": "Select the \"Type:\"",
                "mensagemSelecioneNome": "Select the \"Name:\"",
                "deletar": "Are you sure you would like to delete this group?",
                "formulario": {
                    "Nome": "Name",
                    "TipoDeVencimento": "Maturity Type",
                    "opcoesVencimento": {
                        "VencimentoPorDia": "Expiration per Day (dd/mm/yyyy)",
                        "VencimentoPorMes": "Expiration per Month (mm/yyyy)"
                    },
                    "Modelo": "Model",
                    "Tipo": "Type",
                    "DestinadoA": "Destined to",
                    "NotaMinima": "Minimum grade",
                    "Validade": "Expires in",
                    "CargaHoraria": "Workload",
                    "ContaExperienciaOffShore": "Off-Shore Experience Account",
                    "ContaExperienciaSelva": "Jungle Experience account",
                    "ExperienciaNoturna": "Night Experience",
                    "botaoSalvarEdicao": "Save edit",
                    "placeholder": {
                        "RegistroDeCertificado": "Certification registration",
                        "SelecionarTipoDeVencimento": "Select payment type",
                        "SelecionarModeloDeAeronave": "Select aircraft model",
                        "SelecionarTipo": "Select type",
                        "NotaMinimaParaValidacaoDoCertificado": "Minimum score for certification validation.",
                        "ValidadeEmMesesDoCertificado": "Validity in months of the certification. Only numbers.",
                        "CargaHorariaDoCertificado": "Certification workload."
                    }
                },
                "adicionarGrupoDeCertificados": "Add certification groups",
                "paragrafoRelacionarQuaisCertificadosSaoNecessarios": "Here you will be able to list which certifications are needed for this to be obtained.",
                "adicionarNovoGrupo": "Add New Group",
                "formularioAdicionarNovoGrupo": {
                    "Nome": "Name",
                    "MesesAnteriores": "Previous months",
                    "Tipo": "Type",
                    "Aplicabilidade": "Applicability",
                    "Certificados": "Certifications",
                    "botaoSalvarGrupo": "Save group",
                    "placeholder": {
                        "NomeDoGrupo": "Group's name",
                        "InformarEmMesesDefasagemDoTreinamentoOcertificadoPodeTer": "Inform, in months, how many months of delay in training the required certification may have",
                        "SelecionarTipo": "Select type"
                    }
                },
                "gruposDeCertificado": "Certification groups",
                "deletarCertificadoDesseGrupo": "Are you sure you would like to delete this certification from this group?",
                "formularioGruposDeCertificado": {
                    "Nome": "Name",
                    "Tipo": "Type",
                    "opcoesTipo": {
                        "E": "AND",
                        "OU": "OR"
                    },
                    "MesesAnteriores": "Previous months",
                    "Aplicabilidade": "Applicability",
                    "botaoEditarGrupo": "Edit group",
                    "placeholder": {
                        "NomeDoGrupo": "Group's name",
                        "SelecioneTipo": "Select the type",
                        "InformarEmMesesDefasagemDoTreinamentoOcertificadoPodeTer": "Inform, in months, how many months of delay in training the required certification may have"
                    }
                },
                "formularioCertificados": {
                    "Certificados": "Certifications",
                    "botaoIncluirCertificado": "Include certification",
                    "placeholder": {
                        "NomeDoGrupo": "Group's name",
                        "SelecioneTipo": "Select the type"
                    }
                },
                "tabelaCertificado": {
                    "Certificado": "Certification",
                    "Acoes": "Actions"
                }
            },
            "tabFornecedoresDesteCertificado": {
                "tituloTab": "Supplier of this certification",
                "deletarFornecedor": "Are you sure you would like to delete this vendor?",
                "tabelaFornecedor": {
                    "Fornecedor": "Provider",
                    "Tipo": "Type",
                    "Telefone": "Phone number",
                    "Cidade": "City",
                    "Pais": "Country",
                    "Expiracao": "Expiration",
                    "CustoH": "Cost/H",
                    "Reembolso": "Reimbursement",
                    "Acoes": "Actions"
                },
                "adicionarFornecedor": "Add supplier",
                "formularioAdicionarFornecedor": {
                    "Fornecedores": "Supplier",
                    "CodigoANAC": "ANAC code",
                    "Expiracao": "Expiration",
                    "Certificacao": "Certification",
                    "PrazoDeCancelamentoComRetornoDoPagamentoEmDias": "Deadline for Cancellation with Return of Payment (in days)",
                    "Endereço": "Address",
                    "Cidade": "City",
                    "Estado": "State",
                    "Pais": "Country",
                    "ContatoNome": "Contact name",
                    "Telefone": "Phone number",
                    "Email": "Email",
                    "Observacoes": "Comments",
                    "ValorHora": "Hourly rate",
                    "botaoSalvarFornecedor": "Save vendor",
                    "placeholder": {
                        "SelecionarFornecedor": "Select supplier",
                        "EndereçoDoFornecedor": "Supplier address",
                        "CidadeDoFornecedor": "Supplier city",
                        "EstadoDoFornecedor": "Provider's State/Province",
                        "SelecionePais": "Select country",
                        "TelefoneDoFornecedor": "Supplier phone",
                        "EmailDoFornecedor": "Supplier's email"
                    }
                },
                "editarCertificadoFornecedor": "Edit Certification/Vendor",
                "formularioEditarFornecedor": {
                    "Certificacao": "Certification",
                    "CodigoANAC": "ANAC code",
                    "Expiracao": "Expiration",
                    "ValorHora": "Hourly rate",
                    "PrazoDeCancelamentoComRetornoDoPagamentoEmDias": "Deadline for Cancellation with Return of Payment (in days)",
                    "Endereço": "Address",
                    "Cidade": "City",
                    "Estado": "State",
                    "Pais": "Country",
                    "ContatoNome": "Contact name",
                    "Telefone": "Phone number",
                    "Email": "Email",
                    "Observacoes": "Comments",
                    "botaoSalvarFornecedor": "Save vendor",
                    "placeholder": {
                        "EndereçoDoFornecedor": "Supplier address",
                        "CidadeDoFornecedor": "Supplier city",
                        "EstadoDoFornecedor": "Provider's State/Province",
                        "SelecionePais": "Select country",
                        "TelefoneDoFornecedor": "Supplier phone",
                        "EmailDoFornecedor": "Supplier's email"
                    }
                }
            },
            "tabArquivoMorto": {
                "tituloTab": "Dead file",
                "deletarArquivo": "Are you sure you would like to delete this file?",
                "adicionarCertificadoDeArquivoMorto": "Add archive certification",
                "formularioArquivoMorto": {
                    "Nome": "Name",
                    "botaoAdicionarCertificadoDeArquivoMorto": "Add archive certification"
                },
                "tabelaArquivoMorto": {
                    "Nome": "Name",
                    "Acoes": "Actions"
                }
            }
        }
    },
    "CertificadosAVencer": {
        "titulo": "List of certifications to expire",
        "tabela": {
            "semCertificadosAVencer": "There are no certifications to expire registered",
            "ID": "ID",
            "Certificado": "Certification",
            "Fornecedor": "Provider",
            "Cidade": "City",
            "Pais": "Country",
            "Expirado": "Expired?",
            "DataDeExpiracao": "Expiration date"
        }
    },
    "Clientes": {
        "ListaDeClientes": {
            "titulo": "Customer list",
            "deletar": "Are you sure you would like to delete this customer?",
            "botaoAdicionarCliente": "Add customer",
            "tabela": {
                "semFornecedores": "There are no registered suppliers",
                "ID": "ID",
                "Nome": "Name",
                "Email": "Email",
                "Telefone": "Phone number",
                "Pais": "Country",
                "Acoes": "Actions"
            }
        },
        "AdicionarCliente": {
            "titulo": "Register customer",
            "formulario": {
                "Nome": "Name",
                "Pais": "Country",
                "Endereco": "Address",
                "Telefone": "Phone number",
                "Cidade": "City",
                "Email": "Email",
                "Estado": "State",
                "Observacoes": "Comments",
                "ExigeAprovacaoDosTripulantes": "Requires crew approval",
                "Operador": "Operator",
                "botaoAdicionarCliente": "Add customer",
                "placeholder": {
                    "NomeDoCliente": "Client name",
                    "SelecionarPais": "Select country",
                    "EnderecoDoCliente": "Customer address",
                    "TelefoneDoCliente": "Customer phone",
                    "CidadeDoCliente": "Customer city",
                    "EmailDoCliente": "Customer email",
                    "EstadoDoCliente": "Customer State/Province"
                }
            }
        },
        "EditarCliente": {
            "titulo": "Edit Customer",
            "tabDadosDoCliente": {
                "tituloTab": "Client's data",
                "formulario": {
                    "Nome": "Name",
                    "Pais": "Country",
                    "Endereco": "Address",
                    "Telefone": "Phone number",
                    "Cidade": "City",
                    "Email": "Email",
                    "Estado": "State",
                    "Observacoes": "Comments",
                    "ExigeAprovacaoDosTripulantes": "Requires authorized crew approval",
                    "Operador": "Operator",
                    "RequerEmailAbastecimento": "Refuel e-mail required?",
                    "botaoSalvarEdicao": "Save edit",
                    "placeholder": {
                        "NomeDoCliente": "Client name",
                        "SelecionarPais": "Select country",
                        "EnderecoDoCliente": "Customer address",
                        "TelefoneDoCliente": "Customer phone",
                        "CidadeDoCliente": "Customer city",
                        "EmailDoCliente": "Customer email",
                        "EstadoDoCliente": "Customer State/Province"
                    }
                },
                "adicionarNovoGrupo": "Add new group",
                "formularioNovoGrupo": {
                    "Nome": "Name",
                    "botaoSalvarGrupo": "Save group",
                    "placeholder": {
                        "NomeDoGrupo": "Group's name"
                    }
                }
            },
            "tabGrupoCliente": {
                "botaoEscalar": "Climb",
                "botaoDesescalar": "De-escalate",
                "botaoCOPIL": "COPIL",
                "botaoCDMT": "CDMT",
                "botaoCMS": "CMS",
                "deletarAeronave": "Are you sure you would like to delete this aircraft?",
                "deletarTripulante": "Are you sure you'd like to delete this crew member?",
                "tabelaAeronaves": {
                    "tituloAeronaves": "Aircraft",
                    "aeronavesDisponiveis": "Available",
                    "semAeronaves": "There are no registered aircraft",
                    "IDaeronave": "ID",
                    "Aeronave": "Aircraft",
                    "AcoesAeronave": "Actions",
                    "tituloEscalados": "Climbed",
                    "semAeronaveEscaladas": "There are no registered aircraft",
                    "IDaeronaveEscalada": "ID",
                    "AeronaveEscalada": "Aircraft",
                    "AcoesEscalada": "Actions"
                },
                "tabelaTripulantes": {
                    "tituloTripulantes": "Crew",
                    "tripulanteDisponivel": "Available",
                    "semTripulantes": "There are no registered crew",
                    "IDtripulante": "ID",
                    "Tripulante": "Crew member",
                    "AcoesTripulante": "Actions",
                    "tituloEscalados": "Climbed",
                    "semTripulantesEscalados": "There are no registered crew",
                    "IDescalado": "ID",
                    "TripulanteEscalado": "Crew member",
                    "CargoEscalado": "Role",
                    "AcoesEscalado": "Actions"
                }
            }
        }
    },
    "Empresas": {
        "ListaDeEmpresas": {
            "ativar": "Are you sure you would like to activate this company?",
            "arquivar": "Are you sure you'd like to archive this company?",
            "ativo": "Active",
            "arquivado": "Archived",
            "titulo": "List of companies",
            "botaoAdicionarEmpresa": "Add company",
            "tabela": {
                "semEmpresas": "No companies registered",
                "ID": "ID",
                "RazaoSocial": "Corporate Name",
                "Trigrama": "Trigram",
                "Acoes": "Actions"
            }
        },
        "AdicionarEmpresa": {
            "titulo": "Register company",
            "formulario": {
                "RazaoSocial": "Corporate Name",
                "Trigrama": "Trigram",
                "botaoAdicionarEmpresa": "Add company",
                "placeholder": {
                    "RazaoSocial": "Corporate Name",
                    "Trigrama": "Trigram"
                }
            }
        },
        "EditarEmpresa": {
            "titulo": "Edit company",
            "formulario": {
                "RazaoSocial": "Corporate Name",
                "Trigrama": "Trigram",
                "RequerEmailAbastecimento": "Refuel e-mail required?",
                "botaoEditarEmpresa": "Edit company",
                "placeholder": {
                    "RazaoSocial": "Corporate Name",
                    "Trigrama": "Trigram"
                }
            }
        }
    },
    "Contratos": {
        "ListaDeContratos": {
            "ativar": "Are you sure you'd like to activate this contract?",
            "arquivar": "Are you sure you'd like to archive this contract?",
            "ativo": "Active",
            "arquivado": "Archived",
            "titulo": "List of contracts",
            "botaoAdicionarContrato": "Add contract",
            "tabela": {
                "semContratos": "There are no registered contracts",
                "ID": "ID",
                "Aeronave": "Aircraft",
                "NumDeContrato": "Contract number",
                "Gerencia": "Management",
                "Expiracao": "Expiration",
                "Status": "Status",
                "Acoes": "Actions"
            }
        },
        "AdicionarContrato": {
            "titulo": "Register contract",
            "erros": "The following filling errors prevented the contract from being processed",
            "formulario": {
                "Cliente": "Client",
                "Aeronave": "Aircraft",
                "Tipo": "Type",
                "opcoesTipo": {
                    "TripulacaoRegular": "Regular Crew",
                    "TripulacaoNoturna": "Night Crew",
                    "TripulacaoMEDVAC": "MEDVAC crew",
                    "TripulacaoRegularComComissarios": "Regular crew - with flight attendants",
                    "TripulacaoNoturnaComComissarios": "Night Crew - with flight attendants",
                    "TripulacaoMEDVACComComissarios": "MEDVAC crew - with flight attendants"
                },
                "NumDeContrato": "Contract No.",
                "Gerencia": "Management",
                "IdadeMinimaEmAnos": "Minimum age (in years)",
                "IdadeMaximaEmAnos": "Maximum age (in years)",
                "Inicio": "Start",
                "Termino": "End",
                "DiaFixoDeVencimento": "Fixed Expiration Day",
                "TipoDePagamento": "Type of payment",
                "opcoesTipoDePagamento": {
                    "PartidaAoCorte": "Start to Shutdown",
                    "DecolagemAoPouso": "Takeoff to Landing"
                },
                "Consumo": "Consumption",
                "TempoDeDisponibilidade": "Availability Time",
                "HoraInicialDaDisponibilidade": "Availability Start Time",
                "BaseContratual": "Contract Base",
                "XML": "XML",
                "Noturno": "Nocturnal",
                "CargaExterna": "External load",
                "Comissarios": "Flight Attendants",
                "Fretamento": "Charter",
                "botaoAdicionarContrato": "Add contract",
                "placeholder": {
                    "SelecionarCliente": "Select customer",
                    "SelecionarAeronave": "Select aircraft",
                    "SelecionarTipo": "Select type",
                    "EstadoDoEmpregador": "Employer Status",
                    "NumeroDeContrato": "Contact number",
                    "Gerencia": "Management",
                    "IdadeMinimaEmAnos": "Minimum age (in years)",
                    "IdadeMaximaEmAnos": "Maximum age (in years)",
                    "DataDeInicio": "Start date",
                    "DataDeTermino": "End date",
                    "DiaFixoDeVencimento": "Fixed Expiration Day",
                    "TipoDePagamento": "Type of payment",
                    "Consumo": "Consumption",
                    "Disponibilidade": "Availability",
                    "HoraInicialDaDisponibilidade": "Availability Start Time"
                }
            }
        },
        "EditarContrato": {
            "deletar": "Are you sure you want to delete the request?",
            "titulo": "Edit Contract",
            "adicionarExcecao": "Add Exception",
            "formulario": {
                "Designacao": "Designation",
                "HorasDeVoo": "Flight hours",
                "Treinamento": "Training",
                "Personalizados": "Customized",
                "botaoAdicionarRequisito": "Add requirement",
                "placeholder": {
                    "SelecionarDesignacao": "Select designation",
                    "SelecionarRequisito": "Select requirement"
                }
            },
            "tabelaDesignacao": {
                "Designacao": "Designation",
                "Tipo": "Type",
                "RequisitoExcepcional": "Exceptional Requirement",
                "Acoes": "Actions"
            },
            "tabelaPrimeiroEUltimoVoo": {
                "titulo": "First and last flights of the contract",
                "ID": "ID",
                "NumDoVoo": "Flight No.",
                "Data": "Date"
            },
            "deletarBackup": "Are you sure you want to delete this backup?",
            "erros": "The following filling errors prevented the contract from being processed",
            "formularioCliente": {
                "Cliente": "Client",
                "Aeronave": "Aircraft",
                "Tipo": "Type",
                "opcoesTipo": {
                    "TripulacaoRegular": "Regular Crew",
                    "TripulacaoNoturna": "Night Crew",
                    "TripulacaoMEDVAC": "MEDVAC crew",
                    "TripulacaoRegularComComissarios": "Regular crew - with flight attendants",
                    "TripulacaoNoturnaComComissarios": "Night Crew - with flight attendants",
                    "TripulacaoMEDVACComComissarios": "MEDVAC crew - with flight attendants"
                },
                "NumDeContrato": "Contract No.",
                "Gerencia": "Management",
                "IdadeMinimaEmAnos": "Minimum age (in years)",
                "IdadeMaximaEmAnos": "Maximum age (in years)",
                "Inicio": "Start",
                "Termino": "End",
                "DiaFixoDeVencimento": "Fixed Expiration Day",
                "TipoDePagamento": "Type of payment",
                "opcoesTipoDePagamento": {
                    "PartidaAoCorte": "Start to Shutdown",
                    "DecolagemAoPouso": "Takeoff to Landing"
                },
                "Consumo": "Consumption",
                "TempoDeDisponibilidade": "Availability Time",
                "HoraInicialDaDisponibilidade": "Availability Start Time",
                "BaseContratual": "Contract Base",
                "XML": "XML",
                "Noturno": "Nocturnal",
                "CargaExterna": "External load",
                "Comissarios": "Flight Attendants",
                "Fretamento": "Charter",
                "botaoSalvarEdicao": "Save edit",
                "placeholder": {
                    "SelecionarCliente": "Select customer",
                    "SelecionarAeronave": "Select aircraft",
                    "EstadoDoEmpregador": "Employer Status",
                    "SelecionarTipo": "Select type",
                    "NumeroDeContrato": "Contact number",
                    "Gerencia": "Management",
                    "IdadeMinimaEmAnos": "Minimum age (in years)",
                    "IdadeMaximaEmAnos": "Maximum age (in years)",
                    "DataDeInicio": "Start date",
                    "DataDeTermino": "End date",
                    "DiaFixoDeVencimento": "Fixed Expiration Day",
                    "TipoDePagamento": "Type of payment",
                    "Consumo": "Consumption",
                    "Disponibilidade": "Availability",
                    "HoraInicialDaDisponibilidade": "Availability Start Time"
                }
            },
            "adicionarBackup": "Add Backup",
            "formularioAdicionarBackup": {
                "AeronaveBackup": "Backup aircraft",
                "Numero": "Number",
                "botaoSalvarBackup": "Save backup",
                "placeholder": {
                    "SelecionarAeronaveDeBackup": "Select backup aircraft"
                }
            },
            "backups": "Backups",
            "tabelaBackup": {
                "Numero": "Number",
                "Aeronave": "Aircraft",
                "Acoes": "Actions"
            }
        },
        "ConsultarContrato": {
            "titulo": "Contract consultation",
            "adicionarExcecao": "Add Exception",
            "formulario": {
                "SomenteAtivos": "Active Only",
                "Aeronave": "Aircraft",
                "Cliente": "Client",
                "TipoDeTripulacao": "Crew Type",
                "opcoesTipo": {
                    "TripulacaoRegular": "Regular Crew",
                    "TripulacaoNoturna": "Night Crew",
                    "TripulacaoMEDVAC": "MEDVAC crew",
                    "TripulacaoRegularComComissarios": "Regular crew - with flight attendants",
                    "TripulacaoNoturnaComComissarios": "Night Crew - with flight attendants",
                    "TripulacaoMEDVACComComissarios": "MEDVAC crew - with flight attendants"
                },
                "TipoDePagamento": "Type of payment",
                "opcoesTipoDePagamento": {
                    "PartidaAoCorte": "Start to Shutdown",
                    "DecolagemAoPouso": "Takeoff to Landing"
                },
                "BaseContratual": "Contract Base",
                "XML": "XML",
                "Noturno": "Nocturnal",
                "CargaExterna": "External load",
                "Comissarios": "Flight Attendants",
                "Fretamento": "Charter",
                "AeronaveBackup": "Backup Aircraft",
                "botaoDownloadXLS": "Download XLS"
            },
            "tabela": {
                "semContrato": "No contract found",
                "ID": "ID",
                "Ativo": "Active",
                "Cliente": "Client",
                "Aeronave": "Aircraft",
                "Frota": "Fleet",
                "TipoDeTripulacao": "Crew Type",
                "NumDeContrato": "Contract No.",
                "Gerencia": "Management",
                "IdadeMin": "Min. Age",
                "IdadeMax": "Age Max.",
                "Inicio": "Start",
                "Termino": "End",
                "DiaFixoDeVencimento": "Fixed Expiration Day",
                "TipoDePagamento": "Type of payment",
                "Consumo": "Consumption",
                "TempoDeDisponibilidade": "Availability Time",
                "HoraInicialDaDisponibilidade": "Availability Start Time",
                "BaseContratual": "Contract Base",
                "XML": "XML",
                "Noturno": "Nocturnal",
                "CargaExterna": "External Load",
                "Comissarios": "Flight Attendants",
                "Fretamento": "Charter",
                "Backups": "Backups",
                "Excecoes": "Exceptions"
            }
        }
    },
    "Designacoes": {
        "ListaDeDesignacoes": {
            "titulo": "List of designations",
            "botaoAdicionarDesignicao": "Add designation",
            "tabela": {
                "semDesignacoes": "There are no names registered",
                "ID": "ID",
                "Nome": "Name",
                "Iniciais": "Initials",
                "Acoes": "Actions"
            }
        },
        "AdicionarDesignacao": {
            "opcoesTipos": {
                "Comum": "Ordinary",
                "Instrutor": "Instructor",
                "Examinador": "Examiner"
            },
            "opcoesCargos": {
                "Comandante": "Captain",
                "Copiloto": "Co-pilot",
                "Comissario": "Commissioner"
            },
            "titulo": "Register designation",
            "formulario": {
                "Nome": "Name",
                "Iniciais": "Initials",
                "Tipo": "Type",
                "Funcao": "Occupation",
                "Prioridade": "Priority",
                "ChefeDeEquipamento": "Head of Equipment",
                "botaoAdicionarDesignicao": "Add designation",
                "placeholder": {
                    "SelecionarTipo": "Select type",
                    "SelecionarFuncao": "Select function"
                }
            }
        },
        "EditarDesignacao": {
            "titulo": "Edit Designation",
            "tabDadosDaDesignacao": {
                "listaDeTipos": {
                    "Comum": "Ordinary",
                    "Instrutor": "Instructor",
                    "Examinador": "Examiner"
                },
                "listaDeCargos": {
                    "Comandante": "Captain",
                    "Copiloto": "Co-pilot",
                    "Comissario": "Commissioner"
                },
                "tituloTab": "Designation data",
                "formulario": {
                    "Nome": "Name",
                    "Iniciais": "Initials",
                    "Tipo": "Type",
                    "Funcao": "Occupation",
                    "Prioridade": "Priority",
                    "ChefeDeEquipamento": "Head of Equipment",
                    "botaoSalvarEdicao": "Save edit",
                    "placeholder": {
                        "SelecionarTipo": "Select type",
                        "SelecionarFuncao": "Select function"
                    }
                }
            },
            "tabRequisitosHorasDeVoo": {
                "tituloTab": "Requirements - Flight Hours",
                "deletarRequisicaoDeHoras": "Are you sure you want to delete this time requirement?",
                "formulario": {
                    "Frota": "Fleet",
                    "TotalDeHorasDeVooEmModelosDeComplexidadeSimilar": "Total flight hours on models of similar complexity",
                    "TotalGeralDeHorasDeVoo": "Grand total flight hours",
                    "TotalDeHorasDeVooNoModeloExato": "Total flight hours on exact model",
                    "TotalDeHorasEmComando": "Total flight hours as captain",
                    "TotalDeHorasEmComandoNoModeloExato": "Total flight hours as captain on the exact model",
                    "TotalDeHorasDeVooComOTipoDeMotor": "Total flight hours with engine type",
                    "TotalDeHorasDeVooEmComandoNoTipoDeMotor": "Total flight hours on engine type as captain",
                    "TotalDeHorasDeVooEmIFR": "Total flight hours under IFR",
                    "TotalDeHorasDeVooEmModeloDeMesmoPorte": "Total flight hours in a model of the same size",
                    "Nome": "Name",
                    "Excecao": "Exception",
                    "botaoAdicionarRequisito": "Add requirement",
                    "placeholder": {
                        "SelecionarFrota": "Select fleet",
                        "TotalDeHorasDeVooEmModelosDeComplexidadeSimilar": "Total flight hours on models of similar complexity",
                        "TotalGeralDeHorasDeVoo": "Grand total flight hours",
                        "TotalDeHorasDeVooNoModeloExato": "Total flight hours on exact model",
                        "TotalDeHorasEmComando": "Total flight hours as captain",
                        "TotalDeHorasEmComandoNoModeloExato": "Total flight hours as captain on the exact model",
                        "TotalDeHorasDeVooComOTipoDeMotor": "Total flight hours with engine type",
                        "TotalDeHorasDeVooEmComandoNoTipoDeMotor": "Total flight hours on engine type as captain",
                        "TotalDeHorasDeVooEmIFR": "Total flight hours under IFR",
                        "TotalDeHorasDeVooEmModeloDeMesmoPorte": "Total flight hours in a model of the same size",
                        "NomeDoRegistro": "Requirement name"
                    }
                },
                "tabela": {
                    "Frota": "Fleet",
                    "Nome": "Name",
                    "Total": "Total",
                    "UmP": "1P",
                    "Motor": "Motor",
                    "Similar": "Similar",
                    "IFR": "IFR",
                    "UmPFrota": "1P Fleet",
                    "Porte": "Size",
                    "Excecao": "Exception",
                    "Acoes": "Actions",
                    "SIM": "Yes",
                    "NAO": "No"
                },
                "deletarGrupo": "Are you sure you would like to delete this group?",
                "tituloEditarCertificadoFornecedor": "Edit Certification/Vendor",
                "tituloEditarRequisitos": "Edit requirements",
                "formularioEditarRequisito": {
                    "Frota": "Fleet",
                    "TotalDeHorasDeVooEmModelosDeComplexidadeSimilar": "Total flight hours on models of similar complexity",
                    "TotalGeralDeHorasDeVoo": "Grand total flight hours",
                    "TotalDeHorasDeVooNoModeloExato": "Total flight hours on exact model",
                    "TotalDeHorasEmComando": "Total flight hours as captain",
                    "TotalDeHorasEmComandoNoModeloExato": "Total flight hours as captain on the exact model",
                    "TotalDeHorasDeVooComOTipoDeMotor": "Total flight hours with engine type",
                    "TotalDeHorasDeVooEmComandoNoTipoDeMotor": "Total flight hours on engine type as captain",
                    "TotalDeHorasDeVooEmIFR": "Total flight hours under IFR",
                    "TotalDeHorasDeVooEmModeloDeMesmoPorte": "Total flight hours in a model of the same size",
                    "Nome": "Name",
                    "Excecao": "Exception",
                    "botaoEditarRequisito": "Edit requirement",
                    "placeholder": {
                        "SelecionarFrota": "Select fleet",
                        "TotalDeHorasDeVooEmModelosDeComplexidadeSimilar": "Total flight hours on models of similar complexity",
                        "TotalGeralDeHorasDeVoo": "Grand total flight hours",
                        "TotalDeHorasDeVooNoModeloExato": "Total flight hours on exact model",
                        "TotalDeHorasEmComando": "Total flight hours as captain",
                        "TotalDeHorasEmComandoNoModeloExato": "Total flight hours as captain on the exact model",
                        "TotalDeHorasDeVooComOTipoDeMotor": "Total flight hours with engine type",
                        "TotalDeHorasDeVooEmComandoNoTipoDeMotor": "Total flight hours on engine type as captain",
                        "TotalDeHorasDeVooEmIFR": "Total flight hours under IFR",
                        "TotalDeHorasDeVooEmModeloDeMesmoPorte": "Total flight hours in a model of the same size",
                        "NomeDoRegistro": "Requirement name"
                    }
                }
            },
            "tabRequisitosCertificados": {
                "tituloTab": "Requirements - Certifications",
                "deletarGrupo": "Are you sure you would like to delete this group?",
                "tituloAdicionarNovoGrupo": "Add new group",
                "formulario": {
                    "Nome": "Name",
                    "Tipo": "Type",
                    "opcoesTipo": {
                        "E": "AND",
                        "OU": "OR"
                    },
                    "Frota": "Fleet",
                    "Excecao": "Exception",
                    "botaoSalvarGrupo": "Save group",
                    "placeholder": {
                        "NomeDoGrupo": "Group's name",
                        "SelecioneTipo": "Select the type",
                        "SelecionarFrota": "Select fleet"
                    }
                },
                "deletarTreinamento": "Are you sure you would like to delete this training?",
                "formularioEditarGrupo": {
                    "Nome": "Name",
                    "Tipo": "Type",
                    "opcoesTipo": {
                        "E": "AND",
                        "OU": "OR"
                    },
                    "Frota": "Fleet",
                    "Excecao": "Exception",
                    "botaoEditarGrupo": "Edit group",
                    "placeholder": {
                        "NomeDoGrupo": "Group's name",
                        "SelecioneTipo": "Select the type",
                        "SelecionarFrota": "Select fleet"
                    }
                },
                "formularioIncluirTreinamento": {
                    "Treinamento": "Training",
                    "botaoIncluirTreinamento": "Include training",
                    "placeholder": {
                        "SelecionarTreinamento": "Select training"
                    }
                },
                "tabela": {
                    "Treinamento": "Training",
                    "Acoes": "Actions"
                }
            },
            "tabRequisitosPersonalizados": {
                "tituloTab": "Requirements - Customized",
                "deletarRequisicaoDeHoras": "Are you sure you want to delete this time request?",
                "formulario": {
                    "Nome": "Name",
                    "Tipo": "Type",
                    "opcoesTipo": {
                        "LimiteDeHorasDeVoo": "Flight Hour Limit",
                        "LimiteDeHorasDeJornada": "Working Hours Limit"
                    },
                    "LimiteDeHoras": "Hour limit",
                    "DiasCorridos": "Calendar days",
                    "botaoAdicionarRequisito": "Add requirement",
                    "placeholder": {
                        "NomeDoRequisito": "Requirement name",
                        "SelecionarTipo": "Select type",
                        "LimiteDeHoras": "Hour limit",
                        "DiasCorridos": "Calendar days"
                    }
                },
                "tabela": {
                    "Nome": "Name",
                    "Tipo": "Type",
                    "LimiteDeHoras": "Hour limit",
                    "DiasCorridos": "Calendar days",
                    "Excecao": "Exception",
                    "Acoes": "Actions",
                    "SIM": "Yes",
                    "NAO": "No"
                },
                "tituloEditarCertificadoFornecedor": "Edit Certification/Vendor",
                "tituloEditarRequisitos": "Edit requirements",
                "formularioEditarRequisito": {
                    "Nome": "Name",
                    "Tipo": "Type",
                    "botaoEditarRequisito": "Edit requirement",
                    "opcoesTipo": {
                        "LimiteDeHorasDeVoo": "Flight Hour Limit",
                        "LimiteDeHorasDeJornada": "Working Hours Limit"
                    },
                    "LimiteDeHoras": "Hour limit",
                    "DiasCorridos": "Calendar days",
                    "botaoEditarRequisito": "Edit requirement",
                    "placeholder": {
                        "Nome": "Name",
                        "SelecionarTipo": "Select type",
                        "LimiteDeHoras": "Hour limit",
                        "DiasCorridos": "Total calendar days"
                    }
                }
            }
        }
    },
    "Documentos": {
        "ListaDeDocumentos": {
            "deletar": "Are you sure you would like to delete this document?",
            "titulo": "Documents list",
            "botaoAdicionarDocumento": "Documents list",
            "tabela": {
                "semDocumentos": "There are no registered documents",
                "ID": "ID",
                "Nome": "Name",
                "Acoes": "Actions"
            }
        },
        "AdicionarDocumentos": {
            "titulo": "Register document",
            "forumlario": {
                "Nome": "Name",
                "botaoAdicionarDocumento": "Add document",
                "placeholder": {
                    "NomeDoDocumento": "Document name"
                }
            }
        },
        "EditarDocumentos": {
            "titulo": "Edit document",
            "formulario": {
                "Nome": "Name",
                "botaoSalvarEdicao": "Save edit",
                "placeholder": {
                    "RegistroDeDocumento": "Document registration"
                }
            }
        }
    },
    "EscalasDeTesteDeSonolencia": {
        "ListaDeEscalasDeTesteDeSonolencia": {
            "titulo": "List of drowsiness test scales",
            "botaoAdicionarEscala": "Add scale",
            "tabela": {
                "semEscalas": "There are no test scales registered",
                "ID": "ID",
                "Nome": "Name",
                "DataInicial": "Initial date",
                "DataFinal": "Final date",
                "Acoes": "Actions"
            }
        },
        "AdicionarEscalaDeSonolencia": {
            "aguardeEnquantoAEscalaGerada": "Please wait while the scale is generated. This process can take a few minutes.",
            "titulo": "Register drowsiness test scale",
            "formulario": {
                "Nome": "Name",
                "HorariosDeEnvio": "Sending times",
                "DataInicial": "Initial date",
                "DataFinal": "Final date",
                "AplicabilidadeTipoDeColaborador": "Applicability - Type of Employee",
                "Tripulantes": "Crew",
                "Mecanicos": "Mechanics",
                "Coordenadores": "Coordinators",
                "botaoAdicionarEscalaDeTeste": "Add test scale",
                "placeholder": {
                    "NomeDaEscalaDeSonolencia": "Sleepiness scale name",
                    "HorariosDeEnvio": "Hh:mm, separated by a comma.",
                    "SelecionarAplicabilidade": "Select applicability"
                }
            }
        },
        "EditarEscalaDeSonolencia": {
            "trocarStatusDaEscala": "Are you sure you would like to change the scale status?",
            "trocarStatusDaEscalaParaAprovado": "Are you sure you'd like to change the escalation status to approved?",
            "trocarStatusDaEscalaParaFinalizado": "Are you sure you'd like to change the status of the scale to finished?",
            "titulo": "Edit Sleepiness scale",
            "botaoDeFichas": {
                "TrocarParaAprovado": "Switch to approved",
                "TrocarParaFinalizado": "Switch to finished"
            },
            "tabDadosDaEscala": {
                "tituloTab": "Scale data",
                "formulario": {
                    "Nome": "Name",
                    "DataInicial": "Initial date",
                    "DataFinal": "Final date",
                    "botaoSalvarEdicao": "Save edit",
                    "placeholder": {
                        "NomeDaEscalaDeSonolencia": "Sleepiness scale name"
                    }
                }
            },
            "tabTestesDeEscala": {
                "tituloTab": "Scale tests",
                "deletarColaboradorDaEscalaDeTeste": "Are you sure you'd like to delete this contributor from the roster of tests?",
                "tituloTestesDeEscalaDeSonolencia": "Sleepiness scale tests",
                "tabela": {
                    "semColaboradores": "There are no registered employees",
                    "ID": "ID",
                    "Colaborador": "Collaborator",
                    "ProgramacaoDeEnvio": "Sending Schedule",
                    "Acoes": "Actions"
                },
                "tituloEditarTeste": "Edit test",
                "formulario": {
                    "Data": "Date",
                    "HorariosDeEnvio": "Sending time",
                    "Colaborador": "Collaborator",
                    "botaoSalvarEdicao": "Save edit",
                    "placeholder": {
                        "SelecionarAplicabilidade": "Select applicability"
                    }
                }
            },
            "tabRelatorioFinal": {
                "tituloTab": "Final report",
                "formulario": {
                    "PeriodoDeJornada": "Working Period",
                    "DiasDeJornada": "Journey days",
                    "Bases": "Bases",
                    "Designacoes": "Designations",
                    "Funcoes": "Functions",
                    "Cargos": "Roles",
                    "Frotas": "Fleets",
                    "Grupos": "Groups",
                    "botaoProcurarRelatorios": "Browse reports",
                    "placeholder": {
                        "SelecionarPeriodoDeJornada": "Select journey times",
                        "DiasDeJornada": "Days, separated by a comma. Ex.: 01, 02, 10, 11, etc.",
                        "SelecionarBases": "Select bases",
                        "SelecionarDesignacoes": "Select designations",
                        "SelecionarFuncoes": "Select functions",
                        "SelecionarCargos": "Select roles",
                        "SelecionarFrotas": "Select fleets",
                        "SelecionarGrupos": "Select groups"
                    }
                },
                "tituloPontosPorHorarioDeResposta": "Points for response time",
                "paragrafoPercentualDeAdesaoParcial": "Partial adherence percentage (to date)",
                "paragrafoPercentualDeAdesaoGlobal": "Global adherence percentage",
                "paragrafoTempoMedioDeResposta": "Average response time",
                "paragrafoTotalRespostas": "Total answers",
                "tituloCadaHorarioDeResposta": "Every response time",
                "tabelaHorariosDeResposta": {
                    "PeriodoHoras": "Period hours",
                    "Total": "Total",
                    "Pontos": "Points",
                    "Media": "Average"
                },
                "tituloPontosPorPeriodoDeJornada": "Points per journey period",
                "tabelaPontosPorPeriodoDeJornada": {
                    "PeriodoHoras": "Period hours",
                    "Total": "Total",
                    "Pontos": "Points",
                    "Media": "Average"
                },
                "tituloPontosPorDiasDeJornada": "Points per journey days",
                "tabelaPontosPorDiasDeJornada": {
                    "PeriodoDias": "Period days",
                    "Total": "Total",
                    "Pontos": "Points",
                    "Media": "Average"
                },
                "tituloBases": "Bases",
                "tabelaBases": {
                    "Base": "Base",
                    "Total": "Total",
                    "Pontos": "Points",
                    "Media": "Average"
                },
                "tituloFuncoes": "Functions",
                "tabelaFuncoes": {
                    "Funcao": "Occupation",
                    "Total": "Total",
                    "Pontos": "Points",
                    "Media": "Average"
                },
                "tituloGrupos": "Groups",
                "tabelaGrupos": {
                    "Grupo": "Group",
                    "Total": "Total",
                    "Pontos": "Points",
                    "Media": "Average"
                },
                "tituloDesignacoes": "Designations",
                "tabelaDesignacoes": {
                    "Designacao": "Designation",
                    "Total": "Total",
                    "Pontos": "Points",
                    "Media": "Average"
                },
                "tituloFrotas": "Fleets",
                "tabelaFrotas": {
                    "Frota": "Fleet",
                    "Total": "Total",
                    "Pontos": "Points",
                    "Media": "Average"
                }
            }
        }
    },
    "FuncoesDeBordo": {
        "ListaDeFuncoesDeBordo": {
            "deletar": "Are you sure you would like to delete this role?",
            "titulo": "List of on-board functions",
            "botaoAdicionarFuncaoDeBordo": "Add board function",
            "tabela": {
                "semFuncoesDeBordo": "There are no registered on-board functions",
                "ID": "ID",
                "Nome": "Name",
                "Abreviacao": "Abbreviation",
                "CodigoANAC": "ANAC code",
                "Funcao": "Occupation",
                "Instrutor": "Instructor",
                "PermiteCopilotoLancarHorasDeComando": "Allows Co-Pilot to Enter Command Hours",
                "Acoes": "Actions"
            }
        },
        "AdicionarFuncaoDeBordo": {
            "titulo": "Register role on board",
            "formulario": {
                "Nome": "Name",
                "Abreviacao": "Abbreviation",
                "CodigoANAC": "ANAC code",
                "Funcao": "Occupation",
                "opcoesFuncao": {
                    "CMDT": "CMDT",
                    "COPIL": "COPIL",
                    "CMS": "CMS"
                },
                "Instrutor": "Instructor",
                "PermiteCopilotoRealizarHorasEmComandoDesdePossuaOsRequisitos": "Allows the co-pilot to perform hours in command as long as he has the specific requirements",
                "placeholder": {
                    "SelecioneCodigoANAC": "Select ANAC code",
                    "SelecioneFuncao": "Select function"
                }
            }
        },
        "EditarFuncaoDeBordo": {
            "titulo": "Edit board function",
            "formulario": {
                "Nome": "Name",
                "Abreviacao": "Abbreviation",
                "CodigoANAC": "ANAC code",
                "Funcao": "Occupation",
                "opcoesFuncao": {
                    "CMDT": "CMDT",
                    "COPIL": "COPIL",
                    "CMS": "CMS"
                },
                "Instrutor": "Instructor",
                "PermiteCopilotoRealizarHorasEmComandoDesdePossuaAutorizacao": "Allows the co-pilot to perform hours in command as long as he has the specific requirements",
                "placeholder": {
                    "SelecioneCodigoANAC": "Select ANAC code",
                    "SelecioneFuncao": "Select function"
                }
            }
        }
    },
    "ParametrosDeFadigas": {
        "ListaDeParametrosDeFadigas": {
            "deletar": "Are you sure you'd like to delete this fatigue parameter?",
            "titulo": "List of fatigue parameters",
            "botaoAdicionarFadiga": "Add fatigue",
            "tabela": {
                "semParametroDeFadiga": "There are no registered fatigue parameters",
                "ID": "ID",
                "Aplicabilidade": "Applicability",
                "Nome": "Name",
                "Tipo": "Type",
                "Operador": "Operator",
                "PontosPorHora": "PointsPerHour",
                "PontosPorQuantidade": "Points per quantity",
                "LimiteDePontos": "Point limit",
                "ObrigatorioPreenchimento": "Mandatory completion",
                "Acoes": "Actions"
            }
        },
        "AdicionarParametroDeFadiga": {
            "titulo": "Register effectiveness sections",
            "formulario": {
                "Nome": "Name",
                "AplicabilidadeTipoDeColaborador": "Applicability - Type of Employee",
                "botaoAdicionarParametroDeFadiga": "Add fatigue parameter",
                "placeholder": {
                    "NomeDaSecaoDeEfetividade": "Effectiveness section name",
                    "SelecionarAplicabilidade": "Select applicability"
                }
            }
        },
        "EditarParametroDeFadiga": {
            "opcoesTipos": {
                "Quantidade": "The amount",
                "Tempo": "Time"
            },
            "deletar": "Are you sure you would like to delete this option?",
            "titulo": "Edit effectiveness section",
            "formulario": {
                "Nome": "Name",
                "Aplicabilidade": "Applicability",
                "placeholder": {
                    "NomeDaSecaoDeEfetividade": "Effectiveness section name",
                    "SelecionarCliente": "Select customer"
                }
            },
            "tituloAdicionarParametrosDaSecao": "Add Section Parameters",
            "formularioAdicionarParametrosDaSecao": {
                "Nome": "Name",
                "Tipo": "Type",
                "ParametroObrigatorio": "Mandatory Parameter",
                "ParametroAutomatico": "Automatic parameter",
                "TipoDeAutomacao": "Automation type",
                "placeholder": {
                    "NomeDaSecaoDeEfetividade": "Effectiveness section name",
                    "SelecionarTipoDoCampo": "Select field type",
                    "SelecionarTipo": "Select type"
                }
            },
            "tituloParametrosDaSecao": "Section parameters",
            "tabela": {
                "Nome": "Name",
                "Automatico": "Automatic",
                "Acoes": "Actions"
            }
        }
    },
    "Emails": {
        "ConfiguracaoDeEmailsDestinatario": {
            "titulo": "Recipient email configuration",
            "tabela": {
                "semAeronaves": "There are no registered aircraft",
                "ID": "ID",
                "TipoDeEnvio": "Sending type",
                "Acoes": "Actions"
            }
        },
        "EditarEmail": {
            "deletar": "Are you sure you'd like to delete this email address?",
            "titulo": "Email recipients",
            "tituloCadastrarEmail": "Register email",
            "formulario": {
                "Email": "Email",
                "botaoSalvarEdicao": "Save edit"
            },
            "tituloEmailsCadastrados": "Registered emails",
            "tabela": {
                "semEmails": "There are no registered emails",
                "ID": "ID",
                "TipoDeEnvio": "Sending type",
                "Acoes": "Actions"
            }
        }
    },
    "Fadigas": {
        "ListaDeFadigas": {
            "deletar": "Are you sure you'd like to delete this fatigue parameter?",
            "titulo": "List of fatigue parameters",
            "botaoAdicionarFadiga": "Add Fatigue",
            "tabela": {
                "semParametroDeFadiga": "There are no registered fatigue parameters",
                "ID": "ID",
                "Aplicabilidade": "Applicability",
                "Nome": "Name",
                "Tipo": "Type",
                "Operador": "Operator",
                "PontosPorHora": "PointsPerHour",
                "PontosPorQuantidade": "Points per quantity",
                "LimiteDePontos": "Point limit",
                "ObrigatorioPreenchimento": "Mandatory completion",
                "Acoes": "Actions"
            }
        },
        "AdicionarFadiga": {
            "titulo": "Register fatigue parameter",
            "formulario": {
                "Nome": "Name",
                "Tipo": "Type",
                "Operador": "Operator",
                "PontosPorHora": "Points per hour",
                "PontosPorQuantidade": "Points per quantity",
                "LimiteDePontos": "Point limit",
                "PontuacaoExtraPorHoraNoturna": "Extra Score for Night Time",
                "AplicabilidadeTipoDeColaborador": "Applicability - Type of Employee",
                "PontosAReduzirParaTreinamento": "Points to reduce for training",
                "ParametroObrigatorio": "Mandatory Parameter",
                "ParametroAutomatico": "Automatic parameter",
                "TipoDeAutomacao": "Automation type",
                "tituloAlertas": "Alerts",
                "LimiteMaximoDePontos": "Max points limit",
                "LimiteMinimoDePontos": "Minimum point limit",
                "LimiteDePontosDeHoraExtraPorSemana": "Limit of overtime points per week",
                "LimiteDePontosDeHoraExtraPorMes": "Limit of overtime points per month",
                "LimiteDeDiasComHoraExtraPorSemana": "Limit of overtime days per week",
                "LimiteDeDiasComHoraExtraPorMes": "Limit of days with overtime per month",
                "botaoAdicionarParametroDeFadiga": "Add fatigue parameter",
                "placeholder": {
                    "NomeDoParametroDeFadiga": "Fatigue parameter name",
                    "SelecionarTipo": "Select type",
                    "SelecionarOperador": "Select operator",
                    "QuantidadeDePontosPorHora": "Number of points per hour",
                    "QuantidadeDePontosPorQuantidade": "Number of points per amount",
                    "LimiteDePontosDoParametro": "Parameter point limit",
                    "PontuacaoExtraPorHoraNoturna": "Extra Score for Night Time",
                    "SelecionarAplicabilidade": "Select applicability",
                    "PontosAReduzirParaTreinamento": "Points to reduce for training",
                    "ParametroObrigatorio": "Mandatory Parameter",
                    "ParametroAutomatico": "Automatic parameter",
                    "LimiteMaximoDePontos": "Max points limit",
                    "LimiteMinimoDePontos": "Minimum point limit"
                }
            }
        },
        "EditarFadiga": {
            "deletar": "Are you sure you would like to delete this option?",
            "titulo": "Edit Fatigue Parameter",
            "formulario": {
                "Nome": "Name",
                "Tipo": "Type",
                "Operador": "Operator",
                "PontosPorHora": "Points per hour",
                "PontosPorQuantidade": "Points per quantity",
                "LimiteDePontos": "Point limit",
                "PontuacaoExtraPorHoraNoturna": "Extra Score for Night Time",
                "AplicabilidadeTipoDeColaborador": "Applicability - Type of Employee",
                "PontosAReduzirParaTreinamento": "Points to reduce for training",
                "ParametroObrigatorio": "Mandatory Parameter",
                "ParametroAutomatico": "Automatic parameter",
                "TipoDeAutomacao": "Automation type",
                "tituloAlertas": "Alerts",
                "LimiteMaximoDePontos": "Max points limit",
                "LimiteMinimoDePontos": "Minimum point limit",
                "LimiteDePontosDeHoraExtraPorSemana": "Limit of overtime points per week",
                "LimiteDePontosDeHoraExtraPorMes": "Limit of overtime points per month",
                "LimiteDeDiasComHoraExtraPorSemana": "Limit of overtime days per week",
                "LimiteDeDiasComHoraExtraPorMes": "Limit of days with overtime per month",
                "placeholder": {
                    "NomeDoParametroDeFadiga": "Fatigue parameter name",
                    "SelecionarCliente": "Select customer",
                    "QuantidadeDePontosPorHora": "Number of points per hour",
                    "QuantidadeDePontosPorQuantidade": "Number of points per amount",
                    "LimiteDePontosDoParametro": "Parameter point limit",
                    "PontuacaoExtraPorHoraNoturna": "Extra Score for Night Time",
                    "SelecionarAplicabilidade": "Select applicability",
                    "PontosAReduzirParaTreinamento": "Points to reduce for training",
                    "ParametroObrigatorio": "Mandatory Parameter",
                    "ParametroAutomatico": "Automatic parameter",
                    "SelecionarTipo": "Select type",
                    "LimiteMaximoDePontos": "Max points limit",
                    "LimiteMinimoDePontos": "Minimum point limit"
                }
            },
            "tituloAdicionarOpcoes": "Add options",
            "formularioAdicionarOpcoes": {
                "Nome": "Name",
                "Pontos": "Spots",
                "placeholder": {
                    "NomeDoParametroDeFadiga": "Fatigue parameter name",
                    "QuantidadeDePontos": "Amount of points"
                }
            },
            "tituloOpcoes": "Options",
            "tabela": {
                "Opcao": "Option",
                "Pontos": "Spots",
                "Acoes": "Actions"
            }
        }
    },
    "RelatoriosAuxiliaresFadiga": {
        "ProcurarRelatorioAuxiliar": {
            "titulo": "Statistics (FAPA)",
            "formulario": {
                "DataInicial": "Initial date",
                "DataFinal": "Final date"
            },
            "tituloResultadosDeAutoavaliacoes": "Self-Assessment Results",
            "tabela": {
                "semParametroDeFadiga": "There are no registered fatigue parameters",
                "ID": "ID",
                "Data": "Date",
                "Colaborador": "Collaborator",
                "Questao1": "Question 1",
                "Questao2": "Question 2",
                "Questao3": "Question 3",
                "Questao4": "Question 4",
                "PontuacaoFinal": "Final score"
            }
        },
        "AdicionarRelatorioAuxiliar": {
            "titulo": "Fatigue Self-Assessment Aid Tool (FAPA)",
            "formulario": {
                "tituloQuestao1QuaoAlertaVoceEsta": "Question 1: How alert do you think you are? (Consider your condition before taking the journey)",
                "tituloQuestao2VoceTeveSonoAdequado": "Question 2: Did you get adequate sleep?",
                "QuantoTempoDormiuNas24HorasAnteriores": "At the beginning of the journey, how long did you sleep in the previous 24 hours?",
                "QuantoTempoDormiuNas48HorasAnteriores": "At the beginning of the journey, how long did you sleep in the previous 48 hours?",
                "AoFimDaJornadaPorQuantasHorasTeraPermanicidoAcordado": "At the end of the scheduled journey, how many hours will you have remained awake, discounting any time allocated for rest in suitable accommodation or rest on board when composing an increased crew?",
                "tituloQuestao3QueHorasOcorreAPresenteJornada": "Question 3: What time does this journey take place?",
                "tituloQuestao4QualNivelDeRiscoOperacionalAssociado": "Question 4: What is the level of operational risk associated with the journey?",
                "Rota": "Route",
                "Aeroportos": "Airports",
                "EspacoAereo": "Airspace",
                "NivelExperienciaTripulacao": "Crew Experience Level",
                "CaracteristicasEOperacionalidadeDaAeronave": "Aircraft characteristics and operability",
                "CondicoesAtmosfericas": "Atmosphere conditions",
                "botaoGerarAvaliacao": "Generate Assessment",
                "Opcoes": {
                    "Baixo": "Low",
                    "Moderado": "Moderate",
                    "Elevado": "High"
                },
                "placeholder": {
                    "SelecioneUmaOpcao": "Select an option"
                }
            },
            "tituloQuestao1QuaoAlertaVoceEsta": "Question 1: How alert do you think you are? (Consider your condition before taking the journey)",
            "tituloQuestao2VoceTeveSonoAdequado": "Question 2: Did you get adequate sleep?",
            "QuantoTempoDormiuNas24HorasAnteriores": "At the beginning of the journey, how long did you sleep in the previous 24 hours?",
            "QuantoTempoDormiuNas48HorasAnteriores": "At the beginning of the journey, how long did you sleep in the previous 48 hours?",
            "AoFimDaJornadaPorQuantasHorasTeraPermanicidoAcordado": "At the end of the scheduled journey, how many hours will you have remained awake, discounting any time allocated for rest in suitable accommodation or rest on board when composing an increased crew?",
            "pontos": "Spots",
            "tituloQuestao3QueHorasOcorreAPresenteJornada": "Question 3: What time does this journey take place?",
            "tituloQuestao4QualNivelDeRiscoOperacionalAssociado": "Question 4: What is the level of operational risk associated with the journey?",
            "paragrafoNota": "Note",
            "paragrafoSeORiscoElevadoEstiverPresenteInformarAoDespachoOperacional": "If Elevated Risk is present, it is recommended to consider risk controls such as napping, task rotation or informing the operational dispatch that you are not fit for duty.",
            "paragrafoPontuacao": "Punctuation",
            "paragrafoSeORiscoElevadoEstiverPresenteInformarAoOperador": "If Elevated Risk is present, it is recommended to consider risk controls such as napping, task rotation or informing the operator that you are not fit for duty.",
            "rota": "Route",
            "aeroportos": "Airports",
            "espacoAereo": "Airspace",
            "nivelExperienciaTripulacao": "Crew Experience Level",
            "caracteristicasEOperacionalidadeDaAeronave": "Aircraft characteristics and operability",
            "condicoesAtmosfericas": "Atmosphere conditions",
            "tituloResultadoDosRiscos": "Result of the risks",
            "paragrafoOrientacaoAoTripulante": "Crew Member Orientation",
            "paragrafoMecaONivelDeAlertaTripulacaoAumentada": "Measure the alert level using objective and subjective methods and discuss with your supervisor why your alert level may not be sufficient for this journey and consider being scheduled for another journey in order to manage the risk (e.g. in increased crew , longer rest period).",
            "paragrafoMecaONivelDeAlertaChochilo": "Measure alertness using objective and subjective methods, discuss with your supervisor whether your alertness level is adequate for this journey, and consider using additional mitigation strategies (eg nap, task rotation).",
            "paragrafoMecaONivelDeAlertaCafeina": "Measure alertness using both objective and subjective methods, discuss with your supervisor whether your alertness level is appropriate for this journey, and consider fatigue risk controls beneficial for this journey (e.g. use of caffeine, increased care with hydration and food)."
        }
    },
    "Formularios": {
        "FormulariosMensais": {
            "deletar": "Are you sure you'd like to delete this fatigue parameter?",
            "titulo": "Monthly forms",
            "botaoAdicionarFormulario": "Add form",
            "tabela": {
                "ID": "ID",
                "MesAno": "Month year",
                "Acoes": "Actions"
            }
        },
        "CadastrarFormulario": {
            "mensagemFormularioEstaSendoGerado": "The form is being generated. This action may take a few minutes.",
            "titulo": "Monthly form",
            "formulario": {
                "Data": "Date",
                "Aplicabilidade": "Applicability",
                "placeholder": {
                    "SelecionarAplicabilidade": "Select applicability",
                    "Horas": "Hours",
                    "Quantidade": "The amount"
                },
                "botaoCadastrarFormulario": "Register form"
            }
        },
        "EditarFormulario": {
            "titulo": "Monthly form",
            "formulario": {
                "Data": "Date",
                "Aplicabilidade": "Applicability",
                "placeholder": {
                    "SelecionarAplicabilidade": "Select applicability",
                    "Horas": "Hours",
                    "Quantidade": "The amount"
                },
                "botaoEditarFormulario": "Edit form"
            }
        },
        "ProcurarFormulario": {
            "titulo": "Monthly form",
            "formulario": {
                "Inicio": "Start",
                "Termino": "End",
                "Aplicabilidade": "Applicability",
                "placeholder": {
                    "SelecionarBase": "Select base"
                }
            },
            "tituloListaDeFormulariosDeEfetividade": "List of effectiveness forms",
            "tabela": {
                "Secao": "Section",
                "Subsecao": "Subsection",
                "Campo": "Field"
            }
        }
    },
    "ReportesDeFadigas": {
        "ListaDeReportesDeFadigasAbertos": {
            "tituloMotivo": "Reason",
            "tituloObservacoes": "Comments",
            "botaoConfirmarVisualizacao": "Confirm view",
            "titulo": "List of Voluntary Fatigue Reports - Open",
            "tabela": {
                "semParametroDeFadiga": "There are no registered fatigue parameters",
                "ID": "ID",
                "Tripulante": "Crew member",
                "Data": "Date",
                "Acoes": "Actions"
            }
        },
        "ListaDeReportesDeFadigasFechados": {
            "tituloMotivo": "Reason",
            "tituloObservacoes": "Comments",
            "titulo": "List of Voluntary Fatigue Reports - Closed",
            "tabela": {
                "semParametroDeFadiga": "There are no registered fatigue parameters",
                "ID": "ID",
                "Tripulante": "Crew member",
                "Data": "Date",
                "Acoes": "Actions"
            }
        },
        "AdicionarReporteDeFadiga": {
            "titulo": "Voluntary fatigue report",
            "formulario": {
                "Motivo": "Reason",
                "Data": "Date",
                "OProblemaApresentadoPodeSerAlgoPontual": "Can the problem presented be considered punctual, that is, is it something that allows you to return to activities on the next mission day?",
                "Observacoes": "Comments",
                "botaoEnviarReporte": "Send report",
                "placeholder": {
                    "SelecionarMotivo": "Select reason",
                    "SelecionarOpcao": "Select option"
                }
            }
        },
        "EditarMotivosDeFadiga": {
            "deletar": "Are you sure you would like to delete this fatigue reason?",
            "titulo": "Edit Fatigue Reasons",
            "formulario": {
                "Nome": "Name",
                "placeholder": {
                    "NomeDoMotivoDeFadiga": "Fatigue reason name"
                }
            },
            "tituloMotivosDeFadigaCadastrados": "Registered reasons for fatigue",
            "tabela": {
                "Nome": "Name",
                "Acoes": "Actions"
            }
        }
    },
    "TestesDeFadiga": {
        "PesquisaDeRelatorios": {
            "titulo": "Report search",
            "formulario": {
                "AplicabilidadeTipoDeColaborador": "Applicability - Type of Employee",
                "Tripulantes135": "Crew - 135",
                "Tripulantes121": "Crew - 121",
                "Mecanicos": "Mechanics",
                "Coordenadores": "Coordinators",
                "DataInicial": "Initial date",
                "DataFinal": "Final date",
                "MotivoDoEnvio": "Reason for submission",
                "Respondido": "Answered",
                "botaoProcurarQuestionarios": "Browse surveys",
                "placeholder": {
                    "SelecionarAplicabilidade": "Select applicability",
                    "SelecionarTripulante": "Select crew member",
                    "SelecionarMecanico": "Select mechanic",
                    "SelecionarCoordenador": "Select coordinator",
                    "SelecionarMotivos": "Select reasons",
                    "SelecionarStatus": "Select status"
                }
            },
            "tituloListaDeQuestionarios": "List of questionnaires",
            "tabelaListaDeQuestionarios": {
                "semQuestionarios": "There are no registered questionnaires",
                "Data": "Date",
                "Colaborador": "Collaborator",
                "Status": "Status",
                "Motivo": "Reason",
                "Acoes": "Actions"
            },
            "tituloDadosDoQuestionarioDeFadiga": "Fatigue questionnaire data",
            "tituloBotaoResultadoDaPesquisa": "Search result",
            "tituloBotaoAltResultadoDeProva": "Test result",
            "botaoExportarCSV": "Export CSV",
            "tabelaDadosDoQuestionario": {
                "Pergunta": "Question",
                "Resposta": "Answer"
            }
        }
    },
    "JustificativaDeAtrasoOmni": {
        "AdicionarJustificativaDeAtrasoOmni": {
            "deletar": "Are you sure you'd like to delete this delay justification?",
            "formulario": {
                "Nome": "Name",
                "Motivo": "Reason",
                "Setor": "Sector",
                "Tipo": "Type",
                "opcoesTipo": {
                    "Decolagem": "Take-off",
                    "TempoDeVoo": "Flight time"
                },
                "botaoAdicionarJustificativaDeAtrasoOmni": "Add internal delay justification",
                "placeholder": {
                    "Nome": "Name",
                    "Motivo": "Reason",
                    "Setor": "Sector",
                    "SelecioneTipo": "Select the type"
                }
            },
            "tabela": {
                "semJustificativasAtrasoOmni": "No Omni delay justifications registered",
                "ID": "ID",
                "Nome": "Name",
                "Motivo": "Reason",
                "Setor": "Sector",
                "Tipo": "Type",
                "Acoes": "Actions"
            },
            "tituloEditarJustificativaDeAtrasdoOmni": "Edit internal reason for delay",
            "formularioEditarJustificativaDeAtrasoOmni": {
                "Nome": "Name",
                "Motivo": "Reason",
                "Setor": "Sector",
                "Tipo": "Type",
                "opcoesTipo": {
                    "Decolagem": "Take-off",
                    "TempoDeVoo": "Flight time"
                },
                "botaoEditarJustificativa": "Edit internal reason for delay",
                "placeholder": {
                    "Nome": "Name",
                    "Motivo": "Reason",
                    "Setor": "Sector",
                    "SelecioneTipo": "Select the type"
                }
            }
        }
    },
    "RelatorioAbastecimento": {
        "ListaDeAbastecimentos": {
            "lista": "Refuels list",
            "adicionar": "Add refuel",
            "editar": "Edit refuel",
            "deletar": "Delete refuel",
            "tabela": {
              "Data": "Date",
              "Relatório": "Flight Report Nº",
              "Voo": "Flight N°",
              "Aeronave": "Aircraft",
              "Fornecedor": "Supplier",
              "Localidade": "Location",
              "Quantidade": "Quantity",
              "Acoes": "Actions",
            },
          },
          "EditarAbastecimento": {
            "titulo": "Edit refuel",
            "dados": "Data",
            "formulario": {
                "AnexarNotaFiscal": "Attach invoice",
                "Aeronave": "Aircraft",
                "Empresa": "Company",
                "Relatorio": "Report",
                "CombustivelSolicitado": "Fuel Requested (Kg or Lb)",
                "NumeroDaCe": "EC number",
                "Trecho": "Flight Leg",
                "Fornecedor": "Provider",
                "CombustivelAbastecido": "Fuel supplied (L)",
                "Localidade": "Location",
                "Comandante": "Captain",
                "VendidoPara": "Sold to",
                "Endereco": "Address",
                "Tipo": "Type",
                "Reg": "Register",
                "Capt": "Captain",
                "InicioAbastecimento": "Refuel start",
                "Click": "Click",
                "TerminoAbastecimento": "Refuel finish",
                "ProximaLocalidade": "Next location",
                "NumeroHidrante": "Hydrant number",
                "SeuNumeroDeVenda": "Your sales number",
                "NumeroDeVendaAnterior": "Previous sale number",
                "LeituraInicial": "Initial reading",
                "LeituraFinal": "Final reading",
                "Entregues": "Delivered",
                "TipoCombustivel": "Type of fuel",
                "Preco": "Price.",
                "Quantidade": "Quantity",
                "ValorUnitario": "Unitary valie",
                "ValorTotal": "Total value",
                "ValorReembolsavel": "Refundable value",
                "ValorFinal": "Final value",
                "botaoEditarAbastecimento": "Edit refuel",
                "placeholder": {
                    "SelecioneAeronave": "Select the aircraft",
                    "SelecioneRelatorio": "Select the report",
                    "SelecioneTrecho": "Select the leg",
                    "SelecioneFornecedor": "Select fuel supplier",
                    "SelecioneLocal": "Select location"
                }
            },
            "aprovacoes": {
                "titulo": "Approvals",
                "tabela": {
                  "Tipo": "Type",
                  "Aprovacao": "Approval",
                  "Acoes": "Actions",
                },
                "modalReprovar": {
                  "Titulo": "Reprove",
                  "Razao": "Reproval justification",
                  "BotaoReprovar": "Reprove refuel",
                },
                "modalAprovar": {
                  "Titulo": "Approve",
                  "BotaoAprovar": "Approve refuel",
                }
              }
          },
        "AdicionarAbastecimento": {
            "deletar": "Are you sure you want to delete this refuel?",
            "titulo": "Register refuel",
            "formulario": {
                "AnexarNotaFiscal": "Attach invoice",
                "Aeronave": "Aircraft",
                "Empresa": "Company",
                "Relatorio": "Report",
                "CombustivelSolicitado": "Fuel Requested (Kg or Lb)",
                "NumeroDaCe": "EC number",
                "Trecho": "Flight Leg",
                "Fornecedor": "Provider",
                "CombustivelAbastecido": "Fuel supplied (L)",
                "Localidade": "Location",
                "Comandante": "Captain",
                "VendidoPara": "Sold to",
                "Endereco": "Address",
                "Tipo": "Type",
                "Reg": "Register",
                "Capt": "Captain",
                "InicioAbastecimento": "Refuel start",
                "Click": "Click",
                "TerminoAbastecimento": "Refuel finish",
                "ProximaLocalidade": "Next location",
                "NumeroHidrante": "Hydrant number",
                "SeuNumeroDeVenda": "Your sales number",
                "NumeroDeVendaAnterior": "Previous sale number",
                "LeituraInicial": "Initial reading",
                "LeituraFinal": "Final reading",
                "Entregues": "Delivered",
                "TipoCombustivel": "Type of fuel",
                "Preco": "Price",
                "Quantidade": "Amount",
                "ValorTotal": "Total",
                "botaoAdicionarAbastecimento": "Add refuel",
                "placeholder": {
                    "SelecioneAeronave": "Select the aircraft",
                    "SelecioneRelatorio": "Select the report",
                    "SelecioneTrecho": "Select the leg",
                    "SelecioneFornecedor": "Select fuel supplier",
                    "SelecioneLocal": "Select location"
                }
            },
            "tabela": {
                "Trecho": "Section",
                "NumeroDaCe": "EC No.",
                "Fornecedor": "Provider",
                "Localidade": "Location",
                "QuantidadeSolicitada": "Quantity requested",
                "QuantidadeAbastecida": "Quantity supplied",
                "Acoes": "Actions"
            },
            "modalEditarAbastecimento": {
                "titulo": "Edit fuel request",
                "formulario": {
                    "CombustivelSolicitado": "Fuel Requested (Kg or Lb)",
                    "NumeroDaCe": "EC number",
                    "Trecho": "Section",
                    "Fornecedor": "Provider",
                    "CombustivelAbastecido": "Fuel supplied (L)",
                    "Localidade": "Location",
                    "botaoEditarAbastecimento": "Edit refuel"
                }
            }
        }
    },
    "RelatoriosDeVoo": {
        "ListaDeRelatoriosDeVoo": {
            "titulo": "Flight reports",
            "botaoAdicionarRelatorioDeVoo": "Add flight report",
            "formulario": {
                "botaoMudarData": "Change date"
            },
            "tabela": {
                "ID": "ID",
                "semRelatorios": "There are no registered reports",
                "NumeroDoRelatorio": "Report number",
                "Base": "Base",
                "Data": "Date",
                "Aeronave": "Aircraft",
                "Frota": "Fleet",
                "Cliente": "Client",
                "TipoDeVoo": "Type of flight",
                "NumeroDoVoo": "Flight number",
                "Status": "Status",
                "Acoes": "Actions"
            }
        },
        "AdicionarRelatorioDeVoo": {
            "titulo": "Register new flight report",
            "formulario": {
                "Data": "Date",
                "Prefixo": "Prefix",
                "Voo": "Flight",
                "NumeroDeVoo": "Flight number",
                "NumeroDoRelatorio": "Flight report number",
                "SolicitouIsencao": "Requested exemption",
                "Base": "Base",
                "Contrato": "Contract",
                "MecanicoResponsavel": "Responsible mechanic",
                "Cliente": "Client",
                "Observacoes": "Comments",
                "botaoCriarRelatorioDeVoo": "Create flight report"
            }
        },
        "EditarRelatoriosDeVoo": {
            "trocarStatusDoRelatorioDeVoo": "Are you sure you would like to change the flight report status?",
            "confirmarSalvarTodos": "Are you sure you would like to save all legs?",
            "titulo": "Edit flight report",
            "botaoRelatorio": "Report",
            "botaoExtratoDB": "DB extract",
            "botaoXML": "XML",
            "botaoRelatorioDeVoo": {
                "TrocarParaRascunho": "Switch to draft",
                "TrocarParaFinalizado": "Switch to finished",
                "TrocarParaCancelado": "Switch to Canceled"
            },
            "erros": "The following filling errors prevented the report from being finalized",
            "erros_salvar": "The following filling errors prevented the leg(s) from being saved",
            "modalDiscrepanciaHorarios": {
                "titulo": "Discrepancy of times filled in the sections with those received from Flight Following",
                "substituir": "Are you sure you'd like to replace the leg times with those of Flight Following?",
                "substituirTodos": "Are you sure you'd like to replace the times for all legs with those for Flight Following?",
                "botaoSubstituir": "Replace",
                "botaoSubstituirTodos": "Replace all times with those from Flight Following",
                "ignorar": "Are you sure you'd like to keep the leg times and ignore the Flight Following ones?",
                "ignorarTodos": "Are you sure you'd like to keep the times for all legs and ignore those for Flight Following?",
                "botaoIgnorar": "Ignore",
                "botaoIgnorarTodos": "Ignore all Flight Following times and keep those filled in",
                "tabela": {
                    "ID": "ID",
                    "Trecho": "Flight Leg",
                    "FlightFollowing": "Flight Following",
                    "Preenchido": "Filled",
                    "Partida": "Departure",
                    "Decolagem": "Take off",
                    "Pouso": "Landing",
                    "Corte": "Cut",
                    "Acoes": "Actions",
                    "botaoSubstituir": "To replace",
                    "botaoIgnorar": "Ignore"
                }
            },
            "formularioEditarRelatorio": {
                "Data": "Date",
                "Prefixo": "Prefix",
                "Voo": "Flight",
                "NumeroDeVoo": "Flight number",
                "NumeroDoRelatorio": "Flight report number",
                "SolicitouIsencao": "Requested exemption",
                "Base": "Base",
                "Contrato": "Contract",
                "MecanicoResponsavel": "Responsible mechanic",
                "Cliente": "Client",
                "Observacoes": "Comments",
                "botaoEditarRelatorioDeVoo": "Edit flight report"
            },
            "tabelaVoosDia": {
                "Titulo": "Other flights for the day",
                "SemVoos": "No other flights for the day",
                "Id": "Id",
                "NumeroVoo": "Flight No.",
                "NumeroRelatório": "Flight Report No.",
                "DecolagemPrevista": "Scheduled departure",
                "Origem": "Origin",
                "Cliente": "Client",
                "Contrato": "Contract",
                "TipoVoo": "Flight Type",
                "Status": "Status",
              },
            "excluirTripulante": "Are you sure you want to delete this crew member? It will be deleted from all legs.",
            "tituloCadastrarTripulacao": "Register crew",
            "formularioCadastrarTripulacao": {
                "Tripulante": "Crew member",
                "FuncaoDeBordo": "On-board function",
                "DataDeApresentacao": "Start duty date",
                "HoraDeApresentacao": "Start duty time",
                "botaoAdicionarTripulante": "Add crew member"
            },
            "modalEditarTripulacao": {
                "Titulo": "Edit",
                "FuncaoDeBordo": "On-board function",
                "DataDeApresentacao": "Start duty date",
                "HoraDeApresentacao": "Start duty time",
                "botaoEditarTripulante": "Edit crew member",
            },
            "tituloTripulantesCadastrados": "Registered crew",
            "tabelaTripulantesCadastrados": {
                "Nome": "Name",
                "CANAC": "CANAC",
                "SISPAT": "SISPAT",
                "FB": "FB",
                "Apresentacao": "Presentation",
                "DecolagemPouso": "Takeoff/Landing",
                "TempoTotal": "Total time",
                "Navegacao": "Navigation",
                "Instrumento": "Instrument",
                "Noturno": "Night",
                "PousosDiurnos": "Day Landings",
                "PousosNoturnos": "Night Landings",
                "Pax": "Pax.",
                "Carga": "Payload",
                "Consumo": "Consumption",
                "LongLine": "Long line",
                "ShortLine": "Short line",
                "Acoes": "Actions"
            },
            "tituloCadastrarTrecho": "Register leg",
            "botaoSalvarTodos": "Edit all legs",
            "formularioCadastrarTrecho": {
                "Origem": "From",
                "Destino": "To",
                "Partida": "Start",
                "DEC": "Takeoff",
                "POU": "Landing",
                "Corte": "Shutdown",
                "DECPOU": "Tkof-Land",
                "Total": "Total",
                "Nav": "Nav.",
                "IFR": "IFR",
                "Noturno": "Night",
                "Diurnos": "Day",
                "Noturnos": "Night",
                "Partidas": "Starts",
                "PAX": "PAX",
                "Carga": "Payload",
                "LongLine": "Long line",
                "ShortLine": "Short line",
                "Inicial": "Initial",
                "Final": "Final",
                "CodigoPTBR": "PTBR code",
                "botaoAdicionarTrecho": "Add leg"
            },
            "tabelaCadastrarTrecho": {
                "Realizados": "Performed",
                "Pousos": "Landings",
                "Dados": "Data",
                "CargaExterna": "External load",
                "Combustivel": "Fuel",
                "OperacaoPTBR": "PTBR operation",
                "Acoes": "Actions",
                "Numero": "No.",
                "Origem": "From",
                "Destino": "To",
                "Partida": "Start",
                "DEC": "Takeoff",
                "POU": "Landing",
                "Corte": "Shutdown",
                "DECPOU": "Tkof-Land",
                "Total": "Total",
                "Nav": "Nav.",
                "IFR": "IFR",
                "Noturno": "Night",
                "Diurnos": "Day",
                "Noturnos": "Night",
                "Partidas": "Starts",
                "PAX": "PAX",
                "Carga": "Payload",
                "LongLine": "Long line",
                "ShortLine": "Short line",
                "Inicial": "Initial",
                "Final": "Final",
                "CodigoPTBR": "PTBR code"
            },
            "tituloTotaisDosTrechos": "Total legs",
            "tabelaTotaisDosTrechos": {
                "DecolagemPouso": "Takeoff/Landing",
                "TempoTotal": "Total time",
                "Navegacao": "Navigation",
                "Instrumento": "Instrument",
                "Noturno": "Night",
                "PousosDiurnos": "Day Landings",
                "PousosNoturnos": "Night Landings",
                "Pax": "Pax.",
                "Carga": "Payload",
                "Consumo": "Consumption"
            },
            "excluirTrecho": "Are you sure you want to delete this leg?",
            "removerTripulanteDoTrecho": "Are you sure you'd like to remove this crew member from this leg?",
            "tituloEdicaoTrecho": "Edit leg",
            "formularioEditarTrecho": {
                "Origem": "From",
                "Destino": "To",
                "Partida": "Start",
                "DEC": "Takeoff",
                "POU": "Landing",
                "Corte": "Shutdown",
                "DECPOU": "Tkof-Land",
                "Total": "Total",
                "Nav": "Nav.",
                "IFR": "IFR",
                "Noturno": "Night",
                "Diurnos": "Day",
                "Noturnos": "Night",
                "Partidas": "Starts",
                "PAX": "PAX",
                "Carga": "Payload",
                "LongLine": "Long line",
                "ShortLine": "Short line",
                "Inicial": "Initial",
                "Final": "Final",
                "CodigoPTBR": "PTBR code",
                "Horario": "Schedule",
                "Following": "Following",
                "Atual": "Current",
                "Foll": "Foll.",
                "botaoEditarTrecho": "Edit leg",
                "limparTrecho": "The leg data was deleted.",
            },
            "tituloTripulacaoCadastrada": "Registered crew",
            "formularioAdicionarTripulante": {
                "Tripulante": "Crew member",
                "FuncaoDeBordo": "Role",
                "botaoAdicionarTripulante": "Add crew member"
            },
            "tabelaTripulantes": {
                "Nome": "Name",
                "FuncaoDeBordo": "Role",
                "Acoes": "Actions"
            },
            "excluirAbastecimento": "Are you sure you want to delete this refuel?",
            "mensagemDadosAtualizadosComSucesso": "Data updated successfully",
            "tituloCadastrarAbastecimento": "Register refuel",
            "formularioAdicionarAbastecimento": {
                "CombustivelSolicitado": "Fuel Requested (Kg or Lb)",
                "Trecho": "Leg",
                "NumeroDaCE": "EC number",
                "Fornecedor": "Provider",
                "CombustivelAbastecido": "Fuel supplied (L)",
                "Localidade": "Location",
                "botaoAdicionarAbastecimento": "Add refuel"
            },
            "tituloAbastecimentosCadastrados": "Registered supplies",
            "tabelaAbastecimentosCadastrados": {
                "Trecho": "Flight Leg",
                "NumeroDaCE": "EC No.",
                "Cia": "Co.",
                "QuantidadeSolicitada": "Quantity requested",
                "QuantidadeAbastecida": "Quantity supplied",
                "Acoes": "Actions"
            },
            "tituloEditarSolicitacaoDeCombustivel": "Edit fuel request",
            "formularioEditarSolicitacaoDeCombustivel": {
                "CombustivelSolicitado": "Fuel Requested",
                "Trecho": "Flight Leg",
                "NumeroDaCE": "EC number",
                "Fornecedor": "Provider",
                "CombustivelAbastecido": "Fuel supplied (L)",
                "Localidade": "Location",
                "botaoEditarAbastecimento": "Edit refuel"
            },
            "tituloObservacoes": "Comments",
            "formularioEditarObservacoes": {
                "Observacoes": "Comments",
                "botaoEditarObservacoes": "Edit notes"
            },
            "tituloAlertasDoRelatorio": "Report Alerts",
            "tabelaAlertasDoRelatorio": {
                "Mensagem": "Message",
                "Data": "Date"
            },
            "aprovarRelatorio": "Are you sure you want to approve this report?",
            "reabrirRelatorio": "Are you sure you want to reopen this report?",
            "reprovarRelatorio": "Are you sure you want to disapprove this report?",
            "relatorioReabertoGerouImplicacoes": "This report has been reopened! This led to the following implications",
            "tabelaImplicacoes": {
                "Mensagem": "Message",
                "Data": "Date"
            },
            "tituloAprovacoes": "Approvals",
            "botaoReabrirRelatorio": "Reopen report",
            "tabelaAprovacoes": {
                "Tipo": "Type",
                "Tripulante": "Crew member",
                "Aprovacao": "Approval",
                "Acoes": "Actions"
            },
            "tituloJustificativaReprovacao": "Justification for disapproval",
            "formularioReprovacao": {
                "RazaoDaReprovacao": "Reason for disapproval",
                "botaoReprovarRelatorio": "Fail report"
            },
            "tituloLoginDoComandanteNoLDAP": "Commander login in LDAP",
            "formularioLogin": {
                "botaoAcessarSistema": "Access the system",
                "placeholder": {
                    "Email": "Your email",
                    "Senha": "Your password"
                }
            },
            "tituloLogDoRelatorio": "Report log",
            "tabelaLogRelatorio": {
                "Usuario": "User",
                "Acao": "Action",
                "Descricao": "Description",
                "Data": "Date"
            }
        },
        "ListaDeRelatoriosDeVooOffline": {
            "titulo": "Flight reports",
            "tabela": {
                "semRelatorios": "There are no registered reports",
                "NumeroDoRelatorio": "Report number",
                "Base": "Base",
                "Data": "Date",
                "Aeronave": "Aircraft",
                "Frota": "Fleet",
                "Cliente": "Client",
                "TipoDeVoo": "Type of flight",
                "NumeroDoVoo": "Flight number",
                "Status": "Status",
                "Acoes": "Actions"
            }
        },
        "EditarRelatoriosDeVooOffline": {
            "trocarStatusDoRelatorioDeVoo": "Are you sure you would like to change the flight report status?",
            "titulo": "Edit flight report",
            "botaoRelatorio": "Report",
            "botaoExtratoDB": "DB extract",
            "botaoXML": "XML",
            "botaoRelatorioDeVoo": {
                "TrocarParaRascunho": "Switch to draft",
                "TrocarParaFinalizado": "Switch to finished",
                "TrocarParaCancelado": "Switch to canceled"
            },
            "erros": "The following filling errors prevented the report from being finalized",
            "formularioEditarRelatorio": {
                "Data": "Date",
                "Prefixo": "Prefix",
                "Voo": "Flight",
                "NumeroDeVoo": "Flight number",
                "SolicitouIsencao": "Requested exemption",
                "Base": "Base",
                "Contrato": "Contract",
                "MecanicoResponsavel": "Responsible mechanic",
                "Cliente": "Client",
                "Observacoes": "Comments",
                "botaoEditarRelatorioDeVoo": "Edit flight report"
            },
            "excluirTripulante": "Are you sure you want to delete this crew member? It will be deleted from all legs.",
            "tituloCadastrarTripulacao": "Register crew",
            "formularioCadastrarTripulacao": {
                "Tripulante": "Crew member",
                "FuncaoDeBordo": "On-board function",
                "DataDeApresentacao": "Date of the presentation",
                "HoraDeApresentacao": "Presentation time",
                "botaoAdicionarTripulante": "Add crew member"
            },
            "tituloTripulantesCadastrados": "Registered crew",
            "tabelaTripulantesCadastrados": {
                "Nome": "Name",
                "CANAC": "CANAC",
                "SISPAT": "SISPAT",
                "FB": "FB",
                "Apresentacao": "Presentation",
                "DecolagemPouso": "Takeoff/Landing",
                "TempoTotal": "Total time",
                "Navegacao": "Navigation",
                "Instrumento": "Instrument",
                "Noturno": "Night",
                "PousosDiurnos": "Day Landings",
                "PousosNoturnos": "Night Landings",
                "Pax": "Pax.",
                "Carga": "Payload",
                "Consumo": "Consumption",
                "LongLine": "Long line",
                "ShortLine": "Short line",
                "Acoes": "Actions"
            },
            "tituloCadastrarTrecho": "Register leg",
            "formularioCadastrarTrecho": {
                "Origem": "From",
                "Destino": "To",
                "Partida": "Start",
                "DEC": "Takeoff",
                "POU": "Landing",
                "Corte": "Shutdown",
                "DECPOU": "Tkof-Land",
                "Total": "Total",
                "Nav": "Nav.",
                "IFR": "IFR",
                "Noturno": "Night",
                "Diurnos": "Day",
                "Noturnos": "Night",
                "Partidas": "Starts",
                "PAX": "PAX",
                "Carga": "Payload",
                "LongLine": "Long line",
                "ShortLine": "ShortLine",
                "Inicial": "Initial",
                "Final": "Final",
                "CodigoPTBR": "PTBR code",
                "botaoAdicionarTrecho": "Add leg"
            },
            "tabelaCadastrarTrecho": {
                "Realizados": "Performed",
                "Pousos": "Landings",
                "Dados": "Data",
                "CargaExterna": "External load",
                "Combustivel": "Fuel",
                "OperacaoPTBR": "PTBR operation",
                "Acoes": "Actions",
                "Numero": "No.",
                "Origem": "From",
                "Destino": "To",
                "Partida": "Start",
                "DEC": "Takeoff",
                "POU": "Landing",
                "Corte": "Shutdown",
                "DECPOU": "Tkof-Land",
                "Total": "Total",
                "Nav": "Nav.",
                "IFR": "IFR",
                "Noturno": "Night",
                "Diurnos": "Day",
                "Noturnos": "Night",
                "Partidas": "Starts",
                "PAX": "PAX",
                "Carga": "Payload",
                "LongLine": "Long line",
                "ShortLine": "Short line",
                "Inicial": "Initial",
                "Final": "Final",
                "CodigoPTBR": "PTBR code"
            },
            "tituloTotaisDosTrechos": "Legs total",
            "tabelaTotaisDosTrechos": {
                "DecolagemPouso": "Takeoff/Landing",
                "TempoTotal": "Total time",
                "Navegacao": "Navigation",
                "Instrumento": "Instrument",
                "Noturno": "Night",
                "PousosDiurnos": "Day Landings",
                "PousosNoturnos": "Night Landings",
                "Pax": "Pax.",
                "Carga": "Payload",
                "Consumo": "Consumption"
            },
            "excluirTrecho": "Are you sure you want to delete this leg?",
            "removerTripulanteDoTrecho": "Are you sure you'd like to remove this crew member from this leg?",
            "formularioEditarTrecho": {
                "Origem": "From",
                "Destino": "To",
                "Partida": "Start",
                "DEC": "Takeoff",
                "POU": "Landing",
                "Corte": "Shutdown",
                "DECPOU": "Tkof-Land",
                "Total": "Total",
                "Nav": "Nav.",
                "IFR": "IFR",
                "Noturno": "Night",
                "Diurnos": "Day",
                "Noturnos": "Night",
                "Partidas": "Starts",
                "PAX": "PAX",
                "Carga": "Payload",
                "LongLine": "Long line",
                "ShortLine": "Short line",
                "Inicial": "Initial",
                "Final": "Final",
                "CodigoPTBR": "PTBR code",
                "botaoEditarTrecho": "Edit leg"
            },
            "tituloTripulacaoCadastrada": "Registered crew",
            "formularioAdicionarTripulante": {
                "Tripulante": "Crew member",
                "FuncaoDeBordo": "On-board function",
                "botaoAdicionarTripulante": "Add crew member"
            },
            "tabelaTripulantes": {
                "Nome": "Name",
                "FuncaoDeBordo": "On-board function",
                "Acoes": "Actions"
            },
            "excluirAbastecimento": "Are you sure you want to delete this refuel?",
            "mensagemDadosAtualizadosComSucesso": "Data updated successfully",
            "tituloCadastrarAbastecimento": "Register refuel",
            "formularioAdicionarAbastecimento": {
                "CombustivelSolicitado": "Fuel Requested (Kg or Lb)",
                "Trecho": "Flight Leg",
                "NumeroDaCE": "EC number",
                "Cia": "Co.",
                "CombustivelAbastecido": "Fuel supplied (L)",
                "botaoAdicionarAbastecimento": "Add refuel"
            },
            "tituloAbastecimentosCadastrados": "Registered supplies",
            "tabelaAbastecimentosCadastrados": {
                "Trecho": "Leg",
                "NumeroDaCE": "EC No.",
                "Cia": "Co.",
                "QuantidadeSolicitada": "Quantity requested",
                "QuantidadeAbastecida": "Quantity supplied",
                "Acoes": "Actions"
            },
            "tituloEditarSolicitacaoDeCombustivel": "Edit fuel request",
            "formularioEditarSolicitacaoDeCombustivel": {
                "CombustivelSolicitado": "Fuel Requested",
                "Trecho": "Flight Leg",
                "NumeroDaCE": "EC number",
                "Cia": "Co.",
                "CombustivelAbastecido": "Fuel supplied (L)",
                "botaoEditarAbastecimento": "Edit refuel"
            },
            "tituloObservacoes": "Comments",
            "formularioEditarObservacoes": {
                "Observacoes": "Comments",
                "botaoEditarObservacoes": "Edit notes"
            },
            "tituloAlertasDoRelatorio": "Report Alerts",
            "tabelaAlertasDoRelatorio": {
                "Mensagem": "Message",
                "Data": "Date"
            },
            "aprovarRelatorio": "Are you sure you want to approve this report?",
            "reabrirRelatorio": "Are you sure you want to reopen this report?",
            "reprovarRelatorio": "Are you sure you want to disapprove this report?",
            "relatorioReabertoGerouImplicacoes": "This report has been reopened! This led to the following implications",
            "tabelaImplicacoes": {
                "Mensagem": "Message",
                "Data": "Date"
            },
            "tituloAprovacoes": "Approvals",
            "botaoReabrirRelatorio": "Reopen report",
            "tabelaAprovacoes": {
                "Tipo": "Type",
                "Tripulante": "Crew member",
                "Aprovacao": "Approval",
                "Acoes": "Actions"
            },
            "tituloJustificativaReprovacao": "Justification for disapproval",
            "formularioReprovacao": {
                "RazaoDaReprovacao": "Reason for disapproval",
                "botaoReprovarRelatorio": "Fail report"
            },
            "tituloLoginDoComandanteNoLDAP": "Commander login in LDAP",
            "formularioLogin": {
                "botaoAcessarSistema": "Access the system",
                "placeholder": {
                    "Email": "Your email",
                    "Senha": "Your password"
                }
            },
            "tituloLogDoRelatorio": "Report log",
            "tabelaLogRelatorio": {
                "Usuario": "User",
                "Acao": "Action",
                "Descricao": "Description",
                "Data": "Date"
            }
        },
        "RelatoriosPendentesDeAprovacao": {
            "aprovar": "Are you sure you want to approve this report?",
            "titulo": "Pending Approval Reports",
            "formulario": {
                "Base": "Base",
                "Status": "Status"
            },
            "botaoAprovar": "Approve",
            "tabela": {
                "Data": "Date",
                "Base": "Base",
                "Aeronave": "Aircraft",
                "Frota": "Fleet",
                "Contrato": "Contract",
                "TipoDeVoo": "Flight Type",
                "NumeroDoVoo": "Flight No.",
                "Status": "Status",
                "Acoes": "Actions"
            }
        },
        "QuantidadeDeVoosPorDia": {
            "titulo": "Number of flights per day",
            "formulario": {
                "DataInicial": "Initial date",
                "DataFinal": "Final date",
                "Aeronave": "Aircraft",
                "Frota": "Fleet",
                "Base": "Base",
                "Tripulantes": "Crew",
                "TipoDeVoo": "Flight Type",
                "Contrato": "Contract",
                "SomenteAprovados": "Only approved",
                "BaseContratual": "Contract Base"
            },
            "tituloTotaisDaAeronavePorData": "Aircraft totals by date",
            "tabelaTotaisDaAeronavePorData": {
                "Data": "Date",
                "Prefixo": "Prefix",
                "Frota": "Fleet",
                "QuantidadeDeVoos": "Number of Flights",
                "QuantidadeDePousos": "Number of Landings",
                "QuantidadeDeCortes": "Number of Cuts",
                "QuantidadeDePAX": "Amount of PAX"
            },
            "tituloTotaisDaAeronavePorPeriodo": "Aircraft totals by period",
            "tabelaTotaisDaAeronavePorPeriodo": {
                "DataInicial": "Initial date",
                "DataFinal": "Final date",
                "Prefixo": "Prefix",
                "Frota": "Fleet",
                "QuantidadeDeVoos": "Number of Flights",
                "QuantidadeDePousos": "Number of Landings",
                "QuantidadeDeCortes": "Number of Cuts",
                "QuantidadeDePAX": "Amount of PAX"
            },
            "tituloTotaisDoModeloPorData": "Template Totals by Date",
            "tabelaTotaisDoModeloPorData": {
                "Data": "Date",
                "Frota": "Fleet",
                "QuantidadeDeVoos": "Number of Flights",
                "QuantidadeDePousos": "Number of Landings",
                "QuantidadeDeCortes": "Number of Cuts",
                "QuantidadeDePAX": "Amount of PAX"
            },
            "tituloTotaisDoModeloPorPeriodo": "Model totals by period",
            "tabelaTotaisDoModeloPorPeriodo": {
                "DataInicial": "Initial date",
                "DataFinal": "Final date",
                "Frota": "Fleet",
                "QuantidadeDeVoos": "Number of Flights",
                "QuantidadeDePousos": "Number of Landings",
                "QuantidadeDeCortes": "Number of Cuts",
                "QuantidadeDePAX": "Amount of PAX"
            },
            "tituloTotalGeralPorData": "Grand Total by date",
            "tabelaTotalGeralPorData": {
                "Data": "Date",
                "QuantidadeDeVoos": "Number of Flights",
                "QuantidadeDePousos": "Number of Landings",
                "QuantidadeDeCortes": "Number of Cuts",
                "QuantidadeDePAX": "Amount of PAX"
            },
            "tituloTotalGeralPorPeriodo": "Grand Total per period",
            "tabelaTotalGeralPorPeriodo": {
                "DataInicial": "Initial date",
                "DataFinal": "Final date",
                "Base": "Base",
                "QuantidadeDeVoos": "Number of Flights",
                "QuantidadeDePousos": "Number of Landings",
                "QuantidadeDeCortes": "Number of Cuts",
                "QuantidadeDePAX": "Amount of PAX"
            }
        },
        "RelatorioDeOcorrenciasAnormais": {
            "titulo": "Report of Abnormal Occurrences",
            "formulario": {
                "DataInicial": "Initial date",
                "DataFinal": "Final date",
                "SomenteAprovados": "Only approved",
                "RelatorioDeVoo": "Flight Report",
                "Aeronave": "Aircraft",
                "Frota": "Fleet",
                "placeholder": {
                    "InformeONumeroDoRelatorioDeVoo": "Enter the flight report number"
                }
            },
            "tabela": {
                "Data": "Date",
                "Prefixo": "Prefix",
                "Frota": "Fleet",
                "Base": "Base",
                "TipoDeVoo": "Flight Type",
                "Contrato": "Contract",
                "Cliente": "Client",
                "NumeroRelatorio": "Report No.",
                "NumeroDoVoo": "Flight No.",
                "TipoDeOcorrencia": "Type of Occurrence",
                "DescricaoDaOcorrencia": "Occurrence description",
                "AcaoRequerida": "Required Action",
                "Observacoes": "Comments",
                "Tripulantes": "Crew"
            }
        },
        "ControleDiarioDeUtilizacaoDeAeronavesContratadas": {
            "osCamposDataClienteEBaseSaoObrigatoriosParaExportacaoEmPDF": "The fields Date, Customer and Base are mandatory for PDF export.",
            "titulo": "Daily Control of Use of Contracted Aircraft",
            "formulario": {
                "Data": "Date",
                "SomenteAprovados": "Only approved",
                "Base": "Base",
                "Aeronave": "Aircraft",
                "Contrato": "Contract",
                "Cliente": "Client",
                "BaseContratual": "Contract Base"
            },
            "tabela": {
                "Prefixo": "Prefix",
                "Frota": "Fleet",
                "Contrato": "Contract",
                "CodigoSAP": "SAP code",
                "TempoTotalDeVooNaDataDecolagemAoPouso": "Total Flight Time on Date - 1st Takeoff to Last Landing",
                "TempoTotalDeVooNoDataPartidaAoCorte": "Total Flight Time on Date - Start to Shutoff",
                "TempoTotalDeVooOMNINaDataDecolagemAoPouso": "Internal Total Flight Time on Date - 1st Takeoff to Last Landing",
                "TempoTotalDeVooOMNINoDataPartidaAoCorte": "Internal Total Flight Time on Date - Start to Shutoff",
                "IndisponibilidadesMotivos": "Outages - Reasons",
                "IndisponibilidadesHoras": "Outages - Hours"
            }
        },
        "BoletimDeDisponibilidade": {
            "titulo": "Availability bulletin",
            "formulario": {
                "DataInicial": "Initial date",
                "DataFinal": "Final date",
                "Contrato": "Contract",
                "SomenteAprovados": "Only approved",
                "BaseContratual": "Contract Base"
            },
            "tabela": {
                "Contrato": "Contract",
                "Prefixo": "Prefix",
                "Data": "Date",
                "TipoDeContrato": "Type of contract",
                "VooDecolagemAoPouso": "Flight - 1st Takeoff to Last Landing",
                "VooPartidaAoCorte": "Flight - Start to Shutoff",
                "QtdPousos": "Qty. landings",
                "QtdPartidas": "Qty. Departures",
                "VooTotalDecolagemAoPouso": "Total Flight - 1st Takeoff to Last Landing",
                "DuracaoMediaDeVooDecolagemAoPouso": "Average Flight Duration - 1st Takeoff to Last Landing",
                "VooTotalPartidaAoCorte": "Total Flight - Start to Shutoff",
                "DuracaoMediaDeVooPartidaAoCorte": "Average Flight Duration - Start to Shutoff",
                "MaximoDeDisponibilidadeContratual": "Maximum Contractual Availability",
                "IndisponibilidadeReal": "Actual Unavailability",
                "IndisponibilidadeContratual": "Contractual Unavailability",
                "DisponibilidadeReal": "Actual Availability",
                "DisponibilidadeContratual": "Contractual Availability",
                "TipoMPRG": "MPRG type",
                "TipoMNPR": "MNPR type",
                "TipoOPS": "OPS type",
                "OcorrenciaAnormal": "Abnormal Occurrence"
            },
            "tituloTotais": "Totals",
            "tabelaTotais": {
                "Contrato": "Contract",
                "Prefixo": "Prefix",
                "TipoDeContrato": "Type of contract",
                "QtdPousos": "Qty. landings",
                "QtdPartidas": "Qty. Departures",
                "VooTotalDecolagemAoPouso": "Total Flight - 1st Takeoff to Last Landing",
                "VooTotalPartidaAoCorte": "Total Flight - Start to Shutoff",
                "DuracaoMediaDeVooDecolagemAoPouso": "Average Flight Duration - 1st Takeoff to Last Landing",
                "DuracaoMediaDeVooPartidaAoCorte": "Average Flight Duration - Start to Shutoff",
                "TempoTotalRegistrado": "Total Recorded Time",
                "MaximoDeDisponibilidadeContratual": "Maximum Contractual Availability",
                "IndisponibilidadeReal": "Actual Unavailability",
                "IndisponibilidadeContratual": "Contractual Unavailability",
                "DisponibilidadeReal": "Actual Availability",
                "DisponibilidadeContratual": "Contractual Availability",
                "TipoMPRG": "MPRG type",
                "TipoMNPR": "MNPR type",
                "TipoOPS": "OPS type",
                "OcorrenciaAnormal": "Abnormal Occurrence",
                "PorcentagemIndisponibilidadeReal": "% Actual Unavailability",
                "PorcentagemIndisponibilidadeContratual": "% Contractual Unavailability",
                "PorcentagemDisponibilidadeReal": "% Actual Availability",
                "PorcentagemDisponibilidadeContratual": "% Contractual Availability",
                "PorcentagemTipoMPRG": "% MPRG Type",
                "PorcentagemTipoMNPR": "% MNPR Type",
                "PorcentagemTipoOPS": "% Type OPS",
                "PorcentagemAproveitamentoDecolagemAoPouso": "% Utilization - Takeoff to Landing",
                "PorcentagemAproveitamentoPartidaAoCorte": "% Utilization - Departure to Cut"
            }
        },
        "FichasDeDisponibilidade": {
            "titulo": "Availability sheets",
            "formulario": {
                "DataInicial": "Initial date",
                "DataFinal": "Final date",
                "Aeronave": "Aircraft",
                "Contrato": "Contract",
                "Base": "Base"
            },
            "tabela": {
                "Prefixo": "Prefix",
                "Contrato": "Contract",
                "InicioDisponibilidadeContratual": "Home disp. contractual",
                "FimDispContratual": "End available contractual",
                "InicioIndisponibilidade": "Indisp.",
                "FimIndisponibilidade": "Indisp. end",
                "Franquia": "Franchise",
                "IndisponibilidadeTotal": "Indisp. Total",
                "SemFranquia": "No deductible",
                "TempoTotal": "Total time"
            }
        },
        "RelatorioDeConsumo": {
            "titulo": "Consumption Report",
            "formulario": {
                "DataInicial": "Initial date",
                "DataFinal": "Final date",
                "SomenteAprovados": "Only approved",
                "RelatorioDeVoo": "Flight Report",
                "Aeronave": "Aircraft",
                "Frota": "Fleet",
                "Localidade": "Location",
                "TipoDeVoo": "Flight Type",
                "Contrato": "Contract",
                "Cliente": "Client",
                "NumeroDeReciboDoCombustivel": "Fuel Receipt No.",
                "FornecedorDeCombustivel": "Fuel Supplier",
                "BaseContratual": "Contract Base",
                "placeholder": {
                    "InformeONumeroDoRelatorioDeVoo": "Enter the flight report number"
                }
            },
            "tabela": {
                "Data": "Date",
                "Prefixo": "Prefix",
                "Frota": "Fleet",
                "Base": "Base",
                "TipoDeVoo": "Flight Type",
                "Contrato": "Contract",
                "Cliente": "Client",
                "NumeroRelatorio": "Report No.",
                "NumeroDoVoo": "Flight No.",
                "Isencao": "Exemption",
                "TotalVooDecolagemAoPouso": "Total Flight - 1st Takeoff to Last Landing",
                "TotalDoVooPartidaAoCorte": "Total Flight - Start to Shutoff",
                "TotalDoVooNavegacao": "Total Flight - Navigation",
                "TotalDoVooInstrumento": "Total Flight - Instrument",
                "TotalDoVooNoturno": "Total Flight - Night",
                "TotalDoVooPartidas": "Total Flight - Departures",
                "TotalDoVooPousosDiurnos": "Total Flight - Day Landings",
                "TotalDoVooPousosNoturnos": "Total Flight - Night Landings",
                "TotalDoVooPAX": "Total Flight - PAX",
                "TotalDoVooCarga": "Total Flight - Cargo",
                "TipoDeContrato": "Type of contract",
                "CombustivelAutorizado": "Authorized Fuel",
                "EmpresaDeCombustivel": "Fuel Company",
                "FornecedorDeCombustivel": "Fuel Supplier",
                "NumeroDaCE": "EC No.",
                "LocalDeAbastecimento": "Local de Abastecimento",
                "ValorLitro": "Value/Liter",
                "ValorTotal": "Total Value",
                "QuantidadeSolicitada": "Quantity Requested",
                "QuantidadeAbastecida": "Quantity Supplied",
                "QuantidadeAbastecidaConvertida": "Quantity Supplied Converted",
                "Saldo": "Balance",
                "Consumo": "Consumption",
                "ConsumoEmLitros": "Consumption in liters"
            },
            "tituloTotais": "Totals",
            "tabelaTotais": {
                "Prefixo": "Prefix",
                "Frota": "Fleet",
                "TotalVooDecolagemAoPouso": "Total Flight - 1st Takeoff to Last Landing",
                "TotalDoVooPartidaAoCorte": "Total Flight - Start to Shutoff",
                "TotalDoVooNavegacao": "Total Flight - Navigation",
                "TotalDoVooInstrumento": "Total Flight - Instrument",
                "TotalDoVooNoturno": "Total Flight - Night",
                "TotalDoVooPartidas": "Total Flight - Departures",
                "TotalDoVooPousosDiurnos": "Total Flight - Day Landings",
                "TotalDoVooPousosNoturnos": "Total Flight - Night Landings",
                "TotalDoVooPAX": "Total Flight - PAX",
                "TotalDoVooCarga": "Total Flight - Cargo",
                "CombustivelAutorizado": "Authorized Fuel",
                "ValorTotal": "Total Value",
                "QuantidadeSolicitada": "Quantity Requested",
                "QuantidadeAbastecida": "Quantity Supplied",
                "QuantidadeAbastecidaConvertida": "Quantity Supplied Converted",
                "Saldo": "Balance",
                "Consumo": "Consumption",
                "ConsumoEmLitros": "Consumption in liters"
            }
        },
        "RelatorioDeDisponibilidadeDeCombustivel": {
            "titulo": "Fuel Availability Report",
            "formulario": {
                "MesInicio": "Start Month",
                "MesTermino": "End Month",
                "Aeronave": "Aircraft",
                "Base": "Base",
                "Cliente": "Client",
                "SomenteAprovados": "Only approved"
            },
            "tabela": {
                "Inicio": "Start",
                "Fim": "End",
                "Aeronave": "Aircraft",
                "Frota": "Fleet",
                "Contrato": "Contract",
                "Cliente": "Client",
                "QuantidadeAbastecida": "Quantity Supplied",
                "QuantidadeAbastecidaConvertida": "Quantity Supplied Converted",
                "Consumo": "Consumption",
                "CAutorizado": "C. Authorized",
                "Saldo": "Balance",
                "HorasTotais": "Total hours",
                "Dias": "Days",
                "MediaDeHorasDeVooPorDia": "Average Flight Hours per Day",
                "MediaDeConsumoPorDia": "Average Consumption per Day",
                "MediaDeConsumoPorHorasDeVoo": "Average Consumption by Flight Hours"
            }
        },
        "ExtratoDeDBEmBloco": {
            "titulo": "Multiple DB extract",
            "formulario": {
                "DataInicial": "Initial date",
                "DataFinal": "Final date",
                "Aeronave": "Aircraft",
                "Contrato": "Contract",
                "Base": "Base",
                "BasesContratual": "Contract Bases",
                "SomenteAprovados": "Only approved"
            },
            "tabela": {
                "Data": "Date",
                "Prefixo": "Prefix",
                "Frota": "Fleet",
                "Base": "Base",
                "Contrato": "Contract",
                "Cliente": "Client",
                "NumeroRelatorio": "Report No.",
                "NumeroDoVoo": "Flight No."
            }
        },
        "RelatorioDePousosPorLocalidade": {
            "titulo": "Landing Report by Location",
            "formulario": {
                "DataInicial": "Initial date",
                "DataFinal": "Final date",
                "SomenteAprovados": "Only approved",
                "Local": "Place",
                "RelatorioDeVoo": "Flight Report",
                "Aeronave": "Aircraft",
                "Frota": "Fleet",
                "placeholder": {
                    "InformeONumeroDoRelatorioDeVoo": "Enter the flight report number"
                }
            },
            "tabela": {
                "Data": "Date",
                "Prefixo": "Prefix",
                "Frota": "Fleet",
                "Base": "Base",
                "TipoDeVoo": "Flight Type",
                "Contrato": "Contract",
                "Cliente": "Client",
                "NumeroRelatorio": "Report No.",
                "NumeroDoVoo": "Flight No.",
                "Origem": "From",
                "Destino": "To",
                "Tripulantes": "Crew",
                "DEPARR": "DEP-ARR",
                "Total": "Total",
                "TotalDePousosDaAnvNaData": "Total number of ANV landings on the date",
                "TotalDePousosDaAnvNoPeriodo": "Total number of ANV landings in the period",
                "TotalDePousosDaFrotaNoPeriodo": "Total fleet landings in the period",
                "TotalDePousosGeralNoPeriodo": "Total overall landings in the period"
            }
        },
        "ApuracaoDeHoras": {
            "titulo": "Time calculation",
            "formulario": {
                "DataInicial": "Initial date",
                "DataFinal": "Final date",
                "Aeronave": "Aircraft",
                "BaseContratual": "Contract Base",
                "Contrato": "Contract",
                "Cliente": "Client",
                "Indisponibilidade": "Unavailability",
                "opcoesIndisponibilidade": {
                    "NaoExibir": "Do not display",
                    "ExibirApenasTotal": "Show Only Total",
                    "ExibirApenasContratual": "Show only Contractual",
                    "ExibirTodas": "Show All"
                },
                "SomenteAprovados": "Only approved"
            },
            "tabela": {
                "Data": "Date",
                "Contrato": "Contract",
                "PrefixoContratual": "Contract Prefix",
                "Backup": "Backup",
                "NumeroDoRelatorioDeVoo": "Flight Report No.",
                "NumeroDoVoo": "Flight No.",
                "TipoDeContrato": "Type of contract",
                "TempoTotalDeVooDecolagemAoPouso": "Total Flight Time - 1st Takeoff to Last Landing",
                "TempoTotalDeVooPartidaAoCorte": "Total Flight Time - Start to Shutoff",
                "CombustivelConsumido": "Fuel consumed",
                "CombustivelAbastecido": "Fuel supplied",
                "IndisponibilidadeDiariaTotal": "Unavailability - Total",
                "IndisponibilidadeDiariaContratual": "Unavailability - Contractual",
                "IndisponibilidadeMotivo": "Unavailability - Reason",
                "IndisponibilidadeInicio": "Unavailability - Start",
                "IndisponibilidadeFim": "Unavailability - Finish",
            }
        },
        "RelatorioDeTempoEmSolo": {
            "titulo": "Ground Time Report",
            "formulario": {
                "DataInicial": "Initial date",
                "DataFinal": "Final date",
                "SomenteAprovados": "Only approved",
                "Local": "Place",
                "Aeronave": "Aircraft",
                "Frota": "Fleet"
            },
            "tabela": {
                "Data": "Date",
                "Prefixo": "Prefix",
                "Frota": "Fleet",
                "Base": "Base",
                "TipoDeVoo": "Flight Type",
                "Contrato": "Contract",
                "Cliente": "Client",
                "NumeroRelatorio": "Report No.",
                "NumeroDoVoo": "Flight No.",
                "Origem": "From",
                "Destino": "To",
                "Tripulantes": "Crew",
                "DEPARR": "DEP-ARR",
                "Total": "Total"
            }
        },
        "RelatorioDeTempoEntreTrechos": {
            "titulo": "Time Report between Legs",
            "formulario": {
                "DataInicial": "Initial date",
                "DataFinal": "Final date",
                "SomenteAprovados": "Only approved",
                "RelatorioDeVoo": "Flight Report",
                "Aeronave": "Aircraft",
                "Frota": "Fleet",
                "placeholder": {
                    "InformeONumeroDoRelatorioDeVoo": "Enter the flight report number"
                }
            },
            "tabela": {
                "Data": "Date",
                "Prefixo": "Prefix",
                "Frota": "Fleet",
                "Base": "Base",
                "TipoDeVoo": "Flight Type",
                "Contrato": "Contract",
                "Cliente": "Client",
                "NumeroRelatorio": "Report No.",
                "NumeroDoVoo": "Flight No.",
                "Tripulantes": "Crew",
                "QuantidadeDeTrechos": "Number of sections",
                "TempoEntreTrechos": "Time between legs",
                "TotalDoVooDEPARR": "Total Flight - DEP-ARR",
                "TotalDoVooTempoTotal": "Total Flight - Total Time"
            }
        },
        "ControleGeralDeRelatorios": {
            "titulo": "General Control of Reports",
            "formulario": {
                "DataInicial": "Initial date",
                "DataFinal": "Final date",
                "AnaliticoOuSintetico": "Analytical or Synthetic",
                "opcoesAnaliticoOuSintetico": {
                    "AnaliticoPorTripulante": "Analytics - Per Crew",
                    "AnaliticoPorRelatorio": "Analytics - Per Report",
                    "Sintetico": "Synthetic"
                },
                "SomenteAprovados": "Only approved",
                "RelatorioDeVoo": "Flight Report",
                "NumeroDoVoo": "Flight No.",
                "Aeronave": "Aircraft",
                "Frota": "Fleet",
                "Base": "Base",
                "TipoDeVoo": "Flight Type",
                "Contrato": "Contract",
                "Isencao": "Exemption",
                "CargaExterna": "External load",
                "Cliente": "Client",
                "BasesContratual": "Contract Bases",
                "placeholder": {
                    "InformeONumeroDoRelatorioDeVoo": "Enter the flight report number",
                    "InformeONumeroDoVoo": "Enter the flight number"
                }
            },
            "tabela": {
                "Data": "Date",
                "Prefixo": "Prefix",
                "Frota": "Fleet",
                "Base": "Base",
                "TipoDeVoo": "Flight Type",
                "Contrato": "Contract",
                "Cliente": "Client",
                "NumeroRelatorio": "Report No.",
                "NumeroDoVoo": "Flight No.",
                "Isencao": "Exemption",
                "TotalDoVooDEPARR": "Total Flight - DEP-ARR",
                "TotalDoVooTempoTotal": "Total Flight - Total Time",
                "TotalDoVooNavegacao": "Total Flight - Navigation",
                "TotalDoVooInstrumento": "Total Flight - Instrument",
                "TotalDoVooNoturno": "Total Flight - Night",
                "TotalDoVooPousosDiurnos": "Total Flight - Day Landings",
                "TotalDoVooPousosNoturnos": "Total Flight - Night Landings",
                "TotalDoVooPAX": "Total Flight - PAX",
                "TotalDoVooCarga": "Total Flight - Cargo",
                "TotalDoVooConsumo": "Total Flight - Consumption",
                "QuantidadeAbastecida": "Quantity supplied",
                "Observacoes": "Comments",
                "FB": "FB",
                "Apresentacao": "Presentation",
                "Matricula": "Registration",
                "Tripulante": "Crew member",
                "Etapa": "Stage",
                "Origem": "From",
                "Destino": "To",
                "HrPart": "Hr. part.",
                "DEP": "DEP.",
                "ARR": "ARR.",
                "Corte": "Shutdown",
                "DEPARR": "DEP-ARR",
                "TempoTotal": "Total time",
                "TempoNavegacao": "Weather - Navigation",
                "TempoInstrumento": "Time - Instrument",
                "TempoNoturno": "Weather - Night",
                "PousosDiurnos": "Landings - Daytime",
                "PousosNoturnos": "Landings - Night",
                "Partidas": "Starts",
                "PAX": "PAX.",
                "Carga": "Payload",
                "CargaExternaLongLine": "External Cargo - Long Line",
                "CargaExternaShortLine": "External Load - Short Line",
                "CombustivelInicial": "Fuel - Initial",
                "CombustivelFinal": "Fuel - Final"
            }
        },
        "ExtratoDeRelatorioDeVooEmBloco": {
            "titulo": "Multiple Flight Report Extract",
            "formulario": {
              "DataInicial": "Initial date",
              "DataFinal": "Final date",
              "Aeronave": "Aircraft",
              "Contrato": "Contract",
              "Base": "Base",
              "Tripulantes": "Staff",
              "BasesContratual": "Contract Base",
              "SomenteAprovados": "Only approved",
              "linguagem": "Language",
            },
      
            "tabela": {
              "Data": "Date",
              "Prefixo": "Prefix",
              "Frota": "Fleet",
              "Base": "Base",
              "Contrato": "Contract",
              "Cliente": "Client",
              "NumeroRelatorio": "Report No.",
              "NumeroDoVoo": "Flight No."
            }
      
          },
        "ConferenciaDeMedicao": {
            "titulo": "Measurement conference",
            "formulario": {
                "DataInicial": "Initial date",
                "DataFinal": "Final date",
                "Contrato": "Contract",
                "Cliente": "Client",
                "TipoDeMedicao": "Measurement Type",
                "opcoesMedicao": {
                    "Sintetica": "Synthetic",
                    "Analitica": "Analytics"
                },
                "SomenteAprovados": "Only approved",
                "BaseContratual": "Contract Base"
            },
            "tabela": {
                "Contrato": "Contract",
                "PrefixoContrato": "Contract prefix",
                "Status": "Status",
                "NumeroDoVoo": "Flight No.",
                "Cliente": "Client",
                "CodigoPTBR": "PTBR code",
                "LocalidadeInicio": "Location - start",
                "LocalidadeFim": "Location - end",
                "Prefixo": "Prefix",
                "Inicio": "Start",
                "Fim": "End"
            }
        },
        "RelatorioDeVoosComCargaExterna": {
            "titulo": "Report of Flights with External Cargo",
            "formulario": {
                "DataInicial": "Initial date",
                "DataFinal": "Final date",
                "SomenteAprovados": "Only approved",
                "RelatorioDeVoo": "Flight Report",
                "Aeronave": "Aircraft",
                "Frota": "Fleet",
                "Tripulantes": "Crew",
                "placeholder": {
                    "InformeONumeroDoRelatorioDeVoo": "Enter the flight report number"
                }
            },
            "tabela": {
                "Data": "Date",
                "Prefixo": "Prefix",
                "Frota": "Fleet",
                "Base": "Base",
                "TipoDeVoo": "Flight Type",
                "Contrato": "Contract",
                "Cliente": "Client",
                "NumeroRelatorio": "Report No.",
                "NumeroDoVoo": "Flight No.",
                "Tripulantes": "Crew",
                "TotalDoVooDEPARR": "Total Flight - DEP-ARR",
                "TotalDoVooTempoTotal": "Total Flight - Total Time",
                "CargaExternaLongLine": "External Cargo - Long Line",
                "CargaExternaShortLine": "External Load - Short Line"
            }
        },
        "RelatorioDePontualidade": {
            "titulo": "Punctuality Report",
            "formulario": {
                "DataInicial": "Initial date",
                "DataFinal": "Final date",
                "Base": "Base",
                "SomenteAprovados": "Only approved",
                "TipoDeAtraso": "Type of delay",
                "opcoesTiposDeAtraso": {
                    "Decolagem": "Take-off",
                    "TempoDeVoo": "Flight time"
                }
            },
            "tabela": {
              EstatisticasDeVooDe(dataInicial, dataFinal){
                return `Flight statistic from ${dataInicial} to ${dataFinal}`
              },
      
                "Tipo": "Type",
                "Valor": "Value",
                "TempoTotalDeAtraso": "Total Delay Time",
                "Atrasados": "Late",
                "Pontuais": "Punctual",
                "MediaTempo": "Average Time",
                "Operacoes": "Operations",
                "Coordenacao": "Coordination",
                "Despacho": "Dispatch",
                "Manutencao": "Maintenance",
                "NumeroVoos": "Number of flights",
                "AtrasadosInterno": "Int arrears",
                "AtrasadosExterno": "Late Ext",
                "Pontualidade": "Punctuality",
                "PontualidadeSemAtrasoExterno": "Pont (w/o ext delays)",
                "PontualidadeSemAtrasoInterno": "Pont (w/o int delays)",
                "VooManutencao": "Flight Maintenance",
                "VooGiros": "Flight Tours",
                "VooTreinamento": "Flight Training",
                "VooPTBR": "PTBR flight",
                "VooOutrosClientes": "Flight Other Clients",
                "VoosComerciais": "Commercial Flights"
            }
        },
        "RelatorioDeAbastecimentos": {
            "titulo": "Supply Report",
            "formulario": {
                "DataInicial": "Initial date",
                "DataFinal": "Final date",
                "SomenteAprovados": "Only approved",
                "RelatorioDeVoo": "Flight Report",
                "Aeronave": "Aircraft",
                "Frota": "Fleet",
                "Localidade": "Location",
                "Base": "Base",
                "TipoDeVoo": "Flight Type",
                "Contrato": "Contract",
                "NumeroDeReciboDoCombustivel": "Fuel Receipt No.",
                "FornecedorDeCombustivel": "Fuel Supplier",
                "BaseContratual": "Contractual Base",
                "placeholder": {
                    "InformeONumeroDoRelatorioDeVoo": "Enter the flight report number",
                    "InformeONumeroDeReciboDoCombustivel": "Enter fuel receipt number",
                }
            },
            "tabela": {
                "ID": "ID",
                "Data": "Date",
                "Aeronave": "Aircraft",
                "Modelo": "Model",
                "NumeroRelatorioDeVoo": "Flight Report No.",
                "TipoDeVoo": "Tipo de Voo",
                "Empresa": "Company",
                "Fornecedor": "Supplier",
                "Localidade": "Location",
                "NumeroDoRecibo": "Receipt",
                "Quantidade": "Quantity",
                "ValorLitro": "Value/Liter",
                "ValorTotal": "Total Value",
                "Reembolsavel": "Refundable",
                "ValorReembolsavel": "Refundable Value",
                "ValorFinal": "Final Value",
            }
        },
        "ExtracaoDeXMLEmBloco": {
            "titulo": "Multiple XML extraction",
            "formulario": {
                "DataInicial": "Initial date",
                "DataFinal": "Final date",
                "Aeronave": "Aircraft",
                "Cliente": "Client",
                "Contrato": "Contract",
                "Base": "Base",
                "SomenteAprovados": "Only approved",
                "BaseContratual": "Contract Base"
            },
            "tabela": {
                "Data": "Date",
                "Prefixo": "Prefix",
                "Frota": "Fleet",
                "Base": "Base",
                "Contrato": "Contract",
                "Cliente": "Client",
                "NumeroRelatorio": "Report No.",
                "NumeroDoVoo": "Flight No."
            }
        }
    },
    "Voos": {
        "ListaDeVoos": {
            "deletar": "Are you sure you would like to delete this flight?",
            "titulo": "Flight list",
            "botaoEditarStatus": "Edit status",
            "formulario": {
                "DataInicial": "Initial date",
                "DataFinal": "Final date",
                "Base": "Base",
                "botaoProcurarVoos": "Search flights",
                "placeholder": {
                    "SelecionarBase": "Select base"
                }
            },
            "tabela": {
                EstatisticasDeVooEm(dataInicial, dataFinal) {
                    return `Flight Statistic from ${dataInicial} to ${dataFinal}`
                },
                "Tipo": "Type",
                "Valor": "Value",
                "TempoTotalDeAtraso": "Total Delay Time",
                "Atrasados": "Late",
                "Pontuais": "Punctual",
                "MediaTempo": "Average time",
                "Operacoes": "Operations",
                "Coordenacao": "Coordination",
                "Despacho": "Dispatch",
                "Manutencao": "Maintenance",
                "NumeroVoos": "Number of flights",
                "AtrasadosInt": "Int arrears",
                "AtrasadosExt": "Late Ext",
                "Pontualidade": "Punctuality",
                "PontSemAtrasosExt": "Pont (w/o ext delays)",
                "PontSemAtrasosInt": "Pont (w/o int delays)",
                "VooManutencao": "Flight Maintenance",
                "VooGiros": "Flight Tours",
                "VooTreinamento": "Flight Training",
                "VooPTBR": "PTBR flight",
                "VooOutrosClientes": "Flight Other Clients",
                "VoosComerciais": "Commercial Flights"
            },

            tituloVoosPara(dataInicial, dataFinal) {
                return `Flights from ${dataInicial} to ${dataFinal}`
            },

            "listaVoosPara": {
                "Atrasado": "Late",
                "SaidaPrevista": "Expected departure",
                "SaidaReal": "Actual output",
                "Atraso": "Delay",
                "JustificativaPTBR": "Justification PTBR",
                "Motivo": "Reason",
                "Codigo": "Code",
                "JustificativaOmni": "Internal Justification",
                "Setor": "Sector"
            }
        },
        "EditarVoos": {
            "deletar": "Are you sure you would like to delete this flight?",
            "titulo": "Edit flights",
            "botaoResumoDeVoos": "Flight summary",
            "formulario": {
                "Data": "Date",
                "Base": "Base",
                "Aeronave": "Aircraft",
                "TipoDeVoo": "Type of flight",
                "SaidaPrevista": "Expected departure",
                "SaidaReal": "Actual exit",
                "Atraso": "Delay",
                "JustificativaOMNI": "Internal justification",
                "JustificativaPTBR": "Justification PTBR",
                "CodigoPTBR": "PTBR code",
                "botaoSalvarVoo": "Save flight",
                "placeholder": {
                    "SelecionarBase": "Select base",
                    "SelecionarAeronave": "Select aircraft",
                    "Formato": "Format 00:00"
                }
            },

            tituloVoosPara(dataInicial, dataFinal) {
                return `Flights from ${dataInicial} to ${dataFinal}`
            },
            
            "listaVoosPara": {
                "Atrasado": "Late",
                "SaidaPrevista": "Expected departure",
                "SaidaReal": "Actual output",
                "Atraso": "Delay",
                "JustificativaPTBR": "Justification PTBR",
                "Motivo": "Reason",
                "Codigo": "Code",
                "JustificativaOmni": "Internal Justification",
                "Setor": "Sector"
            }
        },
        "TesteDeAlerta": {
            "titulo": "Alert test",
            "formulario": {
                "Frotas": "Fleets",
                "Escala": "Scale",
                "Aeronaves": "Aircraft",
                "Tripulantes": "Crew",
                "TripulanteSubstituido": "Replaced crew member",
                "botaoTestarAlertas": "Test alerts",
                "placeholder": {
                    "SelecionarFrota": "Select fleet",
                    "SelecionarEscala": "Select schedule",
                    "SelecionarAeronave": "Select aircraft",
                    "SelecionarTripulante": "Select crew member"
                }
            },
            "erros": "Mistakes"
        }
    },
    "TiposDeVoo": {
        "ListaDeTiposDeVoo": {
            "arquivar": "Are you sure you'd like to archive?",
            "ativar": "Are you sure you would like to activate?",
            "deletar": "Are you sure you would like to delete this flight?",
            "ativo": "Active",
            "arquivado": "Archived",
            "titulo": "List of flight types",
            "botaoAdicionarTipoDeVoo": "Add flight type",
            "tabela": {
                "semTiposDeVoo": "No flight types registered",
                "ID": "ID",
                "Nome": "Name",
                "Abreviacao": "Abbreviation",
                "CodigoANAC": "ANAC code",
                "RequerNumeroDeVoo": "Requires Flight Number",
                "RequerIsencao": "Requires Exemption",
                "Manutencao": "Maintenance",
                "Faturado": "Invoiced",
                "Status": "Status",
                "Acoes": "Actions"
            }
        },
        "AdicionarTipoDeVoo": {
            "titulo": "Register flight type",
            "formulario": {
                "Nome": "Name",
                "Abreviacao": "Abbreviation",
                "CodigoANAC": "ANAC code",
                "RequerNumeroDeVoo": "Requires Flight Number",
                "RequerIsencao": "Requires Exemption",
                "ExigeCliente": "Requires Customer",
                "Manutencao": "Maintenance",
                "Faturado": "Invoiced",
                "botaoCadastrarTipoDeVoo": "Register flight type",
                "placeholder": {
                    "SelecioneCodigo": "Select the code"
                }
            }
        },
        "EditarTipoDeVoo": {
            "titulo": "Edit flight type",
            "formulario": {
                "Nome": "Name",
                "Abreviacao": "Abbreviation",
                "CodigoANAC": "ANAC code",
                "RequerNumeroDeVoo": "Requires Flight Number",
                "RequerIsencao": "Requires Exemption",
                "ExigeCliente": "Requires Customer",
                "Manutencao": "Maintenance",
                "Faturado": "Invoiced",
                "botaoEditarTipoDeVoo": "Edit flight type",
                "placeholder": {
                    "SelecioneCodigo": "Select the code"
                }
            }
        }
    },
    "FornecedoresCombustivel": {
        "ListaDeFornecedores": {
            "titulo": "List of fuel suppliers",
            "botaoAdicionarFornecedor": "Add vendor from vendor",
            "deletar": "Are you sure you would like to delete this vendor?",
            "tabela": {
                "ID": "ID",
                "Nome": "Name",
                "Acoes": "Actions"
            }
        },
        "CadastrarFornecedor": {
            "titulo": "Register fuel supplier",
            "formulario": {
                "Nome": "Name",
                "Email": "E-mail",
                "Empresa": "Company",
                "botaoAdicionar": "Add"
            }
        },
        "EditarFornecedor": {
            "titulo": "Edit fuel supplier",
            "deletar": "Are you sure you would like to delete this tax?",
            "formulario": {
                "Nome": "Name",
                "Empresa": "Company",
                "Email": "E-mail",
                "RequerAprovacao": "Approval required?",
                "RequerExportacao": "Caribbean form required?",
                "RequerEmail": "Email required?",
                "botaoAdicionar": "To edit",
                "placeholder": {
                    "SelecionarEmpresa": "Select Company",
                    "SelecionarLocalidade": "Select Location",
                  }
          
            },
            "PrecosPorLocalidade": {
                "titulo": "Prices By Locations",
                "tituloToken": "Preços Por Localidades TOKEN",
                "tituloSupplierToken": "Edit fuel tax",
                "AdicionarLocalidade": {
                    "titulo": "Add Location",
                    "formulario": {
                        "Localidade": "Location",
                        "ValorLitro": "Value/Liter",
                        "DataDeInicioDaVigencia": "Effective date",
                        "DataDeTerminoDaVigencia": "Effective date",
                        "Moeda": "Currency",
                        "Ativos": "Active",
                        "botaoAdicionarLocalidade": "Add locations",
                        "placeholder": {
                            'SelecionarEmpresa': "Select Company",
                            'SelecionarLocalidade': "Select Location",
                            'SelecionarMoeda': "Select currency",
                        }
                    },
                    "tabela": {
                        "Localidade": "Location",
                        "Icao": "ICAO",
                        "InicioDaVigencia": "Effective date",
                        "TerminoDaVigencia": "Expiry date",
                        "Moeda": "Currency",
                        "Valor": "Value"
                    }
                },
                "AdicionarLocalidadeToken": {
                    "titulo": "Add Location",
                    "formulario": {
                        "Localidade": "Location",
                        "ValorLitro": "Value/Liter",
                        "DataDeInicioDaVigencia": "Effective date",
                        "DataDeTerminoDaVigencia": "Effective date",
                        "Moeda": "Currency",
                        "Ativos": "Active",
                        "botaoAdicionarLocalidade": "Add locations by token",
                        "placeholder": {
                            'SelecionarEmpresa': "Select Company",
                            'SelecionarLocalidade': "Select Location",
                            'SelecionarMoeda': "Select currency",
                        }
                    },
                    "tabela": {
                        "Token": "Token",
                        "Status": "Status",
                        "Localidade": "Location",
                        "InicioDaVigencia": "Effective date",
                        "TerminoDaVigencia": "Expiry date",
                        "Moeda": "Currency",
                        "Valor": "Value"
                    }
                },
                "EditarLocalidadeToken": {
                    "titulo": "Add Location",
                    "formulario": {
                        "ValorLitro": "Please fill below the fuel tax valid up from ",
                        "Ate": " until ",
                        "Moeda": "Currency",
                        "botaoEditarLocalidade": "Submit",
                        "placeholder": {
                            'ValorLitro': "Valor/Litro",
                            'SelecionarMoeda': "Select currency",
                        }
                    },
                    "tabela": {
                        "Token": "Token",
                        "Status": "Status",
                        "Localidade": "Location",
                        "InicioDaVigencia": "Effective date",
                        "TerminoDaVigencia": "Expiry date",
                        "Moeda": "Currency",
                        "Valor": "Value"
                    }
                }
            }
        }
    },
    "Gratificacao": {
        "ListaDeGratificacao": {
            "deletar": "Are you sure you'd like to delete this bonus?",
            "titulo": "Bonus list",
            "botaoAdicionarGratificacao": "Add gratuity",
            "tabela": {
                "semFornecedores": "There are no registered suppliers",
                "ID": "ID",
                "Nome": "Name",
                "Valor": "Value",
                "Acoes": "Actions"
            }
        },
        "AdicionarGratificacao": {
            "titulo": "Register gratuity",
            "formulario": {
                "Nome": "Name",
                "Valor": "Value",
                "botaoAdicionarGratificacao": "Add gratuity"
            }
        },
        "EditarGratificacao": {
            "titulo": "Edit Bonus",
            "formulario": {
                "Nome": "Name",
                "Valor": "Value"
            }
        }
    },
    "Importacoes": {
        "ListaDeImportacoes": {
            "atualizarSistemaComInformacoesDoRUBI": "Are you sure you want to update the system with RUBI information?",
            "titulo": "Imports",
            "naoFoiPossivelRealizarImportacaoDosDadosDoRUBI": "It was not possible to import RUBI data for the following reasons",
            "botaoImportar": "Import",
            "tabela": {
                "ID": "ID",
                "DataDeImportacao": "Import Date",
                "Acoes": "Actions"
            },
            "tituloLogDeEdicoes": "Edit log",
            "tabelaLogDeEdicoes": {
                "ID": "ID",
                "Colaborador": "Collaborator",
                "Tipo": "Type",
                "Campo": "Field",
                "ValorAntigo": "Old Value",
                "ValorNovo": "New Value"
            }
        }
    },
    "Incompatibilidades": {
        "ListaDeIncompatibilidades": {
            "deletar": "Are you sure you would like to delete this mismatch?",
            "titulo": "List of incompatibilities",
            "tituloAdicionarTripulante": "Add Crew",
            "formulario": {
                "PrimeiroTripulante": "First Crew",
                "SegundoTripulante": "Second Crew",
                "Obs": "Note",
                "botaoAdicionarTripulante": "Add Crew",
                "placeholder": {
                    "SelecionePrimeiroTripulante": "Select the first crew member",
                    "SelecioneSegundoTripulante": "Select the second crew member",
                    "Observacoes": "Comments"
                }
            },
            "tabela": {
                "semIncompatibilidades": "There are no registered incompatibilities",
                "ID": "ID",
                "Nome": "Name",
                "Tripulante1": "Crew member 1",
                "Tripulante2": "Crew member 2",
                "Observacoes": "Comments",
                "Acoes": "Actions"
            }
        }
    },
    "Layout": {
        "Topo": {
            "bemVindo": "Welcome,",
            "botaoSair": "Logout",
            "botaoMinhaConta": "Minha Conta",
            "menuCadastros": {
                "tituloMenu": "Registrations",
                "Empresas": "Companies",
                "ListaDeEmpresas": "List of companies",
                "CadastrarEmpresas": "Register companies",
                "Bases": "Bases",
                "ListaDeBases": "List of bases",
                "CadastrarBases": "Register bases",
                "Aeronaves": "Aircraft",
                "ListaDeAeronaves": "Aircraft list",
                "CadastrarAeronaves": "Register aircraft",
                "ListaDeModelosDeAeronaves": "List of aircraft models",
                "CadastrarModelosDeAeronave": "Register aircraft models",
                "Cargos": "Roles",
                "ListaDeCargos": "List of roles",
                "CadastrarCargos": "Register roles",
                "Setores": "Sectors",
                "ListaDeSetores": "List of sectors",
                "CadastrarSetores": "Register sectors",
                "Designacoes": "Designations",
                "ListaDeDesignacoes": "List of designations",
                "CadastrarDesignacoes": "Register designations",
                "ComposicaoDaCabine": "Cabin Composition",
                "ExperienciaMinima": "Minimum Experience",
                "IncompatibilidadesDeTripulantes": "Crew incompatibilities",
                "GraduacoesDeTripulantes": "Crew graduations",
                "CopilotosAutorizadosComando": "Authorized Copilots Command",
                "Gratificacoes": "Gratuities",
                "ListaDeGratificacoes": "List of bonuses",
                "CadastrarGratificacao": "Register gratuity",
                "Processos": "Law Suit",
                "ListaDeProcessos": "List of processes",
                "CadastrarProcessos": "Register processes",
                "ListaDeDocumentos": "Documents list",
                "CadastrarDocumentos": "Register documents",
                "OcorrenciaisAnormais": "Abnormal occurrences",
                "ListaDeOcorrenciasAnormais": "List of abnormal occurrences",
                "CadastrarOcorrenciaAnormal": "Register abnormal occurrence",
                "FuncoesDeBordo": "On-board functions",
                "ListaDeFuncoesDeBordo": "List of on-board functions",
                "CadastrarFuncaoDeBordo": "Register role on board",
                "Locais": "Locations",
                "ListaDeLocais": "List of locations",
                "CadastrarLocal": "Register location",
                "ListaDeTiposDeLocal": "List of location types",
                "CadastrarTipoDeLocal": "Register type of location",
                "ListaDeOperadores": "List of airport operators",
                "CadastrarOperador": "Register airport operator",
                "ListaDeResponsaveisPeloEspacoAereo": "List of airspace responsibles",
                "CadastrarResponsavelPeloEspacoAereo": "Register airspace responsible",
                "TiposDeVoo": "Flight types",
                "TiposDeOperacao": "Operation types",
                "ListaDeTiposDeOperacao": "List of operation types",
                "CadastrarTipoDeOperacao": "Register type of operation",
                "ListaDeTiposDeVoo": "List of flight types",
                "CadastrarTipoDeVoo": "Register flight type",
                "Petrobras": "Petrobras",
                "ReferenciasPTBR": "PTBR References",
                "FornecedoresDeCombustivel": "Fuel suppliers",
                "ListaDeFornecedores": "List of suppliers",
                "CadastrarFornecedores": "Register suppliers",
                "Atrasos": "Delays",
                "JustificativasDeAtrasoOmni": "Internal Delay Excuses"
            },
            "menuFuncionarios": {
                "tituloMenu": "Employees",
                "Controles": "Controls",
                "Colaboradores": "Staff",
                "ListaDeTripulantes": "Crew list",
                "ListaDeColaboradores": "Staff list",
                "ListaDeColaboradoresAtivos": "Active staff list",
                "ListaDeTripulantesDesligados": "List of retired crew",
                "ListaDeTodosOsTripulantes": "List of all crew",
                "ListaDeTripulantesPorDesignacao": "List of crew by designation",
                "ListaDeTripulantesPorICAO": "List of crew by ICAO",
                "PesquisaDeHabilitacoes": "Qualification search",
                "Cadastrar": "Register",
                "VencimentoDeCertificados": "Expiration of certifications",
                "VencimentoDeASOEEletrocardiograma": "Expiration of ASO and Electrocardiogram",
                "ListaDeCertificadosGeral": "General certification list",
                "TreinamentosRequeridos": "Required training",
                "Senioridade": "Seniority",
                "ListagemDeFuncionariosSemCargo": "Unassigned staff list",
                "ListagemDeFuncionariosSemCargoArquivados": "Unassigned archived staff list",
                "DocumentosQPulse": "Q-Pulse Docs",
                "ControleDeCertificadosPorDataDeEmissao": "Control of certifications by issue date",
                "CVODVO": "CVO / DVO",
                "ListaDeColaboradoresCVODVO": "List of CVO / DVO contributors",
                "ListaDeColaboradoresCVODVODesligados": "List of terminated CVO / DVO employees",
                "MestreDeCarga": "Load master",
                "ListaDeMestresDeCarga": "List of load masters",
                "ListaDeMestresDeCargaDesligados": "List of shutdown load masters",
                "Controle": "Control",
                "QualificacaoDeFornecedores": "Qualification of suppliers",
                "FiltroMultiploDeCertificados": "Multiple certification filter",
                "TreinamentosConsolidados": "Consolidated Training"
            },
            "menuEscalas": {
                "tituloMenu": "Schedules",
                "Escalas": "Schedules",
                "ListaDeEscalas": "List of schedules",
                "CadastrarEscala": "Register schedule",
                "Regimes": "Regimes",
                "ElaborarEscala": "Elaborate schedule",
                "PendenciasNaoResolvidas": "Pending Issues - Unresolved",
                "PendenciasArquivadas": "Pending Issues - Archived",
                "EscalaDeBase": "Base schedule",
                "ListaDeEscalasDeBase": "List of base schedules",
                "CadastrarEscalaDeBase": "Register base schedule",
                "Contratos": "Contracts",
                "ListaDeContratos": "List of contracts",
                "CadastrarContratos": "Register contracts",
                "Consulta": "Query",
                "Clientes": "Customers",
                "ListaDeClientes": "Customer list",
                "CadastrarClientes": "Register customers",
                "EscalaDeCVODVO": "CVO/DVO schedule",
                "ListaDeEscalasDeCVODVO": "List of CVO/DVO schedules",
                "CadastrarEscalaDeCVODVO": "Register CVO/DVO schedule",
                "EscalaDeMestreDeCarga": "Cargo Master Schedule",
                "ListaDeEscalasDeMestreDeCarga": "List of load master rosters",
                "CadastrarEscalaDeMestreDeCarga": "Register load master schedule",
                "SolicitacaoDeColaborador": "Employee Request",
                "ListaDeSolicitacoes": "List of requests",
                "ListaDeSolicitacoesPendentes": "List of pending requests",
                "Siglas": "Acronyms",
                "ListaDeSiglas": "List of acronyms",
                "CadastrarSiglas": "Register abbreviations",
                "Alertas": "Alerts",
                "TestarAlertas": "Test alerts",
                "EnvioMensalPTBR": "PTBR monthly shipping",
                "SolicitacoesDePagamento": "Payment requests",
                "DeslocamentoDeMissao": "Mission Shift",
                "DeslocamentoDeTreinamento": "Training Displacement",
                "TransporteDeMissao": "Mission Transport",
                "TransporteDeTreinamento": "Training Transport"
            },
            "menuTreinamentos": {
                "tituloMenu": "Trainings",
                "Treinamentos": "Trainings",
                "ListaDeTreinamentos": "Training list",
                "CadastrarTreinamentos": "Register training",
                "Certificados": "Certifications",
                "ListaDeCertificados": "List of certifications",
                "CadastrarCertificados": "Register certifications",
                "Fornecedores": "Supplier",
                "ListaDeFornecedores": "List of suppliers",
                "CadastrarFornecedores": "Register suppliers"
            },
            "menuFRMS": {
                "tituloMenu": "FRMS",
                "ParametrosDeFadiga": "Fatigue parameters",
                "ListaDeParametrosDeFadigas": "List of fatigue parameters",
                "CadastrarParametrosDeFadiga": "Register fatigue parameters",
                "Configuracoes": "Settings",
                "ConfiguracoesDePontuacao": "Score settings",
                "RelatoriosDeFadiga": "Fatigue reports",
                "CadastrarRelatoriosDeFadiga": "Register fatigue reports",
                "MonitoramentoDeFadiga": "Fatigue monitoring",
                "RelacaoDeTripulantesFadigados": "List of fatigued crew members",
                "RelacaoDeRelatoriosFaltantes": "List of missing reports",
                "PesquisaDeRelatoriosDeFadigaDiarios": "Fatigue Report Search - Diaries",
                "RevisaoDeRelatorioIncorreto": "Incorrect report review",
                "RelacaoDeAutoAvaliacoesDeFadiga": "Relationship of fatigue self-assessments",
                "EstatisticasDeEventosDeFadiga": "Fatigue event statistics",
                "ImportacaoSIGLA": "Import - ACRONYM",
                "CadastrarRelatorios": "Register reports",
                "AvaliarEscalaPlanejada": "Evaluate planned schedule",
                "EfetividadeDosControles": "Effectiveness of Controls",
                "ListaDeFormulariosMensais": "List of monthly forms",
                "CadastrarFormularioMensal": "Register monthly form",
                "EstatisticasDosFormulariosDeEfetividade": "Effectiveness form statistics",
                "SimuladorDeRelatoriosDeFadiga": "Fatigue report simulator",
                "SimularRelatoriosDeFadiga": "Simulate fatigue reports",
                "ReporteVoluntarioDeFadiga": "Voluntary fatigue report",
                "CadastroDeMotivosDeFadiga": "Registration of reasons for fatigue",
                "ReportesVoluntariosDeFadigaAbertos": "Voluntary Fatigue Reports - Open",
                "ReportesVoluntariosDeFadigaFechados": "Voluntary Fatigue Reports - Closed",
                "Tarefas": "Tasks",
                "ListaDeTarefas": "To-do list",
                "CadastrarTarefas": "Register tasks",
                "TesteDeSonolencia": "Drowsiness test",
                "EscalasDeTestes": "Test schedules",
                "CadastrarEscalaDeTestes": "Register test schedule",
                "PesquisaDeFadiga": "Fatigue survey",
                "ControleDeRespostasDeQuestionario": "Questionnaire response control"
            },
            "menuVoos": {
                "tituloMenu": "Flights",
                "Abastecimentos": "Refuel",
                "ListaDeAbastecimentos": "Refuel list",
                "CadastrarAbastecimentoAvulso": "Register refuel",
                "Relatorios": "Reports",
                "ListaDeRelatoriosDeVoo": "Flight report list",
                "CadastrarRelatorioDeVoo": "Register flight report",
                "EscalaDiaria": "Daily schedule",
                "ReboqueDeAeronave": "Aircraft Towing",
                "ConsultarReboques": "Consult",
                "CadastrarReboques": "Register",
                "ListaDeEscalasDiaria": "List of daily schedule",
                "DisponibilidadeDeTripulantes": "Crew Availability",
                "SimularEscalaDiaria": "Simulate daily schedule",
                "MovimentacaoDeAeronavesMensal": "Handling of Aircraft - Monthly",
                "MovimentacaoDeAeronavesAnual": "Handling of Aircraft - Annual",
                "Indisponibilidade": "Unavailability",
                "AeronavesIndisponiveis": "Unavailable aircraft",
                "ListaDeIndisponibilidades": "List of Unavailability",
                "IndisponibilidadesArquivadas": "Archived unavailabilitys",
                "CadastrarIndisponibilidade": "Register unavailability",
                "PapeletasIndividuaisFIRA": "Individual pilot logbooks (FIRA)",
                "ConsultaDePapeletas": "Search pilot logboos",
                "ListaDePapeletas": "List of pilot logbooks",
                "ControleDeFIRA": "FIRA control",
                "HorasDeVoo": "Flight hours",
                "GerarPagamentoNoClienteDePagamentos": "Generate payments in the Payments client",
                "Alertas": "Alerts",
                "ListaDeAlertas": "List of alerts",
                "RequisitosPersonalizados": "Custom Requirements",
                "Controles": "Controls",
                "ConsultaContratos": "Contracts search",
                "VisualizarHoraDeVoo": "View flight time",
                "ControleGeralDeRelatorios": "General Control of Reports",
                "ExtratoDeXMLEmBloco": "Multiple XML extract",
                "ExtratoDeDBEmBloco": "Multiple DB extract",
                "ExtratoDeRelatoriosEmBloco": "Multiple Report Extract",
                "ControleDiarioDeUtilizacaoDeAeronavesContratadas": "Daily Control of Use of Contracted Aircraft",
                "QuantidadeDeVoosPorDia": "Number of flights per day",
                "RelatorioDeAbastecimentos": "Supply Report",
                "RelatorioDeConsumo": "Consumption Report",
                "RelatorioDeDisponibilidadeDeCombustivel": "Fuel Availability Report",
                "RelatorioDeHorasGeradasPorTipoDeCargo": "Report of Hours Generated by Type of Position",
                "RelatorioDePousosPorLocalidade": "Landing Report by Location",
                "RelatorioDeTempoEmSolo": "Ground Time Report",
                "RelatorioDeVoosComCargaExterna": "Report of Flights with External Cargo",
                "RelatorioDeTempoEntreTrechos": "Time Report between Legs",
                "ConsultaDeIndisponibilidade": "Unavailability query",
                "BoletimDeDisponibilidade": "Availability bulletin",
                "ApuracaoDeHoras": "Time calculation",
                "ConferenciaDeMedicao": "Measurement conference",
                "ControleDeExperienciaNoturna": "Night Experience Control",
                "ControleDeTarifas": "Tariff Control"
            },
            "menuConfiguracoes": {
                "UsuariosDoSistema": "System users",
                "ListaDeUsuarios": "User list",
                "Emails": "Emails",
                "ListaDeEnderecoDeEmails": "Email address list",
                "Importacoes": "Imports",
                "Importar": "Import",
                "Diversos": "Several",
                "LinksUteis": "Useful links"
            },
            "atencaoVoceEstaUtilizandoOAmbienteDeHomologacao": "Attention: You are using the approval environment"
        }
    },
    "Locais": {
        "ListaDeLocais": {
            "deletar": "Are you sure you would like to delete this location?",
            "ativar": "Are you sure you would like to enable this location?",
            "arquivar": "Are you sure you'd like to archive this location?",
            "ativo": "Active",
            "arquivado": "Archived",
            "titulo": "List of locations",
            "botaoAdicionarLocal": "Add location",
            "tabela": {
                "semLocais": "There are no registered locations",
                "ID": "ID",
                "Nome": "Name",
                "CodigoICAO": "ICAO code",
                "CodigoIATA": "IATA code",
                "Cidade": "City",
                "CoordenadaLat": "Lat coordinate.",
                "CoordenadaLong": "Coordinate long.",
                "Tipo": "Type",
                "Shore": "Shore",
                "Status": "Status",
                "Acoes": "Actions"
            }
        },
        "AdicionarLocal": {
            "titulo": "Register location",
            "formulario": {
                "Nome": "Name",
                "CodigoICAO": "ICAO code",
                "Cidade": "City",
                "Shore": "Shore",
                "opcoesShore": {
                    "OnShore": "On shore",
                    "OffShore": "Off shore"
                },
                "Latitude": "Latitude",
                "Longitude": "Longitude",
                "CodigoIATA": "IATA code",
                "Tipo": "Type",
                "Grupo": "Group",
                "Classe": "Class",
                "Pais": "Country",
                "placeholder": {
                    "CodigoIATA": "IATA code"
                }
            }
        },
        "EditarLocal": {
            "titulo": "Edit location",
            "formulario": {
                "Nome": "Name",
                "CodigoICAO": "ICAO code",
                "Cidade": "City",
                "Shore": "Shore",
                "opcoesShore": {
                    "OnShore": "On shore",
                    "OffShore": "Off shore"
                },
                "Latitude": "Latitude",
                "Longitude": "Longitude",
                "CodigoIATA": "IATA code",
                "Tipo": "Type",
                "Grupo": "Group",
                "Classe": "Class",
                "Pais": "Country",
                "placeholder": {
                    "CodigoIATA": "IATA code"
                }
            }
        }
    },
    "TiposDeLocalidades": {
        "ListaDeTiposDeLocalidade": {
            "deletar": "Are you sure you would like to delete this location type?",
            "titulo": "List of location types",
            "botaoAdicionarTipoDeLocalidade": "Add location type",
            "tabela": {
                "semFuncoesDeBordo": "There are no registered on-board functions",
                "ID": "ID",
                "Descricao": "Description",
                "Acoes": "Actions"
            }
        },
        "AdicionarTipoDeLocalidade": {
            "titulo": "Register location type",
            "formulario": {
                "Descricao": "Description"
            }
        },
        "EditarTipoDeLocalidade": {
            "titulo": "Edit location type",
            "formulario": {
                "Descricao": "Description"
            }
        }
    },
    "Logs": {
        "ListaLogs": {
            "verRequest": "See request",
            "titulo": "Logs",
            "tabela": {
                "semTripulantesCadastrados": "There are no registered crew",
                "ID": "ID",
                "Usuario": "User",
                "Acao": "Action",
                "Controller": "Controller",
                "Action": "Action",
                "Metodo": "Method",
                "Request": "Request",
                "Data": "Date"
            },
            "tituloRequestDetalhado": "Detailed request"
        }
    },
    "Miscelania": {
        "Overlay": {
            "paragrafoCarregando": "Loading..."
        },
        "RequestApi": {
            "seuUsuarioNaoTemPermissaoParaAcessarEstaPagina": "Your username does not have permission to access this page.",
            "seuUsuarioNaoTemPermissaoParaAcessarEstaFuncionalidade": "Your user does not have permission to access this feature."
        }
    },
    "TiposDeOperacao": {
        "ListaDeTiposDeOperacao": {
            "deletar": "Are you sure you would like to delete this operation?",
            "titulo": "List of operation types",
            "botaoAdicionarTipoDeOperacao": "Add Operation Type",
            "tabela": {
                "semFuncoesDeBordo": "There are no registered on-board functions",
                "ID": "ID",
                "Nome": "Name",
                "Descricao": "Description",
                "Acoes": "Actions"
            }
        },
        "AdicionarTipoDeOperacao": {
            "titulo": "Register type of operation",
            "formulario": {
                "Nome": "Name",
                "Descricao": "Description"
            }
        },
        "EditarTipoDeOperacao": {
            "titulo": "Edit type of operation",
            "formulario": {
                "Nome": "Name",
                "Descricao": "Description"
            }
        }
    },
    "OrdensDePagamento": {
        "ListaDeOrdensDePagamentoEnviadas": {
            "deletar": "Are you sure you would like to delete this customer?",
            "titulo": "List of submitted OPs",
            "botaoAdicionarOrdemDePagamento": "Add payment order",
            "tabela": {
                "semFornecedoresCadastrados": "There are no registered suppliers",
                "ID": "ID",
                "Nome": "Name",
                "Codigo": "Code",
                "Status": "Status",
                "DataDeCriacao": "Creation date",
                "Acoes": "Actions"
            }
        },
        "ListaDeOrdensDePagamentoAbertas": {
            "deletar": "Are you sure you would like to delete this customer?",
            "titulo": "Open OP list",
            "botaoAdicionarOrdemDePagamento": "Add payment order",
            "tabela": {
                "semFornecedoresCadastrados": "There are no registered suppliers",
                "ID": "ID",
                "Nome": "Name",
                "Codigo": "Code",
                "Status": "Status",
                "DataDeCriacao": "Creation date",
                "Acoes": "Actions"
            }
        },
        "AdicionarOrdemDePagamento": {
            "opcoesTipo": {
                "Missao": "Mission",
                "Treinamentos": "Trainings"
            },
            "titulo": "Create payment order",
            "formulario": {
                "Nome": "Name",
                "Tipo": "Type",
                "Codigo": "Code",
                "botaoAdicionarOrdemDePagamento": "Add payment order"
            }
        },
        "EditarOrdemDePagamento": {
            "titulo": "Edit Payment order",
            "erros": "The following errors prevented the payment from being sent",
            "tabDadosDaOrdemDePagamento": {
                "tituloTab": "Payment order data",
                "opcoesStatus": {
                    "Prevista": "Preview",
                    "EnviadaParaAprovacao": "Sent for Approval",
                    "Aprovada": "Approved",
                    "PagamentoAgendado": "Scheduled Payment",
                    "PagamentoEfetuado": "Payment made",
                    "Cancelada": "Canceled"
                },
                "osEmailsEstaoSendoReenviados": "Emails are being forwarded. This operation can take between 30 to 60 seconds. We will start shipping soon.",
                "osEmailsEstaoSendoEnviados": "Emails are being sent. This operation can take between 30 to 60 seconds. We will start shipping soon.",
                "formulario": {
                    "Nome": "Name",
                    "Codigo": "Code",
                    "Status": "Status",
                    "DataDePagamento": "Payday"
                },
                "botaoReenviarEmailDePagamento": "Resend payment email",
                "botaoEnviarPagamento": "Send payment"
            },
            "tabTreinamentos": {
                "tituloTab": "Trainings",
                "tabHoras": {
                    "tituloTab": "Hours",
                    "deletar": "Are you sure you'd like to delete this OP payment?",
                    "botaoExportarHoras": "Export hours",
                    "tabela": {
                        "semPagamentosEmAberto": "There are no outstanding payments",
                        "Acoes": "Actions",
                        "ID": "ID",
                        "Status": "Status",
                        "Nome": "Name",
                        "TipoDeTreinamento": "Training type.",
                        "Aula": "Class",
                        "Periodo": "Time course",
                        "Treinamento": "Training",
                        "NumeroERev": "NÂº and Rev.",
                        "Local": "Place",
                        "HorasPagas": "Paid hours",
                        "ValorDaHora": "Time value",
                        "TotalDeHoras": "Total amount of hours"
                    }
                },
                "tabNacional": {
                    "tituloTab": "National",
                    "deletar": "Are you sure you'd like to delete this OP payment?",
                    "botaoExportarDiariasNacionais": "Export national rates",
                    "tabela": {
                        "semPagamentosEmAberto": "There are no outstanding payments",
                        "Acoes": "Actions",
                        "ID": "ID",
                        "Saldo": "Balance",
                        "Nome": "Name",
                        "Periodo": "Time course",
                        "Treinamento": "Training",
                        "NumeroERev": "NÂº and Rev.",
                        "Diarias": "Daily",
                        "ValorDiaria": "Value/daily",
                        "Desconto": "Discount",
                        "TotalEmDiarias": "Total in daily",
                        "Moeda": "Coin"
                    },
                    "tituloDiasDoPagamento": "Paydays",
                    "tabelaDiasDoPagamento": {
                        "Data": "Date",
                        "Diarias": "Daily",
                        "Status": "Status"
                    }
                },
                "tabInternacional": {
                    "tituloTab": "International",
                    "deletar": "Are you sure you'd like to delete this OP payment?",
                    "botaoExportarDiariasInternacionais": "Export international rates",
                    "tabela": {
                        "semPagamentosEmAberto": "There are no outstanding payments",
                        "Acoes": "Actions",
                        "ID": "ID",
                        "Saldo": "Balance",
                        "Nome": "Name",
                        "Periodo": "Time course",
                        "Treinamento": "Training",
                        "NumeroERev": "NÂº and Rev.",
                        "Diarias": "Daily",
                        "ValorDiaria": "Value/daily",
                        "Desconto": "Discount",
                        "TotalEmDiarias": "Total in daily",
                        "Moeda": "Coin"
                    },
                    "tituloDiasDoPagamento": "Paydays",
                    "tabelaDiasDoPagamento": {
                        "Data": "Date",
                        "Diarias": "Daily",
                        "Status": "Status"
                    }
                }
            },
            "tabEscala": {
                "tituloTab": "Schedule",
                "tabHoras": {
                    "tituloTab": "Hours",
                    "deletar": "Are you sure you'd like to delete this OP payment?",
                    "botaoExportarHoras": "Export hours",
                    "tabela": {
                        "semPagamentosEmAberto": "There are no outstanding payments",
                        "Acoes": "Actions",
                        "ID": "ID",
                        "Status": "Status",
                        "Nome": "Name",
                        "Periodo": "Time course",
                        "HorasPagas": "Paid hours",
                        "ValorDaHora": "Time value",
                        "TotalPago": "Total paid"
                    }
                },
                "tabDiarias": {
                    "tituloTab": "Daily",
                    "deletar": "Are you sure you'd like to delete this OP payment?",
                    "botaoExportarDiariasDeMissao": "Export quest dailies",
                    "tabela": {
                        "semPagamentosEmAberto": "There are no outstanding payments",
                        "Acoes": "Actions",
                        "ID": "ID",
                        "Saldo": "Balance",
                        "Nome": "Name",
                        "Frota": "Fleet",
                        "Mes": "Month",
                        "Revisao": "Revision",
                        "Diarias": "Daily",
                        "ValorDiaria": "Amount/Daily",
                        "Desconto": "Discount",
                        "TotalEmDiarias": "Total in daily",
                        "Moeda": "Coin"
                    },
                    "tituloDiasDoPagamento": "Paydays",
                    "tabelaDiasDoPagamento": {
                        "Data": "Date",
                        "Diarias": "Daily",
                        "Status": "Status"
                    }
                }
            },
            "tabIndenizacoes": {
                "tituloTab": "Indemnities",
                "tabCheques": {
                    "tituloTab": "Checks",
                    "deletar": "Are you sure you'd like to delete this OP payment?",
                    "botaoExportarDiariasDeMissao": "Export quest dailies",
                    "tabela": {
                        "semPagamentosEmAberto": "There are no outstanding payments",
                        "Acoes": "Actions",
                        "ID": "ID",
                        "Examinador": "Examiner",
                        "Checado": "Checked",
                        "Data": "Date",
                        "Canac": "Canac",
                        "Matricula": "Registration",
                        "Valor": "Value",
                        "Moeda": "Coin"
                    },
                    "tituloDiasDoPagamento": "Paydays",
                    "tabelaDiasDoPagamento": {
                        "Data": "Date",
                        "Diarias": "Daily",
                        "Status": "Status"
                    }
                },
                "tabRepresentanteOperacional": {
                    "tituloTab": "Operational Representative",
                    "deletar": "Are you sure you'd like to delete this OP payment?",
                    "botaoExportarDiariasDeMissao": "Export quest dailies",
                    "tabela": {
                        "semPagamentosEmAberto": "There are no outstanding payments",
                        "Acoes": "Actions",
                        "ID": "ID",
                        "Nome": "Name",
                        "Mes": "Month",
                        "BaseOperacional": "Operating Base",
                        "Revisao": "Revision",
                        "ValorReferencia": "Reference value",
                        "Quantidade": "The amount",
                        "ValorTotal": "Amount",
                        "Moeda": "Coin"
                    },
                    "tituloDiasDoPagamento": "Paydays",
                    "tabelaDiasDoPagamento": {
                        "Data": "Date",
                        "Diarias": "Daily",
                        "Status": "Status"
                    }
                },
                "tabDeslocamento": {
                    "tituloTab": "Displacement",
                    "deletar": "Are you sure you'd like to delete this OP payment?",
                    "botaoExportarDiariasDeMissao": "Export quest dailies",
                    "tabela": {
                        "semPagamentosEmAberto": "There are no outstanding payments",
                        "Acoes": "Actions",
                        "ID": "ID",
                        "Nome": "Name",
                        "Frota": "Fleet",
                        "Mes": "Month",
                        "Revisao": "Revision",
                        "Distancia": "Distance",
                        "Valor": "Value",
                        "Total": "Total",
                        "Moeda": "Coin"
                    }
                },
                "tabTransporte": {
                    "tituloTab": "Transport",
                    "deletar": "Are you sure you'd like to delete this OP payment?",
                    "botaoExportarDiariasDeMissao": "Export quest dailies",
                    "tabela": {
                        "semPagamentosEmAberto": "There are no outstanding payments",
                        "Acoes": "Actions",
                        "ID": "ID",
                        "Nome": "Name",
                        "Frota": "Fleet",
                        "Mes": "Month",
                        "Revisao": "Revision",
                        "Moeda": "Coin",
                        "Quantidade": "The amount",
                        "Valor": "Value",
                        "Total": "Total"
                    }
                }
            }
        }
    },
    "SolicitacoesDePagamento": {
        "SolicitacoesDePagamentoTransporteTreinamento": {
            "aprovarSolicitacao": "Are you sure you'd like to approve this request?",
            "statusDePagamentoAtualizadoComSucesso": "Payment status updated successfully",
            "reprovarSolicitacao": "Are you sure you'd like to disapprove this request?",
            "titulo": "Payment Requests - Transportation - Training",
            "tabela": {
                "semSolicitacaoDePagamento": "No payment request registered",
                "ID": "ID",
                "Nome": "Name",
                "Status": "Status",
                "Lote": "Batch",
                "Treinamento": "Training",
                "Base": "Base",
                "Revisao": "Revision",
                "Quantidade": "The amount",
                "Valor": "Value",
                "Moeda": "Coin",
                "Observacao": "Observation",
                "Acoes": "Actions"
            },
            "tituloReprovacaoDePagamento": "Disapproval of Payment",
            "formulario": {
                "Justificativa": "Justification",
                "botaoReprovarPagamento": "Reject payment"
            }
        },
        "SolicitacoesDePagamentoDeslocamentoTreinamento": {
            "aprovarSolicitacao": "Are you sure you'd like to approve this request?",
            "statusDePagamentoAtualizadoComSucesso": "Payment status updated successfully",
            "reprovarSolicitacao": "Are you sure you'd like to disapprove this request?",
            "titulo": "Payment Requests - Displacement - Training",
            "tabela": {
                "semSolicitacaoDePagamento": "No payment request registered",
                "ID": "ID",
                "Nome": "Name",
                "Status": "Status",
                "Lote": "Batch",
                "Treinamento": "Training",
                "Revisao": "Revision",
                "Inicio": "Start",
                "Fim": "End",
                "Quantidade": "The amount",
                "Valor": "Value",
                "ValorTotal": "Amount",
                "Moeda": "Coin",
                "Observacao": "Observation",
                "Acoes": "Actions"
            },
            "tituloReprovacaoDePagamento": "Disapproval of Payment",
            "formulario": {
                "Justificativa": "Justification",
                "botaoReprovarPagamento": "Reject payment"
            },
            "tituloBases": "Bases",
            "tabelaBases": {
                "Origem": "From",
                "CEPOrigem": "CEP Origin",
                "Destino": "Destiny",
                "CEPDestino": "CEP Destination"
            }
        },
        "SolicitacoesDePagamentoTransporteMissao": {
            "aprovarSolicitacao": "Are you sure you'd like to approve this request?",
            "statusDePagamentoAtualizadoComSucesso": "Payment status updated successfully",
            "reprovarSolicitacao": "Are you sure you'd like to disapprove this request?",
            "titulo": "Payment Requests - Transport - Mission",
            "tabela": {
                "semSolicitacaoDePagamento": "No payment request registered",
                "ID": "ID",
                "Nome": "Name",
                "Status": "Status",
                "Lote": "Batch",
                "Frota": "Fleet",
                "Mes": "Month",
                "Base": "Base",
                "Revisao": "Revision",
                "Quantidade": "The amount",
                "Valor": "Value",
                "Moeda": "Coin",
                "Observacao": "Observation",
                "Acoes": "Actions"
            },
            "tituloReprovacaoDePagamento": "Disapproval of Payment",
            "formulario": {
                "Justificativa": "Justification",
                "botaoReprovarPagamento": "Reject payment"
            }
        },
        "SolicitacoesDePagamentoDeslocamentoMissao": {
            "aprovarSolicitacao": "Are you sure you'd like to approve this request?",
            "statusDePagamentoAtualizadoComSucesso": "Payment status updated successfully",
            "reprovarSolicitacao": "Are you sure you'd like to disapprove this request?",
            "titulo": "Payment Requests - Displacement - Mission",
            "tabela": {
                "semSolicitacaoDePagamento": "No payment request registered",
                "ID": "ID",
                "Nome": "Name",
                "Status": "Status",
                "Lote": "Batch",
                "Frota": "Fleet",
                "Mes": "Month",
                "Revisao": "Revision",
                "Inicio": "Start",
                "Fim": "End",
                "Quantidade": "The amount",
                "Valor": "Value",
                "ValorTotal": "Amount",
                "Moeda": "Coin",
                "Observacao": "Observation",
                "Acoes": "Actions"
            },
            "tituloReprovacaoDePagamento": "Disapproval of Payment",
            "formulario": {
                "Justificativa": "Justification",
                "botaoReprovarPagamento": "Reject payment"
            },
            "tituloBases": "Bases",
            "tabelaBases": {
                "Origem": "From",
                "CEPOrigem": "CEP Origin",
                "Destino": "Destiny",
                "CEPDestino": "CEP Destination"
            }
        }
    },
    "Pagamentos": {
        "ListaDePagamentosEmAbertoHoras": {
            "titulo": "List of open payments - hours",
            "atencaoRelatoriosAindaNaoConcluidos": "Attention! There are reports not yet completed in the selected period",
            "formulario": {
                "DataInicial": "Initial date",
                "DataFinal": "Final date",
                "IncluirPagos": "Include paid",
                "botaoBuscarPagamentos": "Fetch payments"
            },
            "formularioOrdemDePagamento": {
                "OrdemDePagamento": "Payment order",
                "placeholder": {
                    "SelecionarOrdemDePagamento": "Select payment order"
                },
                "botaoAdicionarOrdemDePagamento": "Add payment order",
                "botaoDeletarPagamentos": "Delete payments"
            },
            "tabela": {
                "semPagamentosEmAberto": "There are no outstanding payments",
                "ID": "ID",
                "Matricula": "Registration",
                "NomeDoColaborador": "Employee Name",
                "TotalGeral": "Grand total",
                "HorasDiurnas": "Daytime hours",
                "HorasNoturnas": "Night hours",
                "HorasDomingosFeriados": "Hours Sundays/Holidays",
                "SomaGeral": "Grand sum"
            }
        }
    },
    "ValoresDePagamento": {
        "EditarValoresDeDiarias": {
            "opcoesTipo": {
                "DiariaNacional": "Daily rate - national",
                "DiariaInternacional": "Daily - international",
                "DiariaEuropa": "Rate - Europe",
                "IndenizacaoTransporte": "Compensation - transport",
                "IndenizacaoDeslocamento": "Compensation - displacement",
                "IndenizacaoRepresentanteOperacional": "Compensation - operational representative",
                "IndenizacaoGratificacaoDeCheque": "Compensation - check gratuity"
            },
            "deletar": "Are you sure you want to delete this payment group?",
            "titulo": "Edit room rates",
            "formulario": {
                "Tipo": "Type",
                "Cargo": "Role",
                "Empresa": "Company",
                "Moeda": "Coin",
                "Valor": "Value"
            },
            "tituloValoresCadastrados": "Registered values",
            "tabela": {
                "Tipo": "Type",
                "Empresa": "Company",
                "Moeda": "Coin",
                "Valor": "Value",
                "Cargos": "Roles"
            }
        }
    },
    "Processos": {
        "ListaDeProcessos": {
            "deletar": "Are you sure you would like to delete this process?",
            "titulo": "List of processes",
            "botaoAdicionarProcesso": "Add process",
            "tabela": {
                "semFornecedoresCadastrados": "There are no registered suppliers",
                "ID": "ID",
                "Nome": "Name",
                "Acoes": "Actions"
            }
        },
        "AdicionarProcesso": {
            "titulo": "Register process",
            "formulario": {
                "Nome": "Name",
                "placeholder": {
                    "NomeDoProcesso": "Process name"
                },
                "botaoAdicionarProcesso": "Add process"
            }
        },
        "EditarProcesso": {
            "titulo": "Edit Process",
            "tabDadosDoProcesso": {
                "tituloTab": "Process data",
                "formulario": {
                    "Nome": "Name",
                    "placeholder": {
                        "NomeDoProcesso": "Process name"
                    }
                },
                "tituloAdicionarNovoSubtipo": "Add new subtype",
                "formularioAdicionarNovoSubtipo": {
                    "NomeDoSubtipo": "Subtype name",
                    "botaoAdicionarSubtipo": "Add subtype",
                    "placeholder": {
                        "NomeDoSubtipo": "Subtype name"
                    }
                },
                "deletarDocumento": "Are you sure you would like to delete this document?",
                "deletarSubtipoEDocumentosRelacionados": "Are you sure you would like to delete this subtype and related documents?",
                "tituloDocumentos": "Documents",
                "formularioDocumentos": {
                    "Documentos": "Documents",
                    "DocumentObrigatorio": "Mandatory document",
                    "botaoAdicionarDocumento": "Add document",
                    "placeholder": {
                        "SelecionarDocumentos": "Select documents"
                    }
                },
                "tabelaDocumentos": {
                    "semDocumentos": "There are no registered documents",
                    "ID": "ID",
                    "Documento": "Document",
                    "DocumentoObrigatorio": "Mandatory document",
                    "Acoes": "Actions"
                }
            }
        }
    },
    "PTBR": {
        "ReferenciasPTBR": {
            "titulo": "PTBR References",
            "tabCodigosDaExportacaoXML": {
                "tituloTab": "XML export codes",
                "deletarCodigo": "Are you sure you want to delete this code?",
                "formulario": {
                    "CDOP": "CDOP",
                    "GRPOP": "GRPOP",
                    "Descricao": "Description",
                    "Tabela": "Table",
                    "UsoInterno": "Intern use",
                    "opcoesUsoInterno": {
                        "CodigoDePartida": "1 - Starting Code",
                        "CodigoDeDecolagem": "2 - Takeoff Code",
                        "CodigoDePouso": "3 - Landing Code",
                        "CodigoDeCorte": "4 - Cut Code",
                        "CodigoDeVoo": "5 - Flight Code",
                        "CodigoDeAtraso": "6 - Delay Code",
                        "CodigoPadraoDeVoo": "7 - Standard Flight Code"
                    },
                    "botaoAdicionarCodigoPTBR": "Add PTBR code",
                    "placeholder": {
                        "CDOP": "CDOP",
                        "GRPOP": "GRPOP",
                        "Descricao": "Description",
                        "NomeDaTabela": "Table name",
                        "SelecioneOUsoInterno": "Select internal use"
                    }
                },
                "tabela": {
                    "semCodigosPTBR": "There are no registered PTBR codes",
                    "ID": "ID",
                    "CDOP": "CDOP",
                    "GRPOP": "GRPOP",
                    "Descricao": "Description",
                    "Tabela": "Table",
                    "UsoInterno": "Intern use",
                    "Acoes": "Actions"
                },
                "tituloEditarCodigoPTBR": "Edit PTBR code",
                "forumlarioEditarCodigoPTBR": {
                    "CDOP": "CDOP",
                    "GRPOP": "GRPOP",
                    "Descricao": "Description",
                    "Tabela": "Table",
                    "UsoInterno": "Intern use",
                    "opcoesUsoInterno": {
                        "CodigoDePartida": "1 - Starting Code",
                        "CodigoDeDecolagem": "2 - Takeoff Code",
                        "CodigoDePouso": "3 - Landing Code",
                        "CodigoDeCorte": "4 - Cut Code",
                        "CodigoDeVoo": "5 - Flight Code",
                        "CodigoDeAtraso": "6 - Delay Code",
                        "CodigoPadraoDeVoo": "7 - Standard Flight Code"
                    },
                    "botaoEditarCodigoPTBR": "Edit PTBR code",
                    "placeholder": {
                        "CDOP": "CDOP",
                        "GRPOP": "GRPOP",
                        "Descricao": "Description",
                        "NomeDaTabela": "Table name",
                        "SelecioneOUsoInterno": "Select internal use"
                    }
                }
            },
            "tabOperacoes": {
                "tituloTab": "Operations",
                "deletarOperacao": "Are you sure you would like to delete this operation?",
                "formulario": {
                    "Tipo": "Type",
                    "Descricao": "Description",
                    "CargaExterna": "External Load",
                    "botaoAdicionarOperacaoPTBR": "Add PTBR operation",
                    "placeholder": {
                        "Tipo": "Type",
                        "Descricao": "Description"
                    }
                },
                "tabela": {
                    "semOperacoesPTBR": "There are no registered PTBR operations",
                    "ID": "ID",
                    "Tipo": "Type",
                    "Descricao": "Description",
                    "CargaExterna": "External Load",
                    "Acoes": "Actions"
                },
                "tituloEditarOperacaoPTBR": "Edit PTBR operation",
                "formularioEditarOperacaoPTBR": {
                    "Tipo": "Type",
                    "Descricao": "Description",
                    "CargaExterna": "External load",
                    "botaoEditarOperacaoPTBR": "Edit PTBR operation",
                    "placeholder": {
                        "Tipo": "Type",
                        "Descricao": "Description"
                    }
                }
            },
            "tabCombustivel": {
                "tituloTab": "Fuel",
                "deletarCombustivel": "Are you sure you would like to delete this fuel?",
                "formulario": {
                    "Tipo": "Type",
                    "Descricao": "Description",
                    "botaoAdicionarCombustivelPTBR": "Add fuel PTBR",
                    "placeholder": {
                        "Tipo": "Type",
                        "Descricao": "Description"
                    }
                },
                "tabela": {
                    "semCombustivelPTBR": "There are no registered PTBR fuels",
                    "ID": "ID",
                    "Tipo": "Type",
                    "Descricao": "Description",
                    "Acoes": "Actions"
                },
                "tituloEditarCombustivelPTBR": "Edit fuel PTBR",
                "formularioEditarCombustivelPTBR": {
                    "Tipo": "Type",
                    "Descricao": "Description",
                    "botaoEditarCombustivelPTBR": "Edit fuel PTBR",
                    "placeholder": {
                        "Tipo": "Type",
                        "Descricao": "Description"
                    }
                }
            },
            "tabCargaExterna": {
                "tituloTab": "External Load",
                "deletarCargaExterna": "Are you sure you would like to delete this external payload?",
                "formulario": {
                    "Tipo": "Type",
                    "Descricao": "Description",
                    "botaoAdicionarCargaExternaPTBR": "Add PTBR external load",
                    "placeholder": {
                        "Tipo": "Type",
                        "Descricao": "Description"
                    }
                },
                "tabela": {
                    "semCargaExternaPTBR": "There are no PTBR external cargo registered",
                    "ID": "ID",
                    "Tipo": "Type",
                    "Descricao": "Description",
                    "Acoes": "Actions"
                },
                "tituloEditarCargaExternaPTBR": "Edit external load PTBR",
                "formularioEditarCargaExternaPTBR": {
                    "Tipo": "Type",
                    "Descricao": "Description",
                    "botaoEditarCargaExternaPTBR": "Edit external load PTBR",
                    "placeholder": {
                        "Tipo": "Type",
                        "Descricao": "Description"
                    }
                }
            },
            "tabJustificativasDeAtraso": {
                "tituloTab": "Delay Justifications",
                "deletarJustificativa": "Are you sure you'd like to delete this delay justification?",
                "formulario": {
                    "Nome": "Name",
                    "Motivo": "Reason",
                    "Codigo": "Code",
                    "Tipo": "Type",
                    "opcoesTipo": {
                        "Decolagem": "Take-off",
                        "TempoDeVoo": "Flight time"
                    },
                    "botaoAdicionarJustificativaDeAtrasoPTBR": "Add PTBR delay justification",
                    "placeholder": {
                        "Nome": "Name",
                        "Motivo": "Reason",
                        "Codigo": "Code",
                        "SelecioneTipo": "Select the type"
                    }
                },
                "tabela": {
                    "semJustificativasDeAtrasoPTBR": "There are no PTBR delay justifications registered",
                    "Nome": "Name",
                    "Motivo": "Reason",
                    "Codigo": "Code",
                    "Tipo": "Type",
                    "Acoes": "Actions"
                },
                "tituloEditarJustificativaDeAtrasoPTBR": "Edit reason for delay PTBR",
                "formularioEditarJustificativaDeAtrasoPTBR": {
                    "Nome": "Name",
                    "Motivo": "Reason",
                    "Codigo": "Code",
                    "Tipo": "Type",
                    "opcoesTipo": {
                        "Decolagem": "Take-off",
                        "TempoDeVoo": "Flight time"
                    },
                    "botaoEditarJustificativaDeAtrasoPTBR": "Edit reason for delay PTBR",
                    "placeholder": {
                        "Nome": "Name",
                        "Motivo": "Reason",
                        "Codigo": "Code",
                        "SelecioneTipo": "Select the type"
                    }
                }
            }
        }
    },
    "Cargos": {
        "ListaDeCargos": {
            "deletar": "Are you sure you'd like to delete this job?",
            "titulo": "List of roles",
            "botaoAdicionar": "Add job",
            "tabela": {
                "semCargos": "There are no roles registered",
                "ID": "ID",
                "Nome": "Name",
                "CodigoRubi": "Rubi code",
                "Funcao": "Occupation",
                "PagaDiaria": "Daily pay?",
                "Acoes": "Actions"
            }
        },
        "AdicionarCargo": {
            "titulo": "Register role",
            "formulario": {
                "Nome": "Name",
                "ValorH": "Value/H",
                "CodigoRubi": "Rubi code",
                "Tipo": "Type",
                "Funcao": "Occupation",
                "placeholder": {
                    "Nome": "Job title",
                    "ValorH": "Value/hour of job training",
                    "Tipo": "Operation type",
                    "TipoFuncao": "Type of function"
                },
                "opcoesFuncao": {
                    "Comandante": "Captain",
                    "Copiloto": "Co-pilot",
                    "Comissario": "Commissioner"
                },
                "ObrigatorioModeloDeCargo": "Mandatory Position model",
                "ObrigatorioBase": "Mandatory Base",
                "ObrigatorioASO": "Mandatory ASO",
                "PagaDiaria": "Daily pay",
                "tituloTiposDeCargo": "Job types",
                "Tripulantes": "Crew",
                "CVODVO": "CVO / DVO",
                "MestreDeCarga": "Load master",
                "Mecanico": "Mechanic",
                "Administrativo": "Administrative",
                "botaoAdicionarCargo": "Add job"
            }
        },
        "EditarCargo": {
            "atualizarSimilar": "Are you sure you want to propagate certification requirements to equivalent jobs? The system will replace all job requirements with the current ones.",
            "deletarEvento": "Are you sure you want to delete this event type?",
            "deletarSimilar": "Are you sure you would like to delete this related job?",
            "deletarGrupo": "Are you sure you would like to delete this group?",
            "titulo": "Edit job",
            "botaoAtualizarRequisitosDeCertificadosDeCargosEquivalentes": "Update job equivalent certification requirements",
            "tabDados": {
                "tituloTab": "Data",
                "formulario": {
                    "Nome": "Name",
                    "ValorH": "Value/H",
                    "CodigoRubi": "Rubi code",
                    "Tipo": "Type",
                    "Funcao": "Occupation",
                    "placeholder": {
                        "Registro": "Job registration",
                        "SelectionarTipoOperacao": "Select type of operation",
                        "SelectionarTipoFuncao": "Select function type"
                    },
                    "opcoesFuncao": {
                        "Comandante": "Captain",
                        "Copiloto": "Co-pilot",
                        "Comissario": "Commissioner"
                    },
                    "ObrigatorioModeloDeCargo": "Mandatory Position model",
                    "ObrigatorioBase": "Mandatory Base",
                    "ObrigatorioASO": "Mandatory ASO",
                    "PagaDiaria": "Daily pay",
                    "tituloTiposDeCargo": "Job types",
                    "Tripulantes": "Crew",
                    "CVODVO": "CVO / DVO",
                    "MestreDeCarga": "Load master",
                    "Mecanico": "Mechanic",
                    "Administrativo": "Administrative",
                    "botaoSalvarEdicao": "Save edit"
                }
            },
            "tabCargosEquivalentes": {
                "tituloTab": "Equivalent roles",
                "formulario": {
                    "Cargo": "Role",
                    "placeholder": {
                        "SelecionarCargo": "Select the role"
                    },
                    "botaoSalvarEdicao": "Save edit"
                },
                "tabela": {
                    "Cargo": "Role",
                    "Acoes": "Actions"
                }
            },
            "tabCertificados": {
                "tituloTab": "Certifications",
                "tituloAdicionarNovoGrupo": "Add new group",
                "formulario": {
                    "Nome": "Name",
                    "Tipo": "Type",
                    "placeholder": {
                        "NomeGrupo": "Group's name",
                        "SelecioneTipo": "Select the type"
                    },
                    "opcoesTipo": {
                        "E": "AND",
                        "OU": "OR"
                    },
                    "botaoSalvarEdicao": "Save edit"
                },
                "deletarCertificado": "Are you sure you would like to delete this training?",
                "formularioEditarGrupo": {
                    "Nome": "Name",
                    "Tipo": "Type",
                    "opcoesTipo": {
                        "E": "AND",
                        "OU": "OR"
                    },
                    "botaoEditarGrupo": "Edit group"
                },
                "formularioIncluirTreinamento": {
                    "Treinamento": "Training",
                    "botaoIncluirTreinamento": "Include training"
                },
                "tabelaGrupo": {
                    "Treinamento": "Training",
                    "Acoes": "Actions"
                }
            },
            "tabEventos": {
                "tituloTab": "Events",
                "tituloAdicionarNovoEvento": "Add new event type",
                "formulario": {
                    "Codigo": "Code",
                    "TipoEventos": "Event Types",
                    "botaoSalvarTipoDeEvento": "Save event type",
                    "placeholder": {
                        "SelecioneTipo": "Select the type"
                    },
                    "tabela": {
                        "ID": "ID",
                        "Codigo": "Code.",
                        "TipoEvento": "Kind of event.",
                        "Acoes": "Actions"
                    }
                }
            }
        }
    },
    "EscalasDeBase": {
        "ListaDeEscalasDeBase": {
            "deletar": "Are you sure you would like to delete this schedule?",
            "titulo": "List of schedules",
            "botaoAdicionarEscala": "Add schedule",
            "tabela": {
                "semEscalasParaEsteMes": "There are no schedules registered for this month",
                "ID": "ID",
                "Referencia": "Reference",
                "Acoes": "Actions"
            }
        },
        "AdicionarEscalaDeBase": {
            "titulo": "Register schedule",
            "formulario": {
                "MesAno": "Month year",
                "DataInicial": "Initial date",
                "DataFinal": "Final date",
                "botaoSalvarEscalaDeBase": "Save base schedule"
            }
        },
        "EditarEscalaDeBase": {
            "trocarStatusParaVerificada": "Are you sure you want to change the status of this grid to verified?",
            "trocarStatusParaAprovada": "Are you sure you want to change the status of this grid to approved?",
            "criarRevisaoDestaGrade": "Are you sure you want to create a revision of this grid?",
            "titulo": "Edit schedule",
            "botaoBloquearEscala": "Block Schedule",
            "botaoDesbloquearEscala": "Unlock Schedule",
            "formulario": {
                "DataInicial": "Initial date",
                "DataFinal": "Final date"
            },
            "tituloGrades": "Grids",
            "tabelaGrades": {
                "Revisao": "Revision",
                "Status": "Status",
                "Acoes": "Actions"
            },
            "botaoMarcarComoVerificada": "Mark as verified",
            "botaoMarcarComoAprovada": "Mark as approved",
            "botaoCriarRevisao": "Create review",
            "tituloRevisao": "Revision",
            "botaoConfirmarMudancaDeStatusParaVerificada": "Confirm status change to verified",
            "botaoAprovarEscala": "Approve schedule",
            "tabela": {
                "Tripulante": "Crew member",
                "Designacao": "Designation",
                "Base": "Base",
                "DataInicial": "Initial date",
                "DataFinal": "Final date"
            }
        }
    },
    "GradesDeEscala": {
        "EditarGradeDeEscala": {
            "naoEPossivelMudarAbaComEdicaoEmAberto": "It is not possible to change tabs with an open edition. Save or discard the edit to proceed.",
            "descartarAlteracoes": "Are you sure you want to discard the changes?",
            "salvarAlteracoes": "Are you sure you want to save the changes?",
            "titulo": "Edit Schedule",
            "botaoExibirAlertas": "Display alerts",
            "botaoExibirAlertasDetalhados": "View detailed alerts",
            "tabEscala": {
                "tituloTab": "Schedule",
                "titulosAlternativos": {
                    "TripulacaoExtra": "Extra Crew",
                    "Instrucao": "Instruction",
                    "ChefeDeEquipamento": "Head of equipment",
                    "DispensaMedica": "Sick leave",
                    "Manutencao": "Maintenance",
                    "Ferias": "Vacation",
                    "ForaDeEscala": "Out of schedule",
                    "Reserva": "Reservation"
                },
                "removerAeronaveETodosSeusTripulantes": "Are you sure you want to remove this aircraft and all of its crew from the roster?",
                "adicionarLinhaNestaAeronave": "Are you sure you want to add a row to this aircraft?",
                "removerLinhaDestaAeronave": "Are you sure you want to remove this row from this aircraft?",
                "removerTripulante": "Are you sure you want to remove this crew member?",
                "numeroDeRegimeNaoCadastrado": "Regime number not registered",
                "retirarTripulacaoDestaLinhaNestaAeronave": "Are you sure you want to remove the crew from this line on this aircraft?",
                "esteTripulanteJaEstaEscalado": "This crew member is already assigned to this grid.",
                "tituloEscala": "Schedule",
                "botaoAbrirEdicao": "Open Edition",
                "botaoSalvarEdicao": "Save edit",
                "botaoDescartarMudancas": "Discard Changes",
                "nenhumaAeronaveEscalada": "No climbing aircraft.",
                "tabelaPrincipal": {
                    "Base": "Base",
                    "Aeronave": "Aircraft",
                    "Regime": "Regime",
                    "Grupo": "Group",
                    "Nome": "Name",
                    "Matricula": "Reg.",
                    "Designacao": "Desig.",
                    "tituloSelecioneUmaOpcao": "Select an option",
                    "botaoAlterarAsSiglasParaOPadraoDoRegime": "Change the abbreviations to the regime default",
                    "botaoAlterarORegimeMantendoAsSiglas": "Change the regime keeping the acronyms",
                    "botaoCancelar": "Cancel",
                    "staffIndisponivel": "Unavailable",
                    "staffNAOTRIPULADA": "UNMANNED",
                    "tituloEscolherQuinzena": "Choose fortnight",
                    "DataInicial": "Initial date",
                    "botaoAdicionarAEscala": "Add to schedule",
                    "placeholder": {
                        "BAS": "BAS.",
                        "AER": "AER.",
                        "Indisponivel": "Unavailable",
                        "SelecionarRegime": "Select regime",
                        "DataInicial": "Initial date"
                    }
                },
                "tabelaAlternativa": {
                    "Nome": "Name",
                    "Matricula": "Reg.",
                    "Designacao": "Desig."
                },
                "tituloTotais": "Totals",
                "tabelaTotaisTripulacao": {
                    "Legenda": "Subtitle",
                    "FaltandoComandantes": "Missing Captains",
                    "SobrandoComandantes": "Leftover captains",
                    "FaltandoCopilotos": "Missing Copilots",
                    "SobrandoCopilotos": "Copilots left",
                    "FaltandoComissarios": "Missing Flight Attendants",
                    "SobrandoComissarios": "Leftover Flight Attendants",
                    "QuantidadesCorretas": "Correct quantities"
                },
                "tabelaTotaisAeronaves": {
                    "Base": "Base",
                    "Aircraft": "Acft."
                }
            },
            "tabAdicionarAeronave": {
                "tituloTab": "Add aircraft",
                "tituloAeronavesDisponiveisParaEscalaDeTripulacao": "Aircraft available for crew roster",
                "NenhumaAeronaveDisponivelCadastrada": "No aircraft available registered.",
                "tabela": {
                    "Aeronave": "Aircraft",
                    "Contrato": "Contract"
                },
                "tituloEscalarAeronave": "Climb aircraft",
                "formulario": {
                    "Aeronave": "Aircraft",
                    "Base": "Base",
                    "botaoEscalarAeronave": "Climb aircraft"
                }
            },
            "tabForaDaEscala": {
                "tituloTab": "Out of schedule",
                "tituloForaDeEscala": "Out of schedule",
                "nenhumChefeDeEquipamentoDisponIvel": "No equipment boss available.",
                "tabela": {
                    "Tripulante": "Crew member",
                    "Matricula": "Registration",
                    "Designacao": "Designation",
                    "AlocarNaEscala": "Allocate on schedule"
                },
                "formulario": {
                    "opcoesTipo": {
                        "FERIAS": "VACATION",
                        "MEDICA": "DOCTOR",
                        "MANUT": "MAINTENANCE",
                        "INS": "INS",
                        "FORA": "OUTSIDE",
                        "RESERVA": "RESERVE",
                        "EXTRA": "EXTRA"
                    },
                    "placeholder": {
                        "DataInicial": "Initial date",
                        "DataFinal": "Final date",
                        "Tipo": "Type",
                        "Sigla": "Acronym"
                    }
                }
            },
            "tabChefesDeEquipamento": {
                "tituloTab": "Equipment heads",
                "tituloChefesDeEquipamento": "Equipment heads",
                "nenhumChefeDeEquipamentoDisponIvel": "No equipment boss available.",
                "tabela": {
                    "Tripulante": "Crew member",
                    "Matricula": "Registration",
                    "Designacao": "Designation",
                    "AlocarNaEscala": "Allocate on schedule"
                },
                "placeholder": {
                    "DataInicial": "Initial date",
                    "DataFinal": "Final date"
                },
                "tituloSelecioneUmaSiglaParaPreencher": "Select an acronym to fill in.",
                "formulario": {
                    "Sigla": "Acronym",
                    "placeholder": {
                        "SelecionarSigla": "Select acronym"
                    }
                }
            },
            "tabTreinamentos": {
                "tituloTab": "Trainings",
                "tituloTreinamentosPresenciaisDosTripulantesEscalados": "On-site training for scheduled crew members",
                "naoHaTreinamentos": "There are no trainings.",
                "tabela": {
                    "semTreinamentos": "There are no trainings.",
                    "ID": "ID",
                    "Matricula": "Reg.",
                    "NomeDeGuerra": "War name",
                    "Treinamento": "Training",
                    "Codigo": "Code",
                    "Inicio": "Start",
                    "Fim": "End"
                }
            },
            "tabSolicitacoes": {
                "tituloTab": "Requests",
                "reprovar": "Are you sure you'd like to disapprove this request?",
                "aprovar": "Are you sure you'd like to approve this request?",
                "tituloSolicitacoesDeTripulantes": "Crew requests",
                "naohaSolicitacoes": "There are no prompts.",
                "tabela": {
                    "semSolicitacoes": "There are no registered requests",
                    "ID": "ID",
                    "DataDeCriacao": "Creation date",
                    "NomeDoColaborador": "Employee Name",
                    "Inicio": "Start",
                    "Fim": "End",
                    "Justificativa": "Justification",
                    "ChefeDeFrotaDataResposta": "Chief of Fleet - Response Date",
                    "ChefeDeFrotaJustificativa": "Chief of Fleet - Justification"
                },
                "tituloJustifiqueAReprovacao": "Justify the disapproval",
                "formulario": {
                    "botaoJustificar": "Justify"
                }
            },
            "tabSiglas": {
                "tituloTab": "Acronyms",
                "tituloSiglas": "Acronyms",
                "nenhumaSiglaCadastrada": "No abbreviation registered.",
                "tabela": {
                    "Sigla": "Acronym",
                    "Diaria": "Daily",
                    "Nome": "Name",
                    "Descricao": "Description",
                    "Treinamento": "Training"
                }
            },
            "tituloRevisao": "Revision",
            "tabelaAeronave": {
                "Aeronave": "Aircraft",
                "Alerta": "Alert"
            },
            "tabelaNome": {
                "NomeMatricula": "Name (Registration)",
                "Nom": "Name",
                "RegimeDeTrabalho": "Work regime",
                "Controlado": "Controlled",
                "Alerta": "Alert"
            }
        },
        "EditarBaseDaGradeDeEscala": {
            "deletar": "Are you sure you want to delete this base rep?",
            "titulo": "Edit Schedule",
            "formulario": {
                "DataInicial": "Initial date",
                "DataFinal": "Final date",
                "Funcionario": "Employee",
                "Designacao": "Designation",
                "Base": "Base",
                "placeholder": {
                    "SelecionarFuncionario": "Select employee",
                    "SelecionarBase": "Select base"
                }
            },
            "tabela": {
                "Tripulante": "Crew member",
                "Designacao": "Designation",
                "Base": "Base",
                "DataInicial": "Initial date",
                "DataFinal": "Final date",
                "Acoes": "Actions"
            }
        },
        "GradesDeEscalaAlternativa": {
            "descartarAlteracoes": "Are you sure you want to discard the changes?",
            "salvarAlteracoes": "Are you sure you want to save the changes?",
            "titulo": "Edit Schedule",
            "botaoExibirAlertas": "Display alerts",
            "tabEscala": {
                "tituloTab": "Schedule",
                "titulosAlternativos": {
                    "TripulacaoExtra": "Extra Crew",
                    "Instrucao": "Instruction",
                    "ChefeDeEquipamento": "Head of equipment",
                    "DispensaMedica": "Sick leave",
                    "Manutencao": "Maintenance",
                    "Ferias": "Vacation",
                    "ForaDeEscala": "Out of schedule",
                    "Reserva": "Reservation"
                },
                "naoEPossivelAdicionarColaboradorEmModoDeEdicao": "Unable to add collaborator on schedule in edit mode",
                "removerTripulante": "Are you sure you want to remove this crew member?",
                "tituloEscala": "Schedule",
                "formulario": {
                    "Funcionario": "Employee",
                    "Regime": "Regime",
                    "DataInicial": "Initial date",
                    "botaoAdicionarAEscala": "Add to schedule",
                    "placeholder": {
                        "SelecionarFuncionario": "Select employee",
                        "SelecionarRegime": "Select regime",
                        "DataInicial": "Initial date"
                    }
                },
                "botaoAbrirEdicao": "Open Edition",
                "botaoSalvarEdicao": "Save edit",
                "botaoDescartarMudancas": "Discard Changes",
                "tituloEscalaPrincipal": "Main schedule",
                "tabelaEscalaPrincipal": {
                    "Nome": "Name",
                    "Matricula": "Reg.",
                    "Designacao": "Desig."
                },
                "tabelaEscalaAlternativa": {
                    "Nome": "Name",
                    "Matricula": "Reg.",
                    "Designacao": "Desig."
                }
            },
            "tabForaDaEscala": {
                "tituloTab": "Out of schedule",
                "tituloForaDeEscala": "Out of schedule",
                "nenhumChefeDeEquipamentoDisponIvel": "No equipment boss available.",
                "tabela": {
                    "Tripulante": "Crew member",
                    "Matricula": "Registration",
                    "Funcao": "Occupation",
                    "AlocarNaEscala": "Allocate on schedule"
                }
            },
            "tabTreinamentos": {
                "tituloTab": "Trainings"
            },
            "tabSiglas": {
                "tituloTab": "Acronyms"
            },
            "tituloRevisao": "Revision"
        },
        "GradesDeEscalaDeTreinamento": {
            "descartarAlteracoes": "Are you sure you want to discard the changes?",
            "salvarAlteracoes": "Are you sure you want to save the changes?",
            "titulo": "Edit Schedule",
            "botaoExibirAlertas": "Display alerts",
            "botaoInclusaoAutomatica": "Automatic inclusion",
            "erros": "The following filling errors prevented the report from being finalized",
            "tabEscala": {
                "tituloTab": "Schedule",
                "naoEPossivelAdicionarColaboradorEmModoDeEdicao": "Unable to add collaborator on schedule in edit mode",
                "removerTripulante": "Are you sure you want to remove this crew member?",
                "formulario": {
                    "Funcionario": "Employee",
                    "botaoAdicionarAEscala": "Add to schedule",
                    "placeholder": {
                        "SelecionarFuncionario": "Select employee"
                    }
                },
                "casoSejaSelecionadaUmComunicadoDeTreinamentoNaSigla": "If a training communication with the acronym is selected, it will generate a national training per diem payment for the employee. If you are not sure about the training, or if you do not want to generate the daily automatically, fill in a training abbreviation instead of the announcement abbreviation.",
                "tituloEscala": "Schedule",
                "botaoAbrirEdicao": "Open Edition",
                "botaoSalvarEdicao": "Save edit",
                "botaoDescartarMudancas": "Discard Changes",
                "tabela": {
                    "Nome": "Name",
                    "Matricula": "Registration",
                    "Designacao": "Desig."
                }
            },
            "tabFerias": {
                "tituloTab": "Vacation",
                "tituloEscala": "Schedule",
                "formulario": {
                    "Funcionario": "Employee",
                    "DataInicial": "Initial date",
                    "DataFinal": "Final date",
                    "botaoAdicionarAEscala": "Add to schedule",
                    "placeholder": {
                        "SelecionarFuncionario": "Select employee",
                        "DataInicial": "Initial date",
                        "DataFinal": "Final date"
                    }
                },
                "tabela": {
                    "Turma": "Class",
                    "Nome": "Name",
                    "Matricula": "Registration",
                    "Designacao": "Designation"
                },
                "removerTripulante": "Are you sure you want to remove this crew member from this roster?"
            },
            "tabSiglas": {
                "tituloTab": "Acronyms"
            },
            "tabTreinamentos": {
                "tituloTab": "Trainings",
                "tituloTreinamentosAssociadosATripulantesEscalados": "Training Associated with Escalated Crew Members",
                "naoHaTreinamentos": "There are no trainings.",
                "tabelaTreinamentosAssociadosATripulantesEscalados": {
                    "semTreinamentos": "There are no trainings.",
                    "ID": "ID",
                    "Tripulante": "Crew member",
                    "Treinamento": "Training",
                    "Codigo": "Code",
                    "Certificado": "Certification",
                    "DataInicial": "Initial date",
                    "DataFinal": "Final date"
                },
                "tituloTreinamentosElegiveis": "Eligible Training",
                "tabelaTreinamentosElegiveis": {
                    "semTreinamentos": "There are no trainings.",
                    "ID": "ID",
                    "Tripulante": "Crew member",
                    "Treinamento": "Training",
                    "Codigo": "Code",
                    "Certificado": "Certification",
                    "DataInicial": "Initial date",
                    "DataFinal": "Final date"
                }
            },
            "tituloRevisao": "Revision",
            "tabelarRevisao": {
                "Nome": "Name",
                "Alerta": "Alert"
            },
            "tituloSelecioneOsTripulantesParaAdicionarAEscala": "Select crew members to add to the roster",
            "tabelaAdicionarTripulantes": {
                "semTreinamentos": "There are no trainings.",
                "ID": "ID",
                "Tripulante": "Crew member",
                "Treinamento": "Training",
                "Certificado": "Certification",
                "Codigo": "Code",
                "Periodo": "Time course"
            },
            "botaoIncluirColaboradores": "Include collaborators"
        },
        "GradesDeEscalaAlertas": {
            "ListaGradesDeEscalaAlertas": {
                "titulo": "Escalation alerts",
                "ativar": "Are you sure you'd like to mark this alert as controlled?",
                "arquivar": "Are you sure you'd like to deselect the controller for this alert?",
                "tabela": {
                    "ID": "ID",
                    "Cor": "Color",
                    "Tipo": "Type",
                    "Mat": "Reg.",
                    "Nome": "Name",
                    "Regime": "Regime",
                    "Aeronave": "Aircraft",
                    "Responsavel": "Responsible",
                    "Controlado": "Controlled",
                    "Alerta": "Alert",
                    "Comentarios": "Comments",
                    "Acoes": "Actions"
                }
            },
            "modal": {
                "titulo": "Edit comments",
                "tituloComentarios": "Comments",
                "ComentariosAlerta": "Alert Comments",
                "form": {
                    "Comentario": "Comment"
                },
                "tabela": {
                    "Autor": "Author",
                    "Mensagem": "Message"
                }
            }
        }
    },
    "Siglas": {
        "ListaDeSiglas": {
            "deletar": "Are you sure you would like to delete this acronym?",
            "titulo": "List of acronyms",
            "botaoAdicionarSigla": "Add abbreviation",
            "tabela": {
                "semSiglas": "No abbreviations registered",
                "ID": "ID",
                "Sigla": "Acronym",
                "Nome": "Name",
                "Descricao": "Description",
                "Diaria": "Daily",
                "Acoes": "Actions"
            }
        },
        "AdicionarSigla": {
            "titulo": "Register abbreviation",
            "formulario": {
                "Sigla": "Acronym",
                "NomeInteiro": "Full name",
                "Descricao": "Description",
                "ContaDiaria": "Daily account",
                "TripulaAeronave": "Count as aircraft crew member",
                "SiglaDeTreinamento": "Training acronym",
                "SiglaDeTripulacaoExtra": "Extra crew acronym",
                "SiglaDeFerias": "Holiday abbreviation",
                "SiglaDeFolga": "Abbreviation off",
                "SiglaDeApresentacao": "Abbreviation of presentation",
                "SiglaOficialASerUsadaEmEscala": "Official acronym to be used in schedule",
                "SiglaOficialASerUsadaNaEscalaDiaria": "Official abbreviation to be used on the Daily Schedule",
                "SiglaDeSobreaviso": "Abbreviation of notice",
                "SiglaDeReserva": "Booking Acronym",
                "SelecioneACorDeFundo": "Select background color",
                "SelecioneACorDaFonte": "Select font color",
                "botaoAdicionarSigla": "Add abbreviation",
                "placeholder": {
                    "Sigla": "Acronym",
                    "NomeInteiro": "Full name"
                }
            }
        },
        "EditarSigla": {
            "titulo": "Edit abbreviation",
            "formulario": {
                "Sigla": "Acronym",
                "NomeInteiro": "Full name",
                "Descricao": "Description",
                "ContaDiaria": "Daily account",
                "TripulaAeronave": "Count as aircraft crew member",
                "SiglaDeTreinamento": "Training acronym",
                "SiglaDeTripulacaoExtra": "Extra crew acronym",
                "SiglaDeFerias": "Holiday abbreviation",
                "SiglaDeFolga": "Abbreviation off",
                "SiglaDeApresentacao": "Abbreviation of presentation",
                "SiglaOficialASerUsadaEmEscala": "Official acronym to be used in schedule",
                "SiglaOficialASerUsadaNaEscalaDiaria": "Official abbreviation to be used on the Daily Schedule",
                "SiglaDeSobreaviso": "Abbreviation of notice",
                "SiglaDeReserva": "Booking Acronym",
                "SelecioneACorDeFundo": "Select background color",
                "SelecioneACorDaFonte": "Select font color",
                "placeholder": {
                    "Sigla": "Acronym",
                    "NomeInteiro": "Full name"
                }
            }
        }
    },
    "PagamentosDeEscala": {
        "PagamentosEmAbertoRepresentanteOperacional": {
            "botaoCadastrarPagamento": "Register payment",
            "eNecessarioSelecionarUmaOP": "You must select an OP to perform this action",
            "deletarPagamentos": "Are you sure you'd like to delete the selected payments?",
            "titulo": "Open payments - operational representative",
            "formulario": {
                "OrdemDePagamento": "Payment order",
                "botaoAdicionarAOrdemDePagamento": "Add payment order",
                "botaoDeletarPagamentos": "Delete payments",
                "placeholder": {
                    "SelecionarOrdemDePagamento": "Select payment order"
                }
            },
            "tabela": {
                "semPagamentosEmAberto": "There are no outstanding payments",
                "Acoes": "Actions",
                "ID": "ID",
                "Credito": "Credit",
                "Nome": "Name",
                "BaseContratual": "Contract Base",
                "BaseOperacional": "Operating Base",
                "Regime": "Regime",
                "Mes": "Month",
                "Revisao": "Revision",
                "ValorReferencia": "Value/Reference",
                "Quantidade": "The amount",
                "ValorTotal": "Amount",
                "Moeda": "Coin"
            },
            "deletarEsseDia": "Are you sure you want to delete this day?",
            "tituloEditarPagamento": "Edit payment",
            "formularioEditarPagamento": {
                "Escala": "Schedule",
                "Revisao": "Revision",
                "Local": "Place",
                "Tripulante": "Crew member",
                "ValorReferencia": "Value/Reference",
                "Quantidade": "The amount",
                "Moeda": "Coin",
                "ValorTotal": "Amount",
                "Observacao": "Observation",
                "IgnorarSaldoDevedor": "Ignore Debit Balance",
                "JustificativaDeEdicao": "Editing justification",
                "botaoSalvarPagamento": "Save payment",
                "placeholder": {
                    "Local": "Place",
                    "Tripulante": "Crew member",
                    "Moeda": "Coin",
                    "Observacao": "Observation",
                    "JustifiqueAEdicao": "Justify the edit"
                }
            },
            "tituloLogDeEdicoesDoPagamento": "Payment edit log",
            "tabelaLogDeEdicoesDoPagamento": {
                "Id": "Id",
                "QuantidadeAnterior": "Quantity - Previous",
                "QuantidadeEditada": "Quantity - Edited",
                "ValorUnitarioAnterior": "Unit value - Previous",
                "ValorUnitarioEditado": "Unit value - Edited",
                "ValorTotalAnterior": "Total value - Previous",
                "ValorTotalEditado": "Total value - Edited",
                "StatusDeSaldoDevedorAnterior": "Debt Balance Status - Previous",
                "StatusDeSaldoDevedorEditado": "Debt Balance Status - Edited",
                "Usuario": "User",
                "Justificativa": "Justification",
                "Data": "Date"
            }
        },
        "AdicionarPagamentoEscala": {
            "opcoesMoedas": {
                "Euro": "Euro",
                "Dolar": "Dollar",
                "Real": "Real"
            },
            "titulo": "Add payment - schedule",
            "formulario": {
                "EscalaGrade": "Schedule / Grid",
                "Tripulante": "Crew member",
                "DiariaValor": "Daily value",
                "DiariasPagas": "Paid per diem",
                "DiariaMoeda": "Daily currency",
                "DiariaTotal": "Total daily rate",
                "Observacao": "Observation",
                "IgnorarSaldoDevedor": "Ignore Debit Balance",
                "botaoSalvarPagamento": "Save payment",
                "placeholder": {
                    "SelecionarEscala": "Select schedule",
                    "SelecionarTripulante": "Select crew member",
                    "SelecionarMoeda": "Select currency",
                    "Observacao": "Observation"
                }
            }
        },
        "AdicionarPagamentoRepresentanteOperacional": {
            "opcoesMoedas": {
                "Euro": "Euro",
                "Dolar": "Dollar",
                "Real": "Real"
            },
            "titulo": "Add Pay - Operations Representative",
            "formulario": {
                "EscalaGrade": "Schedule / Grid",
                "Tripulante": "Crew member",
                "ValorReferencia": "Value/Reference",
                "Quantidade": "The amount",
                "Moeda": "Coin",
                "ValorTotal": "Amount",
                "Observacao": "Observation",
                "IgnorarSaldoDevedor": "Ignore Debit Balance",
                "botaoSalvarPagamento": "Save payment",
                "placeholder": {
                    "SelecionarEscala": "Select schedule",
                    "SelecionarTripulante": "Select crew member",
                    "SelecionarMoeda": "Select currency",
                    "Observacao": "Observation"
                }
            }
        },
        "PagamentosEmAbertoDiariasDeMissao": {
            "botaoCadastrarPagamento": "Register payment",
            "eNecessarioSelecionarUmaOP": "You must select an OP to perform this action",
            "deletarPagamentosSelecionados": "Are you sure you'd like to delete the selected payments?",
            "titulo": "Open payments - mission dailies",
            "formulario": {
                "OrdemDePagamento": "Payment order",
                "botaoAdicionarAOrdemDePagamento": "Add payment order",
                "botaoDeletarPagamentos": "Delete payments",
                "placeholder": {
                    "SelecionarOrdemDePagamento": "Select payment order"
                }
            },
            "tabela": {
                "semPagamentosEmAberto": "There are no outstanding payments",
                "Acoes": "Actions",
                "ID": "ID",
                "Credito": "Credit",
                "Nome": "Name",
                "Regime": "Regime",
                "Frota": "Fleet",
                "Mes": "Month",
                "BaseContratual": "Contract Base",
                "BaseOperacional": "Operating Base",
                "Revisao": "Revision",
                "ValorDiaria": "Value/daily",
                "Diarias": "Daily",
                "TotalEmDiarias": "Total in daily",
                "Moeda": "Coin"
            },
            "deletarEsseDia": "Are you sure you want to delete this day?",
            "tituloEditarPagamento": "Edit payment",
            "formularioEditarPagamento": {
                "Escala": "Schedule",
                "Revisao": "Revision",
                "Local": "Place",
                "Tripulante": "Crew member",
                "DiariaValor": "Daily value",
                "DiariasPagas": "Paid per diem",
                "DiariaMoeda": "Daily currency",
                "DiariaTotal": "Total daily rate",
                "Observacao": "Observation",
                "IgnorarSaldoDevedor": "Ignore Debit Balance",
                "JustificativaDeEdicao": "Editing justification",
                "botaoSalvarPagamento": "Save payment",
                "placeholder": {
                    "Local": "Place",
                    "Tripulante": "Crew member",
                    "Moeda": "Coin",
                    "Observacao": "Observation",
                    "JustifiqueAEdicao": "Justify the edit"
                }
            },
            "tituloAdicionarDia": "Add day",
            "formularioAdicionarDia": {
                "Data": "Date",
                "Coeficiente": "Coefficient",
                "botaoSalvarDia": "Save day"
            },
            "tabelaAdicionarDia": {
                "Dia": "Day",
                "Coeficiente": "Coefficient",
                "Acoes": "Actions"
            },
            "tituloLogDeEdicoesDoPagamento": "Payment edit log",
            "tabelaLogDeEdicoesDoPagamento": {
                "Id": "Id",
                "QuantidadeAnterior": "Quantity - Previous",
                "QuantidadeEditada": "Quantity - Edited",
                "ValorUnitarioAnterior": "Unit value - Previous",
                "ValorUnitarioEditado": "Unit value - Edited",
                "ValorTotalAnterior": "Total value - Previous",
                "ValorTotalEditado": "Total value - Edited",
                "StatusDeSaldoDevedorAnterior": "Debt Balance Status - Previous",
                "StatusDeSaldoDevedorEditado": "Debt Balance Status - Edited",
                "Usuario": "User",
                "Justificativa": "Justification",
                "Data": "Date"
            }
        },
        "PagamentosEmAbertoDiariasInternacional": {
            "deletar": "Are you sure you'd like to delete the selected payments?",
            "titulo": "Open payments - daily",
            "tituloInternacional": "International",
            "formulario": {
                "OrdemDePagamento": "Payment order",
                "botaoAdicionarAOrdemDePagamento": "Add payment order",
                "botaoDeletarPagamentos": "Delete payments",
                "placeholder": {
                    "SelecionarOrdemDePagamento": "Select payment order"
                }
            },
            "tabela": {
                "semPagamentosEmAberto": "There are no outstanding payments",
                "Acoes": "Actions",
                "ID": "ID",
                "Nome": "Name",
                "Regime": "Regime",
                "Periodo": "Time course",
                "Treinamento": "Training",
                "NumeroERev": "NÂº and Rev.",
                "Diarias": "Daily",
                "ValorDiaria": "Value/daily",
                "TotalEmDiarias": "Total in daily",
                "Moeda": "Coin"
            }
        },
        "AdicionarPagamentoDeslocamento": {
            "opcoesMoedas": {
                "Euro": "Euro",
                "Dolar": "Dollar",
                "Real": "Real"
            },
            "titulo": "Add payment - displacement",
            "formulario": {
                "EscalaGrade": "Schedule / Grid",
                "Tripulante": "Crew member",
                "DistanciaKm": "Distance (km)",
                "ValorKm": "Value/km",
                "Moeda": "Coin",
                "ValorTotal": "Amount",
                "Observacao": "Observation",
                "IgnorarSaldoDevedor": "Ignore Debit Balance",
                "botaoSalvarPagamento": "Save payment",
                "placeholder": {
                    "SelecionarEscala": "Select schedule",
                    "SelecionarTripulante": "Select crew member",
                    "SelecionarMoeda": "Select currency",
                    "ValorTotal": "Amount",
                    "Observacao": "Observation"
                }
            }
        },
        "PagamentosEmAbertoIndenizacaoDeDeslocamento": {
            "botaoCadastrarPagamento": "Register payment",
            "eNecessarioSelecionarUmaOP": "You must select an OP to perform this action",
            "deletarPagamentosSelecionados": "Are you sure you would like to delete the selected payments?",
            "titulo": "Outstanding payments - displacement compensation",
            "formulario": {
                "OrdemDePagamento": "Payment order",
                "botaoAdicionarAOrdemDePagamento": "Add payment order",
                "botaoDeletarPagamentos": "Delete payments",
                "placeholder": {
                    "SelecionarOrdemDePagamento": "Select payment order"
                }
            },
            "tabela": {
                "semPagamentosEmAberto": "There are no outstanding payments",
                "Acoes": "Actions",
                "ID": "ID",
                "Credito": "Credit",
                "Nome": "Name",
                "Frota": "Fleet",
                "Regime": "Regime",
                "Mes": "Month",
                "BaseContratual": "Contract Base",
                "BaseOperacional": "Operating Base",
                "Revisao": "Revision",
                "Distancia": "Distance",
                "Valor": "Value",
                "Total": "Total",
                "Moeda": "Coin"
            },
            "deletarEsseDia": "Are you sure you want to delete this day?",
            "tituloEditarPagamento": "Edit payment",
            "formularioEditarPagamento": {
                "Escala": "Schedule",
                "CodigoDoTreinamento": "Training code",
                "Local": "Place",
                "Tripulante": "Crew member",
                "Valor": "Value",
                "DistanciaKm": "Distance (Km)",
                "Moeda": "Coin",
                "Total": "Total",
                "Observacao": "Observation",
                "IgnorarSaldoDevedor": "Ignore Debit Balance",
                "JustificativaDeEdicao": "Editing justification",
                "botaoSalvarPagamento": "Save payment",
                "placeholder": {
                    "Local": "Place",
                    "Tripulante": "Crew member",
                    "Moeda": "Coin",
                    "Observacao": "Observation",
                    "JustifiqueAEdicao": "Justify the edit"
                }
            },
            "tituloLogDeEdicoesDoPagamento": "Payment edit log",
            "tabelaLogDeEdicoesDoPagamento": {
                "Id": "Id",
                "QuantidadeAnterior": "Quantity - Previous",
                "QuantidadeEditada": "Quantity - Edited",
                "ValorUnitarioAnterior": "Unit value - Previous",
                "ValorUnitarioEditado": "Unit value - Edited",
                "ValorTotalAnterior": "Total value - Previous",
                "ValorTotalEditado": "Total value - Edited",
                "StatusDeSaldoDevedorAnterior": "Debt Balance Status - Previous",
                "StatusDeSaldoDevedorEditado": "Debt Balance Status - Edited",
                "Usuario": "User",
                "Justificativa": "Justification",
                "Data": "Date"
            }
        },
        "AdicionarPagamentoExtra": {
            "opcoesMoedas": {
                "Euro": "Euro",
                "Dolar": "Dollar",
                "Real": "Real"
            },
            "titulo": "Add payment - extra",
            "formulario": {
                "EscalaGrade": "Schedule / Grid",
                "Tripulante": "Crew member",
                "Quantidade": "The amount",
                "Valor": "Value",
                "Moeda": "Coin",
                "ValorTotal": "Amount",
                "Observacao": "Observation",
                "botaoSalvarPagamento": "Save payment",
                "placeholder": {
                    "SelecionarEscala": "Select schedule",
                    "SelecionarTripulante": "Select crew member",
                    "SelecionarMoeda": "Select currency",
                    "Observacao": "Observation"
                }
            }
        },
        "PagamentosEmAbertoExtra": {
            "botaoCadastrarPagamento": "Register payment",
            "eNecessarioSelecionarUmaOP": "You must select an OP to perform this action",
            "deletarPagamentosSelecionados": "Are you sure you would like to delete the selected payments?",
            "titulo": "Open payments - extra",
            "formulario": {
                "OrdemDePagamento": "Payment order",
                "botaoAdicionarAOrdemDePagamento": "Add payment order",
                "botaoDeletarPagamentos": "Delete payments",
                "placeholder": {
                    "SelecionarOrdemDePagamento": "Select payment order"
                }
            },
            "tabela": {
                "semPagamentosEmAberto": "There are no outstanding payments",
                "Acoes": "Actions",
                "ID": "ID",
                "Credito": "Credit",
                "Nome": "Name",
                "Regime": "Regime",
                "Frota": "Fleet",
                "Mes": "Month",
                "BaseContratual": "Contract Base",
                "BaseOperacional": "Operating Base",
                "Revisao": "Revision",
                "Quantidade": "The amount",
                "Valor": "Value",
                "Total": "Total",
                "Moeda": "Coin"
            },
            "deletarEsseDia": "Are you sure you want to delete this day?",
            "tituloEditarPagamento": "Edit payment",
            "formularioEditarPagamento": {
                "Escala": "Schedule",
                "Revisao": "Revision",
                "Local": "Place",
                "Tripulante": "Crew member",
                "Valor": "Value",
                "Quantidade": "The amount",
                "Moeda": "Coin",
                "Total": "Total",
                "Observacao": "Observation",
                "JustificativaDeEdicao": "Editing justification",
                "botaoSalvarPagamento": "Save payment",
                "placeholder": {
                    "Local": "Place",
                    "Tripulante": "Crew member",
                    "Moeda": "Coin",
                    "Observacao": "Observation",
                    "JustifiqueAEdicao": "Justify the edit"
                }
            },
            "tituloLogDeEdicoesDoPagamento": "Payment edit log",
            "tabelaLogDeEdicoesDoPagamento": {
                "Id": "Id",
                "QuantidadeAnterior": "Quantity - Previous",
                "QuantidadeEditada": "Quantity - Edited",
                "ValorUnitarioAnterior": "Unit value - Previous",
                "ValorUnitarioEditado": "Unit value - Edited",
                "ValorTotalAnterior": "Total value - Previous",
                "ValorTotalEditado": "Total value - Edited",
                "StatusDeSaldoDevedorAnterior": "Debt Balance Status - Previous",
                "StatusDeSaldoDevedorEditado": "Debt Balance Status - Edited",
                "Usuario": "User",
                "Justificativa": "Justification",
                "Data": "Date"
            }
        },
        "ListaDePagamentosEmAbertoHoras": {
            "deletarPagamentosSelecionados": "Are you sure you'd like to delete the selected payments?",
            "titulo": "List of open payments - hours",
            "botaoCadastrarPagamento": "Register payment",
            "formulario": {
                "OrdemDePagamento": "Payment order",
                "botaoAdicionarAOrdemDePagamento": "Add payment order",
                "botaoDeletarPagamentos": "Delete payments",
                "placeholder": {
                    "SelecionarOrdemDePagamento": "Select payment order"
                }
            },
            "tabela": {
                "semPagamentosEmAberto": "There are no outstanding payments",
                "Acoes": "Actions",
                "ID": "ID",
                "Nome": "Name",
                "TipoDeTreinamento": "Training type.",
                "Aula": "Class",
                "Periodo": "Time course",
                "Treinamento": "Training",
                "NumeroERev": "NÂº and Rev.",
                "Local": "Place",
                "HorasPagas": "Paid hours",
                "ValorDaHora": "Time value",
                "TotalDeHoras": "Total amount of hours"
            },
            "tituloEditarPagamento": "Edit payment",
            "formularioEditarPagamento": {
                "NomeDoTreinamento": "Training Name",
                "Aula": "Class",
                "DataInicial": "Initial date",
                "DataFinal": "Final date",
                "Local": "Place",
                "Tripulante": "Crew member",
                "HorasPagas": "Paid hours",
                "HorasPNFPagas": "Paid PNF Hours",
                "HorasDobradas": "Double hours",
                "ValorHora": "Hourly rate",
                "TotalPago": "Total paid",
                "botaoSalvarPagamento": "Save payment"
            }
        },
        "AdicionarPagamentoHoras": {
            "titulo": "Add payment",
            "formulario": {
                "Treinamento": "Training",
                "Aula": "Class",
                "CodigoDoTreinamento": "Training code",
                "Tipo": "Type",
                "DataInicial": "Initial date",
                "DataFinal": "Final date",
                "Local": "Place",
                "Tripulante": "Crew member",
                "HorasPagas": "Paid hours",
                "HorasPNFPagas": "Paid PNF Hours",
                "HorasDobradas": "Double hours",
                "ValorHora": "Hourly rate",
                "TotalPago": "Total paid",
                "botaoSalvarPagamento": "Save payment",
                "placeholder": {
                    "SelecionarTreinamento": "Select training",
                    "SelecionarAula": "Select class",
                    "SelecionarTipo": "Select type",
                    "Local": "Place",
                    "SelecionarTripulante": "Select crew member"
                }
            }
        },
        "AdicionarPagamentoTransporte": {
            "opcoesMoedas": {
                "Euro": "Euro",
                "Dolar": "Dollar",
                "Real": "Real"
            },
            "titulo": "Add payment - shipping",
            "formulario": {
                "EscalaGrade": "Schedule / Grid",
                "Tripulante": "Crew member",
                "Quantidade": "The amount",
                "Valor": "Value",
                "Moeda": "Coin",
                "ValorTotal": "Amount",
                "Observacao": "Observation",
                "IgnorarSaldoDevedor": "Ignore Debit Balance",
                "botaoSalvarPagamento": "Save payment",
                "placeholder": {
                    "SelecionarEscala": "Select schedule",
                    "SelecionarTripulante": "Select crew member",
                    "SelecionarMoeda": "Select currency",
                    "Observacao": "Observation"
                }
            }
        },
        "PagamentosEmAbertoIndenizacaoDeTransporte": {
            "botaoCadastrarPagamento": "Register payment",
            "eNecessarioSelecionarUmaOP": "You must select an OP to perform this action",
            "deletarPagamentosSelecionados": "Are you sure you'd like to delete the selected payments?",
            "titulo": "Outstanding payments - transport compensation",
            "formulario": {
                "OrdemDePagamento": "Payment order",
                "botaoAdicionarAOrdemDePagamento": "Add payment order",
                "botaoDeletarPagamentos": "Delete payments",
                "placeholder": {
                    "SelecionarOrdemDePagamento": "Select payment order"
                }
            },
            "tabela": {
                "semPagamentosEmAberto": "There are no outstanding payments",
                "Acoes": "Actions",
                "ID": "ID",
                "Credito": "Credit",
                "Nome": "Name",
                "Regime": "Regime",
                "Frota": "Fleet",
                "Mes": "Month",
                "BaseContratual": "Contract Base",
                "BaseOperacional": "Operating Base",
                "Revisao": "Revision",
                "Quantidade": "The amount",
                "Valor": "Value",
                "Total": "Total",
                "Moeda": "Coin"
            },
            "deletarEsseDia": "Are you sure you want to delete this day?",
            "tituloEditarPagamento": "Edit payment",
            "formularioEditarPagamento": {
                "Escala": "Schedule",
                "Revisao": "Revision",
                "Local": "Place",
                "Tripulante": "Crew member",
                "Valor": "Value",
                "Quantidade": "The amount",
                "Moeda": "Coin",
                "Total": "Total",
                "Observacao": "Observation",
                "IgnorarSaldoDevedor": "Ignore Debit Balance",
                "JustificativaDeEdicao": "Editing justification",
                "botaoSalvarPagamento": "Save payment",
                "placeholder": {
                    "Local": "Place",
                    "Tripulante": "Crew member",
                    "Moeda": "Coin",
                    "Observacao": "Observation",
                    "JustifiqueAEdicao": "Justify the edit"
                }
            },
            "tituloLogDeEdicoesDoPagamento": "Payment edit log",
            "tabelaLogDeEdicoesDoPagamento": {
                "Id": "Id",
                "QuantidadeAnterior": "Quantity - Previous",
                "QuantidadeEditada": "Quantity - Edited",
                "ValorUnitarioAnterior": "Unit value - Previous",
                "ValorUnitarioEditado": "Unit value - Edited",
                "ValorTotalAnterior": "Total value - Previous",
                "ValorTotalEditado": "Total value - Edited",
                "StatusDeSaldoDevedorAnterior": "Debt Balance Status - Previous",
                "StatusDeSaldoDevedorEditado": "Debt Balance Status - Edited",
                "Usuario": "User",
                "Justificativa": "Justification",
                "Data": "Date"
            }
        }
    },
    "PendenciasDeEscala": {
        "ListaDePendenciasArquivadas": {
            "titulo": "Archived Backlog List",
            "tabela": {
                "semSolicitacoes": "There are no registered requests",
                "Acoes": "Actions",
                "ID": "ID",
                "Data": "Date",
                "Matricula": "Registration",
                "Nome": "Name",
                "EscalaDiariaID": "Daily Schedule - ID",
                "EscalaDiariaBase": "Daily Schedule - Base",
                "RelatorioDeVooID": "Flight Report - ID",
                "RelatorioDeVooBase": "Flight Report - Base",
                "EscalaDeMissao": "Mission Schedule",
                "EscalaDeMissaoBase": "Mission Schedule - Base",
                "ArquivadaEm": "Archived in",
                "Usuario": "User"
            }
        },
        "ListaDePendenciasNaoResolvidas": {
            "arquivarPendencia": "Are you sure you'd like to archive this issue?",
            "botaoArquivar": "To file",
            "titulo": "Backlog - Unresolved",
            "tabela": {
                "semPendencias": "There are no pending issues left",
                "Acoes": "Actions",
                "ID": "ID",
                "Data": "Date",
                "Matricula": "Registration",
                "Nome": "Name",
                "EscalaDiariaID": "Daily Schedule - ID",
                "EscalaDiariaBase": "Daily Schedule - Base",
                "RelatorioDeVooID": "Flight Report - ID",
                "RelatorioDeVooBase": "Flight Report - Base",
                "EscalaDeMissao": "Mission Schedule",
                "EscalaDeMissaoBase": "Mission Schedule - Base"
            }
        }
    },
    "RegimesDeEscala": {
        "RegimesDeTrabalho": {
            "opcoesRegimes": {
                "Escala": "Schedule",
                "Administrativo": "Administrative"
            },
            "opcoesTitulo": {
                "MestreDeCarga": "Load master",
                "CVODVO": "CVO/DVO",
                "EscalaDeTripulantes": "Crew roster"
            },
            "titulo": "Work regimes",
            "formulario": {
                "Nome": "Name",
                "RegimeDeTrabalho": "Work regime",
                "DiasDeMissao": "Mission days",
                "DiasDeFolga": "Days off",
                "IdEscalaRubi": "Schedule Id - Rubi",
                "IdTurmaRubi": "Class ID - Rubi",
                "botaoSalvarRegime": "Save regime",
                "placeholder": {
                    "Nome": "Name",
                    "SelecionarTipoDeRegime": "Select type of scheme",
                    "DiasDeMissao": "Mission days",
                    "DiasDeFolga": "Days off",
                    "IdEscalaRubi": "Schedule Id - Rubi",
                    "IdTurmaRubi": "Class ID - Rubi"
                }
            },
            "tabela": {
                "Nome": "Name",
                "IdRubiEscala": "Rubi Schedule Id",
                "IdRubiTurma": "Id Rubi Class",
                "RegimeDeTrabalho": "Work regime",
                "DiasDeMissao": "Mission days",
                "DiasDeFolga": "Days off",
                "Acoes": "Actions",
                "placeholder": {
                    "Nome": "Name",
                    "IdEscalaRubi": "Schedule Id - Rubi",
                    "IdTurmaRubi": "Class ID - Rubi",
                    "SelecionarRegime": "Select regimen"
                }
            }
        }
    },
    "Escalas": {
        "ListaDeEscalasCVODVO": {
            "botaoDuplicar": "Duplicate",
            "deletar": "Are you sure you would like to delete this schedule?",
            "titulo": "List of schedules - CVO/DVO",
            "botaoAdicionarEscala": "Add schedule",
            "tabela": {
                "semEscalasEsteMes": "There are no schedules registered for this month",
                "ID": "ID",
                "Base": "Base",
                "Empresa": "Company",
                "Referencia": "Reference",
                "Acoes": "Actions"
            }
        },
        "DuplicarEscalaCVODVO": {
            "aguardeEnquantoAEscalaEDuplicada": "Please wait while the schedule is duplicated. This process can take a few minutes.",
            "titulo": "Duplicate schedule",
            "formulario": {
                "MesAno": "Month year",
                "DataInicial": "Initial date",
                "DataFinal": "Final date",
                "tituloRegimesDaEscala": "Schedule regimes",
                "botaoSalvarDuplicacao": "Save duplication"
            }
        },
        "AdicionarEscalaCVODVO": {
            "titulo": "Register schedule - CVO/DVO",
            "formulario": {
                "MesAno": "Month year",
                "Base": "Base",
                "Empresa": "Company",
                "DataInicial": "Initial date",
                "DataFinal": "Final date",
                "botaoSalvarEscala": "Save schedule"
            }
        },
        "EditarEscalaCVODVO": {
            "efetivarGrade": "Are you sure you want to make this grid effective? This action is irreversible.",
            "trocarStatusDessaGradeParaVerificada": "Are you sure you want to change the status of this grid to verified?",
            "trocarStatusDessaGradeParaAprovada": "Are you sure you want to change the status of this grid to approved?",
            "trocarStatusDessaGradeParaRascunho": "Are you sure you want to change the status of this grid to draft?",
            "criarRevisaoDestaGrade": "Are you sure you want to create a revision of this grid?",
            "deletarFrota": "Are you sure you would like to delete this fleet?",
            "tituloCVODVO": "CVO/DVO",
            "titulo": "Edit schedule",
            "botaoBloquearEscala": "Block Schedule",
            "botaoDesbloquearEscala": "Unlock Schedule",
            "tituloGrades": "Grids",
            "tabelaGrades": {
                "Revisao": "Revision",
                "Status": "Status",
                "Efetivacao": "Effectiveness",
                "Acoes": "Actions",
                "botaoGerarPDF": "Generate PDF",
                "botaoMarcarComoVerificada": "Mark as verified",
                "botaoRelatorioDeAlertas": "Alert report",
                "botaoMarcarComoAprovada": "Mark as approved",
                "botaoCriarRevisao": "Create review",
                "botaoEfetivar": "Effect",
                "botaoEscalaEfetivada": "Effective Schedule",
                "EstamosProcessandoAAprovacao": "We are processing schedule approval. Hold..."
            },
            "tituloRegimesDeTrabalho": "Work regimes",
            "formularioRegimesDeTrabalho": {
                "Regime": "Regime",
                "DataDeInicio": "Start date",
                "placeholder": {
                    "SelecioneORegime": "Select the regime"
                }
            },
            "tituloRegimesEmUso": "Regimes in use",
            "tabelaRegimesEmUso": {
                "ID": "ID",
                "Regime": "Regime",
                "DataDeInicio": "Start date",
                "Acoes": "Actions",
                "deletarRegime": "Are you sure you would like to delete this regime?"
            },
            "tituloRevisao": "Revision",
            "tituloAlertasImpeditivos": "IMPEDITIVE ALERTS",
            "existemAsSeguintesPendencias": "There are the following unarchived issues for this schedule",
            "botaoConfirmarMudancaDeStatusParaVerificada": "Confirm status change to verified",
            "botaoVoltarParaRascunho": "Back to draft",
            "botaoAprovarEscala": "Approve schedule",
            "tituloEscala": "Schedule",
            "tabelaEscala": {
                "Nome": "Name",
                "Matricula": "Registration",
                "Funcao": "Occupation"
            },
            "tituloInstrucao": "Instruction",
            "tabelaInstrucao": {
                "Nome": "Name",
                "Matricula": "Registration",
                "Designacao": "Desig."
            },
            "tituloChefeDeEquipamento": "Head of equipment",
            "tabelaChefeDeEquipamento": {
                "Nome": "Name",
                "Matricula": "Registration",
                "Designacao": "Desig."
            },
            "tituloDispensaMedica": "Sick leave",
            "tabelaDispensaMedica": {
                "Nome": "Name",
                "Matricula": "Registration",
                "Designacao": "Desig."
            },
            "tituloManutencao": "Maintenance",
            "tabelaManutencao": {
                "Nome": "Name",
                "Matricula": "Registration",
                "Designacao": "Desig."
            },
            "tituloFerias": "Vacation",
            "tabelaFerias": {
                "Nome": "Name",
                "Matricula": "Registration",
                "Designacao": "Desig."
            },
            "tituloForaDeEscala": "Out of schedule",
            "tabelaForaDeEscala": {
                "Nome": "Name",
                "Matricula": "Registration",
                "Designacao": "Desig."
            },
            "tituloAlteracoesNaEscala": "Schedule changes",
            "tituloRevisaoAtual": "Current Review",
            "tabelaRevisaoAtual": {
                "Base": "Base",
                "Aeronave": "Aircraft",
                "Grupo": "Group",
                "Nome": "Name",
                "Matricula": "Registration",
                "Designacao": "Desig.",
                "Indisponivel": "Unavailable"
            },
            "tituloRevisaoAnterior": "Previous Review",
            "tabelaRevisaoAnterior": {
                "Base": "Base",
                "Aeronave": "Aircraft",
                "Grupo": "Group",
                "Nome": "Name",
                "Matricula": "Registration",
                "Designacao": "Desig.",
                "Indisponivel": "Unavailable"
            },
            "nenhumaAlteracaoNaEscalaPrincipal": "No changes to main crew roster."
        },
        "ListaDeEscalasMestreDeCarga": {
            "botaoDuplicar": "Duplicate",
            "deletar": "Are you sure you would like to delete this schedule?",
            "titulo": "List of schedules - Load master",
            "botaoAdicionarEscala": "Add schedule",
            "tabela": {
                "semEscalasEsteMes": "There are no schedules registered for this month",
                "ID": "ID",
                "Base": "Base",
                "Empresa": "Company",
                "Referencia": "Reference",
                "Acoes": "Actions"
            }
        },
        "DuplicarEscalaMestreDeCarga": {
            "aguardeEnquantoAEscalaEDuplicada": "Please wait while the schedule is duplicated. This process can take a few minutes.",
            "titulo": "Duplicate schedule",
            "formulario": {
                "MesAno": "Month year",
                "DataInicial": "Initial date",
                "DataFinal": "Final date",
                "tituloRegimesDaEscala": "Schedule regimes",
                "botaoSalvarDuplicacao": "Save duplication"
            }
        },
        "EditarEscalaMestreDeCarga": {
            "efetivarGrade": "Are you sure you want to make this grid effective? This action is irreversible.",
            "trocarStatusDessaGradeParaVerificada": "Are you sure you want to change the status of this grid to verified?",
            "trocarStatusDessaGradeParaAprovada": "Are you sure you want to change the status of this grid to approved?",
            "trocarStatusDessaGradeParaRascunho": "Are you sure you want to change the status of this grid to draft?",
            "criarRevisaoDestaGrade": "Are you sure you want to create a revision of this grid?",
            "deletarFrota": "Are you sure you would like to delete this fleet?",
            "tituloMestreDeCarga": "Cargo Master",
            "titulo": "Edit schedule",
            "botaoBloquearEscala": "Block Schedule",
            "botaoDesbloquearEscala": "Unlock Schedule",
            "tituloGrades": "Grids",
            "tabelaGrades": {
                "Revisao": "Revision",
                "Status": "Status",
                "Efetivacao": "Effectiveness",
                "Acoes": "Actions",
                "botaoGerarPDF": "Generate PDF",
                "botaoMarcarComoVerificada": "Mark as verified",
                "botaoRelatorioDeAlertas": "Alert report",
                "botaoMarcarComoAprovada": "Mark as approved",
                "botaoCriarRevisao": "Create review",
                "botaoEfetivar": "Effect",
                "botaoEscalaEfetivada": "Effective Schedule",
                "EstamosProcessandoAAprovacao": "We are processing schedule approval. Hold..."
            },
            "tituloRegimesDeTrabalho": "Work regimes",
            "formularioRegimesDeTrabalho": {
                "Regime": "Regime",
                "DataDeInicio": "Start date",
                "placeholder": {
                    "SelecioneORegime": "Select the regime"
                }
            },
            "tituloRegimesEmUso": "Regimes in use",
            "tabelaRegimesEmUso": {
                "ID": "ID",
                "Regime": "Regime",
                "DataDeInicio": "Start date",
                "Acoes": "Actions",
                "deletarRegime": "Are you sure you would like to delete this regime?"
            },
            "tituloRevisao": "Revision",
            "tituloAlertasImpeditivos": "IMPEDITIVE ALERTS",
            "existemAsSeguintesPendencias": "There are the following unarchived issues for this schedule",
            "botaoConfirmarMudancaDeStatusParaVerificada": "Confirm status change to verified",
            "botaoVoltarParaRascunho": "Back to draft",
            "botaoAprovarEscala": "Approve schedule",
            "tituloEscala": "Schedule",
            "tabelaEscala": {
                "Nome": "Name",
                "Matricula": "Registration",
                "Funcao": "Occupation"
            },
            "tituloInstrucao": "Instruction",
            "tabelaInstrucao": {
                "Nome": "Name",
                "Matricula": "Registration",
                "Designacao": "Desig."
            },
            "tituloChefeDeEquipamento": "Head of equipment",
            "tabelaChefeDeEquipamento": {
                "Nome": "Name",
                "Matricula": "Registration",
                "Designacao": "Desig."
            },
            "tituloDispensaMedica": "Sick leave",
            "tabelaDispensaMedica": {
                "Nome": "Name",
                "Matricula": "Registration",
                "Designacao": "Desig."
            },
            "tituloManutencao": "Maintenance",
            "tabelaManutencao": {
                "Nome": "Name",
                "Matricula": "Registration",
                "Designacao": "Desig."
            },
            "tituloFerias": "Vacation",
            "tabelaFerias": {
                "Nome": "Name",
                "Matricula": "Registration",
                "Designacao": "Desig."
            },
            "tituloForaDeEscala": "Out of schedule",
            "tabelaForaDeEscala": {
                "Nome": "Name",
                "Matricula": "Registration",
                "Designacao": "Desig."
            },
            "tituloAlteracoesNaEscala": "Schedule changes",
            "tituloRevisaoAtual": "Current Review",
            "tabelaRevisaoAtual": {
                "Base": "Base",
                "Aeronave": "Aircraft",
                "Grupo": "Group",
                "Nome": "Name",
                "Matricula": "Registration",
                "Designacao": "Desig.",
                "Indisponivel": "Unavailable"
            },
            "tituloRevisaoAnterior": "Previous Review",
            "tabelaRevisaoAnterior": {
                "Base": "Base",
                "Aeronave": "Aircraft",
                "Grupo": "Group",
                "Nome": "Name",
                "Matricula": "Registration",
                "Designacao": "Desig.",
                "Indisponivel": "Unavailable"
            },
            "nenhumaAlteracaoNaEscalaPrincipal": "No changes to main crew roster."
        },
        "AdicionarEscalaMestreDeCarga": {
            "titulo": "Register schedule - Load Master",
            "formulario": {
                "MesAno": "Month year",
                "Base": "Base",
                "Empresa": "Company",
                "DataInicial": "Initial date",
                "DataFinal": "Final date",
                "botaoSalvarEscala": "Save schedule"
            }
        },
        "ListaDeEscalaDiaria": {
            "botaoDisponivel": "Available",
            "botaoIndisponivel": "Unavailable",
            "deletar": "Are you sure you would like to delete this schedule?",
            "titulo": "Daily roster list",
            "botaoAdicionarProgramacao": "Add schedule",
            "formulario": {
                "botaoMudarData": "Change date"
            },
            "tabela": {
                "semProgramacaoParaHoje": "There is no schedule registered for today",
                "ID": "ID",
                "Base": "Base",
                "Aeronave": "Aircraft",
                "Modelo": "Model",
                "Contrato": "Contract",
                "Disponibilidade": "Availability",
                "ComandanteS": "Captain(s)",
                "CopilotoS": "Copilot(s)",
                "ComissarioS": "Commissioner(s)",
                "Apresentacao": "Presentation",
                "Corte": "Shutdown",
                "Status": "Status",
                "Acoes": "Actions"
            }
        },
        "AdicionarEscalaDiaria": {
            "titulo": "Register daily schedule",
            "formulario": {
                "Data": "Date",
                "Base": "Base",
                "TripulacaoExtra": "Extra Crew",
                "Prefixo": "Prefix",
                "Contrato": "Contract",
                "DesejaImportarTripulacaoDaEscala": "Want to import roster crew",
                "botaoSalvarProgramacao": "Save schedule"
            }
        },
        "EditarEscalaDiaria": {
            "trocarOStatusDaEscala": "Are you sure you would like to change the schedule status?",
            "aprovarEscalaMesmoComAlertasVermelhos": "Are you sure you would like to approve the schedule even with the red flags?",
            "titulo": "Edit daily schedule",
            "tituloEditarEscalaDiariaTripulacaoExtra": "Edit Daily Schedule Extra Crew",
            "botaoProgramacao": {
                "TrocarParaRascunho": "Switch to draft",
                "TrocarParaAprovada": "Change to Approved"
            },
            "botaoAlertas": "Alerts",
            "erros": "The following filling errors prevented the unavailability form from being processed",
            "tituloDisponibilidadeDaAeronave": "Aircraft Availability",
            "formularioDisponibilidadeDaAeronave": {
                "Disponivel": "Available",
                "IndisponivelDesde": "Unavailable since",
                "Razao": "Reason",
                "Previsao": "Prediction",
                "FlightFollowingAnormal": "Flight following abnormal",
                "AnormalDesde": "Abnormal since",
                "InspetorMecanicoResponsavel": "Inspector / Responsible Mechanic",
                "Observacoes": "Comments"
            },
            "tituloCriarGrupo": "Create group",
            "formularioCriarGrupo": {
                "HorarioDeApresentacao": "Presentation Time",
                "HorarioDeTerminoDaJornada": "End of Day Time",
                "Situacao": "Situation",
                "Voos": "Flights",
                "botaoAdicionarGrupo": "Add group"
            },
            "tituloAlertasDeAprovacao": "Approval alerts",
            "tabelaAlertasDeAprovacao": {
                "Mensagem": "Message",
                "Data": "Date"
            },
            "tituloLogDeStatus": "Status log",
            "tabelaLogDeStatus": {
                "Usuario": "User",
                "Acao": "Action",
                "Descricao": "Description",
                "Justificativa": "Justification",
                "Data": "Date"
            },
            "tituloAlertas": "Alerts",
            "formularioAlertas": {
                "Justificativa": "Justification",
                "botaoContinuarAprovacao": "Continue approval"
            },
            "deletarTripulante": "Are you sure you want to delete this crew member?",
            "deletarGrupo": "Are you sure you want to delete this group?",
            "deletarVoo": "Are you sure you want to delete this flight?",

            tituloGrupoAs(Numero, Inicio, Fim) {
                // Verifico se o Fim é nulo, se for, retorno apenas o Inicio
                if (Fim == null) {
                    return `Group ${Numero} - ${Inicio}`
                }
                return `Group ${Numero} - ${Inicio} to ${Fim}`
            },
              
                    
            "formularioGrupo": {
                "HorarioDeApresentacao": "Presentation Time",
                "HorarioDeTerminoDaJornada": "End of Day Time",
                "Situacao": "Situation",
                "Voos": "Flights",
                "botaoEditarGrupo": "Edit group"
            },
            "formularioAdicionarComandante": {
                "Comandante": "Captain",
                "FuncaoDeBordo": "Captain on board role"
            },
            "formularioAdicionarCopiloto": {
                "Copiloto": "Co-pilot",
                "FuncaoDeBordo": "On-board co-pilot function"
            },
            "formularioAdicionarComissario": {
                "Comissario": "Commissioner",
                "FuncaoDeBordo": "Flight attendant role"
            },
            "tabelaTripulantes": {
                "Tripulante": "Crew member",
                "FuncaoDeBordo": "On-board function"
            },
            "tabelaGrupo": {
                "Voo": "Flight"
            }
        },
        "SimulacaoEscalaDiaria": {
            "titulo": "Daily schedule simulation",
            "tituloSimulacaoEscalaDiariaTripulacaoExtra": "Daily layover simulation - extra crew",
            "formulario": {
                "Data": "Date",
                "TripulacaoExtra": "Extra Crew",
                "Prefixo": "Prefix",
                "Contrato": "Contract",
                "HorarioDeApresentacao": "Presentation Time",
                "HorarioDeTerminoDaJornada": "End of Day Time",
                "Situacao": "Situation"
            },
            "formularioAdicionarComandante": {
                "Comandante": "Captain",
                "FuncaoDeBordo": "Captain on board role"
            },
            "formularioAdicionarCopiloto": {
                "Copiloto": "Co-pilot",
                "FuncaoDeBordo": "On-board co-pilot function"
            },
            "formularioAdicionarComissario": {
                "Comissario": "Commissioner",
                "FuncaoDeBordo": "Flight attendant role"
            },
            "tabelaGrupo": {
                "Tripulante": "Crew member",
                "FuncaoDeBordo": "On-board function"
            },
            "formularioSimularProgramacao": {
                "botaoSimularProgramacao": "Simulate programming"
            },
            "tituloAlertas": "Alerts",
            "formularioContinuarAprovacao": {
                "Justificativa": "Justification",
                "botaoContinuarAprovacao": "Continue approval"
            }
        },
        "ListaDeEscalas": {
            "botaoDuplicar": "Duplicate",
            "deletar": "Are you sure you would like to delete this schedule?",
            "titulo": "List of schedules",
            "botaoAdicionarEscala": "Add schedule",
            "tabela": {
                "semEscalasEsteMes": "There are no schedules registered for this month",
                "ID": "ID",
                "Frota": "Fleet",
                "Empresa": "Company",
                "Referencia": "Reference",
                "Acoes": "Actions"
            }
        },
        "DuplicarEscala": {
            "aguardeEnquantoAEscalaEDuplicada": "Please wait while the schedule is duplicated. This process can take a few minutes.",
            "titulo": "Duplicate schedule",
            "formulario": {
                "MesAno": "Month year",
                "DataInicial": "Initial date",
                "DataFinal": "Final date",
                "tituloRegimesDaEscala": "Schedule regimes",
                "botaoSalvarDuplicacao": "Save duplication"
            }
        },
        "AdicionarEscala": {
            "titulo": "Register schedule",
            "formulario": {
                "MesAno": "Month year",
                "Frota": "Fleet",
                "DataInicial": "Initial date",
                "DataFinal": "Final date",
                "Empresa": "Company",
                "botaoSalvarEscala": "Save schedule"
            }
        },
        "EditarEscala": {
            "efetivarGrade": "Are you sure you want to make this grid effective? This action is irreversible.",
            "trocarStatusDessaGradeParaVerificadaMesmoHavendoPendencias": "Are you sure you want to change the status of this grid to verified, even if there are pending issues that have not yet been archived?",
            "trocarStatusDessaGradeParaVerificada": "Are you sure you want to change the status of this grid to verified?",
            "trocarStatusDessaGradeParaAprovada": "Are you sure you want to change the status of this grid to approved?",
            "trocarStatusDessaGradeParaRascunho": "Are you sure you want to change the status of this grid to draft?",
            "criarRevisaoDestaGrade": "Are you sure you want to create a revision of this grid?",
            "deletarGrade": "Are you sure you would like to delete this grid?",
            "titulo": "Edit schedule",
            "botaoBloquearEscala": "Block Schedule",
            "botaoDesbloquearEscala": "Unlock Schedule",
            "formulario": {
                "DataInicial": "Initial date",
                "DataFinal": "Final date"
            },
            "tituloGrades": "Grids",
            "tabelaGrades": {
                "Revisao": "Revision",
                "Status": "Status",
                "Efetivacao": "Effectiveness",
                "Acoes": "Actions",
                "botaoGerarPDF": "Generate PDF",
                "botaoMarcarComoVerificada": "Mark as verified",
                "botaoAlertas": "Alerts",
                "botaoMarcarComoAprovada": "Mark as approved",
                "botaoCriarRevisao": "Create review",
                "botaoEfetivar": "Effect",
                "botaoEscalaEfetivada": "Effective Schedule",
                "EstamosProcessandoAAprovacao": "We are processing schedule approval. Hold...",
                "tituloEditarObservacoesDaGrade": "Edit Grid Notes",
                "formularioEditarObservacoesDaGrade": {
                    "Observacoes": "Comments",
                    "botaoEditarObservacoesDaGrade": "Edit Grid Notes"
                }
            },
            "tituloRegimesDeTrabalho": "Work regimes",
            "formularioRegimesDeTrabalho": {
                "Regime": "Regime",
                "DataDeInicio": "Start date",
                "placeholder": {
                    "SelecioneORegime": "Select the regime"
                }
            },
            "tituloRegimesEmUso": "Regimes in use",
            "tabelaRegimesEmUso": {
                "ID": "ID",
                "Regime": "Regime",
                "DataDeInicio": "Start date",
                "Acoes": "Actions"
            },
            "tituloRevisao": "Revision",
            "tituloAlertasImpeditivos": "IMPEDITIVE ALERTS",
            "tabelaAlertas": {
                "Matricula": "Registration",
                "Nome": "Name",
                "Setor": "Sector",
                "Alerta": "Alert"
            },
            "existemAsSeguintesPendencias": "There are the following unarchived issues for this schedule",
            "botaoConfirmarMudancaDeStatusParaVerificada": "Confirm status change to verified",
            "botaoVoltarParaRascunho": "Back to draft",
            "botaoAprovarEscala": "Approve schedule",
            "tabelaAlertasCompacta": {
                "NomeMatricula": "Name (Registration)",
                "Alerta": "Alert"
            },
            "nenhumaAeronaveEscalada": "No climbing aircraft.",
            "botaoAprovado": "Okay",
            "tabelaVisualizarEscala": {
                "Base": "Base",
                "Aeronave": "Aircraft",
                "Grupo": "Group",
                "Nome": "Name",
                "Matricula": "Reg.",
                "Designacao": "Desig."
            },
            "tituloTripulacaoExtra": "Extra crew",
            "tabelaTripulacaoExtra": {
                "Nome": "Name",
                "Matricula": "Registration",
                "Designacao": "Desig."
            },
            "tituloInstrucao": "Instruction",
            "tabelaInstrucao": {
                "Nome": "Name",
                "Matricula": "Registration",
                "Designacao": "Desig."
            },
            "tituloChefeDeEquipamento": "Head of equipment",
            "tabelaChefeDeEquipamento": {
                "Nome": "Name",
                "Matricula": "Registration",
                "Designacao": "Desig."
            },
            "tituloDispensaMedica": "Sick leave",
            "tabelaDispensaMedica": {
                "Nome": "Name",
                "Matricula": "Registration",
                "Designacao": "Desig."
            },
            "tituloManutencao": "Maintenance",
            "tabelaManutencao": {
                "Nome": "Name",
                "Matricula": "Registration",
                "Designacao": "Desig."
            },
            "tituloFerias": "Vacation",
            "tabelaFerias": {
                "Nome": "Name",
                "Matricula": "Registration",
                "Designacao": "Desig."
            },
            "tituloForaDeEscala": "Out of schedule",
            "tabelaForaDeEscala": {
                "Nome": "Name",
                "Matricula": "Registration",
                "Designacao": "Desig."
            },
            "tituloAlteracoesNaEscala": "Schedule changes",
            "tituloRevisaoAtual": "Current Review",
            "tabelaRevisaoAtual": {
                "Base": "Base",
                "Aeronave": "Aircraft",
                "Grupo": "Group",
                "Nome": "Name",
                "Matricula": "Registration",
                "Designacao": "Desig."
            },
            "tituloRevisaoAnterior": "Previous Review",
            "tabelaRevisaoAnterior": {
                "Base": "Base",
                "Aeronave": "Aircraft",
                "Grupo": "Group",
                "Nome": "Name",
                "Matricula": "Registration",
                "Designacao": "Desig."
            },
            "nenhumaAlteracaoNaEscalaPrincipal": "No changes to main crew roster."
        },
        "ElaboracaoDeEscala": {
            "todosOsCamposDoFormularioDevemSerPreenchdios": "All form fields must be filled in.",
            "formulario": {
                "Mes": "Month",
                "Ano": "Year",
                "Frota": "Fleet",
                "botaoBases": "Bases",
                "botaoRodizio": "Rotation",
                "botaoVencimentos": "Salaries",
                "placeholder": {
                    "SelecionarFrota": "Select fleet"
                }
            },
            "tituloElaboraçãoDeEscalaBases": "Elaboration of Schedule - Bases",
            "tabDatas": {
                "tituloEscalaDe": "Schedule of",
                "tabela": {
                    "Nome": "Name",
                    "Escala": "Schedule",
                    "Base": "Base",
                    "Aeronave": "Aircraft",
                    "TotalHoras": "Total hours"
                }
            },
            "tabTotaisDoPeriodo": {
                "tituloTab": "Period totals",
                "tituloEscalaDe": "Schedule of",
                "tabela": {
                    "Nome": "Name",
                    "TotalAno": "Total year",
                    "TotalGeral": "Grand total"
                }
            },
            "tituloElaboracaoDeEscalaRodizio": "Elaboration of Schedule - Rotation",
            "tabelaElaboracaoDeEscalaRodizio": {
                "Base": "Base",
                "TotalHoras": "Total hours",
                "TotalDeTripulantes": "Total number of crew",
                "VagasDisponiveis": "Available vacancies",
                "MediaDeHoras": "Average hours"
            },

            tituloTotalDeHorasEntreCMDT(dataInicial, hoje) {
                return `Total hours from ${dataInicial}  ${hoje} - CMDT`
            },
                            
            "tabelaTotalDeHorasEntreCMDT": {
                "Total90Dias": "Total 90 days",
                "Tripulante": "Crew member",
                "Matricula": "Registration",
                "FB": "FB",
                "Base": "Base"
            },

            tituloTotalDeHorasEntreCMDT(dataInicial, hoje) {
                return `Total hours from ${dataInicial}  ${hoje} - COPIL`
            },
            
            "tabelaTotalDeHorasEntreCOPIL": {
                "Total90Dias": "Total 90 days",
                "Tripulante": "Crew member",
                "Matricula": "Registration",
                "FB": "FB",
                "Base": "Base"
            },

            tituloTotalDeHorasEntreCMDT(dataInicial, hoje) {
                return `Total hours from ${dataInicial}  ${hoje} - CMS`
            },
            
            "tabelaTotalDeHorasEntreCMS": {
                "Total90Dias": "Total 90 days",
                "Tripulante": "Crew member",
                "Matricula": "Registration",
                "FB": "FB",
                "Base": "Base"
            },
            "tituloSugestaoDeRodizio": "Rotation suggestion",
            "tabelaSugestaoDeRodizio": {
                "Tripulante1": "Crew member 1",
                "FB": "FB",
                "TotalDeHoras": "Total amount of hours",
                "Tripulante2": "Crew member 2",
                "BaseAAlocar": "Base to Allocate"
            },
            "tituloElaboracaoDeEscalaVencimentos": "Elaboration of Schedule - Salaries",
            "formularioElaboracaoDeEscalaVencimentos": {
                "Certificados": "Certifications",
                "tabela": {
                    "Matricula": "Reg.",
                    "NomeDeGuerra": "War name",
                    "CHTFrota": "CHT Fleet",
                    "CCF": "CCF",
                    "TotalHoras": "Total hours",
                    "VencimentoNoturno": "Maturity nocturnal"
                },
                "placeholder": {
                    "SelecionarCertificados": "Select certifications"
                }
            }
        },
        "ListaDeEscalasDeTreinamentos": {
            "botaoDuplicar": "Duplicate",
            "deletar": "Are you sure you would like to delete this schedule?",
            "titulo": "List of training schedules",
            "botaoAdicionarEscala": "Add schedule",
            "tabela": {
                "semEscalasCadastradasParaEsteMes": "There are no schedules registered for this month",
                "ID": "ID",
                "Frota": "Fleet",
                "Referencia": "Reference",
                "Acoes": "Actions"
            }
        },
        "AdicionarEscalaDeTreinamento": {
            "titulo": "Register training schedule",
            "formulario": {
                "MesAno": "Month year",
                "Frota": "Fleet",
                "DataInicial": "Initial date",
                "DataFinal": "Final date",
                "botaoSalvarEscala": "Save schedule"
            }
        },
        "DuplicarEscalaDeTreinamento": {
            "aguardeEnquantoAEscalaEDuplicada": "Please wait while the schedule is duplicated. This process can take a few minutes.",
            "titulo": "Duplicate schedule",
            "formulario": {
                "DataInicial": "Initial date",
                "DataFinal": "Final date",
                "tituloRegimesDaEscala": "Schedule regimes",
                "botaoSalvarDuplicacao": "Save duplication"
            }
        },
        "EditarEscalaDeTreinamento": {
            "trocarStatusDessaGradeParaVerificada": "Are you sure you want to change the status of this grid to verified?",
            "trocarStatusDessaGradeParaAprovada": "Are you sure you want to change the status of this grid to approved?",
            "trocarStatusDessaGradeParaRascunho": "Are you sure you want to change the status of this grid to draft?",
            "criarRevisaoDestaGrade": "Are you sure you want to create a revision of this grid?",
            "deletarEssaGrade": "Are you sure you would like to delete this grid?",
            "titulo": "Edit schedule",
            "botaoBloquearEscala": "Block Schedule",
            "botaoDesbloquearEscala": "Unlock Schedule",
            "formulario": {
                "DataInicial": "Initial date",
                "DataFinal": "Final date"
            },
            "tituloGrades": "Grids",
            "tabelaGrades": {
                "Revisao": "Revision",
                "Status": "Status",
                "Acoes": "Actions",
                "botaoGerarPDF": "Generate PDF",
                "botaoMarcarComoVerificada": "Mark as verified",
                "botaoAlertas": "Alerts",
                "botaoMarcarComoAprovada": "Mark as approved",
                "botaoCriarRevisao": "Create review",
                "botaoEfetivar": "Effect",
                "botaoEscalaEfetivada": "Effective Schedule",
                "EstamosProcessandoAAprovacao": "We are processing schedule approval. Hold...",
                "tituloEditarObservacoesDaGrade": "Edit Grid Notes",
                "formularioEditarObservacoesDaGrade": {
                    "Observacoes": "Comments",
                    "botaoEditarObservacoesDaGrade": "Edit Grid Notes"
                }
            },
            "tituloRegimesDeTrabalho": "Work regimes",
            "formularioRegimesDeTrabalho": {
                "Regime": "Regime",
                "DataDeInicio": "Start date",
                "placeholder": {
                    "SelecioneORegime": "Select the regime"
                }
            },
            "tituloRegimesEmUso": "Regimes in use",
            "tabelaRegimesEmUso": {
                "ID": "ID",
                "Regime": "Regime",
                "DataDeInicio": "Start date",
                "Acoes": "Actions"
            },
            "tituloRevisao": "Revision",
            "tituloAlertasImpeditivos": "IMPEDITIVE ALERTS",
            "botaoConfirmarMudancaDeStatusParaVerificada": "Confirm Status Change to Verified",
            "botaoVoltarParaRascunho": "Back to draft",
            "botaoAprovarEscala": "Approve schedule",
            "tituloTreinamentos": "Trainings",
            "tabelaTreinamentos": {
                "Nome": "Name",
                "Matricula": "Registration",
                "Designacao": "Desig."
            },
            "tituloFerias": "Vacation",
            "tabelaFerias": {
                "Nome": "Name",
                "Matricula": "Registration",
                "Designacao": "Desig."
            },
            "tituloAlteracoesNaEscala": "Schedule changes",
            "tituloRevisaoAtual": "Current Review",
            "tabelaRevisaoAtual": {
                "Base": "Base",
                "Aeronave": "Aircraft",
                "Grupo": "Group",
                "Nome": "Name",
                "Matricula": "Registration",
                "Designacao": "Desig."
            },
            "tituloRevisaoAnterior": "Previous Review",
            "tabelaRevisaoAnterior": {
                "Base": "Base",
                "Aeronave": "Aircraft",
                "Grupo": "Group",
                "Nome": "Name",
                "Matricula": "Registration",
                "Designacao": "Desig."
            }
        }
    },
    "Setores": {
        "ListaDeSetores": {
            "titulo": "List of sectors",
            "deletar": "Are you sure you would like to delete this sector?",
            "botaoAdicionarSetor": "Add sector",
            "tabela": {
                "ID": "ID",
                "Nome": "Name",
                "Acoes": "Actions"
            }
        },
        "EditarSetor": {
            "titulo": "Edit sector",
            "deletarEmail": "Are you sure you would like to delete this related email?",
            "formulario": {
                "Nome": "Name",
                "Email": "Email",
                "botaoAdicionarEmail": "Save email addition",
                "placeholder": {
                    "registroDoSetor": "Industry registration",
                    "emailDoSetor": "Sector email"
                }
            },
            "tabela": {
                "Email": "Email",
                "Acoes": "Actions"
            }
        },
        "CadastrarSetor": {
            "titulo": "Register sector",
            "formulario": {
                "Nome": "Name",
                "placeholder": {
                    "registroDoSetor": "Industry registration"
                }
            }
        }
    },
    "Configuracoes": {
        "EditarConfiguracoes": {
            "deletarConfiguracao": "Are you sure you would like to delete this configuration?",
            "deletarTarefa": "Are you sure you would like to delete this task?",
            "titulo": "Editing Fatigue Settings",
            "formulario": {
                "AplicabilidadeTipoDeColaborador": "Applicability - Type of Employee",
                "LimiteDePontosZonaAzul": "Limit points - blue zone",
                "LimiteDePontosZonaAmarela": "Points limit - yellow zone",
                "LimiteDePontosZonaVermelha": "Point limit - red zone",
                "LimiteDePontosDiario": "Point limit - daily",
                "PontuacaoPorDiaDeFolga": "Score per day off",
                "placeholder": {
                    "SelecionarAplicabilidade": "Select applicability"
                }
            },
            "tituloConfiguracoesDePontuacao": "Scoring Settings",
            "tabelaConfiguracoesDePontuacao": {
                "TipoDeColaborador": "Employee Type",
                "Acoes": "Actions"
            },
            "tituloEditarConfiguracao": "Edit configuration",
            "formularioEditarConfiguracao": {
                "AplicabilidadeTipoDeColaborador": "Applicability - Type of Employee",
                "LimiteDePontosZonaAzul": "Limit points - blue zone",
                "LimiteDePontosZonaAmarela": "Points limit - yellow zone",
                "LimiteDePontosZonaVermelha": "Point limit - red zone",
                "LimiteDePontosDiario": "Point limit - daily",
                "PontuacaoPorDiaDeFolga": "Score per day off",
                "placeholder": {
                    "SelecionarAplicabilidade": "Select applicability"
                }
            },
            "tituloTarefasDeRestricao": "Constraint tasks",
            "formularioTarefasDeRestricao": {
                "Tarefa": "Assignment",
                "LimiteDaRestricao": "Constraint limit",
                "Restricao": "Restriction",
                "botaoCadastrarTarefa": "Register task",
                "placeholder": {
                    "SelecionarAplicabilidade": "Select applicability",
                    "SelecionarLimite": "Select limit",
                    "Restricao": "Restriction"
                }
            },
            "tituloTarefasDaAplicabilidade": "Applicability tasks",
            "tabelaTarefasDaAplicabilidade": {
                "Limite": "Limit",
                "Tarefa": "Assignment",
                "Restricao": "Restriction",
                "Acoes": "Actions"
            }
        }
    },
    "AutorizacoesDeCopilotos": {
        "ListaDeCopilotosAutorizados": {
            "deletarRegistro": "Are you sure you would like to delete this record?",
            "titulo": "List of co-pilots authorized to post hours on command",
            "tituloAdicionarAutorizacao": "Add Authorization",
            "formulario": {
                "Tripulante": "Crew member",
                "Frota": "Fleet",
                "botaoAdicionarAutorizacao": "Add authorization",
                "placeholder": {
                    "SelecioneOTripulante": "Select the crew",
                    "SelecioneAFrota": "Select the fleet"
                }
            },
            "tabela": {
                "semGraduacoes": "There are no registered degrees",
                "ID": "ID",
                "Nome": "Name",
                "Frota": "Fleet",
                "Acoes": "Actions"
            }
        }
    },
    "VoosTotais": {
        "DisponibilidadeDeTripulantes": {
            "titulo": "Crew Availability",
            "formulario": {
                "botaoMudarData": "Change date"
            },
            "tabela": {
                "semProgramacaoParaHoje": "There is no schedule registered for today",
                "Matricula": "Reg.",
                "NomeDeGuerra": "War name",
                "Cargo": "Role",
                "Base": "Base",
                "Aeronave": "Aircraft",
                "Frota": "Fleet",
                "HorasRealizadasDisponiveisDia": "Hours Performed (Available) - day",
                "HorasRealizadasDisponiveisMes": "Hours Performed (Available) - month",
                "HorasRealizadasDisponiveisAno": "Hours Performed (Available) - year",
                "HorasRealizadasUltimos30Dias": "Hours Performed - Last. 30 days",
                "JornadaMensal": "Day - Monthly",
                "ExperienciaNoturna": "Exp. nocturnal",
                "CargaExterna": "External Load",
                "Fadiga": "Fatigue",
                "ValidadeASO": "ASO Validity",
                "PendenciasQPulse": "Pending Q-Pulse"
            }
        }
    },
    "Graduacoes": {
        "ListaDeGraduacoesDeTripulantes": {
            "deletarRegistro": "Are you sure you would like to delete this record?",
            "titulo": "List of crew ranks",
            "tituloAdicionarGraduacao": "Add Graduation",
            "formulario": {
                "Tripulante": "Crew member",
                "Frota": "Fleet",
                "Graduacao": "Graduation",
                "opcoesGraduacao": {
                    "Vermelho": "Red",
                    "Amarelo": "Yellow",
                    "Verde": "Green"
                },
                "botaoAdicionarGraduacao": "Add graduation",
                "placeholder": {
                    "SelecioneOTripulante": "Select the crew",
                    "SelecioneAFrota": "Select the fleet",
                    "SelecioneAGraduacao": "Select graduation"
                }
            },
            "tabela": {
                "semGraduacoes": "There are no registered degrees",
                "ID": "ID",
                "Nome": "Name",
                "Frota": "Fleet",
                "Graduacao": "Graduation",
                "Acoes": "Actions"
            }
        }
    },
    "Habilitacoes": {
        "PesquisaDeHabilitacoes": {
            "opcoesCodigoDeHabilitacao": {
                "CCF": "CCF",
                "CHT": "CHT"
            },
            "opcoesHabilitacao": {
                "SelecionarTipo": "Select type",
                "IFRH": "IFRH"
            },
            "titulo": "Qualification search",
            "formulario": {
                "Tripulante": "Crew member",
                "ExibirTripulantesDesligados": "View Disconnected Crewmates",
                "Codigo": "Code",
                "Tipo": "Type",
                "VencimentoInicio": "Start Expiration",
                "VencimentoFim": "End maturity",
                "Aeronave": "Aircraft",
                "botaoProcurarHabilitacoes": "Search qualifications",
                "placeholder": {
                    "SelecionarBase": "Select base",
                    "SelecionarCodigo": "Select code",
                    "SelecionarTipo": "Select type"
                }
            },
            "botaoExportarEmCSV": "Export in CSV",
            "tabela": {
                "Matricula": "Reg.",
                "Apelido": "Surname",
                "CANAC": "CANAC",
                "Licenca": "License",
                "CCF": "CCF",
                "IFRH": "IFRH"
            }
        },
        "StatusDeFrota": {
            "deletarVoo": "Are you sure you would like to delete this flight?",
            "titulo": "Fleet status",
            "botaoEditarStatus": "Edit status",
            "formulario": {
                "DataInicial": "Initial date",
                "DataFinal": "Final date",
                "Base": "Base",
                "botaoProcurarVoos": "Search flights",
                "placeholder": {
                    "SelecionarBase": "Select base"
                }
            },

            tituloVoosPara(dataInicial, dataFinal) {
                return `Flights from ${dataInicial} to ${dataFinal}`
            },
            
            "listaVoosPara": {
                "Atrasado": "Late",
                "SaidaPrevista": "Expected departure",
                "SaidaReal": "Actual exit",
                "Atraso": "Delay",
                "JustificativaPTBR": "Justification PTBR",
                "Motivo": "Reason",
                "Codigo": "Code",
                "JustificativaOmni": "Internal Justification",
                "Setor": "Sector"
            }
        }
    },
    "Papeletas": {
        "ListaDePapeletas": {
            "deletar": "Are you sure you would like to delete this pilot logbook?",
            "trocarStatus": "Are you sure you want to change the pilot logbook status?",
            "botaoAprovarSelecionados": "Approve Selected",
            "titulo": "List of pilot logbooks",
            "tabela": {
                "semPapeletasPendentes": "There are no outstanding papers",
                "ID": "ID",
                "Nome": "Name",
                "Matricula": "Registration",
                "Referencia": "Reference",
                "Alertas": "Alerts",
                "Status": "Status",
                "Acoes": "Actions"
            }
        },
        "AdicionarPapeleta": {
            "titulo": "Register pilot logbook",
            "formulario": {
                "MesAno": "Month year",
                "Tripulante": "Crew member"
            }
        },
        "EditarPapeleta": {
            "aguardeEnquantoOArquivoEGerado": "Wait while the file is generated. This process can take a few minutes.",
            "atualizarAsInformacoes": "Are you sure you want to update the information? Changes made in the FIRA will be lost.",
            "titulo": "Edit Slip",
            "botaoAtualizar": "To update",
            "botaoAlertas": "Alerts",
            "tituloPendencias": "Pendencies",
            "tabelaPendencias": {
                "Data": "Date",
                "Localidades": "Places",
                "Situacao": "Situation",
                "Horarios": "Schedules",
                "Totais": "Totals",
                "Apresentacao": "Presentation",
                "Liberacao": "Release",
                "InicioDaRefeicao": "Start of Meal",
                "TerminoDaRefeicao": "End of Meal",
                "InicioDaSegundaRefeicao": "Beginning of the Second Meal",
                "TerminoDaSegundaRefeicao": "End of the Second Meal",
                "HorasDeJornada": "Working hours",
                "VooNoturno": "Night flight",
                "VooTotal": "Total Flight",
                "AtualizarAsInformacoesDestaDataDeAcordoComAPendencia": "Are you sure you want to update the information for this date according to the issue? Changes made to the FIRA on this date will be lost.",
                "tituloInterrupcoes": "Interruptions",
                "tabelaInterrupcoes": {
                    "Inicio": "Start",
                    "Fim": "End",
                    "Total": "Total"
                },
                "tituloEquipamentos": "Equipment",
                "tabelaEquipamentos": {
                    "Frota": "Fleet"
                }
            },
            "tituloPapeleta": "Slip",
            "tabelaPapeleta": {
                "Data": "Date",
                "Localidades": "Places",
                "Situacao": "Situation",
                "Horarios": "Schedules",
                "Totais": "Totals",
                "Apresentacao": "Presentation",
                "Liberacao": "Release",
                "ApresentacaoData": "Presentation date",
                "ApresentacaoHora": "Presentation time",
                "InicioDaRefeicaoData": "Meal start date",
                "InicioDaRefeicaoHora": "Meal start time",
                "TerminoDaRefeicaoData": "End of Meal date",
                "TerminoDaRefeicaoHora": "Meal end time",
                "InicioDaSegundaRefeicaoData": "Start of Second Meal date",
                "InicioDaSegundaRefeicaoHora": "Start of Second Meal time",
                "TerminoDaSegundaRefeicaoData": "End of Second Meal date",
                "TerminoDaSegundaRefeicaoHora": "End of Second Meal hour",
                "LiberacaoData": "Release date",
                "Liberacaohora": "Release time",
                "HorasDeJornada": "Working hours",
                "VooNoturno": "Night flight",
                "VooTotal": "Total Flight",
                "DeletarFrota": "Are you sure you want to delete this fleet?",
                "DeletarInterrupcao": "Are you sure you want to delete this interrupt?",
                "AtualizarInformacoesDestaData": "Are you sure you want to update the information for this date? Changes made to the FIRA on this date will be lost.",
                "placeholder": {
                    "SelecionarSituacao": "Select situation"
                },
                "tituloInterrupcoes": "Interruptions",
                "formularioInterrupcoes": {
                    "InicioDaInterrupcao": "Start of interruption",
                    "FimDaInterrupcao": "End of interruption",
                    "botaoAdicionarInterrupcao": "Add interrupt"
                },
                "tabelaInterrupcoes": {
                    "Inicio": "Start",
                    "Fim": "End",
                    "Total": "Total",
                    "Acoes": "Actions"
                },
                "tituloEquipamentos": "Equipment",
                "formularioEquipamentos": {
                    "botaoAdicionarFrota": "Add fleet",
                    "placeholder": {
                        "SelecionarFrota": "Select fleet"
                    }
                },
                "tabelaEquipamentos": {
                    "Frota": "Fleet",
                    "Acoes": "Actions"
                }
            },
            "tituloAlertasDoRelatorio": "Report alerts",
            "tabelaAlertasDoRelatorio": {
                "Mensagem": "Message"
            },
            "tituloAlertas": "Alerts",
            "trocarStatus": "Are you sure you want to change the pilot logbook status?",
            "reabrir": "Are you sure you want to reopen the pilot logbook?",
            "botaoForcarAprovacao": "Force Approval",
            "botaoAprovacaoTripulante": "Approval - Crew",
            "botaoAprovacaoGestor": "Approval - Manager",
            "botaoReabrirPapeleta": "Reopen pilot logbook",
            "botaoPapeletaAprovada": "Approved pilot logbook",
            "erros": "The following filling errors on the indicated days prevented the pilot logbook from being finalized",
            "tituloLogDeAprovacoes": "Approvals log",
            "tabelaLogDeAprovacoes": {
                "Usuario": "User",
                "Acao": "Action",
                "Data": "Date"
            },
            "tituloFIRA": "FIRA",
            "botaoReprovacaoGestor": "Failure - Manager"
        },
        "ListaDePapeletasFinalizadas": {
            "deletar": "Are you sure you would like to delete this pilot logbook?",
            "titulo": "List of completed papers",
            "tabela": {
                "semPapeletasPendentes": "There are no outstanding papers",
                "ID": "ID",
                "Nome": "Name",
                "Matricula": "Registration",
                "Referencia": "Reference",
                "Acoes": "Actions"
            }
        },
        "ListaDePapeletasPendentesGestor": {
            "deletar": "Are you sure you would like to delete this pilot logbook?",
            "trocarStatus": "Are you sure you want to change the pilot logbook status?",
            "titulo": "List of pending pilot logbooks - Manager",
            "botaoAprovarSelecionados": "Approve Selected",
            "tabela": {
                "semPapeletasPendentes": "There are no outstanding papers",
                "ID": "ID",
                "Nome": "Name",
                "Matricula": "Registration",
                "Referencia": "Reference",
                "Alertas": "Alerts",
                "Acoes": "Actions"
            }
        },
        "ListaDePapeletasPendentesTripulantes": {
            "deletar": "Are you sure you would like to delete this pilot logbook?",
            "titulo": "List of pending pilot logbooks - Crew",
            "tabela": {
                "semPapeletasPendentes": "There are no outstanding papers",
                "ID": "ID",
                "Nome": "Name",
                "Matricula": "Registration",
                "Referencia": "Reference",
                "Acoes": "Actions"
            }
        },
        "ControleRequisicaoCustomizada": {
            "titulo": "Consultation of pilot logbooks - Managers",
            "formulario": {
                "Data": "Date",
                "RequisitosPersonalizados": "Custom Requirements",
                "Tripulante": "Crew member"
            },
            "tabela": {
                "Matricula": "Reg.",
                "Nome": "Name",
                "Requisito": "Requirement",
                "Tipo": "Type",
                "Dias": "Days",
                "LimiteDeHoras": "Hour Limit",
                "HorasRealizadas": "Hours Performed"
            }
        },
        "ControleDePapeletas": {
            "titulo": "Control of pilot logbooks",
            "formulario": {
                "DataInicial": "Initial date",
                "DataFinal": "Final date",
                "Nome": "Name",
                "placeholder": {
                    "SelecionarTripulantes": "Select crew"
                }
            },
            "tabela": {
                "semInformacao": "There is no information to display",
                "Tripulante": "Crew member",
                "SomaDeHorasDeJornada": "Sum of Working Hours",
                "SomaDeHorasDeVooNoturno": "Sum of Night Flight Hours",
                "SomaDeHorasDeVooTotal": "Sum of Total Flight Hours"
            }
        },
        "ConsultaDePapeletas": {
            "titulo": "Consultation of pilot logbooks",
            "formulario": {
                "DataInicial": "Initial date",
                "DataFinal": "Final date"
            },
            "tabela": {
                "MesAno": "Month year",
                "Alertas": "Alerts",
                "Acoes": "Actions"
            }
        },
        "ConsultaDePapeletasGestores": {
            "aguardeEnquantoOArquivoEGerado": "Wait while the file is generated. This process can take a few minutes.",
            "titulo": "Consultation of pilot logbooks - Managers",
            "formulario": {
                "DataInicial": "Initial date",
                "DataFinal": "Final date",
                "Tripulante": "Crew member",
                "ExibirDesligados": "Show off",
                "SomenteComAlertas": "Only with alerts"
            },
            "tabela": {
                "Tripulante": "Crew member",
                "MesAno": "Month year",
                "Alertas": "Alerts",
                "Acoes": "Actions"
            }
        }
    },
    "RelatoriosDeFadiga": {
        "ListaDeRelatoriosDeFadigas": {
            "botaoAdicionarRelatorioDeFadiga": "Add Fatigue Report",
            "titulo": "Fatigue report list",
            "tabela": {
                "semParametroDeFadiga": "There are no registered fatigue parameters",
                "Data": "Date",
                "Revisao": "Revision",
                "Tripulante": "Crew member",
                "Folga": "Day off",
                "QuantidadeDePontosAtual": "Current amount of points",
                "QuantidadeDePontosReportados": "Number of points reported",
                "Acoes": "Actions"
            }
        },
        "AdicionarRelatorioDeFadiga": {
            noParametroAPontuacaoMaximaFoiUltrapassada(name){
                return `In the parameter ${name} the maximum score was exceeded, confirm sending the report?`
            },
        
            noParametroAPontuacaoMinimaNaoFoiAtingida(name){
                return `In parameter ${name} the minimum score was not reached, confirm sending the report?`
            },
        
            "titulo": "Register fatigue report",
            "formulario": {
                "Data": "Date",
                "Bases": "Bases",
                "botaoAdicionarRelatorioDeFadiga": "Add Fatigue Report",
                "placeholder": {
                    "SelecionarBase": "Select base",
                    "SelecionarOpcao": "Select option",
                    "Horas": "Hours",
                    "Quantidade": "The amount"
                }
            }
        },
        "EditarRelatorioDeFadiga": {
            noParametroAPontuacaoMaximaFoiUltrapassada(name){
                return `In the parameter ${name} the maximum score was exceeded, confirm sending the report?`
            },
        
            noParametroAPontuacaoMinimaNaoFoiAtingida(name){
                return `In parameter ${name} the minimum score was not reached, confirm sending the report?`
            },
        
            "titulo": "Fatigue Report Editing - Review",
            "paragrafoStatusDaRevisao": "Review status",
            "paragrafoQuantidadeDePontosAtual": "Current amount of points",
            "paragrafoQuantidadeDePontosReportados": "Number of points reported",
            "tabRevisao": {
                "tituloTab": "Revision",
                "paragrafoStatusDaRevisao": "Review status",
                "paragrafoQuantidadeDePontosAtual": "Current amount of points",
                "paragrafoQuantidadeDePontosReportados": "Number of points reported"
            },
            "tituloCriarRevisao": "Create review",
            "formularioCriarRevisao": {
                "botaoCriarRevisaoDeRelatorioDeFadiga": "Create fatigue report review",
                "placeholder": {
                    "SelecionarOpcao": "Select option",
                    "Horas": "Hours",
                    "Quantidade": "The amount"
                }
            }
        },
        "EditarParametroDeFadiga": {
            "deletar": "Are you sure you would like to delete this option?",
            "titulo": "Edit Fatigue Parameter",
            "formulario": {
                "Nome": "Name",
                "Tipo": "Type",
                "Operador": "Operator",
                "PontosPorHora": "Points per hour",
                "PontosPorQuantidade": "Points per quantity",
                "LimiteDePontos": "Point limit",
                "placeholder": {
                    "NomeDoParametroDeFadiga": "Fatigue parameter name",
                    "SelecionarCliente": "Select customer",
                    "QuantidadeDePontosPorHora": "Number of points per hour",
                    "QuantidadeDePontosPorQuantidade": "Number of points per amount"
                }
            },
            "tituloAdicionarOpcoes": "Add options",
            "formularioAdicionarOpcoes": {
                "Nome": "Name",
                "Pontos": "Spots",
                "placeholder": {
                    "NomeDoParametroDeFadiga": "Fatigue parameter name",
                    "QuantidadeDePontos": "Amount of points"
                }
            },
            "tituloOpcoes": "Options",
            "tabelaOpcoes": {
                "Opcao": "Option",
                "Pontos": "Spots",
                "Acoes": "Actions"
            }
        },
        "SimuladorDeRelatoriosDeFadiga": {
            "titulo": "Fatigue report simulator",
            "formulario": {
                "DataInicial": "Initial date",
                "DataFinal": "Final date",
                "AplicabilidadeTipoDeColaborador": "Applicability - Type of Employee",
                "QuantidadeDePontos": "Amount of points",
                "botaoGerarSimulacaoDeRelatoriosDeFadiga": "Generate simulation of fatigue reports",
                "placeholder": {
                    "SelecionarAplicabilidade": "Select applicability"
                }
            },
            "tabDatas": {
                "botaoGerarRelatoriosDeFadiga": "Generate fatigue reports",
                "botaoCopiarParaProximasDatas": "Copy to next dates",
                "formulario": {
                    "MarcarComoFolga": "Mark as day off",
                    "Data": "Date",
                    "placeholder": {
                        "SelecionarOpcao": "Select option",
                        "Horas": "Hours",
                        "Quantidade": "The amount"
                    }
                }
            },
            "tabela": {
                "Data": "Date",
                "Diaria": "Daily",
                "Acumulada": "Accumulated"
            }
        },
        "RevisarHorariosDePonto": {
            "titulo": "Review point schedules",
            "tituloUtilizeEstaFerramentaParaCorrigirOsReportes": "Use this tool to correct reports according to the point API.",
            "tituloAtencaoCasoOReportNaoExistaDeveraSerCriado": "Attention: If the report does not exist, it must be created manually first.",
            "formulario": {
                "AplicabilidadeTipoDeColaborador": "Applicability - Type of Employee",
                "Tripulantes135": "Crew - 135",
                "Tripulantes121": "Crew - 121",
                "Mecanicos": "Mechanics",
                "Coordenadores": "Coordinators",
                "Data": "Date",
                "botaoRevisarHorarios": "Review schedules",
                "placeholder": {
                    "SelecionarAplicabilidade": "Select applicability",
                    "SelecionarTripulante": "Select crew member",
                    "SelecionarMecanico": "Select mechanic",
                    "SelecionarCoordenador": "Select coordinator"
                }
            }
        },
        "AdicionarRelatorioDeFadigaAdministrador": {
            noParametroAPontuacaoMaximaFoiUltrapassada(name){
                return `In the parameter ${name} the maximum score was exceeded, confirm sending the report?`
            },
    
            noParametroAPontuacaoMinimaNaoFoiAtingida(name){
                return `In parameter ${name} the minimum score was not reached, confirm sending the report?`
            },
        
            "titulo": "Register fatigue report",
            "formulario": {
                "AplicabilidadeTipoDeColaborador": "Applicability - Type of Employee",
                "Tripulantes135": "Crew - 135",
                "Tripulantes121": "Crew - 121",
                "Mecanicos": "Mechanics",
                "Coordenadores": "Coordinators",
                "Data": "Date",
                "Bases": "Bases",
                "botaoAdicionarRelatorioDeFadiga": "Add Fatigue Report",
                "placeholder": {
                    "SelecionarAplicabilidade": "Select applicability",
                    "SelecionarTripulante": "Select crew member",
                    "SelecionarMecanico": "Select mechanic",
                    "SelecionarCoordenador": "Select coordinator",
                    "SelecionarBase": "Select base",
                    "SelecionarOpcao": "Select option",
                    "Horas": "Hours",
                    "Quantidade": "The amount"
                }
            }
        },
        "EditarRelatorioDeFadigaAdministrador": {
            noParametroAPontuacaoMaximaFoiUltrapassada(name){
                return `In the parameter ${name} the maximum score was exceeded, confirm sending the report?`
            },
    
            noParametroAPontuacaoMinimaNaoFoiAtingida(name){
                return `In parameter ${name} the minimum score was not reached, confirm sending the report?`
            },
        
            "titulo": "Fatigue Report Editing - Review",
            "paragrafoStatusDaRevisao": "Review status",
            "paragrafoQuantidadeDePontosAtual": "Current amount of points",
            "paragrafoQuantidadeDePontosReportados": "Number of points reported",
            "tabRevisao": {
                "tituloTab": "Revision",
                "paragrafoStatusDaRevisao": "Review status",
                "paragrafoQuantidadeDePontosAtual": "Current amount of points",
                "paragrafoQuantidadeDePontosReportados": "Number of points reported"
            },
            "tituloCriarRevisao": "Create review",
            "formularioCriarRevisao": {
                "botaoCriarRevisaoDeRelatorioDeFadiga": "Create fatigue report review",
                "placeholder": {
                    "SelecionarOpcao": "Select option",
                    "Horas": "Hours",
                    "Quantidade": "The amount"
                }
            }
        },
        "EstatisticasDeEventosDeFadiga": {
            "opcoesEvento": {
                "Verde": "Green",
                "Amarelo": "Yellow",
                "Vermelho": "Red"
            },
            "opcoesPeriodo": {
                "UmDia": "1 day",
                "DoisDias": "2 days",
                "TresDias": "3 days"
            },
            "titulo": "Fatigue Event Statistics",
            "formulario": {
                "DataInicial": "Initial date",
                "DataFinal": "Final date",
                "TipoDeEvento": "Kind of event",
                "AplicabilidadeTipoDeColaborador": "Applicability - Type of Employee",
                "PeriodoEstatisticoAnteriorAoEvento": "Statistical Period Prior to the Event",
                "botaoProcurarRelatorios": "Browse reports",
                "placeholder": {
                    "DeixarEmBrancoParaTodos": "Leave blank for all.",
                    "SelecionarAplicabilidade": "Select applicability",
                    "SelecionarPeriodo": "Select period"
                }
            },
            "tabela": {
                "semEventosDeFadigaParaEstePeriodo": "There are no fatigue events for this period."
            }
        },
        "FiltroDeRelatorio": {
            "deletar": "Are you sure you'd like to delete this fatigue parameter?",
            "titulo": "Report search",
            "formulario": {
                "DataInicial": "Initial date",
                "DataFinal": "Final date",
                "AplicabilidadeTipoDeColaborador": "Applicability - Type of Employee",
                "Mecanicos": "Mechanics",
                "Coordenadores": "Coordinators",
                "Tripulantes": "Crew",
                "Cargos": "Roles",
                "Frotas": "Fleets",
                "Bases": "Bases",
                "ApenasIncidentesDeFadiga": "Just incidents of fatigue",
                "botaoProcurarRelatorios": "Browse reports",
                "placeholder": {
                    "SelecionarAplicabilidade": "Select applicability",
                    "SelecionarMecanicos": "Select Mechanics",
                    "SelecionarCoordenadores": "Select Coordinators",
                    "SelecionarTripulantes": "Select Crew Members",
                    "SelecionarCargos": "Select roles",
                    "SelecionarFrotas": "Select fleets",
                    "SelecionarBases": "Select bases"
                }
            },
            "tituloListaDeRelatoriosDeFadiga": "Fatigue report list",
            "botaoMostrarEsconderTripulantes": "Show/Hide Crewmates",
            "botaoFiltrarTripulantes": "Filter crew",
            "tabela": {
                "Nome": "Name",
                "Pontos": "Spots"
            }
        },
        "RelatorioDeEventosIncidentesDeFadiga": {
            "titulo": "Fatigue Event/Incident Report",
            "formulario": {
                "DataInicial": "Initial date",
                "DataFinal": "Final date",
                "AplicabilidadeTipoDeColaborador": "Applicability - Type of Employee",
                "Mecanicos": "Mechanics",
                "Coordenadores": "Coordinators",
                "Tripulantes": "Crew",
                "TipoDeEventoIncidente": "Type of Event/Incident",
                "ApenasIncidentesDeFadigaChecados": "Only fatigue incidents checked",
                "botaoProcurarRelatorios": "Browse reports",
                "placeholder": {
                    "SelecionarAplicabilidade": "Select applicability",
                    "SelecionarMecanicos": "Select Mechanics",
                    "SelecionarCoordenadores": "Select Coordinators",
                    "SelecionarTripulantes": "Select Crew Members",
                    "SelecionarIncidente": "Select incident"
                }
            },
            "tituloListaDeEventosIncidentesDeFadiga": "List of fatigue events/incidents",
            "tabela": {
                "semEventosIncidentesDeFadiga": "There were no fatigue events/incidents in the period",
                "ID": "ID",
                "TipoDeEvento": "Kind of event",
                "Data": "Date",
                "Revisao": "Revision",
                "Tripulante": "Crew member",
                "PontuacaoReportada": "Reported score",
                "PontuacaoTotal": "Total score",
                "Checado": "Checked",
                "DataDaChecagem": "Check Date",
                "AcaoRealizada": "Action Taken",
                "Acoes": "Actions"
            },
            "tituloEditarPlanoDeAcao": "Edit action plan",
            "formularioEditarPlanoDeAcao": {
                "PlanoDeAcao": "Action plan",
                "botaoEditarPlanoDeAcao": "Edit action plan"
            },
            "marcarEsteIncidenteComoChecado": "Are you sure you want to mark this incident as checked?"
        },
        "PesquisaDeRelatoriosNaoPreenchidos": {
            "titulo": "Search for unfilled reports",
            "formulario": {
                "DataInicial": "Initial date",
                "DataFinal": "Final date",
                "AplicabilidadeTipoDeColaborador": "Applicability - Type of Employee",
                "Bases": "Bases",
                "IncluirFolgaCadastradaAutomaticamente": "Include automatically registered time off",
                "botaoProcurarRelatorios": "Browse reports",
                "placeholder": {
                    "SelecionarAplicabilidade": "Select applicability",
                    "SelecionarBase": "Select base"
                }
            },
            "tituloListaDeRelatOriosDeFadigasFaltantes": "List of missing fatigue reports",
            "tabela": {
                "semReportesFaltantes": "There are no missing reports in this period",
                "Nome": "Name",
                "Data": "Date",
                "Situacao": "Situation"
            }
        },
        "PesquisaDeRelatorios": {
            "titulo": "Report search",
            "formulario": {
                "DataInicial": "Initial date",
                "DataFinal": "Final date",
                "AplicabilidadeTipoDeColaborador": "Applicability - Type of Employee",
                "Mecanicos": "Mechanics",
                "Coordenadores": "Coordinators",
                "Tripulantes": "Crew",
                "Cargos": "Roles",
                "Bases": "Bases",
                "botaoProcurarRelatarios": "Browse reports",
                "placeholder": {
                    "SelecionarAplicabilidade": "Select applicability",
                    "SelecionarMecanicos": "Select Mechanics",
                    "SelecionarCoordenadores": "Select Coordinators",
                    "SelecionarTripulantes": "Select Crew Members",
                    "SelecionarCargos": "Select roles",
                    "SelecionarBases": "Select bases"
                }
            },
            "tituloTotalDoPeriodo": "Period Total",
            "tabelaTotalDoPeriodo": {
                "semParametrosDeFadiga": "There are no registered fatigue parameters",
                "NaoFadigados": "Not fatigued",
                "PontosAzul": "Blue Points",
                "PontosAmarelo": "Yellow Points",
                "PontosVermelho": "Red dots"
            },
            "tituloTotalDiario": "Daily Total",
            "tabelaTotalDiario": {
                "semParametrosDeFadiga": "There are no registered fatigue parameters",
                "Data": "Date",
                "NaoFadigados": "Not fatigued",
                "PontosAzul": "Blue Points",
                "PontosAmarelo": "Yellow Points",
                "PontosVermelho": "Red dots"
            },
            "tituloListaDeRelatoriosDeFadigas": "Fatigue report list",
            "tabelaListaDeRelatoriosDeFadigas": {
                "semParametrosDeFadiga": "There are no registered fatigue parameters",
                "Data": "Date",
                "Revisao": "Revision",
                "Tripulante": "Crew member",
                "Folga": "Day off",
                "QuantidadeDePontosAtual": "Current amount of points",
                "QuantidadeDePontosReportados": "Number of points reported",
                "DiaDePreenchimento": "Filling day",
                "Acoes": "Actions"
            },
            "tituloDadosDoRelatorioDeFadiga": "Fatigue report data",
            "paragrafoQuantidadeDePontosAtual": "Current amount of points",
            "paragrafoQuantidadeDePontosReportados": "Number of points reported",
            "tabelaDadosDoRelatorioDeFadiga": {
                "Parametro": "Parameter",
                "Dados": "Data",
                "Pontos": "Spots"
            }
        },
        "Importacoes": {
            "titulo": "Imports",
            "formulario": {
                "Aplicabilidade": "Applicability",
                "Arquivo": "Archive",
                "tituloErrosDeImportacao": "Import errors",
                "botaoImportar": "Import",
                "placeholder": {
                    "SelecionarAplicabilidade": "Select applicability",
                    "Arquivo": "Archive"
                }
            },
            "tabela": {
                "ID": "ID",
                "DataDosRelatorios": "Date of reports",
                "DataDeImportacao": "Import Date",
                "Arquivo": "Archive",
                "Hash": "Hash",
                "Acoes": "Actions"
            }
        },
        "AvaliarEscalaPlanejada": {
            "titulo": "Evaluate Planned Schedule",
            "formulario": {
                "Aplicabilidade": "Applicability",
                "Arquivo": "Archive",
                "tituloErrosDeImportacao": "Import errors",
                "botaoImportar": "Import",
                "placeholder": {
                    "SelecionarAplicabilidade": "Select applicability",
                    "Arquivo": "Archive"
                }
            },
            "tabela": {
                "semParametrosDeFadiga": "There are no registered fatigue parameters",
                "Data": "Date",
                "Revisao": "Revision",
                "Tripulante": "Crew member",
                "Folga": "Day off",
                "QuantidadeDePontosAtual": "Current amount of points",
                "QuantidadeDePontosReportados": "Number of points reported",
                "Status": "Status",
                "Acoes": "Actions"
            }
        }
    },
    "Tripulantes": {
        "ListadeTripulantes": {
            "titulo": "Crew list",
            "botaoAdicionarFuncionario": "Add employee",
            "tabela": {
                "semTripulantes": "There are no registered crew",
                "Nome": "Name",
                "Matricula": "Registration",
                "Cargo": "Role",
                "Licenca": "License",
                "CANAC": "CANAC",
                "Acoes": "Actions"
            }
        },
        "AdicionarFuncionario": {
            "titulo": "Register employee",
            "formulario": {
                "tituloInformacoesPessoais": "Personal information",
                "Nome": "Name",
                "Apelido": "Surname",
                "Telefone1": "Phone 1",
                "Telefone2": "Phone 2",
                "EstadoCivil": "Marital status",
                "Email": "Email",
                "Naturalidade": "Naturalness",
                "Escolaridade": "Education",
                "NomeDaMae": "Mother's name",
                "NomeDoPai": "Father's name",
                "Raca": "Race",
                "Foto": "Photograph",
                "DataDeNascimento": "Birth date",
                "tituloEndereco": "Address",
                "Endereco": "Address",
                "Numero": "Number",
                "Complemento": "Complement",
                "Bairro": "Neighborhood",
                "Cidade": "City",
                "Estado": "State",
                "Pais": "Country",
                "CEP": "Zip code",
                "CPF": "CPF",
                "Identidade": "Identity",
                "IdentidadeUF": "Identity - State",
                "IdentidadeDataDeExpedicao": "Identity - date of issue",
                "PIS": "PIS",
                "IdentidadeOrgaoExpeditor": "Identity - issuing body",
                "ConfidenceUS": "US Confidence",
                "ExpiracaoConfidenceUS": "US confidence expiration",
                "ConfidenceEU": "Confidence EU",
                "ExpiracaoConfidenceEU": "EU confidence expiry",
                "CTPS": "CTPS",
                "CTPSNumeroDeSerie": "CTPS - Serial No.",
                "CTPSExpedicao": "CTPS expedition",
                "CTPSUF": "CTPS UF",
                "TipoSanguineo": "Blood type",
                "Matricula": "Registration",
                "SISPAT": "SISPAT",
                "CANAC": "CANAC",
                "Licenca": "License",
                "Contratacao": "Hiring",
                "CargoDeAdmissao": "Admission role",
                "CargoAtual": "Current Position",
                "EstadoDeNascimento": "Birth state",
                "CidadeDeNascimento": "City of birth",
                "PaisDeNascimento": "Country of birth",
                "ASO": "ASO",
                "Eletrocardiograma": "Electrocardiogram",
                "CodigoSapiens": "Sapiens Code",
                "botaoAdicionarFuncionario": "Add Employee",
                "placeholder": {
                    "Arquivo": "Archive"
                }
            }
        },
        "EditarFuncionario": {
            "titulo": "Employee edit",
            "botaoRestaurar": "To restore",
            "botaoArquivoMorto": "Dead file",
            "botaoExportacoes": {
                "Exportacoes": "Exports",
                "ANAC": "ANAC",
                "Declaracao": "Declaration",
                "Designacoes": "Designations",
                "Indicacoes": "Indications",
                "FileDigitalCompleto": "Full digital file",
                "Certificacoes": "Certifications",
                "VisualizarTodos": "View all",
                "VisualizarValidos": "View valid",
                "Curriculo": "Resume",
                "VisualizarPTBR": "View PT-BR",
                "VisualizarENUS": "View EN-US"
            },
            "tabDadosDoFuncionario": {
                "tituloTab": "Employee data",
                "formulario": {
                    "tituloInformacoesPessoais": "Personal information",
                    "Nome": "Name",
                    "Apelido": "Surname",
                    "Telefone1": "Phone 1",
                    "Telefone2": "Phone 2",
                    "EstadoCivil": "Marital status",
                    "Email": "Email",
                    "Naturalidade": "Naturalness",
                    "Escolaridade": "Education",
                    "NomeDaMae": "Mother's name",
                    "NomeDoPai": "Father's name",
                    "Raca": "Race",
                    "Foto": "Photograph",
                    "DataDeNascimento": "Birth date",
                    "tituloEndereco": "Address",
                    "Endereco": "Address",
                    "Numero": "Number",
                    "Complemento": "Complement",
                    "Bairro": "Neighborhood",
                    "Cidade": "City",
                    "Estado": "State",
                    "Pais": "Country",
                    "CEP": "Zip code",
                    "CPF": "CPF",
                    "Identidade": "Identity",
                    "IdentidadeUF": "Identity - State",
                    "IdentidadeDataDeExpedicao": "Identity - date of issue",
                    "PIS": "PIS",
                    "IdentidadeOrgaoExpeditor": "Identity - issuing body",
                    "ConfidenceUS": "US Confidence",
                    "ExpiracaoConfidenceUS": "US confidence expiration",
                    "ConfidenceEU": "Confidence EU",
                    "ExpiracaoConfidenceEU": "EU confidence expiry",
                    "CTPS": "CTPS",
                    "CTPSNumeroDeSerie": "CTPS - Serial No.",
                    "CTPSExpedicao": "CTPS expedition",
                    "CTPSUF": "CTPS UF",
                    "TipoSanguineo": "Blood type",
                    "Matricula": "Registration",
                    "SISPAT": "SISPAT",
                    "CANAC": "CANAC",
                    "Licenca": "License",
                    "Contratacao": "Hiring",
                    "CargoDeAdmissao": "Admission role",
                    "CargoAtual": "Current Position",
                    "EstadoDeNascimento": "Birth state",
                    "CidadeDeNascimento": "City of birth",
                    "PaisDeNascimento": "Country of birth",
                    "ASO": "ASO",
                    "Eletrocardiograma": "Electrocardiogram",
                    "CodigoSapiens": "Sapiens Code",
                    "placeholder": {
                        "Arquivo": "Archive"
                    }
                }
            },
            "tabAdministrativo": {
                "tituloTab": "Administrative",
                "deletar": "Are you sure you would like to delete this file?",
                "tituloAdicionarArquivos": "Add files",
                "formulario": {
                    "TipoDeArquivo": "File type",
                    "Arquivo": "Archive",
                    "NomeDoArquivo": "File name",
                    "DataDeValidade": "Expiration date",
                    "botaoAdicionarArquivo": "Add file",
                    "placeholder": {
                        "Arquivo": "Archive",
                        "NomeDoArquivo": "File name"
                    }
                },
                "tabela": {
                    "semArquivos": "There are no registered files",
                    "NomeDoArquivo": "File name",
                    "Tipo": "Type",
                    "Validade": "Expires in",
                    "Acoes": "Actions"
                }
            },
            "tabHorasDeVoo": {
                "tituloTab": "Flight hours",
                "deletar": "Are you sure you would like to delete this file?",
                "tituloTotaisDeHoras": "Total hours",
                "tabelaTotaisDeHoras": {
                    "semAeronaves": "There are no registered aircraft",
                    "ID": "ID",
                    "Modelo": "Model",
                    "FB": "FB",
                    "Total": "Total",
                    "IFR": "IFR.",
                    "Noturno": "Nocturnal",
                    "APP": "APP",
                    "Diurno": "Diurnal"
                },
                "tituloAdicionarArquivos": "Add files",
                "formularioAdicionarArquivo": {
                    "Arquivo": "Archive",
                    "NomeDoArquivo": "File name",
                    "botaoAdicionarArquivo": "Add file",
                    "placeholder": {
                        "Arquivo": "Archive",
                        "NomeDoArquivo": "File name"
                    }
                },
                "tabelaArquivos": {
                    "semArquivos": "There are no registered files",
                    "NomeDoArquivo": "File name",
                    "Validade": "Expires in",
                    "Acoes": "Actions"
                }
            },
            "tabHabilitacoes": {
                "tituloTab": "Qualifications",
                "opcoesCodigoDeHabilitacao": {
                    "CCF": "CCF",
                    "CHT": "CHT"
                },
                "opcoesHabilitacao": {
                    "SelecionarTipo": "Select type",
                    "IFRH": "IFRH"
                },
                "ativar": "Are you sure you would like to activate this license?",
                "deletar": "Are you sure you would like to delete this license?",
                "arquivar": "Are you sure you'd like to archive this license?",
                "tituloHabilitacoes": "Qualifications",
                "botaoEsconderArquivoMorto": "Hide archive",
                "botaoMostrarArquivoMorto": "Show archive",
                "nenhumaHabilitacaoCadastrada": "No registration registered.",
                "tabela": {
                    "Codigo": "Code",
                    "Frota": "Fleet",
                    "Tipo": "Type",
                    "CANAC": "CANAC",
                    "Licenca": "License",
                    "Vencimento": "Maturity",
                    "Status": "Status",
                    "Acoes": "Actions",
                    "Ativo": "Active",
                    "Arquivado": "Archived"
                },
                "tituloCadastrarHabilitacao": "Register license",
                "formulario": {
                    "Codigo": "Code",
                    "Validade": "Expires in",
                    "Frota": "Fleet",
                    "Tipo": "Type",
                    "botaoSalvarHabilitacao": "Save license"
                }
            },
            "tabProcessos": {
                "tituloTab": "Law Suit",
                "deletar": "Are you sure you would like to delete this file?",
                "tituloCadastrarProcesso": "Register process",
                "formulario": {
                    "DataDeEmissao": "Date of issue",
                    "DataDeValidade": "Expiration date",
                    "Frota": "Fleet",
                    "Processo": "Process",
                    "Subtipo": "Subtype",
                    "ArquivoDeProcessosFileDigital": "Process file (DIGITAL FILE)",
                    "botaoAdicionarProcesso": "Add process",
                    "placeholder": {
                        "Arquivo": "Archive"
                    }
                },
                "tituloProcessos": "Law Suit",
                "tabela": {
                    "semArquivosDeProcessos": "No process files",
                    "Frota": "Fleet",
                    "Processo": "Process",
                    "Subtipo": "Subtype",
                    "DataDeEmissao": "Date of issue",
                    "Validade": "Expires in",
                    "Acoes": "Actions"
                }
            },
            "tabCertificacoes": {
                "tituloTab": "Certifications",
                "ativar": "Are you sure you would like to activate this certification?",
                "arquivar": "Are you sure you'd like to archive this certification?",
                "deletar": "Are you sure you would like to delete this certification?",
                "tituloCertificados": "Certifications",
                "botaoEsconderArquivoMorto": "Hide archive",
                "botaoMostrarArquivoMorto": "Show archive",
                "nenhumCertificadoCadastrado": "No registered certification.",
                "tabela": {
                    "NomeDoCertificado": "Certification name",
                    "Inicio": "Start",
                    "Fim": "End",
                    "Vencimento": "Maturity",
                    "Status": "Status",
                    "Arquivo": "Archive",
                    "Acoes": "Actions",
                    "Ativo": "Active",
                    "Arquivado": "Archived"
                },
                "tituloCadastrarCertificado": "Register certification",
                "formulario": {
                    "Certificado": "Certification",
                    "Fornecedor": "Provider",
                    "DataDeInicio": "Start date",
                    "DataFinal": "Final date",
                    "CargaHoraria": "Workload",
                    "QuantidadeDePousosNoturnos": "Number of night landings",
                    "Observacoes": "Comments",
                    "botaoSalvarCertificado": "Save certification",
                    "placeholder": {
                        "SelecionarCertificado": "Select certification",
                        "SelecionarFornecedor": "Select supplier"
                    }
                },
                "temCertezaQueGostariaDeImportarEsteArquivo": "Are you sure you would like to import this file? When importing, the previous file will be permanently replaced.",
                "formularioAdicionarArquivo": {
                    "placeholder": {
                        "Arquivo": "Archive"
                    }
                }
            },
            "tabAvaliacoes": {
                "tituloTab": "Assessments",
                "ativar": "Are you sure you would like to activate this certification?",
                "arquivar": "Are you sure you'd like to archive this certification?",
                "deletar": "Are you sure you would like to delete this certification?",
                "tituloAvaliacoes": "Assessments",
                "botaoEsconderArquivoMorto": "Hide archive",
                "botaoMostrarArquivoMorto": "Show archive",
                "nenhumCertificadoCadastrado": "No registered certification.",
                "tabela": {
                    "NomeDoCertificado": "Certification name",
                    "Inicio": "Start",
                    "Fim": "End",
                    "Vencimento": "Maturity",
                    "Status": "Status",
                    "Arquivo": "Archive",
                    "Acoes": "Actions",
                    "Ativo": "Active",
                    "Arquivado": "Archived"
                },
                "tituloCadastrarCertificado": "Register certification",
                "formulario": {
                    "Certificado": "Certification",
                    "Fornecedor": "Provider",
                    "DataDeInicio": "Start date",
                    "DataFinal": "Final date",
                    "CargaHoraria": "Workload",
                    "QuantidadeDePousosNoturnos": "Number of night landings",
                    "Observacoes": "Comments",
                    "botaoSalvarCertificado": "Save certification",
                    "placeholder": {
                        "SelecionarCertificado": "Select certification",
                        "SelecionarFornecedor": "Select supplier"
                    }
                }
            },
            "tabFIRA": {
                "tituloTab": "FIRA",
                "deletar": "Are you sure you would like to delete this file?",
                "tituloAdicionarArquivos": "Add files",
                "formulario": {
                    "Data": "Date",
                    "Arquivo": "Archive",
                    "botaoAdicionarArquivo": "Add file",
                    "placeholder": {
                        "Arquivo": "Archive"
                    }
                },
                "tabela": {
                    "semArquivos": "There are no registered files",
                    "Data": "Date",
                    "Acoes": "Actions"
                }
            },
            "tabCargos": {
                "tituloTab": "Roles",
                "ativar": "Are you sure you'd like to activate this role?",
                "arquivar": "Are you sure you'd like to archive this job?",
                "deletar": "Are you sure you'd like to delete this job?",
                "tituloCargos": "Roles",
                "nenhumCargoCadastrado": "No jobs registered.",
                "tabela": {
                    "Cargo": "Role",
                    "CodigoRubi": "Code Rubi",
                    "Status": "Status",
                    "Data": "Date",
                    "Acoes": "Actions",
                    "Ativo": "Active",
                    "Arquivado": "Archived"
                },
                "tituloCadastrarCargo": "Register role",
                "formulario": {
                    "Cargo": "Role",
                    "DataInicial": "Initial date",
                    "botaoSalvarCargo": "Save charge"
                }
            },
            "tabDesignacoes": {
                "tituloTab": "Designations",
                "ativar": "Are you sure you'd like to activate this designation?",
                "deletar": "Are you sure you would like to delete this assignment?",
                "arquivar": "Are you sure you'd like to archive this designation?",
                "tituloDesignacoes": "Designations",
                "nenhumaDesignacaoCadastrada": "No designation registered.",
                "tabela": {
                    "Designacao": "Designation",
                    "Frota": "Fleet",
                    "Status": "Status",
                    "Data": "Date",
                    "Acoes": "Actions",
                    "Ativo": "Active",
                    "Arquivado": "Archived"
                },
                "tituloCadastrarDesignacao": "Register designation",
                "formulario": {
                    "Designacao": "Designation",
                    "DataInicial": "Initial date",
                    "Frota": "Fleet",
                    "botaoSalvarDesignacao": "Save designation"
                }
            },
            "tabIndicacoes": {
                "tituloTab": "Indications",
                "ativar": "Are you sure you would like to enable this indication?",
                "arquivar": "Are you sure you'd like to archive this nomination?",
                "deletar": "Are you sure you would like to delete this indication?",
                "tituloIndicacao": "Recommendation",
                "nenhumaIndicacaoCadastrada": "No indication registered.",
                "tabela": {
                    "Designacao": "Designation",
                    "Frota": "Fleet",
                    "Status": "Status",
                    "Data": "Date",
                    "Acoes": "Actions",
                    "Ativo": "Active",
                    "Arquivado": "Archived"
                },
                "tituloCadastrarIndicacao": "Register indication",
                "formulario": {
                    "Designacao": "Designation",
                    "Validade": "Expires in",
                    "Frota": "Fleet",
                    "botaoSalvarIndicacao": "Save indication"
                }
            },
            "tabRegimes": {
                "tituloTab": "Regimes",
                "ativar": "Are you sure you would like to activate this fortnight?",
                "arquivar": "Are you sure you'd like to archive this fortnight?",
                "deletar": "Are you sure you would like to delete this fortnight?",
                "tituloRegimes": "Regimes",
                "nenhumRegimeCadastrado": "No regime registered.",
                "tabela": {
                    "Regime": "Regime",
                    "Data": "Date",
                    "Mes": "Month",
                    "Ano": "Year",
                    "Status": "Status",
                    "Acoes": "Actions",
                    "Ativo": "Active",
                    "Arquivado": "Archived"
                },
                "tituloCadastrarRegime": "Register regime",
                "formulario": {
                    "Regime": "Regime",
                    "DataInicial": "Initial date",
                    "botaoSalvarRegime": "Save regime"
                }
            },
            "tabGratificacoes": {
                "tituloTab": "Gratuities",
                "ativar": "Are you sure you'd like to activate this bonus?",
                "arquivar": "Are you sure you'd like to archive this bonus?",
                "deletar": "Are you sure you'd like to delete this bonus?",
                "tituloGratificacoes": "Gratuities",
                "nenhumaGratificacaoCadastrada": "No bonus registered.",
                "tabela": {
                    "Gratificacao": "Gratification",
                    "Data": "Date",
                    "Status": "Status",
                    "Acoes": "Actions",
                    "Ativo": "Active",
                    "Arquivado": "Archived"
                },
                "tituloCadastrarGratificacao": "Register gratuity",
                "formulario": {
                    "Gratificacao": "Gratification",
                    "DataInicial": "Initial date",
                    "botaoSalvarGratificacao": "Save bonus"
                }
            },
            "tabAprovacoes": {
                "tituloTab": "Approvals",
                "tituloAprovacoesDeClientes": "Customer Approvals",
                "nenhumaAprovacaoCadastrada": "No registered approval.",
                "tabela": {
                    "Client": "Client",
                    "Grupo": "Group",
                    "Funcao": "Occupation",
                    "Aeronaves": "Aircraft"
                }
            },
            "tabICAO": {
                "tituloTab": "ICAO",
                "ativar": "Are you sure you would like to activate this ICAO?",
                "deletar": "Are you sure you want to delete this ICAO?",
                "arquivar": "Are you sure you would like to archive this ICAO?",
                "tituloICAOS": "ICAOS",
                "nenhumICAOCadastrado": "No ICAO registered.",
                "tabela": {
                    "Level": "Level",
                    "Vencimento": "Maturity",
                    "DataDeInsercao": "Insertion Date",
                    "Status": "Status",
                    "Acoes": "Actions",
                    "Ativo": "Active",
                    "Arquivado": "Archived"
                },
                "tituloCadastrarICAO": "Register ICAO",
                "formulario": {
                    "Level": "Level",
                    "DataDeVencimento": "Due date",
                    "botaoSalvarICAO": "Save ICAO"
                }
            },
            "tabPagamentos": {
                "tituloTab": "Payments",
                "tabHoras": {
                    "tituloTab": "Hours",
                    "tabela": {
                        "semPagamentosEmAberto": "There are no outstanding payments",
                        "ID": "ID",
                        "CodigoTreinamento": "Training code",
                        "TipoDeTreinamento": "Training type.",
                        "Aula": "Class",
                        "Periodo": "Time course",
                        "Treinamento": "Training",
                        "NumeroERev": "NÂº and Rev.",
                        "Local": "Place",
                        "HorasPagas": "Paid hours",
                        "ValorDaHora": "Time value",
                        "TotalDeHoras": "Total amount of hours"
                    }
                },
                "tabDiariaNacional": {
                    "tituloTab": "National rate",
                    "tabela": {
                        "semPagamentosEmAberto": "There are no outstanding payments",
                        "ID": "ID",
                        "CodigoTreinamento": "Training code",
                        "Periodo": "Time course",
                        "Treinamento": "Training",
                        "NumeroERev": "NÂº and Rev.",
                        "Diarias": "Daily",
                        "ValorDiaria": "Value/daily",
                        "TotalEmDiarias": "Total in daily",
                        "Moeda": "Coin"
                    }
                },
                "tabDiariaInternacional": {
                    "tituloTab": "International rate",
                    "tabela": {
                        "semPagamentosEmAberto": "There are no outstanding payments",
                        "ID": "ID",
                        "CodigoTreinamento": "Training code",
                        "Periodo": "Time course",
                        "Treinamento": "Training",
                        "NumeroERev": "NÂº and Rev.",
                        "Diarias": "Daily",
                        "ValorDiaria": "Value/daily",
                        "TotalEmDiarias": "Total in daily",
                        "Moeda": "Coin"
                    }
                }
            },
            "tabFerias": {
                "tituloTab": "Vacation",
                "ativar": "Are you sure you would like to enable this indication?",
                "arquivar": "Are you sure you'd like to archive this nomination?",
                "tituloFerias": "Vacation",
                "nenhumaIndicacaoCadastrada": "No indication registered.",
                "tabela": {
                    "Limite": "Limit",
                    "Direito": "Right",
                    "InicioEscala": "Home Schedule",
                    "TerminoEscala": "End Schedule"
                }
            },
            "tabBaseContratual": {
                "tituloTab": "Contractual base",
                "ativar": "Are you sure you would like to activate this base?",
                "arquivar": "Are you sure you'd like to archive this base?",
                "deletar": "Are you sure you would like to delete this base?",
                "tituloBases": "Bases",
                "nenhumaBaseCadastrada": "No base registered.",
                "tabela": {
                    "Base": "Base",
                    "Status": "Status",
                    "Acoes": "Actions",
                    "Ativo": "Active",
                    "Arquivado": "Archived"
                },
                "tituloAdicionarBase": "Add base",
                "formulario": {
                    "Base": "Base",
                    "botaoSalvarBase": "Save base"
                }
            },
            "tabCentroDeCusto": {
                "tituloTab": "Cost center",
                "ativar": "Are you sure you would like to activate this cost center?",
                "arquivar": "Are you sure you'd like to archive this cost center?",
                "deletar": "Are you sure you'd like to delete this cost center?",
                "tituloCentroDeCusto": "Cost center",
                "nenhumCentroDeCustoCadastrado": "No cost center registered.",
                "tabela": {
                    "CentroDeCusto": "Cost center",
                    "Data": "Date",
                    "Status": "Status",
                    "Acoes": "Actions",
                    "Ativo": "Active",
                    "Arquivado": "Archived"
                },
                "tituloCadastrarCentroDeCusto": "Register cost center",
                "formulario": {
                    "CentroDeCusto": "Cost center",
                    "DataInicial": "Initial date",
                    "botaoSalvarCentroDeCusto": "Save cost center"
                }
            },
            "tabHorasGarantidas": {
                "tituloTab": "Guaranteed hours",
                "ativar": "Are you sure you'd like to activate these guaranteed hours?",
                "arquivar": "Are you sure you'd like to archive these guaranteed hours?",
                "deletar": "Are you sure you want to delete these guaranteed hours?",
                "tituloCentroDeCusto": "Cost center",
                "botaoEsconderArquivoMorto": "Hide archive",
                "botaoMostrarArquivoMorto": "Show archive",
                "nenhumaHorasGarantidasCadastrado": "No guaranteed hours registered.",
                "tabela": {
                    "HorasGarantidasAdicional": "Guaranteed Hours - Additional",
                    "Codigo": "Code",
                    "CadastradoEm": "Registered at",
                    "Status": "Status",
                    "Acoes": "Actions",
                    "Ativo": "Active",
                    "Arquivado": "Archived"
                },
                "tituloCadastrarHorasGarantidas": "Register guaranteed hours",
                "formulario": {
                    "HorasGarantidasAdicional": "Guaranteed Hours - Additional",
                    "Codigo": "Code",
                    "botaoSalvarHorasGarantidas": "Save hours guaranteed"
                }
            }
        },
        "ListaDeFuncionariosCVODVO": {
            "titulo": "List of CVO/DVO employees",
            "botaoAdicionarFuncionario": "Add employee",
            "tabela": {
                "semCVODVO": "No CVO/DVO registered",
                "Nome": "Name",
                "Matricula": "Registration",
                "Cargo": "Role",
                "Licenca": "License",
                "CANAC": "CANAC",
                "Acoes": "Actions"
            }
        },
        "ListaDeFuncionariosCVODVOdesligados": {
            "titulo": "List of terminated CVO/DVO employees",
            "botaoAdicionarFuncionario": "Add employee",
            "tabela": {
                "semCVODVO": "No CVO/DVO registered",
                "Nome": "Name",
                "Matricula": "Registration",
                "Cargo": "Role",
                "Licenca": "License",
                "CANAC": "CANAC",
                "Acoes": "Actions"
            }
        },
        "ListaDeCertificadosAVencerPorColaborador": {
            "titulo": "List of certifications due by employee",
            "tabela": {
                "semTripulantes": "There are no registered crew",
                "Tripulante": "Crew member",
                "Certificados": "Certifications",
                "Prazo": "Deadline",
                "Expirado": "Expired",
                "DataDeExpiracao": "Expiration date"
            }
        },
        "CVOSemCertificado": {
            "titulo": "Employees without certification",
            "tabela": {
                "semColaboradorSemCertificado": "There is no employee without a certification",
                "Tripulante": "Crew member",
                "Cargo": "Role",
                "Grupo": "Group",
                "Certificado": "Certification"
            }
        },
        "ListaDeCertificadosAVencerPorMestreDeCarga": {
            "titulo": "List of expiring certifications per cargo master",
            "tabela": {
                "semTripulantes": "There are no registered crew",
                "Tripulante": "Crew member",
                "Certificados": "Certifications",
                "Prazo": "Deadline",
                "Expirado": "Expired",
                "DataDeExpiracao": "Expiration date"
            }
        },
        "ListaDeMestresDeCargaDesligados": {
            "titulo": "List of shutdown load masters",
            "botaoAdicionarFuncionario": "Add employee",
            "tabela": {
                "semMestres": "There are no registered masters",
                "Nome": "Name",
                "Matricula": "Registration",
                "Cargo": "Role",
                "Licenca": "License",
                "CANAC": "CANAC",
                "Acoes": "Actions"
            }
        },
        "ListaDeMestresDeCarga": {
            "titulo": "List of load masters",
            "botaoAdicionarFuncionario": "Add employee",
            "tabela": {
                "semMestres": "There are no registered masters",
                "Nome": "Name",
                "Matricula": "Registration",
                "Cargo": "Role",
                "Licenca": "License",
                "CANAC": "CANAC",
                "Acoes": "Actions"
            }
        },
        "MestreDeCargaSemCertificado": {
            "titulo": "Employees without certification",
            "tabela": {
                "semColaboradorSemCertificado": "There is no employee without a certification",
                "Colaborador": "Collaborator",
                "Cargo": "Role",
                "Grupo": "Group",
                "Certificado": "Certification"
            }
        },
        "ControleDeCertificadosPorDataDeEmissao": {
            "titulo": "Control of certifications by issue date",
            "formulario": {
                "DataInicial": "Initial date",
                "DataFinal": "Final date"
            },
            "tabela": {
                "ID": "ID",
                "Matricula": "Registration",
                "Nome": "Name",
                "Certificado": "Certification",
                "DataDeEmissao": "Date of issue",
                "DataDeVencimento": "Due date"
            },
            "eNecessarioPreencherDataDeInicioEFimParaPesquisasAnaliticas": "It is necessary to fill in start and end date for analytical searches."
        },
        "ListaDeFuncionariosQuePossuemDocumentosPendentes": {
            "titulo": "List of employees who have pending documents",
            "tituloAListaDeDocumentosPendentesEAtualizadaUmaVezAoDia": "The list of pending documents is updated once a day at 05:00.",
            "tabela": {
                "semTripulantes": "There are no registered crew",
                "Matricula": "Registration",
                "Nome": "Name",
                "Documentos": "Documents"
            }
        },
        "VisualizarHorasDeVoo": {
            "opcoesTipo": {
                "Sintetica": "Synthetic (Ignores date filter)",
                "Analitica": "Analytics"
            },
            "eNecessarioPreencherDataDeInicioEFimParaPesquisasAnaliticas": "It is necessary to fill in start and end date for analytical searches",
            "titulo": "View flight hours",
            "formulario": {
                "DataInicial": "Initial date",
                "DataFinal": "Final date",
                "FB": "FB",
                "Listagem": "Listing",
                "Modelo": "Model",
                "Nome": "Name",
                "placeholder": {
                    "SelecionarTipo": "Select type",
                    "SelecionarModelosDeAeronave": "Select aircraft models",
                    "SelecionarTripulantes": "Select crew"
                }
            },
            "tabela": {
                "semAeronaves": "There are no registered aircraft",
                "ID": "ID",
                "Data": "Date",
                "Matricula": "Reg.",
                "Apelido": "Surname",
                "Modelo": "Model",
                "FB": "FB",
                "Simulador": "Simulator",
                "Total": "Total",
                "IFR": "IFR.",
                "Noturno": "Nocturnal",
                "APP": "APP",
                "Diu": "Diu",
                "No": "No",
                "CgExt": "Cg. Ext."
            },
            "tituloTotais": "Totals",
            "tabelaTotais": {
                "semAeronaves": "There are no registered aircraft",
                "ID": "ID",
                "Matricula": "Reg.",
                "Apelido": "Surname",
                "Modelo": "Model",
                "Total": "Total",
                "IFR": "IFR.",
                "Noturno": "Nocturnal",
                "APP": "APP",
                "Diu": "Diu",
                "No": "No"
            }
        },
        "AdicionarHorasDoTripulante": {
            "deletar": "Are you sure you would like to delete this hour?",
            "titulo": "Add crew hours",
            "formulario": {
                "Aeronave": "Aircraft",
                "FB": "FB",
                "Total": "Total",
                "IFR": "IFR",
                "Noturno": "Nocturnal",
                "HNav": "H.Nav",
                "Data": "Date",
                "APP": "APP",
                "Diurno": "Diurnal",
                "Empresa": "Company",
                "CargaExterna": "External Load",
                "Observacoes": "Comments",
                "botaoAdicionarHoras": "Add hours",
                "opcoesEmpresa": {
                    "Omni": "Costa do Sol",
                    "Outros": "Others"
                },
                "placeholder": {
                    "SelecionarAeronave": "Select aircraft",
                    "SelecionarTipo": "Select type"
                }
            },
            "tituloListagemDeHoras": "Hours listing",
            "tabelaListagemDeHoras": {
                "semAeronaves": "There are no registered aircraft",
                "ID": "ID",
                "Modelo": "Model",
                "FB": "FB",
                "Total": "Total",
                "IFR": "IFR.",
                "Noturno": "Nocturnal",
                "APP": "APP",
                "Diurno": "Diurnal",
                "Data": "Date",
                "Acoes": "Actions"
            },
            "tituloTotaisDeHoras": "Total hours",
            "tabelaTotaisDeHoras": {
                "semAeronaves": "There are no registered aircraft",
                "ID": "ID",
                "Modelo": "Model",
                "FB": "FB",
                "Total": "Total",
                "IFR": "IFR.",
                "Noturno": "Nocturnal",
                "APP": "APP",
                "Diurno": "Diurnal"
            },
            "tituloEditarHorasDeVoo": "Edit flight hours",
            "formularioEditarHorasDeVoo": {
                "Aeronave": "Aircraft",
                "FB": "FB",
                "Total": "Total",
                "IFR": "IFR",
                "Noturno": "Nocturnal",
                "HNav": "H.Nav",
                "Data": "Date",
                "APP": "APP",
                "Diurno": "Diurnal",
                "Empresa": "Company",
                "opcoesEmpresa": {
                    "Omni": "Costa do Sol",
                    "Outros": "Others"
                },
                "CargaExterna": "External Load",
                "Observacoes": "Comments",
                "botaoEditarHora": "Edit time",
                "placeholder": {
                    "SelecionarAeronave": "Select aircraft",
                    "SelecionarTipo": "Select type"
                }
            }
        },
        "ListagemDeFuncionariosSemCargoArquivados": {
            "titulo": "List of archived unemployed employees",
            "botaoAdicionarFuncionario": "Add employee",
            "tabela": {
                "semTripulantes": "There are no registered crew",
                "Nome": "Name",
                "Matricula": "Registration",
                "Cargo": "Role",
                "Licenca": "License",
                "CANAC": "CANAC",
                "Acoes": "Actions"
            }
        },
        "ListaDeASOVencidos": {
            "titulo": "List of certifications to expire per crew member",
            "tabela": {
                "semTripulantes": "There are no registered crew",
                "Tripulante": "Crew member",
                "Matricula": "Registration",
                "Idade": "Age",
                "ASO": "ASO",
                "AtualizacaoASO": "ASO update",
                "Eletrocardiograma": "Electrocardiogram",
                "AtualizacaoEletro": "Electro Update"
            }
        },
        "ControleDeTreinamentosConsolidados": {
            "titulo": "Consolidated Training Control",
            "formulario": {
                "AplicabilidadeTipoDeColaborador": "Applicability - Type of Employee",
                "opcoesAplicabilidade": {
                    "Tripulantes135": "Crew - 135",
                    "Tripulantes121": "Crew - 121",
                    "Coordenadores": "Coordinators",
                    "MestresDeCarga": "Cargo Masters"
                },
                "Colaboradores": "Contributors",
                "Certificados": "Certifications",
                "Designacoes": "Designations",
                "ApenasAtivos": "Active only",
                "OcultarCamposPadroesDeTripulantes": "Hide crew default fields",
                "placeholder": {
                    "SelecionarAplicabilidade": "Select applicability",
                    "SelecionarColaboradores": "Select collaborators",
                    "SelecionarCertificados": "Select certifications",
                    "SelecionarModeloDeAeronave": "Select aircraft model"
                }
            },
            "botaoExportarEmCSV": "Export in CSV",
            "tabela": {
                "Matricula": "Reg.",
                "NomeDeGuerra": "War name",
                "Designacao": "Designation",
                "Cargo": "Role",
                "Licenca": "License",
                "CHT": "CHT",
                "IFR": "IFR",
                "CMA": "CMA",
                "Noturno": "Nocturnal"
            }
        },
        "ListaDeCertificados": {
            "titulo": "List of certifications to expire per crew member",
            "tabela": {
                "semTripulantes": "There are no registered crew",
                "Tripulante": "Crew member",
                "Certificado": "Certification",
                "CargaHoraria": "Workload",
                "Prazo": "Deadline",
                "Expirado": "Expired",
                "DataDeExpiracao": "Expiration date"
            }
        },
        "CertificadosDeFiltroMultiplo": {
            "formulario": {
                "Certificados": "Certifications",
                "placeholder": {
                    "SelecionarCertificados": "Select certifications"
                }
            },
            "tabela": {
                "Tripulante": "Crew member",
                "Matricula": "Registration"
            }
        },
        "ListaDeCertificadosAVencerPorTripulante": {
            "titulo": "List of certifications to expire per crew member",
            "tabela": {
                "semTripulantes": "There are no registered crew",
                "Tripulante": "Crew member",
                "Certificados": "Certifications",
                "Prazo": "Deadline",
                "Expirado": "Expired",
                "DataDeExpiracao": "Expiration date"
            }
        },
        "ListaDeTripulantesPorDesignacao": {
            "titulo": "List of crew by designation",
            "tabela": {
                "semTripulantes": "There are no registered crew",
                "Matricula": "Registration",
                "Nome": "Name",
                "Cargo": "Role",
                "Designacao": "Designation",
                "Modelo": "Model",
                "DataDesig": "Design date"
            }
        },
        "ListagemDeTripulantesPorSenioridade": {
            "titulo": "List of Crew Members by Seniority",
            "botaoExportarEmCSV": "Export in CSV",
            "tabela": {
                "Matricula": "Reg.",
                "Tripulante": "Crew member",
                "Designacoes": "Designations",
                "Quinzena": "Fortnight",
                "Cargo": "Role",
                "Licenca": "License",
                "Admissao": "Admission",
                "Senioridade": "Seniority",
                "Icao": "Icao",
                "Total": "Total",
                "UmP": "1P",
                "DoisP": "2P",
                "Heli": "Helicopter.",
                "UmPH": "1PH",
                "Mono": "Mono",
                "Multi": "Multi",
                "UmPMu": "1PMu",
                "MuH": "Muh",
                "UmPMuH": "1PMuH",
                "GP": "GP",
                "GP1P": "GP - 1P",
                "MP": "MP",
                "MP1P": "MP - 1P",
                "PP": "PP",
                "PP1P": "PP - 1P",
                "IFR": "IFR",
                "No": "Note"
            }
        },
        "ListaDeICAOSTripulante": {
            "titulo": "List of ICAOS crewmembers",
            "tabela": {
                "semTripulantes": "There are no registered crew",
                "Matricula": "Registration",
                "Tripulante": "Crew member",
                "Designacao": "Designation",
                "Frota": "Fleet",
                "Level": "Level",
                "DataDeExpiracao": "Expiration date",
                "Status": "Status",
                "DataDeInsercao": "Insertion date"
            }
        },
        "ListaDeTripulantesDesligados": {
            "titulo": "List of retired crew",
            "botaoAdicionarFuncionario": "Add employee",
            "tabela": {
                "semTripulantes": "There are no registered crew",
                "Nome": "Name",
                "Matricula": "Registration",
                "Cargo": "Role",
                "Licenca": "License",
                "CANAC": "CANAC",
                "Acoes": "Actions"
            }
        },
        "ListaDeTodosOsTripulantes": {
            "titulo": "List of all crew",
            "botaoAdicionarFuncionario": "Add employee",
            "tabela": {
                "semTripulantes": "There are no registered crew",
                "Nome": "Name",
                "Matricula": "Registration",
                "Cargo": "Role",
                "Licenca": "License",
                "CANAC": "CANAC",
                "Acoes": "Actions"
            }
        },
        "ColaboradoresSemCertificado": {
            "titulo": "Employees without certification",
            "tabela": {
                "semColaboradorSemCertificado": "There is no employee without a certification",
                "Colaborador": "Collaborator",
                "Cargo": "Role",
                "Grupo": "Group",
                "Certificado": "Certification"
            }
        },
        "ListaDeFuncionariosSemCargo": {
            "titulo": "List of unemployed employees",
            "botaoAdicionarFuncionario": "Add employee",
            "tabela": {
                "semTripulantes": "There are no registered crew",
                "Nome": "Name",
                "Matricula": "Registration",
                "Cargo": "Role",
                "Licenca": "License",
                "CANAC": "CANAC",
                "Acoes": "Actions"
            }
        }
    },
    "Solicitacoes": {
        "ListaDeSolicitacoes": {
            "reprovar": "Are you sure you'd like to disapprove this request?",
            "aprovar": "Are you sure you'd like to approve this request?",
            "titulo": "List of Requests",
            "tabela": {
                "semSolicitacoes": "There are no registered requests",
                "DataDeCriacao": "Creation date",
                "NomeDoColaborador": "Employee Name",
                "Inicio": "Start",
                "Fim": "End",
                "Justificativa": "Justification",
                "Status": "Status",
                "ChefeDeFrota": "Fleet Chief",
                "ChefeDeFrotaDataResposta": "Chief of Fleet - Response Date",
                "ChefeDeFrotaAprovacao": "Chief of Fleet - Approval",
                "ChefeDeFrotaJustificativa": "Chief of Fleet - Justification",
                "Administrativo": "Administrative",
                "AdministrativoDataResposta": "Administrative - Reply Date",
                "AdministrativoAprovacao": "Administrative - Approval",
                "AdministrativoResposta": "Administrative - Answer"
            }
        },
        "SolicitaçãoDeAlteracaoDeEscala": {
            "aprovar": "Are you sure you want to approve this request?",
            "reprovar": "Are you sure you want to disapprove this request?",
            "solicitacaoReprovadaComSucesso": "Request rejected successfully",
            "eNecessarioPreencherUmaJustificativaParaReprovacao": "It is necessary to fill in a justification for disapproval",
            "titulo": "Schedule Change Request",
            "tabela": {
                "Nome": "Name",
                "Inicio": "Start",
                "Fim": "End",
                "Justificativa": "Justification"
            },
            "botaoConfirmarAprovacao": "Confirm approval",
            "botaoConfirmarReprovacao": "Confirm disapproval",
            "placeholder": {
                "InstrucoesAoEscalador": "Instructions to the climber",
                "JustifiqueAReprovacao": "Justify the disapproval"
            },
            "paragrafoSolicitacaoJaRespondida": "Request already answered."
        },
        "ListaDeSolicitacoesPendentes": {
            "reprovar": "Are you sure you'd like to disapprove this request?",
            "aprovar": "Are you sure you'd like to approve this request?",
            "titulo": "List of Pending Requests",
            "tabela": {
                "semSolicitacoes": "There are no registered requests",
                "Acoes": "Actions",
                "ID": "ID",
                "DataDeCriacao": "Creation date",
                "NomeDoColaborador": "Employee Name",
                "Inicio": "Start",
                "Fim": "End",
                "Justificativa": "Justification",
                "ChefeDeFrotaDataResposta": "Chief of Fleet - Response Date",
                "ChefeDeFrotaJustificativa": "Chief of Fleet - Justification"
            },
            "tituloJustifiqueAReprovacao": "Justify the disapproval",
            "formulario": {
                "botaoJustificar": "Justify"
            }
        }
    },
    "Fornecedores": {
        "ListaDeFornecedores": {
            "ativo": "Active",
            "arquivado": "Archived",
            "ativar": "Are you sure you would like to activate this vendor?",
            "arquivar": "Are you sure you'd like to archive this vendor?",
            "titulo": "List of suppliers",
            "botaoAdicionarFornecedor": "Add supplier",
            "tabela": {
                "semFornecedores": "There are no registered suppliers",
                "ID": "ID",
                "Nome": "Name",
                "Email": "Email",
                "Telefone": "Phone number",
                "Pais": "Country",
                "Status": "Status",
                "Acoes": "Actions"
            }
        },
        "AdicionarFornecedor": {
            "titulo": "Register supplier",
            "formulario": {
                "Nome": "Name",
                "Endereco": "Address",
                "Cidade": "City",
                "Estado": "State",
                "Pais": "Country",
                "CEP": "Zip code",
                "Telefone": "Phone number",
                "Email": "Email",
                "Observacoes": "Comments",
                "placeholder": {
                    "NomeDoFornecedor": "Provider's name",
                    "EnderecoDoFornecedor": "Supplier address",
                    "CidadeDoFornecedor": "Supplier city",
                    "EstadoProvinciaDoFornecedor": "Provider's State/Province",
                    "SelecionarPais": "Select country",
                    "CEPDoFornecedor": "Supplier zip code",
                    "TelefoneDoFornecedor": "Supplier phone",
                    "EmailDoFornecedor": "Supplier's email"
                }
            }
        },
        "EditarFornecedor": {
            "titulo": "Edit Vendor",
            "tabDadosDoFornecedor": {
                "tituloTab": "Supplier data",
                "formulario": {
                    "Nome": "Name",
                    "Endereco": "Address",
                    "Cidade": "City",
                    "Estado": "State",
                    "Pais": "Country",
                    "CEP": "Zip code",
                    "Telefone": "Phone number",
                    "Email": "Email",
                    "Observacoes": "Comments",
                    "placeholder": {
                        "NomeDoFornecedor": "Provider's name",
                        "EnderecoDoFornecedor": "Supplier address",
                        "CidadeDoFornecedor": "Supplier city",
                        "EstadoProvinciaDoFornecedor": "Provider's State/Province",
                        "SelecionarPais": "Select country",
                        "CEPDoFornecedor": "Supplier zip code",
                        "TelefoneDoFornecedor": "Supplier phone",
                        "EmailDoFornecedor": "Supplier's email"
                    }
                }
            },
            "tabCertificadosDoFornecedor": {
                "tituloTab": "Supplier certifications",
                "deletarCertificado": "Are you sure you would like to delete this certification?",
                "ativarFornecedor": "Are you sure you would like to activate this vendor",
                "arquivarFornecedor": "Are you sure you'd like to archive this vendor?",
                "tabela": {
                    "Certificado": "Certification",
                    "Tipo": "Type",
                    "Telefone": "Phone number",
                    "Cidade": "City",
                    "Pais": "Country",
                    "Expiracao": "Expiration",
                    "CustoH": "Cost/H",
                    "Reembolso": "Reimbursement",
                    "Status": "Status",
                    "Acoes": "Actions",
                    "Ativo": "Active",
                    "Arquivado": "Archived"
                },
                "tituloAdicionarCertificado": "Add certification",
                "formulario": {
                    "Certificados": "Certifications",
                    "CodigoANAC": "ANAC code",
                    "Expiracao": "Expiration",
                    "Certificacao": "Certification",
                    "PrazoParaCancelamentoComRetornoDoPagamentoEmDias": "Deadline for Cancellation with Return of Payment (in days)",
                    "Endereco": "Address",
                    "Cidade": "City",
                    "Estado": "State",
                    "Pais": "Country",
                    "ContatoNome": "Contact name",
                    "Telefone": "Phone number",
                    "Email": "Email",
                    "Observacoes": "Comments",
                    "ValorHora": "Hourly Value",
                    "botaoSalvarCertificado": "Save certification",
                    "placeholder": {
                        "SelecionarCertificado": "Select certification",
                        "EnderecoDoFornecedor": "Supplier address",
                        "CidadeDofornecedor": "Supplier city",
                        "EstadoProvinciaDoFornecedor": "Provider's State/Province",
                        "SelecionarPais": "Select country",
                        "TelefoneDoFornecedor": "Supplier phone",
                        "EmailDoFornecedor": "Supplier's email"
                    }
                }
            }
        }
    },
    "Tarefas": {
        "ListaDeTarefas": {
            "titulo": "To-do list",
            "botaoAdicionarTarefa": "Add task",
            "tabela": {
                "semTarefas": "There are no registered tasks",
                "ID": "ID",
                "Nome": "Name",
                "Acoes": "Actions"
            }
        },
        "AdicionarTarefa": {
            "titulo": "Register restriction tasks",
            "formulario": {
                "Tarefa": "Assignment",
                "botaoCadastrarTarefa": "Register task",
                "placeholder": {
                    "TarefaDeRestricao": "Constraint task"
                }
            }
        },
        "EditarTarefa": {
            "titulo": "Edit Constraint Task",
            "formulario": {
                "Tarefa": "Assignment",
                "placeholder": {
                    "TarefaDeRestricao": "Constraint task"
                }
            }
        }
    },
    "Treinamentos": {
        "ListaDeTreinamentos": {
            "titulo": "Training list",
            "botaoAdicionarTreinamento": "Add training",
            "tabela": {
                "semTreinamentos": "There are no registered trainings",
                "ID": "ID",
                "Nome": "Name",
                "Status": "Status",
                "CodigoDeControle": "Control code",
                "TiposDeCertificado": "Certification types",
                "Modalidade": "Modality",
                "DataInicial": "Initial date",
                "DataFinal": "Final date",
                "Acoes": "Actions"
            }
        },
        "AdicionarDeTreinamento": {
            "titulo": "Register training",
            "formulario": {
                "DataDeInicio": "Start date",
                "DataDeTermino": "End date",
                "Nome": "Name",
                "Observacoes": "Comments",
                "botaoAdicionarTreinamento": "Add training",
                "placeholder": {
                    "DataDeInicio": "Start date",
                    "DataDeTermino": "End date",
                    "NomeDoTreinamento": "Training name"
                }
            }
        },
        "EditarTreinamento": {
            "trocarStatus": "Are you sure you'd like to change the training status?",
            "trocarStatusParaCancelado": "Are you sure you'd like to change the training status to cancelled?",
            "trocarStatusParaDivulgado": "Are you sure you'd like to change the training status to released?",
            "trocarStatusParaFinalizado": "Are you sure you'd like to change the training status to Completed?",
            "ignorarFichas": "Skip chips",
            "fichasNecessarias": "Required chips",
            "gerarOsPagamentosDosAlunosDePresencaConfirmada": "Are you sure you would like to generate payments for students who have confirmed attendance at this training?",
            "selecioneUmTipoDeExportacao": "Select an export type.",
            "desejaEnviarEmail": "Do you want to send email?",
            "naoHaNenhumArquivoAnexado": "There is no file attached, are you sure you want to proceed?",
            "titulo": "Edit Training",
            "botaoTripulantesElegiveis": "Eligible crew members",
            "botaoConfirmarPagamentos": "Confirm payments",
            "botaoExportar": {
                "Exportar": "Export",
                "Solo": "Ground",
                "SoloTIC": "ICT floor",
                "Simulador": "Simulator",
                "EAD": "EAD"
            },
            "botaoFichas": {
                "TrocarParaIgnorarFichas": "Swap to ignore tokens",
                "TrocarParaFichasNecessarias": "Swap for required tokens"
            },
            "botaoAlertas": "Alerts",
            "botaoStatus": {
                "TrocarParaDivulgado": "Switch to Disclosed",
                "TrocarParaCancelado": "Switch to Canceled",
                "TrocarParaFinalizado": "Switch to Finished",
                "Cancelado": "Called off"
            },
            "botaoEmail": "Email",
            "tabDadosDoTreinamento": {
                "tituloTab": "Training data",
                "formulario": {
                    "DataDeInicio": "Start date",
                    "DataDeTermino": "End date",
                    "Nome": "Name",
                    "Codigo": "Code",
                    "Revisao": "Revision",
                    "Observacoes": "Comments",
                    "placeholder": {
                        "DataDeInicio": "Start date",
                        "DataDeTermino": "End date",
                        "NomeDoTreinamento": "Training name"
                    }
                }
            },
            "tabAulas": {
                "tituloTab": "Classes",
                "deletarAula": "Are you sure you would like to delete this class?",
                "mensagemDadosAtualizadosComSucesso": "The data has been updated successfully",
                "tituloAdicionarCertificado": "Add certification",
                "formularioAdicionarCertificado": {
                    "Certificado": "Certification",
                    "Fornecedor": "Provider",
                    "DataDeInicio": "Start date",
                    "DataDeTermino": "End date",
                    "Periodo": "Time course",
                    "TipoDeModalidade": "Modality type",
                    "opcoesTipoDeModalidade": {
                        "Presencial": "Presential",
                        "EAD": "EAD"
                    },
                    "botaoAdicionarCertificado": "Add certification",
                    "placeholder": {
                        "SelecionarCertificado": "Select certification",
                        "SelecionarFornecedor": "Select supplier",
                        "DataDeInicio": "Start date",
                        "DataDeTermino": "End date",
                        "PeriodoDaAula": "Class period",
                        "SelecionarTipoDeModalidade": "Select mode type"
                    }
                },
                "tituloListaDeCertificados": "List of certifications",
                "tabelaListaDeCertificados": {
                    "Certificado": "Certification",
                    "Fornecedor": "Provider",
                    "Cidade": "City",
                    "Inicio": "Start",
                    "Fim": "End",
                    "Modalidade": "Modality",
                    "Acoes": "Actions"
                },
                "tituloEditarCertificadoFornecedor": "Edit Certification/Vendor",
                "formularioCertificadoFornecedor": {
                    "DataDeInicio": "Start date",
                    "DataDeTermino": "End date",
                    "Certificado": "Certification",
                    "Fornecedor": "Provider",
                    "Periodo": "Time course",
                    "TipoDeModalidade": "Modality type",
                    "opcoesTipoDeModalidade": {
                        "Presencial": "Presential",
                        "EAD": "EAD"
                    },
                    "botaoSalvarFornecedor": "Save vendor",
                    "placeholder": {
                        "DataDeInicio": "Start date",
                        "DataDeTermino": "End date",
                        "SelecionarFornecedor": "Select supplier",
                        "PeriodoDaAula": "Class period",
                        "SelecionarTipoDeModalidade": "Select mode type"
                    }
                },
                "tabInstrutores": {
                    "tituloTab": "Instructors",
                    "deletarInstrutor": "Are you sure you'd like to delete the instructor for this class?",
                    "tituloAdicionarInstrutor": "Add instructor",
                    "formulario": {
                        "Instrutor": "Instructor",
                        "CargaHoraria": "Workload",
                        "botaoAdicionarInstrutor": "Add instructor",
                        "placeholder": {
                            "SelecionarInstrutor": "Select instructor",
                            "PreenchaACargaHoraria": "Fill in the workload"
                        }
                    },
                    "tituloListaDeInstrutores": "List of instructors",
                    "tabelaListaDeInstrutores": {
                        "semCertificados": "There are no registered certifications",
                        "ID": "ID",
                        "Instrutor": "Instructor",
                        "Horas": "Hours",
                        "Certificado": "Certification",
                        "Periodo": "Time course",
                        "Acoes": "Actions"
                    },
                    "formularioDatas": {
                        "a": "To",
                        "placeholder": {
                            "DataDeInicio": "Start date",
                            "DataDeTermino": "End date"
                        }
                    }
                },
                "tabExaminadores": {
                    "tituloTab": "Examiners",
                    "deletarExaminador": "Are you sure you'd like to delete the examiner for this class?",
                    "tituloAdicionarExaminador": "Add examiner",
                    "formulario": {
                        "Examinador": "Examiner",
                        "CargaHoraria": "Workload",
                        "botaoAdicionarExaminador": "Add examiner",
                        "placeholder": {
                            "SelecionarExaminador": "Select examiner",
                            "PreenchaACargaHoraria": "Fill in the workload"
                        }
                    },
                    "tituloListaDeExaminadores": "List of examiners",
                    "tabelaListaDeExaminadores": {
                        "semCertificados": "There are no registered certifications",
                        "ID": "ID",
                        "Examinador": "Examiner",
                        "Horas": "Hours",
                        "Certificado": "Certification",
                        "Periodo": "Time course",
                        "Acoes": "Actions"
                    }
                },
                "tituloVisualizarCertificadoFornecedor": "View certification/vendor",
                "tituloInstrutores": "Instructors",
                "tabelaInstrutores": {
                    "Nome": "Name",
                    "Inicio": "Start",
                    "Fim": "End",
                    "Horas": "Hours"
                },
                "tituloExaminadores": "Examiners",
                "tabelaExaminadores": {
                    "Nome": "Name",
                    "Inicio": "Start",
                    "Fim": "End",
                    "Horas": "Hours"
                }
            },
            "tabAlunos": {
                "tituloTab": "Students",
                "deletarAlunoDessaAula": "Are you sure you would like to delete the student from this class?",
                "deletarAlunoDesseTreinamento": "Are you sure you would like to delete the student from this training?",
                "tituloAdicionarAluno": "Add student",
                "formularioAdicionarAluno": {
                    "Tripulante": "Crew member",
                    "botaoAdicionarTripulante": "Add crew member",
                    "placeholder": {
                        "SelecionarTripulante": "Select Crew"
                    }
                },
                "tituloListaDeAlunos": "List of students",
                "nenhumAlunoCadastrado": "No students registered.",
                "botaoRemoverTodasAsAulas": "Remove all classes",

                tituloCertificadoDeTreinamentoDe(DataInicial, DataFinal) {
                    return `From ${DataInicial} to ${DataFinal}`;
                },
          
                "formularioObservacoes": {
                    "placeholder": {
                        "Observacoes": "Comments"
                    }
                }
            },
            "tabDiarias": {
                "tituloTab": "Daily",
                "tituloDiariasDoTreinamento": "Training diaries",
                "nenhumaDiariaCadastrada": "No daily registered.",
                "tabela": {
                    "Funcionario": "Employee",
                    "Ida": "One way",
                    "CheckIn": "Check in",
                    "Inicio": "Start",
                    "Fim": "End",
                    "CheckOut": "Check-out",
                    "Volta": "Return",
                    "Qtd": "Qty.",
                    "Diarias": "Daily",
                    "VDiaria": "V. daily",
                    "VTotal": "V. Total"
                }
            },
            "tabPresenca": {
                "tituloTab": "Presence",
                "confirmarTodasAsPresencas": "Are you sure you would like to confirm all attendance for this training?",
                "confirmarPresencaDesseAluno": "Are you sure you'd like to RSVP for this student?",
                "confirmarAusenciaDesseAluno": "Are you sure you'd like to confirm this student's absence?",
                "tituloListaDePresenca": "Attendance list",
                "botaoConfirmarTodasAsPresencas": "Confirm all attendance",
                "nenhumAlunoCadastrado": "No students registered.",
                "tabela": {
                    "Funcionario": "Employee",
                    "PresencaAusencia": "Presence / Absence",
                    "PresencaConfirmada": "Confirmed presence",
                    "AusenciaConfirmada": "Confirmed absence",
                    "ConfirmarPresenca": "RSVP",
                    "ConfirmarAusencia": "Confirm absence"
                }
            },
            "tabAlertas": {
                "tituloTab": "Alerts",
                "deletarComentario": "Are you sure you'd like to delete this comment?",
                "tituloListaDeAlertas": "List of alerts",
                "tabelaListaDeAlertas": {
                    "semAlertas": "There are no registered alerts.",
                    "ID": "ID",
                    "Tipo": "Type",
                    "Tripulante": "Crew member",
                    "Cargo": "Role",
                    "Aula": "Class",
                    "Titulo": "Title",
                    "Acoes": "Actions"
                },
                "tituloAdicionarComentarioNesteAlertaDeTreinamento": "Add comment on this training alert",
                "formulario": {
                    "Comentario": "Comment",
                    "botaoAdicionarComentario": "Add Comment"
                },
                "tituloComentariosSobreOAlerta": "Comments about the alert",
                "tabelaComentariosSobreOAlerta": {
                    "semComentarios": "There are no registered comments",
                    "Comentario": "Comment",
                    "Usuario": "User",
                    "Data": "Date",
                    "Acoes": "Actions"
                }
            },
            "tabResultados": {
                "tituloTab": "Results",
                "finalizarTodosOsCertificados": "Are you sure you would like to finalize all approved crew certifications?",
                "tituloInstrutoresExaminadores": "Instructors / Examiners",
                "nenhumAlunoCadastrado": "No students registered.",
                "tabelaIntrutoresExaminadores": {
                    "Instrutor": "Instructor",
                    "Examinador": "Examiner",
                    "PagamentoViaLogbook": "Payment via logbook",
                    "formulario": {
                        "Horas": "Hours",
                        "HorasDobradas": "Double hours",
                        "Acoes": "Actions",
                        "botaoConfirmarPagamento": "Confirm payment"
                    }
                },
                "tituloTripulantes": "Crew",
                "botaoFinalizarTodos": "Finalize all",
                "tabelaTripulantes": {
                    "HoraPF": "PF time",
                    "HoraPNF": "PNF time",
                    "Finalizado": "Finished",
                    "HorasPF": "PF hours",
                    "HorasPNF": "PNF hours",
                    "Status": "Status",
                    "Faltante": "Missing",
                    "MarcarAlunoComoFaltante": "Are you sure you'd like to mark the student as absent?",
                    "formulario": {
                        "Reprovado": "Disapproved",
                        "MarcarComoFaltante": "Mark as missing",
                        "Acoes": "Actions",
                        "botaoFaltante": "Missing",
                        "botaoInserirResultado": "Insert result"
                    },
                    "Nota": "Note",
                    "Horas": "Hours",
                    "MarcarComoFaltante": "MarkAsMissing",
                    "Acoes": "Actions",
                    "botaoAtualizarNota": "Update grade"
                }
            },
            "tabLogbook": {
                "tituloTab": "Logbook",
                "finalizarSessao": "Are you sure you'd like to end this session?",
                "reabrirSessao": "Are you sure you'd like to reopen this session?",
                "deletarSessao": "Are you sure you would like to delete this session?",
                "dadosAtualizadosComSucesso": "The data has been updated successfully",
                "tituloAdicionarSessao": "Add session",
                "botaoConfirmarHoras": "Confirm hours",
                "formularioAdicionarSessao": {
                    "Certificado": "Certification",
                    "Data": "Date",
                    "Inicio": "Start",
                    "Fim": "End",
                    "Examinador": "Examiner",
                    "Instrutor": "Instructor",
                    "PilotFlying": "Pilot Flying",
                    "PilotMonitoring": "Pilot Monitoring",
                    "botaoAdicionarSessao": "Add session",
                    "placeholder": {
                        "SelecionarCertificado": "Select certification",
                        "Data": "Date",
                        "HorarioDeInicio": "Start time",
                        "HorarioDeFim": "End time"
                    }
                },
                "tituloListaDeSessoes": "List of sessions",
                "tabelaListaDeSessoes": {
                    "Certificado": "Certification",
                    "Inicio": "Start",
                    "Fim": "End",
                    "HorasTotais": "Total hours",
                    "Tripulacao": "Crew",
                    "Arquivo": "Archive",
                    "Status": "Status",
                    "Acoes": "Actions",
                    "Aberto": "Open",
                    "Finalizado": "Finished",
                    "Confirmado": "Confirmed",
                    "ImportarArquivo": "Are you sure you would like to import this file? When importing, the previous file, if any, will be permanently replaced.",
                    "formularioListaDeSessoes": {
                        "placeholder": {
                            "Arquivo": "Archive"
                        }
                    }
                },
                "opcoesTipo": {
                    "Examinador": "Examiner",
                    "Instrutor": "Instructor",
                    "PilotFlying": "Pilot Flying",
                    "PilotMonitoring": "Pilot Monitoring"
                },
                "deletarTripulante": "Are you sure you want to delete this crew member?",
                "tituloAdicionarTripulante": "Add crew member",
                "formularioAdicionarTripulante": {
                    "Tripulante": "Crew member",
                    "Tipo": "Type"
                },
                "tabelaAdicionarTripulante": {
                    "Tripulante": "Crew member",
                    "Matricula": "Registration",
                    "Tipo": "Type",
                    "Acoes": "Actions"
                },
                "tituloDuplicarSessao": "Duplicate session",
                "formularioDuplicarSessao": {
                    "Data": "Date",
                    "Inicio": "Start",
                    "Fim": "End",
                    "botaoDuplicarSessao": "Duplicate session",
                    "placeholder": {
                        "Data": "Date",
                        "HorarioDeInicio": "Start time",
                        "HorarioDeFim": "End time"
                    }
                }
            },
            "tabRevisao": {
                "tituloTab": "Revision",
                "tituloRevisoes": "Revisions",
                "botaoCriarRevisao": "Create review",
                "nenhumaRevisaoParaEsteTreinamento": "No reviews for this training.",
                "tabela": {
                    "DataDeCriacao": "Creation date",
                    "Status": "Status",
                    "Acoes": "Actions"
                }
            },
            "tituloSelecioneOTipoDePDF": "Select PDF type",
            "botaoSolo": "GROUND",
            "botaoSoloTIC": "SOLO ICT",
            "botaoSimulador": "SIMULATOR",
            "botaoEAD": "EAD",
            "botaoConfirmarTrocaDeStatus": "Confirm status change",
            "botaoCancelar": "Cancel",
            "tituloInformativoDeAlertas": "Alert information",
            "tituloTripulantesElegiveis": "Eligible crew members",
            "tabelaTripulantesElegiveis": {
                "Tripulante": "Crew member",
                "Certificado": "Certification",
                "DataDeExpiracao": "Expiration date",
                "Prazo": "Deadline",
                "Acoes": "Actions"
            },
            "tituloEnvioDeEmail": "Email sending",
            "tituloUploadDeArquivos": "File upload",
            "formularioUploadDeArquivos": {
                "Arquivo": "Archive",
                "SelecionarExportacaoDoTreinamento": "Select training export",
                "opcoesTipo": {
                    "Solo": "GROUND",
                    "SoloTIC": "SOLO ICT",
                    "Simulador": "SIMULATOR",
                    "EAD": "EAD"
                },
                "SelecionarDestinatariosExtras": "Select extra recipients",
                "botaoEnviarEmail": "Send email",
                "placeholder": {
                    "Arquivo": "Archive",
                    "SelecionarTipo": "Select type",
                    "SeparePorVirgula": "Separate by comma"
                }
            }
        }
    },
    "Links": {
        "LinksUteis": {
            "deletar": "Are you sure you would like to delete this link?",
            "titulo": "Useful links",
            "tituloAdicionarLink": "Add link",
            "formulario": {
                "Nome": "Name",
                "Link": "Link"
            },
            "tabela": {
                "semIncompatibilidades": "There are no registered incompatibilities",
                "ID": "ID",
                "Nome": "Name",
                "Link": "Link",
                "Acoes": "Actions"
            }
        }
    },
    "Usuarios": {
        "ListaDeUsuarios": {
            "deletar": "Are you sure you would like to delete this user?",
            "titulo": "User list",
            "tabela": {
                "semUsuarios": "There are no registered users",
                "ID": "ID",
                "Nome": "Name",
                "Funcionario": "Employee",
                "Email": "Email",
                "Criacao": "Creation",
                "Acoes": "Actions"
            }
        },
        "AdicionarUsuario": {
            "titulo": "Register user",
            "formulario": {
                "Nome": "Name",
                "Email": "Email",
                "Funcionario": "Employee",
                "UsadoEmSigtrip": "Used in sigvoos",
                "UsadoEmSigrfms": "Used in sigrfms",
                "placeholder": {
                    "SelecionarBase": "Select base"
                }
            }
        },
        "EditarUsuario": {
            "titulo": "Edit user",
            "deletarEmpresa": "Are you sure you want to delete this company?",
            "formulario": {
                "Nome": "Name",
                "Email": "Email",
                "Funcionario": "Employee",
                "UsadoEmSigtrip": "Used in sigvoos",
                "UsadoEmSigrfms": "Used in sigrfms",
                "placeholder": {
                    "SelecionarBase": "Select base"
                }
            },
            "tituloGruposDePermissoes": "Permission groups",
            "tituloBasesRelacionadas": "Related bases",
            "formularioBasesRelacionadas": {
                "botaoSalvarBasesRelacionadas": "Save related bases"
            },
            "botaoSalvar": "Save",
            "botaoSalvarGrupos": "Save groups",
            "tituloEmpresas": "Companies",
            "adicionarEmpresa": "Add company",
            "formularioEmpresas": {
                "Empresas": "Companies",
                "botaoSalvarEmpresas": "Save companies",
                "botaoAdicionarEmpresa": "Add company",
                "placeHolder": {
                    "SelecionarEmpresa": "Select company"
                }
            },
            "tabelaEmpresas": {
                "Empresa": "Company"
            }
        },
        "EditarSenha": {
            "titulo": "Change password",
            "formulario": {
                "SenhaAtual": "Current password",
                "NovaSenha": "New Password",
                "RepitaANovaSenha": "Repeat the new password",
                "placeholder": {
                    "SenhaAtual": "Current password",
                    "NovaSenha": "New Password",
                    "RepitaANovaSenha": "Repeat the new password"
                }
            }
        },
        "RecuperarSenha": {
            "paragrafoVoltarParaLogin": "Back to login",
            "formulario": {
                "botaoRecuperarSenha": "Recover Password",
                "placeholder": {
                    "SeuEmail": "Your email"
                }
            }
        },
        "SistemaSuspenso": {
            "titulo": "Suspended system for maintenance",
            "tituloAtualizacao": "Update",
            "paragrafoPrevisaoDeVolta": "Back forecast"
        },
        "Login": {
            "usuarioNaoCadastrado": "User not registered. Ask IT to create the user.",
            "usuarioInativo": "Inactive user on this system. Ask IT to release the user.",
            "usuarioSemPermissoes": "User without permissions for this system. Ask IT for access permissions for this user.",
            "usuarioOuSenhaInvalidos": "Username or password is invalid.",
            "paragrafoModuloAdministrativo": "ADMINISTRATIVE MODULE",
            "formulario": {
                "paragrafoAtencao": "ATTENTION: YOU WILL ACCESS THE APPROVAL ENVIRONMENT",
                "botaoAcessarOSistema": "Access the system",
                "placeholder": {
                    "SeuEmail": "Your email",
                    "SuaSenha": "Your password"
                }
            },
            "paragrafoOLoginDeveSerFeitoComUsuarioESenhaOmniRubi": "LOGIN MUST BE DONE WITH THE USERNAME AND PASSWORD RUBI",
            "paragrafoEsqueciMinhaSenha": "I forgot my password",
            "paragrafoParaRecuperarSuaSenha": "To retrieve your password, contact IT."
        }
    },
    "RequisitosDeExperiencia": {
        "EditarRequisitoDeExperiencia": {
            "titulo": "Edit Minimum Experience Requirement",
            "formulario": {
                "DesignacaoDoTripulante": "Crew designation",
                "opcoesFuncao": {
                    "Comandante": "Captain",
                    "Copiloto": "Co-pilot",
                    "Comissario": "Commissioner"
                },
                "MinimoDeHorasParaOperacional": "Minimum hours for operational",
                "RequerTripulanteComDesignacao": "Requires designated crew member",
                "MinimoDeHorasNoModelo": "Minimum hours in model",
                "MinimoDeHorasTotais": "Minimum total hours",
                "botaoAdicionarRequisito": "Add requirement",
                "placeholder": {
                    "SelecionarFuncao": "Select function",
                    "MinimoDeHorasParaOperacional": "Minimum hours for operational",
                    "SelecionarDesignacao": "Select designation",
                    "MinimoDeHorasNoModelo": "Minimum hours in model",
                    "MinimoDeHorasTotais": "Minimum total hours"
                }
            },
            "tabela": {
                "DesignacaoDoTripulante": "Crew designation",
                "MinimoDeHorasParaOperacional": "Minimum hours for operational",
                "RequerTripulanteComDesignacao": "Requires designated crew member",
                "MinimoDeHorasNoModelo": "Minimum hours in model",
                "MinimoDeHorasTotais": "Minimum total hours",
                "Acoes": "Actions"
            }
        }
    },
    "Alertas": {
        "ListaDeAlertas": {
            "titulo": "List of alerts",
            "tabela": {
                "semAlertas": "There are no registered alerts",
                "ID": "ID",
                "Nome": "Name",
                "EscalaDeMissao": "Mission Schedule",
                "Cor": "Color",
                "RelatorioDeVoo": "Flight report",
                "EscalaDiaria": "Daily schedule",
                "Papeletas": "Pilot logbook",
                "Acoes": "Actions"
            }
        },
        "EditarAlerta": {
            "titulo": "Edit alert",
            "formulario": {
                "EscalaDeMissaoAtivo": "Mission Schedule - Active",
                "EscalaDeMissaoCor": "Mission Schedule - Color",
                "opcoesCor": {
                    "Vermelho": "Red",
                    "Laranja": "Orange",
                    "Verde": "Green"
                },
                "RelatorioDeVooAtivo": "Flight Report - Active",
                "RelatorioDeVooCor": "Flight Report - Color",
                "EscalaDiariaAtivo": "Daily schedule - Active",
                "EscalaDiariaCor": "Daily Schedule - Color",
                "PapeletasAtivo": "Pilot logbook - Active",
                "PapeletasCor": "Pilot logbook - Color",
                "AreaResponsavel": "Responsible area",
                "Premissas": "Premises"
            },
            "tituloRevisoesPendentes": "Pending revisions",
            "tabelaRevisoesPendentes": {
                "AreaResponsavel": "Responsible area",
                "Premissas": "Premises",
                "EscalaDeMissaoAtivo": "Mission Schedule - Active",
                "EscalaDeMissaoCor": "Mission Schedule - Color",
                "RelatorioDeVooAtivo": "Flight Report - Active",
                "RelatorioDeVooCor": "Flight Report - Color",
                "EscalaDiariaAtivo": "Daily schedule - Active",
                "EscalaDiariaCor": "Daily Schedule - Color",
                "PapeletasAtivo": "Pilot logbook - Active",
                "PapeletasCor": "Pilot logbook - Color",
                "Autor": "Author",
                "Acoes": "Actions"
            },
            "naoHaRevisoesPendentes": "There are no pending reviews",
            "tituloLogDeRevisoes": "Revision log",
            "tabelaLogDeRevisoes": {
                "Situacao": "Situation",
                "Data": "Date",
                "AreaResponsavel": "Responsible area",
                "Premissas": "Premises",
                "EscalaDeMissaoAtivo": "Mission Schedule - Active",
                "EscalaDeMissaoCor": "Mission Schedule - Color",
                "RelatorioDeVooAtivo": "Flight Report - Active",
                "RelatorioDeVooCor": "Flight Report - Color",
                "EscalaDiariaAtivo": "Daily schedule - Active",
                "EscalaDiariaCor": "Daily Schedule - Color",
                "PapeletasAtivo": "Pilot logbook - Active",
                "PapeletasCor": "Pilot logbook - Color",
                "Autor": "Author",
                "Aprovacao": "Approval",
                "Inicial": "Initial",
                "Aprovada": "Approved",
                "Reprovada": "Reproved"
            }
        }
    }
});

export default getLocale;


// WEBPACK FOOTER //
// ./src/i18n/en-US.jsx